var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
(() => {
    angular.module('QMC.Stammdaten', ['QMC.Klient']).config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', '$urlRouterProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, $urlRouterProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        const params = {
            dataId: {
                dynamic: true
            }
        };
        $stateProvider
            // client
            .state('stammdatenOwn', {
            url: '/stammdaten',
            templateUrl: qmcBase + '/stammdaten',
            controller: 'StammdatenClientListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client list');
                    }]
            }
        })
            .state('stammdaten', {
            url: '/stammdaten/:id',
            templateUrl: qmcBase + '/stammdaten',
            controller: 'StammdatenClientListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client list');
                    }]
            }
        })
            .state('detail', {
            url: '/stammdaten/detail/:client',
            templateUrl: qmcBase + '/stammdaten/detail',
            controller: 'StammdatenClientDetailController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail');
                    }]
            }
        })
            // detail
            .state('detail.address', {
            url: '/address/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/address',
            controller: 'DetailAddressController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail address');
                    }]
            },
            params
        })
            .state('detail.admission', {
            url: '/admission/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/admission',
            controller: 'DetailAdmissionController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail admission');
                    }]
            },
            params
        })
            .state('detail.communication', {
            url: '/communication/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/communication',
            controller: 'DetailCommunicationController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail communication');
                    }]
            },
            params
        })
            .state('detail.contactperson', {
            url: '/contactperson/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/contactperson',
            controller: 'DetailContactPersonController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail contact person');
                    }]
            },
            params
        })
            .state('detail.cover', {
            url: '/cover/:id',
            templateUrl: qmcBase + '/stammdaten/detail/cover',
            controller: 'DetailCoverController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail cover');
                    }]
            }
        })
            .state('detail.doctorsvisit', {
            url: '/doctorsvisit/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/doctorsvisit',
            controller: 'DetailDoctorsVisitController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail doctors visit');
                    }]
            },
            params
        })
            .state('detail.disease', {
            url: '/disease/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/disease',
            controller: 'DetailDiseaseController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail disease');
                    }]
            },
            params
        })
            .state('detail.dismissal', {
            url: '/dismissal/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/dismissal',
            controller: 'DetailDismissalController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail dismissal');
                    }]
            },
            params
        })
            .state('detail.note', {
            url: '/note/:id',
            templateUrl: qmcBase + '/stammdaten/detail/note',
            controller: 'DetailNoteController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail note');
                    }]
            }
        })
            .state('detail.education', {
            url: '/education/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/education',
            controller: 'DetailEducationController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail school');
                    }]
            },
            params
        })
            .state('detail.vaccination', {
            url: '/vaccination/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/vaccination',
            controller: 'DetailVaccinationController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail vaccination');
                    }]
            },
            params
        })
            .state('detail.hobby', {
            url: '/hobby/:id',
            templateUrl: qmcBase + '/stammdaten/detail/hobby',
            controller: 'DetailHobbyController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail hobby');
                    }]
            }
        })
            .state('detail.checklist', {
            url: '/checklist/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/checklist',
            controller: 'DetailChecklistController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail checklist');
                    }]
            },
            params
        })
            .state('detail.document', {
            url: '/documents/:id',
            templateUrl: qmcBase + '/stammdaten/detail/document',
            controller: 'DetailDocumentsController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail document');
                    }]
            },
            params
        })
            .state('detail.absenteeism', {
            url: '/absenteeism/:id',
            templateUrl: qmcBase + '/stammdaten/detail/absenteeism',
            controller: 'DetailAbsenteeismController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail absenteeism');
                    }]
            }
        })
            .state('detail.accountingBook', {
            url: '/accountingBook/:id',
            templateUrl: qmcBase + '/stammdaten/detail/accountingBook',
            controller: 'DetailAccountingBookController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail accounting book');
                    }]
            }
        })
            .state('detail.legal', {
            url: '/legal/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/legal',
            controller: 'DetailLegalController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail legal');
                    }]
            },
            params
        })
            .state('detail.extendedMainData', {
            url: '/extendedMainData/:id',
            templateUrl: qmcBase + '/stammdaten/detail/extendedMainData',
            controller: 'DetailExtendedMainDataController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail extended Main Data');
                    }]
            }
        })
            .state('detail.tempInstituteChange', {
            url: '/tempInstituteChange/:id',
            templateUrl: qmcBase + '/stammdaten/detail/tempInstituteChange',
            controller: 'DetailTempInstituteChangeController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client temp institute change');
                    }]
            }
        })
            .state('detail.clientInfo', {
            url: '/clientInformation/:id',
            templateUrl: qmcBase + '/stammdaten/detail/clientInfo',
            controller: 'DetailClientInfoController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten ClientInfo');
                    }]
            }
        })
            .state('detail.udf', {
            url: '/udf/:type/:definitionId/:definitionObjectType/:id',
            templateUrl: qmcBase + '/stammdaten/detail/udf',
            controller: 'DetailUdfController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten UDF');
                    }]
            }
        })
            // misc
            .state('globalDocuments', {
            url: '/globalDocuments',
            templateUrl: qmcBase + '/stammdaten/globaldocuments/List',
            controller: 'GlobalDocumentsListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten GlobalDocuments');
                    }]
            }
        })
            .state('orgaAccountingBooks', {
            url: '/orgaAccountingBooks',
            templateUrl: qmcBase + '/stammdaten/orgaAccountingBooks/List',
            controller: 'OrgaAccountingBooksListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten Organsations Accounting Books');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        class HttpProvider {
            static configureHttpProvider($httpProvider) {
                // initialize get if not there
                if (!$httpProvider.defaults.headers.get) {
                    $httpProvider.defaults.headers.get = {};
                }
                // disable IE ajax request caching
                $httpProvider.defaults.headers.get['If-Modified-Since'] = 'Mon, 26 Jul 1997 05:00:00 GMT';
                // extra
                $httpProvider.defaults.headers.get['Cache-Control'] = 'no-cache';
                $httpProvider.defaults.headers.get['Pragma'] = 'no-cache';
            }
        }
        Stammdaten.HttpProvider = HttpProvider;
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
(() => {
    angular.module('QMC.Stammdaten')
        .config(['$httpProvider', QMC.Stammdaten.HttpProvider.configureHttpProvider]);
})();
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        var StammdatenService_1;
        let StammdatenService = StammdatenService_1 = class StammdatenService extends QMC.Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.modulePath = '/Stammdaten';
            }
            /***** Check for warnings and errors related to the social insurance number *****/
            getPersonValidation(dataPersonValidation) {
                return super.post('/Person/WarningsAndErrors', dataPersonValidation).then((dataResult) => {
                    return dataResult;
                });
            }
            getParticipantsSelectionAssignment(key, addEmptyItem = false) {
                return super.getItem("/Person/PeopleSelectionAssignment/" + key, { addEmptyItem: addEmptyItem }, (data) => {
                    return data;
                });
            }
            /***** Doctor *****/
            getDoctorList() {
                return super.get('/Person/Doctor', {}, (data) => {
                    return data;
                });
            }
            getMedicalOrganisationList() {
                return super.get('/Person/MedicalOrganisation', {}, (data) => {
                    return data;
                });
            }
            /***** Address *****/
            getAddressList(parentObjectId) {
                return super.get(this.modulePath + '/Address/' + parentObjectId, {}, (data) => {
                    return data;
                });
            }
            getAddress(parentObjectId, id) {
                return super.get(this.modulePath + '/Address/' + parentObjectId + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getAddressWv() {
                return super.getItem(this.modulePath + '/Address/WvModel', {}, (data) => {
                    return data;
                });
            }
            getStatesWv(id) {
                return super.get(this.modulePath + '/Address/StatesWv/' + id, {}, (data) => {
                    return data;
                });
            }
            getCityByPostCodeList(countryId, searchPostCode) {
                return super.get(this.modulePath + '/Address/CitiesByPostCode/' + countryId + '/' + searchPostCode, {}, (data) => {
                    return data;
                });
            }
            getPostCodeByCityList(countryId, searchCity) {
                return super.get(this.modulePath + '/Address/PostCodesByCity/' + countryId + '/' + searchCity, {}, (data) => {
                    return data;
                });
            }
            postAddress(data) {
                return super.post(this.modulePath + '/Address', data).then((d) => {
                    return d;
                });
            }
            putAddress(parentObjectId, id, data) {
                return super.put(this.modulePath + '/Address/' + parentObjectId + '/' + id, data).then((data) => {
                    console.log(data);
                    return data;
                });
            }
            deleteAddress(parentObjectId, id) {
                return super.delete(this.modulePath + '/Address/' + parentObjectId + '/' + id).then((e) => {
                    return e;
                });
            }
            /***** Admission *****/
            getAdmissionList(parentObjectId) {
                return super.get('/Client/AdmissionDismissal/Admission/' + parentObjectId, {}, (data) => {
                    return data;
                });
            }
            getAdmission(parentObjectId, id) {
                return super.getItem('/Client/AdmissionDismissal/Admission/' + parentObjectId + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getAdmissionWv() {
                return super.getItem('/Client/AdmissionDismissal/Admission/WvModel', {}, (data) => {
                    return data;
                });
            }
            getAdmissionFieldInfo() {
                return super.getItem('/Client/AdmissionDismissal/Admission/FieldInfo', {}, (data) => {
                    return data;
                });
            }
            getAdmissionRequiredFields() {
                return super.getItem('/Client/AdmissionDismissal/Admission/RequiredFields', {}, (data) => {
                    return data;
                });
            }
            postAdmission(parentObjectId, data) {
                return super.post('/Client/AdmissionDismissal/Admission/' + parentObjectId, data).then((d) => {
                    return d;
                });
            }
            putAdmission(parentObjectId, id, data) {
                return super.put('/Client/AdmissionDismissal/Admission/' + parentObjectId + '/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteAdmission(parentObjectId, id) {
                return super.delete('/Client/AdmissionDismissal/Admission/' + parentObjectId + '/' + id).then((e) => {
                    return e;
                });
            }
            validateAdmission(dataAdmissionValidation) {
                return super.post('/Client/AdmissionDismissal/Admission/WarningsAndErrors', dataAdmissionValidation).then((dataResult) => {
                    return dataResult;
                });
            }
            /***** AccountingBook *****/
            checkForWarningsAndErrors(data) {
                return super.post(this.modulePath + '/AccountingBook/WarningsAndErrors', data).then((data) => {
                    return data;
                });
            }
            getAccountingBooks() {
                return super.get(this.modulePath + '/AccountingBook/', {}, (data) => {
                    return data;
                });
            }
            getAccountingBookList(parentId) {
                return super.get(this.modulePath + '/AccountingBook/' + parentId, {}, (data) => {
                    return data;
                });
            }
            getAccountingBook(parentObjectid, bookId, dateFrom, dateTo) {
                return super.getItem(this.modulePath + '/AccountingBook/' + parentObjectid + "/" + bookId, { dateFrom: dateFrom, dateTo: dateTo }, (data) => {
                    return data;
                });
            }
            postAccountingBook(data) {
                return super.post(this.modulePath + '/AccountingBook', data).then((d) => {
                    return d;
                });
            }
            postAccountingBookEntry(data) {
                return super.post(this.modulePath + '/AccountingBook/Entry', data).then((d) => {
                    return d;
                });
            }
            putAccountingBook(parentObjectId, id, data) {
                return super.put(this.modulePath + '/AccountingBook/' + parentObjectId + '/' + id, data).then((data) => {
                    return data;
                });
            }
            putAccountingBookEntry(id, data) {
                return super.put(this.modulePath + '/AccountingBook/Entry/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteAccountingBook(parentObjectId, id) {
                return super.delete(this.modulePath + '/AccountingBook/' + parentObjectId + '/' + id).then((e) => {
                    return e;
                });
            }
            deleteAccountingBookEntry(bookId, id) {
                return super.delete(this.modulePath + '/AccountingBook/Entry/' + bookId + '/' + id).then((e) => {
                    return e;
                });
            }
            getAccountingBookWv() {
                return super.getItem(this.modulePath + '/AccountingBook/WvModel', {}, (data) => {
                    return data;
                });
            }
            getAccountingBookWvForCountry(id) {
                return super.getItem(this.modulePath + '/AccountingBook/WvModel/' + id, {}, (data) => {
                    return data;
                });
            }
            getAccountingBookUserConfig() {
                return super.getItem(this.modulePath + '/AccountingBook/UserConfig', {}, (data) => {
                    return data;
                });
            }
            getAccountingBookReferences() {
                //const cacheName = 'AccountingBookReferenceCache';
                //const cacheContent = sessionStorage.getItem(cacheName);
                //if (cacheContent) {
                //	return this.$q((resolve, reject) => {
                //		try {
                //			resolve(JSON.parse(cacheContent));
                //		}
                //		catch (e) {
                //			console.log('failed cache parsing for AccountingBookReferences', e);
                //			reject([]);
                //		}
                //	});
                //}
                return super.get("/Person/PeopleSelectionAssignment/KASSENBUCHDATENBEZUG.PERSONENTYP", {}, (data) => {
                    //sessionStorage.setItem(cacheName, JSON.stringify(data));
                    return data;
                });
            }
            /***** Authority *****/
            getAuthorityList() {
                return super.get('/Person/Authority', {}, (data) => {
                    return data;
                });
            }
            getAuthorityContactList() {
                return super.get('/Person/Authority/Contact', {}, (data) => {
                    return data;
                });
            }
            /***** Connect *****/
            isConnectRegistrationAvailable() {
                return super.getItem("/Connect/RegistrationAvailable", {}, (data) => data);
            }
            getConnectRegistrationUrl(careReceiverId, connectUserId) {
                return super.getItem(`/Connect/RegistrationUrl/${careReceiverId}`, { connectUserId }, (result) => result.url);
            }
            /***** Checklist *****/
            getChecklistList(referenceType) {
                return super.get(this.modulePath + '/Checklist/', { referenceType }, (data) => {
                    return data;
                });
            }
            getChecklistItemList(parentObjectId, checklistId) {
                return super.get(this.modulePath + '/Checklist/Items/' + parentObjectId + '/' + checklistId, {}, (data) => {
                    return data;
                });
            }
            getChecklistItem(parentObjectId, checklistId, itemid) {
                return super.getItem(this.modulePath + `/Checklist/Items/${parentObjectId}/${checklistId}/${itemid}`, {}, (data) => {
                    return data;
                });
            }
            postCheckedItem(parentObjectId, data) {
                return super.post(`${this.modulePath}/Checklist/Items/${parentObjectId}`, data).then((data) => {
                    return data;
                });
            }
            putCheckedItem(parentObjectId, itemId, data) {
                return super.put(`${this.modulePath}/Checklist/Items/${parentObjectId}/${itemId}`, data).then((data) => {
                    return data;
                });
            }
            deleteCheckedItems(parentObjectId, itemId) {
                return super.delete(`${this.modulePath}/Checklist/Items/${parentObjectId}/${itemId}`).then((data) => {
                    return data;
                });
            }
            deleteCheckedItem(parentObjectId, itemId, id) {
                return super.delete(`${this.modulePath}/Checklist/Items/${parentObjectId}/${itemId}/${id}`).then((data) => {
                    return data;
                });
            }
            /***** Communication *****/
            getCommunicationList(parentObjectId) {
                return super.get(this.modulePath + '/Communication/' + parentObjectId, {}, (data) => {
                    return data;
                });
            }
            getCommunication(parentObjectId, id) {
                return super.get(this.modulePath + '/Communication/' + parentObjectId + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getCommunicationWv() {
                return super.getItem(this.modulePath + '/Communication/WvModel', {}, (data) => {
                    return data;
                });
            }
            postCommunication(data) {
                return super.post(this.modulePath + '/Communication', data).then((data) => {
                    return data;
                });
            }
            putCommunication(parentObjectId, id, data) {
                return super.put(this.modulePath + '/Communication/' + parentObjectId + '/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteCommunication(parentObjectId, id) {
                return super.delete(this.modulePath + '/Communication/' + parentObjectId + '/' + id).then((data) => {
                    return data;
                });
            }
            /***** Society (VEREIN) *****/
            getSocietyListItem() {
                return super.get('/Person/Society/', {}, (data) => {
                    return data;
                });
            }
            /***** Contact Person *****/
            getContactPersonList(parentObjectId, categoryId, contactPersonStatusId) {
                let additionalParams = "";
                if (categoryId !== null)
                    additionalParams += "?categoryId=" + categoryId;
                if (contactPersonStatusId !== null) {
                    if (categoryId !== null)
                        additionalParams += "&activeStatusId=" + contactPersonStatusId;
                    else
                        additionalParams += "?activeStatusId=" + contactPersonStatusId;
                }
                return super.get(this.modulePath + '/ContactPerson/' + parentObjectId + additionalParams, {}, (data) => {
                    return data;
                });
            }
            getContactPersonWvList() {
                return super.getItem(this.modulePath + '/ContactPerson/WvModel', {}, (data) => {
                    return data;
                });
            }
            getContactPersonCategories() {
                return super.get(this.modulePath + '/ContactPerson/Category', {}, (data) => {
                    return data;
                });
            }
            getContactPerson(parentObjectId, id) {
                return super.get(this.modulePath + '/ContactPerson/' + parentObjectId + '/' + id, {}, (data) => {
                    return data;
                });
            }
            postContactPerson(data) {
                return super.post(this.modulePath + '/ContactPerson', data).then((data) => {
                    return data;
                });
            }
            putContactPerson(parentObjectId, id, data) {
                return super.put(this.modulePath + '/ContactPerson/' + parentObjectId + '/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteContactPerson(parentObjectId, id) {
                return super.delete(this.modulePath + '/ContactPerson/' + parentObjectId + '/' + id).then((data) => {
                    return data;
                });
            }
            validateContactPersonDeletion(referenceId, referenceObjectId) {
                return super.post(`${this.modulePath}/ContactPerson/DeletionValidation`, { contactPersonId: referenceId, contactPersonObjId: referenceObjectId }).then((data) => {
                    return data;
                });
            }
            /***** Dismissal *****/
            getDismissalList(parentObjectId) {
                return super.get('/Client/AdmissionDismissal/Dismissal/' + parentObjectId, {}, (data) => {
                    return data;
                });
            }
            getDismissal(parentObjectId, id) {
                return super.getItem('/Client/AdmissionDismissal/Dismissal/' + parentObjectId + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getDismissalWv() {
                return super.getItem('/Client/AdmissionDismissal/Dismissal/WvModel', {}, (data) => {
                    return data;
                });
            }
            getDismissalRequiredFields() {
                return super.getItem('/Client/AdmissionDismissal/Dismissal/RequiredFields', {}, (data) => {
                    return data;
                });
            }
            postDismissal(parentObjectId, data) {
                return super.post('/Client/AdmissionDismissal/Dismissal/' + parentObjectId, data).then((d) => {
                    return d;
                });
            }
            putDismissal(parentObjectId, id, data) {
                return super.put('/Client/AdmissionDismissal/Dismissal/' + parentObjectId + '/' + id, data).then((data) => {
                    console.log(data);
                    return data;
                });
            }
            deleteDismissal(parentObjectId, id) {
                return super.delete('/Client/AdmissionDismissal/Dismissal/' + parentObjectId + '/' + id).then((e) => {
                    return e;
                });
            }
            /***** Training ****/
            getTrainingList(parentObjectId, parentObjectType) {
                return super.get(this.modulePath + '/Training/' + parentObjectId + '/' + parentObjectType, {}, (data) => {
                    return data;
                });
            }
            getTraining(parentObjectId, id) {
                return super.getItem(this.modulePath + '/Training/' + parentObjectId + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getTrainingWvList() {
                return super.getItem(this.modulePath + '/Training/WvModel', {}, (data) => {
                    return data;
                });
            }
            postTraining(data) {
                return super.post(this.modulePath + '/Training', data).then((data) => {
                    return data;
                });
            }
            putTraining(parentObjectId, id, data) {
                return super.put(this.modulePath + '/Training/' + parentObjectId + '/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteTraining(parentObjectId, id) {
                return super.delete(this.modulePath + '/Training/' + parentObjectId + '/' + id).then((data) => {
                    return data;
                });
            }
            /***** Education ****/
            getEducationList(parentObjectId) {
                return super.get(this.modulePath + '/Education/' + parentObjectId, {}, (data) => {
                    return data;
                });
            }
            getCompaniesList() {
                return super.get('/Person/Company', {}, (data) => {
                    return data;
                });
            }
            getSchoolsList() {
                return super.get('/Person/School', {}, (data) => {
                    return data;
                });
            }
            getGradeLevelList(parentObjectId) {
                return super.get('/Person/School/GradeLevel/' + parentObjectId, {}, (data) => {
                    return data;
                });
            }
            getEducation(parentObjectId, id, educationKind) {
                return super.getItem(this.modulePath + '/Education/' + parentObjectId + '/' + id + '/' + educationKind, {}, (data) => {
                    return data;
                });
            }
            getEducationWvList() {
                return super.getItem(this.modulePath + '/Education/WvModel', {}, (data) => {
                    return data;
                });
            }
            postEducation(data) {
                return super.post(this.modulePath + '/Education', data).then((data) => {
                    return data;
                });
            }
            putEducation(parentObjectId, id, data) {
                return super.put(this.modulePath + '/Education/' + parentObjectId + '/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteEducation(parentObjectId, id, educationKind) {
                return super.delete(this.modulePath + '/Education/' + parentObjectId + '/' + id + '/' + educationKind).then((data) => {
                    return data;
                });
            }
            /***** Disease ****/
            getDiseaseRequiredFields() {
                return super.getItem(this.modulePath + '/Disease/RequiredFields/', {}, (data) => {
                    return data;
                });
            }
            getDiseaseList(parentObjectId) {
                return super.get(this.modulePath + '/Disease/' + parentObjectId, {}, (data) => {
                    return data;
                });
            }
            getDisease(parentObjectId, id) {
                return super.get(this.modulePath + '/Disease/' + parentObjectId + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getDiseaseWvList() {
                return super.getItem(this.modulePath + '/Disease/WvModel', {}, (data) => {
                    return data;
                });
            }
            getDiseasesBySearchText(codeSchemaWvId, searchText) {
                return super.get(this.modulePath + '/Disease/Base/MatchSearchText/' + codeSchemaWvId + '/' + searchText, { pageSize: 30 }, (data) => {
                    return data;
                });
            }
            postDisease(data) {
                return super.post(this.modulePath + '/Disease', data).then((data) => {
                    return data;
                });
            }
            putDisease(parentObjectId, id, data) {
                return super.put(this.modulePath + '/Disease/' + parentObjectId + '/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteDisease(parentObjectId, id) {
                return super.delete(this.modulePath + '/Disease/' + parentObjectId + '/' + id).then((data) => {
                    return data;
                });
            }
            /***** Legal *****/
            getLegalList(parentObjectId) {
                return super.get(this.modulePath + '/Legal/' + parentObjectId, {}, (data) => {
                    return data;
                });
            }
            getLegal(parentObjectId, id) {
                return super.getItem(this.modulePath + '/Legal/' + parentObjectId + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getLegalWvList() {
                return super.getItem(this.modulePath + '/Legal/WvModel', {}, (data) => {
                    return data;
                });
            }
            postLegal(data) {
                return super.post(this.modulePath + '/Legal', data).then((data) => {
                    return data;
                });
            }
            putLegal(parentobjectId, id, data) {
                return super.put(this.modulePath + '/Legal/' + parentobjectId + '/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteLegal(parentObjectId, id) {
                return super.delete(this.modulePath + '/Legal/' + parentObjectId + '/' + id).then((data) => {
                    return data;
                });
            }
            /***** Doctors Visit *****/
            getDoctorsVisitList(parentObjectId) {
                return super.get(this.modulePath + '/DoctorsVisit/' + parentObjectId, {}, (data) => {
                    return data;
                });
            }
            getDoctorsVisit(parentObjectId, id) {
                return super.getItem(this.modulePath + '/DoctorsVisit/' + parentObjectId + '/' + id, {}, (data) => {
                    return data;
                });
            }
            postDoctorsVisit(data) {
                return super.post(this.modulePath + '/DoctorsVisit', data).then((data) => {
                    return data;
                });
            }
            putDoctorsVisit(parentObjectId, id, data) {
                return super.put(this.modulePath + '/DoctorsVisit/' + parentObjectId + '/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteDoctorsVisit(parentObjectId, id) {
                return super.delete(this.modulePath + '/DoctorsVisit/' + parentObjectId + '/' + id).then((data) => {
                    return data;
                });
            }
            /**** Notes *****/
            getNote(parentObjectId) {
                return super.getItem('/Client/Note/' + parentObjectId, {}, (data) => {
                    return data;
                });
            }
            putNote(parentObjectId, data) {
                return super.put('/Client/Note/' + parentObjectId, data).then((data) => {
                    return data;
                });
            }
            /***** Vaccination *****/
            getVaccinationList(parentObjectId) {
                return super.get(this.modulePath + '/Vaccination/' + parentObjectId, {}, (data) => {
                    return data;
                });
            }
            getVaccination(parentObjectId, id) {
                return super.get(this.modulePath + '/Vaccination/' + parentObjectId + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getVaccinationWv() {
                return super.getItem(this.modulePath + '/Vaccination/WvModel', {}, (data) => {
                    return data;
                });
            }
            postVaccination(data) {
                return super.post(this.modulePath + '/Vaccination', data).then((data) => {
                    return data;
                });
            }
            putVaccination(parentObjectId, id, data) {
                return super.put(this.modulePath + '/Vaccination/' + parentObjectId + '/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteVaccination(parentObjectId, id) {
                return super.delete(this.modulePath + '/Vaccination/' + parentObjectId + '/' + id).then((data) => {
                    return data;
                });
            }
            /***** Hobby *****/
            getHobbyRequiredFields() {
                return super.getItem(this.modulePath + '/Hobby/' + "/RequiredFields", {}, (data) => {
                    return data;
                });
            }
            getHobbyList(parentObjectId) {
                return super.get(this.modulePath + '/Hobby/' + parentObjectId, {}, (data) => {
                    return data;
                });
            }
            getHobby(parentObjectId, id) {
                return super.getItem(this.modulePath + '/Hobby/' + parentObjectId + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getHobbyWv() {
                return super.getItem(this.modulePath + '/Hobby/WvModel', {}, (data) => {
                    return data;
                });
            }
            postHobby(data) {
                return super.post(this.modulePath + '/Hobby', data).then((data) => {
                    return data;
                });
            }
            putHobby(parentObjectId, id, data) {
                return super.put(this.modulePath + '/Hobby/' + parentObjectId + '/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteHobby(parentObjectId, id) {
                return super.delete(this.modulePath + '/Hobby/' + parentObjectId + '/' + id).then((data) => {
                    return data;
                });
            }
            /***** Documents ****/
            getDocumentsUserConfig() {
                return super.getItem('/Document/UserConfig', {}, (data) => {
                    return data;
                });
            }
            getDocumentList(parentObjectId) {
                return super.get('/Document/' + parentObjectId, {}, (data) => {
                    return data;
                });
            }
            getDocument(parentObjectId, id) {
                return super.getItem('/Document/' + parentObjectId + '/' + id, {}, (data) => {
                    return data;
                });
            }
            downloadAttachment(documentId, attachmentId) {
                return super.getItem('/Document/Media/' + documentId + '/' + attachmentId, {}).then((data) => {
                    return data;
                });
            }
            postNewDocument(data) {
                return super.post('/Document', data).then((data) => {
                    return data;
                });
            }
            editDocument(parentObjectId, id, data) {
                return super.put('/Document/' + parentObjectId + '/' + id, data).then((data) => {
                    return data;
                });
            }
            addFileToDocument(data) {
                return super.post('/Document/Media', data).then((data) => {
                    return data;
                });
            }
            deleteDocument(parentObjectId, id) {
                return super.delete('/Document/' + parentObjectId + '/' + id).then((e) => {
                    return e;
                });
            }
            deleteFile(documentId, id) {
                return super.delete('/Document/Media/' + documentId + "/" + id).then((e) => {
                    return e;
                });
            }
            getDocumentWV() {
                return super.cachedGetItem('/Document/WvModel', {}, (data) => {
                    return data;
                });
            }
            getDocumentMappingForObjecttype(type) {
                return super.cachedGetItem(`/Document/Media/DocumentMapping/${type}`).then(data => data);
            }
            /***** Absenteeism *****/
            getAbsenteeismList(parentObjectId) {
                return super.get(this.modulePath + '/Absenteeism/' + parentObjectId, {}, (data) => {
                    return data;
                });
            }
            getAbsenteeismBanList(clientId) {
                return super.get(this.modulePath + '/Absenteeism/Bans/' + clientId, {}, (data) => {
                    return data;
                });
            }
            getAbsenteeism(parentObjectId, id) {
                return super.getItem(this.modulePath + '/Absenteeism/' + parentObjectId + '/' + id, {}, (data) => {
                    return data;
                });
            }
            postAbsenteeism(data) {
                return super.post(this.modulePath + '/Absenteeism', data).then((data) => {
                    return data;
                });
            }
            putAbsenteeism(parentObjectId, id, data) {
                return super.put(this.modulePath + '/Absenteeism/' + parentObjectId + '/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteAbsenteeism(parentObjectId, id) {
                return super.delete(this.modulePath + '/Absenteeism/' + parentObjectId + '/' + id).then((data) => {
                    return data;
                });
            }
            getAbsenteeismWv() {
                return super.cachedGetItem(this.modulePath + '/Absenteeism/WvModel', {}, (data) => {
                    return data;
                });
            }
            /***** Check for warnings and errors *****/
            checkAbsenteeismValidation(dataAbsenteeismValidation) {
                return super.post(this.modulePath + '/Absenteeism/WarningsAndErrors', dataAbsenteeismValidation).then((dataResult) => {
                    return dataResult;
                });
            }
            getClientImage(clientId, thumbnail, objectType = 140031) {
                if (clientId === undefined)
                    return null;
                const thumbnailString = thumbnail ? 'true' : 'false';
                const key = 'avatar:client:' + clientId + ':' + thumbnailString + ':' + objectType;
                return this.getCached(key, () => super.getItem('/Media/Image/MainImage', { parentObjectId: clientId, getThumbnail: thumbnailString, objectType: objectType }, (data) => data), { ttlMs: StammdatenService_1.AVATAR_CACHE_TTL_MS, maxSizeInBytes: StammdatenService_1.AVATAR_CACHE_MAX_SIZE_IN_BYTES });
            }
            getAvatarByName(foreName, name) {
                if (foreName === "" || name === "")
                    return null;
                const key = 'avatar:name:' + foreName + ':' + name;
                return this.getCached(key, () => super.getItem('Media/Image/CreateAvatar', { foreName: foreName, name: name }, (data) => data), { ttlMs: StammdatenService_1.AVATAR_CACHE_TTL_MS, maxSizeInBytes: StammdatenService_1.AVATAR_CACHE_MAX_SIZE_IN_BYTES });
            }
            getClientImageList(clientIds, thumbnail, objectType = 140031) {
                if (clientIds !== undefined) {
                    console.log("ids", clientIds);
                    const thumbnailString = thumbnail ? 'true' : 'false';
                    return super.get('Media/Image/MainImageList', { objectIdList: clientIds, getThumbnail: thumbnailString, objectType: objectType }, (data) => {
                        return data;
                    });
                }
            }
            /***** GlobalDocuments *****/
            getGlobalDocumentList(dateFrom, dateTo, showOnlyGlobal, referenceObjectType, page, pageSize, searchString, searchProperties = [], sortBy = '', sortDescending = false) {
                return super.getPagination('/GlobalDocuments', { dateFrom: dateFrom, dateTo: dateTo, showOnlyGlobal: showOnlyGlobal, referenceObjectType, page: page, pageSize: pageSize, listSearch: searchString, searchProperties, sortBy, sortDecending: sortDescending }, (data) => {
                    return data;
                });
            }
            getGlobalDocumentReferences() {
                return super.get('/GlobalDocuments/References', {}, (data) => {
                    return data;
                });
            }
            getGlobalDocumentFile(id) {
                return super.getItem('/GlobalDocuments/Media/' + id, {}).then((data) => {
                    return data === null || data === void 0 ? void 0 : data.base64;
                });
            }
            postGlobalDocument(data) {
                return super.post('/GlobalDocuments', data).then((data) => {
                    return data;
                });
            }
            deleteGlobalDocument(document) {
                //return super.delete('/GlobalDocuments/' + document.grandParentId + "/" + document.parentId + "/" + document.objectId).then((e) => {
                return super.delete('/GlobalDocuments/' + document.objectId).then((e) => {
                    return e;
                });
            }
            /***** MedicalEvidence ****/
            getMedicalEvidenceList(parentObjectId) {
                return super.get(this.modulePath + '/MedicalEvidence/' + parentObjectId, {}, (data) => {
                    return data;
                });
            }
            getMedicalEvidence(parentObjectId, id) {
                return super.getItem(this.modulePath + '/MedicalEvidence/' + parentObjectId + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getMedicalEvidenceWvList() {
                return super.getItem(this.modulePath + '/MedicalEvidence/WvModel', {}, (data) => {
                    return data;
                });
            }
            postMedicalEvidence(data) {
                return super.post(this.modulePath + '/MedicalEvidence', data).then((data) => {
                    return data;
                });
            }
            putMedicalEvidence(parentObjectId, id, data) {
                return super.put(this.modulePath + '/MedicalEvidence/' + parentObjectId + '/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteMedicalEvidence(parentObjectId, id) {
                return super.delete(this.modulePath + '/MedicalEvidence/' + parentObjectId + '/' + id).then((data) => {
                    return data;
                });
            }
            getMedicalEvidenceExecutioners() {
                return super.get("/Person/PeopleSelectionAssignment/MedNachweisDurchfuehrender", {}, (data) => {
                    return data;
                });
            }
            /***** MedicationResponsible / Medication Issued Through ****/
            getMedicationResponsibleMedicatioThroughList(parentObjectId, assignmentType) {
                return super.get(this.modulePath + '/MedicalResponsible/' + parentObjectId + '/' + assignmentType, {}, (data) => {
                    return data;
                });
            }
            getMedResponsibleIssuedThroughItem(parentObjectId, id) {
                return super.getItem(this.modulePath + '/MedicalResponsible/' + parentObjectId + '/' + id, {}, (data) => {
                    return data;
                });
            }
            postMedResponsibleIssuedThroughItem(data) {
                return super.post(this.modulePath + '/MedicalResponsible', data).then((data) => {
                    return data;
                });
            }
            putMedResponsibleIssuedThroughItem(parentObjectId, id, data) {
                return super.put(this.modulePath + '/MedicalResponsible/' + parentObjectId + '/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteMedResponsibleIssuedThroughItem(parentObjectId, assignmentType, id) {
                return super.delete(this.modulePath + '/MedicalResponsible/' + parentObjectId + '/' + assignmentType + '/' + id).then((data) => {
                    return data;
                });
            }
            /***** TempInstituteChange ****/
            getTempInstituteChangeList(parentObjectId) {
                return super.get(this.modulePath + '/TempInstituteChange/' + parentObjectId, {}, (data) => {
                    return data;
                });
            }
            getTempInstituteChange(parentObjectId, id) {
                return super.getItem(this.modulePath + '/TempInstituteChange/' + parentObjectId + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getTempInstituteChangeWvList() {
                return super.getItem(this.modulePath + '/TempInstituteChange/WvModel', {}, (data) => {
                    return data;
                });
            }
            postTempInstituteChange(data) {
                return super.post(this.modulePath + '/TempInstituteChange', data).then((data) => {
                    return data;
                });
            }
            putTempInstituteChange(parentObjectId, id, data) {
                return super.put(this.modulePath + '/TempInstituteChange/' + parentObjectId + '/' + id, data).then((data) => {
                    return data;
                });
            }
            deleteTempInstituteChange(parentObjectId, id) {
                return super.delete(this.modulePath + '/TempInstituteChange/' + parentObjectId + '/' + id).then((data) => {
                    return data;
                });
            }
            /***** Organisation *****/
            getOrganisationList() {
                return super.get('/Person/Organisation').then((data) => {
                    return data;
                });
            }
            getOrganisationForPerson(personId) {
                return super.getItem('/Person/Organisation/' + personId, {}, (data) => {
                    return data;
                });
            }
            /***** ReweCommon *****/
            getReweNumber(objectType, referenceId) {
                return super.get('/ReweCommon/ReweNumber', { objectType: objectType, referenceId: referenceId }, (data) => {
                    return data;
                });
            }
        };
        /***** Media *****/
        StammdatenService.AVATAR_CACHE_TTL_MS = 20 * 60 * 1000; // 20 minutes
        /** Keep moderate: avatar images are base64 (large bytes per entry). Cache evicts oldest by count; BaseService.getCached also supports maxSizeInBytes if needed. */
        StammdatenService.AVATAR_CACHE_MAX_SIZE_IN_BYTES = 10 * 1024 * 1024; // 10 MB
        StammdatenService = StammdatenService_1 = __decorate([
            QMC.Service('QMC.Stammdaten', 'StammdatenService'),
            QMC.Inject('$http', '$q')
        ], StammdatenService);
        Stammdaten.StammdatenService = StammdatenService;
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let StammdatenClientListController = class StammdatenClientListController {
            /**
             * Creates an instance of StammdatenClientListController.
             * @param {StammdatenService} stammdatenService
             * @param {any} $qui
             * @param {Klient.KlientService} clientService
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {any} $state
             *
             * @memberOf StammdatenClientListController
             */
            constructor($location, stammdatenService, $qui, clientService, $stateParams, $scope, $state, userService, permissionService) {
                this.$location = $location;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$state = $state;
                this.userService = userService;
                this.permissionService = permissionService;
                this.ui = new QMC.Stammdaten.UserInterface();
                this.allowTableExport = false;
                this.page = 0;
                this.filter = {
                    searchText: "",
                    searchId: QMC.Common.Constants.DEFAULT_CLIENT_PREDEFINED_SEARCH_ID,
                    showActiveOnly: false
                };
                this.sortBy = '';
                this.sortDescending = false;
                this.afterClientSave = () => {
                    this.getData();
                };
                this.onSort = (sortBy, sortDescending) => {
                    this.sortBy = sortBy;
                    this.sortDescending = sortDescending;
                    this.page = 0;
                    this.getData();
                };
                this.clientListSchema = {
                    "config": {
                        "tableRowLink": "#/stammdaten/detail/{{id}}/cover/{{id}}",
                    },
                    "table": {
                        "Bild": {
                            "label": "id",
                            "dType": "Avatar",
                            "name": "name",
                            "href": "#/stammdaten/detail/{{id}}/cover/{{id}}",
                            "forename": "forename"
                        },
                        "Name": {
                            "label": "name",
                            "dType": "string",
                            "lngTag": "20000072"
                        },
                        "Vorname": {
                            "label": "forename",
                            "dType": "string",
                            "lngTag": "20000057"
                        },
                        "Kürzel": {
                            "label": "shortCaption",
                            "dType": "string",
                            "lngTag": "20000221"
                        },
                        "Nummer": {
                            "label": "clientNumber",
                            "dType": "string",
                            "lngTag": "20000316"
                        },
                        "Stammhaus": {
                            "label": "actualInstitution",
                            "dType": "string",
                            "lngTag": "20000031"
                        },
                        "Geburtsdatum": {
                            "label": "birthday",
                            "dType": "Date",
                            "lngTag": "21002004"
                        },
                    },
                    "card": {
                        "avatar": {
                            "name": "name",
                            "forename": "forename",
                            "label": "id",
                            "href": "#/stammdaten/detail/{{id}}/cover/{{id}}",
                        },
                        "text": {
                            "label": ["name", "forename"],
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "shortCaption",
                                "dType": "string"
                            },
                            {
                                "label": "clientNumber",
                                "dType": "string"
                            },
                            {
                                "label": "actualInstitution",
                                "dType": "string"
                            },
                            {
                                "label": "birthday",
                                "dType": "Date",
                            }
                        ],
                        "buttons": []
                    },
                    "data": []
                };
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $('.qm-card').unbind('click');
                    this.events();
                });
                if (document.getElementById("permissions").getAttribute("client").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module client");
                    this.forbidden = true;
                    return;
                }
                permissionService.getPermissionsByObjectTypes([140000]).then((data) => {
                    this.allowTableExport = data[0].print;
                    this.newPermission = data[0].new;
                });
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.fullClientList = [];
                this.cards = QMC.Common.Constants.IS_MOBILE;
                this.mobile = QMC.Common.Constants.IS_MOBILE;
                this.getFilterFromStorage();
                if ($('#session').data('data-stammdaten-grid') === ('false' || false))
                    this.cards = true;
                this.$qui.getTableAutoload(this.userService).then((ltd) => {
                    this.shouldLoadTableData = ltd;
                    if (this.shouldLoadTableData) {
                        this.getClients(this.filter.searchId, this.page);
                    }
                });
                let isFirstLoad = true;
                setTimeout(() => {
                    isFirstLoad = false;
                }, 250);
                $scope.$watch('vm.filter.searchId', (newValue, oldValue) => {
                    if (!isFirstLoad && newValue != oldValue && this.shouldLoadTableData) {
                        this.page = 0;
                        this.getData();
                    }
                });
                $scope.$watch('vm.filter.showActiveOnly', (newValue, oldValue) => {
                    if (newValue != oldValue && this.shouldLoadTableData) {
                        this.toggleShowActiveOnly();
                    }
                });
                $scope.$watch('vm.filter.searchText', (newValue, oldValue) => {
                    if (newValue != oldValue) {
                        if (isFirstLoad) {
                            setTimeout(() => {
                                isFirstLoad = false;
                            }, 5);
                        }
                        else if (this.shouldLoadTableData) {
                            let lastValue = this.filter.searchText;
                            setTimeout(() => {
                                if (this.filter.searchText === lastValue && (newValue.length < oldValue.length || this.filter.searchText.length >= 3)) {
                                    this.page = 0;
                                    this.getData();
                                }
                            }, 1500);
                        }
                    }
                });
                $scope.$watch('vm.page', (newValue, oldValue) => {
                    if (newValue != oldValue)
                        if (isFirstLoad) {
                            setTimeout(() => {
                                isFirstLoad = false;
                            }, 5);
                        }
                        else {
                            this.getData();
                        }
                });
                // Get data
                this.getSearchValues();
            }
            /**
             * register view events
             *
             * @private
             *
             * @memberOf StammdatenClientListController
             */
            events() {
            }
            getClients(searchId, page) {
                if (searchId === (undefined || null))
                    searchId = QMC.Common.Constants.DEFAULT_CLIENT_PREDEFINED_SEARCH_ID;
                this.page = page;
                this.loading = true;
                this.clientListSchema.data = [];
                this.setFilterToStorage();
                this.clientService.getClientListByPredefinedSearch(searchId, page, 30, this.filter.searchText, this.filter.showActiveOnly, ['name', 'forename', 'shortCaption', 'clientNumber', 'actualInstitution', 'birthday'], this.sortBy, this.sortDescending).then((data) => {
                    this.clientListSchema.data = data.items;
                    this.pagination = data.paginationInfo;
                    $('.qm-card').unbind('click');
                    this.loading = false;
                    this.$qui.functionWaiter("createTable", this);
                });
            }
            /**
             * search clients by a search value
             *
             * @private
             *
             * @memberOf StammdatenClientListController
             */
            getSearchValues() {
                this.loading = true;
                this.clientService.getPredefinedSearches().then((data) => {
                    this.searchValues = data;
                    this.searchValuesMap = this.$qui.selectAutoMap(data, 'id', 'caption');
                    this.loading = false;
                });
            }
            toggleShowActiveOnly() {
                this.setFilterToStorage();
                if (this.shouldLoadTableData)
                    this.getClients(this.filter.searchId, this.page);
            }
            /**
             * get a filtered list of clients
             *
             * @private
             *
             * @memberOf StammdatenClientListController
             */
            getData() {
                this.getClients(this.filter.searchId, this.page);
            }
            setFilterToStorage() {
                QMC.Common.personalLocalStorage.setItem('client-list-settings', JSON.stringify(this.filter));
            }
            getFilterFromStorage() {
                var store = QMC.Common.personalLocalStorage.getItem('client-list-settings');
                if (store == (null || undefined))
                    return;
                this.filter = JSON.parse(store);
            }
            /**
             * toggle the between card and table view
             *
             * @private
             *
             * @memberOf StammdatenClientListController
             */
            changeTableView() {
                this.cards = !this.cards;
                $('#session').data('data-stammdaten-grid', this.cards.toString());
            }
        };
        StammdatenClientListController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'StammdatenClientListController'),
            QMC.Inject('$location', 'StammdatenService', '$qui', 'KlientService', '$stateParams', '$scope', '$state', 'UserService', 'QmcPermissionService')
        ], StammdatenClientListController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let StammdatenClientDetailController = class StammdatenClientDetailController {
            /**
             * Creates an instance of StammdatenClientDetailController.
             * @param {StammdatenService} stammdatenService
             * @param {any} $qui
             * @param {Klient.KlientService} clientService
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {any} $location
             * @param {Common.QmcLanguageService} lng
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberOf StammdatenClientDetailController
             */
            constructor(stammdatenService, $qui, clientService, $stateParams, $scope, $location, lng, permissionService, udfService) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$scope = $scope;
                this.$location = $location;
                this.lng = lng;
                this.permissionService = permissionService;
                this.EXTENDED_MAIN_DATA_FIELDS = ['birthname', 'birthplace'];
                this.ui = new Stammdaten.DetailUI();
                this.createForm = null;
                this.menuItems = [];
                this.loading = true;
                this.formState = 'new';
                this.udf = [];
                this.isConnectLicenseAvailable = false;
                this.isConnectRegistrationAvailable = false;
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    this.events();
                    $('.qm-card').unbind('click');
                });
                if (document.getElementById("permissions").getAttribute("client").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module client");
                    this.forbidden = true;
                    return;
                }
                this.$scope.Model = this.$scope.Model || { Name: 'xxx' };
                this.id = $stateParams.client;
                this.section = $location.$$path.split('/')[4];
                if (!$('body').hasClass('hideNav')) {
                    permissionService.getPermissionsByObjectTypes([140000, 140002, 140003, 140005, 140006, 140008, 140021, 140023, 140027, 140032, 140033, 140054, 140057, 140068, 140086, 143000, 820003, 140011, 140012]).then((data) => {
                        this.permissionService.getPermissionsForDataset(this.id, null).then((dData) => {
                            this.permissions = data;
                            this.permissions[0] = dData[0];
                            this.permissions[0].objectType = 140000;
                            this.permissions = data;
                            this.applyExtendedMainDataFieldPermissions();
                            if (!window.license || window.license === 'loading')
                                permissionService.getLicense().then((license) => {
                                    window.license = license !== null && license !== void 0 ? license : []; //since we already got it, might as well set it in windowstore. might reduce waittime later
                                    this.createMenuByPermissions();
                                });
                            else {
                                this.createMenuByPermissions();
                            }
                        });
                    });
                    udfService.getUserDefinedFields(140000).then((data) => {
                        this.udf = data;
                        this.addUdfMenu();
                    });
                }
                else {
                    this.toggleInfoBox(false);
                }
                this.getClientWv().then(() => {
                    this.getClientData(this.id);
                    this.getClientAvatar(this.id);
                });
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    this.events();
                    $('.qm-card').unbind('click');
                });
                permissionService.isLicenseAvailable('MYNEVA_CONNECT').then(data => this.isConnectLicenseAvailable = data);
                stammdatenService.isConnectRegistrationAvailable().then(data => this.isConnectRegistrationAvailable = data);
            }
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * register view events
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
             */
            events() {
                this.$scope.$watch('vm.mobileSelect', () => {
                    if (this.mobileSelect !== (null || undefined)) {
                        this.changeSection(this.mobileSelect);
                    }
                });
                this.$scope.$on('$locationChangeStart', (_event, next) => {
                    const activeItem = this.menuItems.filter(x => next.includes(`stammdaten/detail/${this.id}/${x.section}/${this.id}`))[0];
                    if (activeItem)
                        this.section = activeItem.section;
                });
            }
            /**
             * init form
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
             */
            initForm() {
                this.form = {
                    id: null,
                    objectId: null,
                    name: "",
                    forename: "",
                    birthday: new Date(),
                    birthplace: "",
                    birthname: "",
                    salutationId: null,
                    titleId: null,
                    secondTitleId: null,
                    genderId: null,
                    shortCaption: '',
                    clientNumber: ''
                };
            }
            createConnectUser() {
                this.stammdatenService.getConnectRegistrationUrl(this.id, this.id)
                    .then(url => window.open(url, '_blank'))
                    .catch(_ => this.$qui.notify({
                    message: this.lng.translate(20003527, "Das Anlegen eines myneva.connect Benutzers ist nicht möglich. Die Konfiguration ist unvollständig."),
                    title: this.lng.translate(20002015, "Fehler"),
                    icon: "fa-cloud",
                    status: "warning",
                    timer: 3500
                }));
            }
            /**
             * create the stammdaten menue by given permissions
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
             */
            applyExtendedMainDataFieldPermissions() {
                this.permissionService.getPermissionsForDataset(this.id, 140086).then((data) => {
                    var _a, _b;
                    const extendedMainDataPermission = data[0];
                    const canView = (_a = ((extendedMainDataPermission === null || extendedMainDataPermission === void 0 ? void 0 : extendedMainDataPermission.view) || (extendedMainDataPermission === null || extendedMainDataPermission === void 0 ? void 0 : extendedMainDataPermission.moduleAccess))) !== null && _a !== void 0 ? _a : false;
                    const canModify = (_b = extendedMainDataPermission === null || extendedMainDataPermission === void 0 ? void 0 : extendedMainDataPermission.modify) !== null && _b !== void 0 ? _b : false;
                    this.EXTENDED_MAIN_DATA_FIELDS.forEach(model => {
                        const field = this.ui.infoForm.form.find(x => x.model === model);
                        if (field) {
                            field.hidden = !canView;
                            field.disabled = !canModify;
                        }
                    });
                    this.$qui.functionWaiter("createForm", this);
                });
            }
            createMenuByPermissions() {
                this.menuItems = [];
                // Address
                if ($.grep(this.permissions, item => { return item.objectType === 140021; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20001511, "Adressen"), section: "address", icon: "qm-icon-location_pin" });
                }
                // Communication
                if ($.grep(this.permissions, item => { return item.objectType === 140023; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20001047, "Kommunikation"), section: "communication", icon: "qm-icon-book_telephone" });
                }
                // Contact Person
                if ($.grep(this.permissions, item => { return item.objectType === 140006; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20004000, "Kontaktpersonen"), section: "contactperson", icon: "qm-icon-users" });
                }
                // Doctors Visit
                if ($.grep(this.permissions, item => { return item.objectType === 140003; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20010000, "Arztbesuche"), section: "doctorsvisit", icon: "qm-icon-doctor" });
                }
                // Vaccination
                if ($.grep(this.permissions, item => { return item.objectType === 140005; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20009000, "Impfungen"), section: "vaccination", icon: "qm-icon-injection" });
                }
                // Education
                if ($.grep(this.permissions, item => { return item.objectType === 140068; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20012032, "Lebenslauf / Ausbildungen"), section: "education", icon: "qm-icon-graduation_hat2" });
                }
                // Disease
                if ($.grep(this.permissions, item => { return item.objectType === 140002; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20007504, "Krankheiten"), section: "disease", icon: "qm-icon-virus" });
                }
                // Note
                if ($.grep(this.permissions, item => { return item.objectType === 140000; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(21007000, "Notizen"), section: "note", icon: "qm-icon-note" });
                }
                // Hobby
                if ($.grep(this.permissions, item => { return item.objectType === 140054; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20008004, "Hobby"), section: "hobby", icon: "qm-icon-soccer_ball" });
                }
                // Checklist
                if ($.grep(this.permissions, item => { return item.objectType === 140057; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20011505, "Checklisten"), section: "checklist", icon: "qm-icon-check" });
                }
                // Document
                if ($.grep(this.permissions, item => { return item.objectType === 140032; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(21006000, "Dokumente"), section: "documents", icon: "qm-icon-document_attachment" });
                }
                // Absenteeism
                if ($.grep(this.permissions, item => { return item.objectType === 140033; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(21008000, "Abwesenheiten"), section: "absenteeism", icon: "qm-icon-calendar_7" });
                }
                // AccountingBook
                if ($.grep(this.permissions, item => { return item.objectType === 140008; })[0].moduleAccess && window.license.some(x => x.license === 'KASSENBUCH' && x.granted)) {
                    this.menuItems.push({ caption: this.lng.translate(20001044, "Kassenbuch"), section: "accountingBook", icon: "qm-icon-cashier" });
                }
                // Legal
                if ($.grep(this.permissions, item => { return item.objectType === 140027; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20022000, "Rechtliches"), section: "legal", icon: "qm-icon-codes_of_law" });
                }
                // TempInstituteChange
                if ($.grep(this.permissions, item => { return item.objectType === 820003; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20032000, "Temp. Organisationswechsel"), section: "tempInstituteChange", icon: "qm-icon-arrow_circle2" });
                }
                // ClientInfo
                if ($.grep(this.permissions, item => { return item.objectType === 143000; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20001063, "KlientInformation"), section: "clientInformation", icon: "qm-icon-print_layout_single" });
                }
                // Admission
                if ($.grep(this.permissions, item => { return item.objectType === 140011; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20006000, "Aufnahmen"), section: "admission", icon: "qm-icon-arrow_into" });
                }
                // Dismissal
                if ($.grep(this.permissions, item => { return item.objectType === 140012; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20006503, "Entlassungen"), section: "dismissal", icon: "qm-icon-arrow_out" });
                }
                this.addUdfMenu();
                this.menuItems = this.menuItems.sort((a, b) => { return a.caption > b.caption ? 1 : a.caption < b.caption ? -1 : 0; });
                this.menuItems.unshift({ caption: this.lng.translate(21002031, "Deckblatt"), section: "cover", icon: "qm-icon-form" });
                // Erweiterte Stammdaten
                if ($.grep(this.permissions, item => { return item.objectType === 140086; })[0].moduleAccess) {
                    this.menuItems.splice(1, 0, { caption: this.lng.translate(21002048, "Erweiterte Stammdaten"), section: "extendedMainData", icon: "qm-icon-id_cards" });
                }
            }
            addUdfMenu() {
                this.udf.sort((a, b) => { return a.caption > b.caption ? 1 : a.caption < b.caption ? -1 : 0; }).forEach(udf => {
                    this.menuItems.push({
                        caption: udf.caption, section: `udf/${udf.type}/${udf.definitionId}/${udf.objectType}`, icon: "qm-icon-window_explorer"
                    });
                });
            }
            /**
             * change the section given by the view
             *
             * @private
             * @param {string} section
             *
             * @memberOf StammdatenClientDetailController
             */
            changeSection(section) {
                this.section = section;
                console.log("SECTION", section);
                this.$location.search('');
                this.$location.path(`stammdaten/detail/${this.id}/${section}/${this.id}`);
                $('#mobile-data').css('display', 'none'); // Hide mobile menu after selecting a section
                this.toggleInfoBox(false);
            }
            toggleInfoBox(state = !this.showinfoBox) {
                const header = window.getComputedStyle(document.getElementById('largerClientDetailHeader'));
                if (header.display === 'none')
                    return; // if we got no option to show details again, never hide them
                const element = document.getElementById('infoContent');
                this.showinfoBox = state;
                if (this.showinfoBox)
                    element.style.display = 'unset';
                else
                    element.style.display = 'none';
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the client avatar by id
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
             */
            getClientAvatar(id) {
                this.stammdatenService.getClientImage(id, true).then((data) => {
                    if (data.imageData.length > 1) {
                        this.clientAvatar = data.imageData;
                    }
                }).catch((data) => {
                    console.error(data);
                });
            }
            /**
             * get the client data by id
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
             */
            getClientData(id) {
                console.time('answer time');
                return this.clientService.getClient(id).then((data) => {
                    this.$qui.functionWaiter("createForm", this);
                    this.form = angular.copy(data);
                    console.log('this.form', this.form);
                    this.client = data;
                    const birthday = moment(data.birthday);
                    const prehistoric = moment('1900-01-01').endOf('day');
                    this.client.birthday = birthday <= prehistoric ? null : this.form.birthday;
                    this.clientAge = birthday <= prehistoric ? '?' : moment().diff(birthday, 'years');
                    this.clientDaysToBirthday = moment(data.birthday).add(this.clientAge, 'years').fromNow();
                    if (this.clientDaysToBirthday.includes('ago')) {
                        this.clientAge = Number(this.clientAge);
                    }
                    setTimeout(() => {
                        console.timeEnd('answer time');
                        this.$qui.anonAvatar();
                    }, 500);
                });
            }
            /**
             * edit the client
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
            */
            editClient() {
                this.applyExtendedMainDataFieldPermissions();
                this.formState = "edit";
                $('#edit-client').modal('toggle');
                this.loading = false;
            }
            /**
             * get the client wv list
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
            */
            getClientWv() {
                return this.clientService.getClientWv().then((data) => {
                    console.log("wv list", data);
                    this.wv = data;
                });
            }
            /**
             * get the client title list
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
            */
            getTitleList() {
                return this.wv.titleWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name,
                        isFix: obj.isFix
                    };
                });
            }
            getSecondTitleList() {
                return this.wv.secondTitleWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name,
                        isFix: obj.isFix
                    };
                });
            }
            /**
             * get the client salutation list
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
            */
            getSalutationList() {
                return this.wv.salutationWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name,
                        isFix: obj.isFix
                    };
                });
            }
            /**
             * get the client gender list
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
            */
            getGenderList() {
                return this.wv.genderWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name,
                        isFix: obj.isFix
                    };
                });
            }
            /**
             * get the client wv list
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
            */
            updateClient(data) {
                this.clientService.putClient(this.id, this.form).then((data) => {
                    this.$qui.notify(this.$qui.successNote);
                    this.getClientData(this.id);
                });
            }
            /**
             * get the last admission date for client
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
            */
            getLastAdmissionDate() {
                if (this.client === (null || undefined) || this.client.admissions.length < 1) {
                    return;
                }
                return this.client.admissions[this.client.admissions.length - 1].date;
            }
            /**
             * get the first admission date for client
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
            */
            getFirstAdmissionDate() {
                if (this.client === (null || undefined) || this.client.admissions.length < 1) {
                    return;
                }
                return this.client.admissions[0].date;
            }
            /**
             * get the last dismissal date for client
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
            */
            getLastDismissalDate() {
                if (this.client === (null || undefined) || this.client.dismissals.length < 1) {
                    return;
                }
                return this.client.dismissals[this.client.dismissals.length - 1].date;
            }
        };
        StammdatenClientDetailController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'StammdatenClientDetailController'),
            QMC.Inject('StammdatenService', '$qui', 'KlientService', '$stateParams', '$scope', '$location', 'QmcLanguageService', 'QmcPermissionService', 'QmcUdfService')
        ], StammdatenClientDetailController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let GlobalDocumentsListController = class GlobalDocumentsListController {
            /**
             * Creates an instance of GlobalDocumentsListController.
             * @param {StammdatenService} stammdatenService
             * @param {any} $qui
             * @param {Klient.KlientService} clientService
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {any} $state
             * @param {Common.QmcLanguageService} lng
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberOf GlobalDocumentsListController
             */
            constructor($location, stammdatenService, $qui, clientService, $stateParams, $scope, $state, lng, permissionService, userService) {
                var _a, _b;
                this.$location = $location;
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$scope = $scope;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.ui = new Stammdaten.UserInterface();
                this.allowTableExport = false;
                this.files = [];
                this.showPrivateCheckbox = true;
                this.showOnlyGlobalFiles = false;
                this.showMonthFilter = false;
                this.isFirstLoad = true;
                this.subCategoryList = [];
                this.dontAllowDownload = true;
                this.filterCacheName = "GlobalDocumentFilterCache";
                this.page = 0;
                this.pageWatcher = [];
                this.sortBy = '';
                this.sortDescending = false;
                this.onSort = (sortBy, sortDescending) => {
                    this.sortBy = sortBy;
                    this.sortDescending = sortDescending;
                    this.page = 0;
                    this.getData();
                };
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                if (document.getElementById("permissions").getAttribute("globalDocuments").toLocaleLowerCase() !== "true") {
                    console.log("No rights to see module global documents");
                    this.forbidden = true;
                    return;
                }
                if (!this.tableFilter) {
                    this.tableFilter = '';
                }
                ;
                this.references = [{ text: `- ${this.lng.translate(20000162, 'Alle')} -`, value: 0 }];
                this.stammdatenService.getGlobalDocumentReferences().then(data => {
                    data.sort((a, b) => (a.caption > b.caption) ? 1 : -1);
                    this.references = this.references.concat(data.map(x => ({ value: x.objectType, text: x.caption })));
                });
                permissionService.getPermissionsByObjectTypes([905001, 920002, 905000]).then((data) => {
                    // if no permission for module access, return
                    if (!data[2].moduleAccess) {
                        this.forbidden = true;
                        return;
                    }
                    this.delete = data[0].delete && data[0].moduleAccess;
                    this.new = data[0].new && data[0].moduleAccess;
                    this.modify = data[0].modify && data[0].moduleAccess;
                    if (!this.new) {
                        this.$qui.waitForEl('#newModalButton', () => {
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                        });
                    }
                    this.dontAllowDownload = !data[1].openFile;
                    this.allowTableExport = data[2].print;
                    let isFirstLoad = true;
                    this.$qui.getTableAutoload(this.userService).then((ltd) => {
                        this.shouldLoadTableData = ltd;
                        if (this.shouldLoadTableData) {
                            this.getDocumentList();
                        }
                    });
                    this.userService.getGlobalSettings(["MEDIEN.DOKUMENT.ALLOWPRIVATEDOCUMENTS"], false).then((dataSettings) => {
                        this.showPrivateCheckbox = dataSettings[0].value.toLowerCase() === 'true';
                    });
                    this.getWv();
                    this.init();
                });
                this.promptOptions = {
                    title: this.lng.translate(20001062, 'Dokumentverwaltung'),
                    yesNo: true,
                    icon: "qm-icon-document_attachment",
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                const cache = QMC.Common.personalLocalStorage.getItem(this.filterCacheName);
                if (cache) {
                    const jsonCache = JSON.parse(cache);
                    this.filter = {
                        dateFrom: this.$qui.createDateFromString((_a = jsonCache.dateFrom) !== null && _a !== void 0 ? _a : moment().startOf('month').toDate()),
                        dateTo: this.$qui.createDateFromString((_b = jsonCache.dateTo) !== null && _b !== void 0 ? _b : moment().endOf('month').toDate()),
                        parentObjectType: jsonCache.parentObjectType
                    };
                    this.showOnlyGlobalFiles = jsonCache.onlyGlobalFiles;
                }
                else {
                    this.filter = {
                        dateFrom: moment().startOf('month').toDate(),
                        dateTo: moment().endOf('month').toDate(),
                        parentObjectType: 0,
                        onlyGlobalFiles: false
                    };
                }
                this.events();
            }
            /////////////// DISPLAY LOGIC ///////////////
            init() {
                this.initForm();
            }
            initForm() {
                this.form = {
                    title: '',
                    subtitle: '',
                    comment: '',
                    documentTypeId: QMC.Common.Constants.GUID_EMPTY,
                    mainCategoryId: QMC.Common.Constants.GUID_EMPTY,
                    subCategoryId: QMC.Common.Constants.GUID_EMPTY,
                    fileName: '',
                    base64String: '',
                    isPrivate: false
                };
                const fileSelector = angular.element('#fileselect');
                if (fileSelector[0] && fileSelector[0].files.length > 0) {
                    $("#fileselect").val('');
                }
                ;
                this.showError = "";
                this.files = [];
                this.listLoad = false;
                this.$qui.scopeApply(this.$scope);
            }
            /**
            * Register view events
            *
            * @private
            *
            * @memberOf FlsDocumentationListController
            */
            events() {
                this.$scope.$watch('vm.tableFilter', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        if (this.isFirstLoad) {
                            setTimeout(() => {
                                this.isFirstLoad = false;
                            }, 5);
                        }
                        else {
                            const lastValue = this.tableFilter;
                            setTimeout(() => {
                                if (this.tableFilter === lastValue) {
                                    this.page = 0;
                                    this.getData();
                                }
                            }, 500);
                        }
                        this.cacheFilter();
                    }
                }.bind(this, this));
                this.$scope.$watch('vm.filter.dateFrom', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        if (this.isFirstLoad) {
                            setTimeout(() => {
                                this.isFirstLoad = false;
                            }, 5);
                        }
                        else {
                            const lastValue = this.tableFilter;
                            setTimeout(() => {
                                if (this.tableFilter === lastValue) {
                                    this.page = 0;
                                    this.getData();
                                }
                            }, 500);
                        }
                        this.cacheFilter();
                    }
                }.bind(this, this));
                this.$scope.$watch('vm.filter.dateTo', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        if (this.isFirstLoad) {
                            setTimeout(() => {
                                this.isFirstLoad = false;
                            }, 5);
                        }
                        else {
                            const lastValue = this.tableFilter;
                            setTimeout(() => {
                                if (this.tableFilter === lastValue) {
                                    this.page = 0;
                                    this.getData();
                                }
                            }, 500);
                        }
                        this.cacheFilter();
                    }
                }.bind(this, this));
                this.$scope.$watch('vm.filter.parentObjectType', function (newValue, oldValue) {
                    if (newValue !== oldValue) {
                        if (this.isFirstLoad) {
                            setTimeout(() => {
                                this.isFirstLoad = false;
                            }, 5);
                        }
                        else {
                            const lastValue = this.tableFilter;
                            setTimeout(() => {
                                if (this.tableFilter === lastValue) {
                                    this.page = 0;
                                    this.getData();
                                }
                            }, 500);
                        }
                        this.cacheFilter();
                    }
                }.bind(this, this));
                this.$scope.$watchCollection('vm.showOnlyGlobalFiles', (newValue, oldValue) => {
                    if (newValue === oldValue)
                        return;
                    this.getData();
                    this.cacheFilter();
                });
                this.$scope.$watchCollection('vm.tableFilter', (newValue, oldValue) => {
                    if (newValue === oldValue)
                        return;
                    this.getData();
                    this.cacheFilter();
                });
                this.$scope.$watch('vm.form.mainCategoryId', () => {
                    if (this.wv !== null && this.wv !== undefined)
                        this.getSubCategoryList();
                });
                this.$scope.$watch('vm.parentObjectType', (newVal, oldVal) => {
                    if (newVal !== oldVal) {
                        this.cacheFilter();
                        this.getData();
                    }
                });
            }
            setPage(page) {
                this.page = page;
            }
            getData() {
                this.clearPageWatcher();
                this.getDocumentList();
                this.page = 0;
            }
            open(item) {
                $('#loadingScreen').modal('show');
                this.fileInfos = {
                    base64: '',
                    fileType: '',
                    fileName: ''
                };
                this.stammdatenService.getGlobalDocumentFile(item.objectId).then((data) => {
                    $('#loadingScreen').modal('hide');
                    try {
                        const filename = item.fileName;
                        // get filename suffix and contenttype
                        const temp = filename.split('.');
                        const ext = temp[temp.length - 1];
                        this.fileInfos = {
                            base64: data,
                            fileType: ext,
                            fileName: filename
                        };
                        $('#previewModal').modal('show');
                    }
                    catch (e) {
                        console.log("downloadDocument Fehler: ", e);
                    }
                });
            }
            download(item) {
                $('#loadingScreen').modal('show');
                // get filename suffix and contenttype
                const temp = item.fileName.split('.');
                const ext = temp.length > 0 ? temp[temp.length - 1] : '';
                this.stammdatenService.getGlobalDocumentFile(item.objectId).then((data) => {
                    $('#loadingScreen').modal('hide');
                    const blob = this.$qui.base64ToBlob(data, this.$qui.extToMime(ext));
                    this.$qui.downloadBlob(item.fileName, blob);
                });
            }
            getSubCategoryList() {
                const data = [];
                this.form.subCategoryId = null;
                for (let i = 0; i < this.wv.subCategoryWvList.length; i++) {
                    if ((this.wv.subCategoryWvList[i].parentWvId === this.form.mainCategoryId) && !(/^\s*$/).test(this.wv.subCategoryWvList[i].name)) {
                        data.push(this.wv.subCategoryWvList[i]);
                    }
                }
                this.subCategoryList = this.$qui.select(data, { value: 'objectId', text: 'name' });
            }
            cacheFilter() {
                const cacheObject = {
                    dateFrom: this.filter.dateFrom,
                    dateTo: this.filter.dateTo,
                    parentObjectType: this.filter.parentObjectType,
                    onlyGlobalFiles: this.showOnlyGlobalFiles
                };
                QMC.Common.personalLocalStorage.setItem(this.filterCacheName, JSON.stringify(cacheObject));
            }
            shouldDisableTimeFilter(filterString) {
                if (!filterString)
                    return false;
                return filterString.length > 0;
            }
            isFormInvalid() {
                return !this.new || this.files.length < 1 || !this.form.mainCategoryId || !this.form.documentTypeId || this.form.mainCategoryId === QMC.Common.Constants.GUID_EMPTY || this.form.documentTypeId === QMC.Common.Constants.GUID_EMPTY;
            }
            clearPageWatcher() {
                for (const watcher of this.pageWatcher) {
                    if (watcher)
                        watcher();
                }
                this.pageWatcher = [];
            }
            getDocumentList() {
                const currentRequest = {
                    dateFrom: this.tableFilter.length > 0 || !this.filter || this.showOnlyGlobalFiles === true ? null : this.filter.dateFrom,
                    dateTo: this.tableFilter.length > 0 || !this.filter || this.showOnlyGlobalFiles === true ? null : this.filter.dateTo,
                    onlyGlobal: this.showOnlyGlobalFiles,
                    parentTypeId: this.filter.parentObjectType !== 0 && this.showOnlyGlobalFiles === false ? this.filter.parentObjectType : null,
                    page: this.page,
                    text: this.tableFilter.length > 0 ? this.tableFilter : null,
                    sortBy: this.sortBy,
                    sortDescending: this.sortDescending
                };
                if (JSON.stringify(currentRequest) === JSON.stringify(this.lastRequest))
                    return;
                this.lastRequest = currentRequest;
                const rId = this.$qui.generateGuid();
                this.requestId = rId;
                this.listLoad = true;
                this.documentList = [];
                this.stammdatenService.getGlobalDocumentList(this.tableFilter.length > 0 || !this.filter || this.showOnlyGlobalFiles === true ? null : this.filter.dateFrom, this.tableFilter.length > 0 || !this.filter || this.showOnlyGlobalFiles === true ? null : this.filter.dateTo, this.showOnlyGlobalFiles, this.filter.parentObjectType !== 0 && this.showOnlyGlobalFiles === false ? this.filter.parentObjectType : null, this.page, QMC.Common.Constants.DEFAULT_PAGINATION_SIZE, this.tableFilter.length > 0 ? this.tableFilter : null, [...this.ui.getDisplayedPropertiesFromSchema(this.ui.documentTable), "fileName"], this.sortBy, this.sortDescending).then((data) => {
                    if (this.requestId !== rId)
                        return;
                    this.clearPageWatcher();
                    this.paginationInfo = data.paginationInfo;
                    for (const element of data.items) {
                        element.truncatedFileName = element.fileName.substr(0, 27);
                        if (element.fileName.length > 27)
                            element.truncatedFileName += "...";
                    }
                    data.items.forEach(x => x.stateLink = this.createStateLink(x));
                    this.documentList = data.items;
                    data.items.forEach((x) => x.dontAllowDownload = this.dontAllowDownload || (!x.isDocumentDownloadAllowed));
                    data.items.forEach((x) => x.dontAllowPreview = (!x.isDocumentDownloadAllowed));
                    this.ui.documentTable.data = data.items;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.listLoad = false;
                    this.pageWatcher.push(this.$scope.$watch('vm.page', (newValue, oldValue) => {
                        if (newValue !== oldValue)
                            this.getDocumentList();
                    }));
                });
            }
            createStateLink(data) {
                if (!data.referenceObjectType || !data.referenceId || !data.parentReferenceId)
                    return undefined;
                let state = '';
                switch (data.referenceObjectType) {
                    case 120002:
                        state = 'employee.address';
                        break;
                    case 120004:
                        state = 'employee.communication';
                        break;
                    case 120012:
                        state = 'employee.contactperson';
                        break;
                    case 120020:
                        state = 'employee.checklist';
                        break;
                    case 120046:
                        state = 'employee.vaccination';
                        break;
                    case 140002:
                        state = 'detail.disease';
                        break;
                    case 140003:
                        state = 'detail.doctorsvisit';
                        break;
                    case 140005:
                        state = 'detail.vaccination';
                        break;
                    case 140006:
                        state = 'detail.contactperson';
                        break;
                    case 140021:
                        state = 'detail.address';
                        break;
                    case 140023:
                        state = 'detail.communication';
                        break;
                    case 140027:
                        state = 'detail.legal';
                        break;
                    case 140057:
                        state = 'detail.checklist';
                        break;
                    case 140068:
                        state = 'detail.education';
                        break;
                    default: return undefined;
                }
                return {
                    state,
                    parentId: data.parentReferenceId,
                    referenceId: data.referenceId
                };
            }
            openReference(data) {
                if (!data.stateLink)
                    return;
                this.$state.go(data.stateLink.state, { client: data.stateLink.parentId, id: data.stateLink.parentId, dataId: data.stateLink.referenceId });
            }
            newDocument() {
                if (this.form.title !== null && this.form.title !== undefined && this.form.title.length < 1) {
                    this.showError = this.lng.translate(21003017, 'Bitte einen Titel eingeben.');
                    return;
                }
                if (this.files.length < 1) {
                    this.showError = this.lng.translate(21003018, 'Bitte eine Datei auswählen.');
                    return;
                }
                this.form.fileName = this.files[this.files.length - 1].name;
                this.form.base64String = this.files[this.files.length - 1].base64;
                this.upload = true;
                this.stammdatenService.postGlobalDocument(this.form).then(() => {
                    $('#newDocumentModal').modal('hide');
                    this.$qui.notify(this.$qui.successNote);
                    this.initForm();
                    this.getDocumentList();
                    this.upload = false;
                });
            }
            ;
            deleteItem(item) {
                if (!this.delete)
                    return;
                this.promptOptions.itemText = item.fileName;
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data) {
                        this.stammdatenService.deleteGlobalDocument(item).then(() => {
                            this.$qui.notify(this.$qui.deleteNote);
                            this.getDocumentList();
                        });
                    }
                });
            }
            getWv() {
                this.stammdatenService.getDocumentWV().then((data) => {
                    this.wv = data;
                    this.documentTypeList = this.$qui.select(data.documentTypeWvList, { value: 'objectId', text: 'name' });
                    this.categoryList = this.$qui.select(data.mainCategoryWvList, { value: 'objectId', text: 'name' });
                });
            }
        };
        GlobalDocumentsListController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'GlobalDocumentsListController'),
            QMC.Inject('$location', 'StammdatenService', '$qui', 'KlientService', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService')
        ], GlobalDocumentsListController);
        Stammdaten.GlobalDocumentsListController = GlobalDocumentsListController;
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let OrgaAccountingBooksListController = class OrgaAccountingBooksListController {
            constructor($qui, $scope, $location, stammdatenService, permissionService) {
                this.$qui = $qui;
                this.$scope = $scope;
                this.$location = $location;
                this.stammdatenService = stammdatenService;
                this.permissionService = permissionService;
                this.forbidden = false;
                this.id = QMC.Common.Constants.GUID_EMPTY;
                this.organisations = [];
                $qui.init($qui.getSectionColor($location.path()), () => {
                    $qui.anonAvatar();
                    $('.qm-card').unbind('click');
                });
                this.permissionService.getPermissionsByObjectTypes([130022]).then((data) => {
                    // if no permission for module access, return
                    if (!data[0].moduleAccess) {
                        this.forbidden = true;
                        return;
                    }
                    this.getOrganisations();
                    this.$scope.$watch('vm.selectedOrganisation', (newVal, oldVal) => {
                        if (newVal !== oldVal && this.selectedOrganisation && this.selectedOrganisation !== QMC.Common.Constants.GUID_EMPTY) {
                            this.id = this.selectedOrganisation;
                            QMC.Common.personalLocalStorage.setItem(QMC.Common.LocalStorageConstants.ORGANISATION_LAST_SELECTED_ID, this.selectedOrganisation);
                            this.$qui.functionWaiter("createDirective", this);
                        }
                    });
                });
            }
            getOrganisations() {
                this.stammdatenService.getOrganisationList().then((data) => {
                    this.organisations = data.map(x => ({ value: x.id, text: x.displayTitle }));
                    if (QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.ORGANISATION_LAST_SELECTED_ID) !== null) {
                        const organisationId = QMC.Common.personalLocalStorage.getItem(QMC.Common.LocalStorageConstants.ORGANISATION_LAST_SELECTED_ID);
                        if (organisationId) {
                            this.selectedOrganisation = organisationId;
                        }
                    }
                    else {
                        this.$qui.functionWaiter("createDirective", this);
                    }
                });
            }
        };
        OrgaAccountingBooksListController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'OrgaAccountingBooksListController'),
            QMC.Inject('$qui', '$scope', '$location', 'StammdatenService', 'QmcPermissionService')
        ], OrgaAccountingBooksListController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        /**
         * Stammdaten UserInterface class
         *
         * @export
         * @class UserInterface
         * @extends {Common.UserInterface}
         */
        class UserInterface extends QMC.Common.UserInterface {
            constructor() {
                super(...arguments);
                /**
                 * Client detail address table
                 * @memberOf UserInterface
                 */
                this.documentTable = {
                    "config": {
                        "defaultSort": "title",
                        "sortReverse": "true",
                    },
                    "table": {
                        "Kategorie": {
                            "label": "category",
                            "dType": "string",
                            "lngTag": "20000137"
                        },
                        "Unterkategorie": {
                            "label": "subCategory",
                            "dType": "string",
                            "lngTag": "21006003"
                        },
                        "Dokumentkategorie": {
                            "label": "documentCategory",
                            "dType": "string",
                            "lngTag": "20021010"
                        },
                        "Ordnerstruktur": {
                            "label": "folderStructure",
                            "dType": "string",
                            "lngTag": "21006025"
                        },
                        "Titel": {
                            "label": "title",
                            "dType": "string",
                            "lngTag": "20000066"
                        },
                        "Angelegt am": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20021002"
                        },
                        "Bezug": {
                            "label": "parent",
                            "dType": "string",
                            "lngTag": "20000283"
                        },
                        "Dateiname": {
                            "label": "truncatedFileName",
                            "dType": "string",
                            "lngTag": "21006017"
                        },
                        "Art": {
                            "label": "type",
                            "dType": "string",
                            "lngTag": "20000138"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-download grey",
                                "click": "download",
                                "dType": "Button",
                                "tooltip": "Download",
                                "lngTag": "21006014",
                                "events": {
                                    "hide": "dontAllowDownload",
                                }
                            }, {
                                "icon": "qm-icon-document_attachment green",
                                "click": "open",
                                "dType": "Button",
                                "tooltip": "Vorschau",
                                "lngTag": "20000091",
                                "events": {
                                    "hide": "dontAllowPreview",
                                }
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteItem",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            },
                            {
                                "icon": "qm-icon-arrow_into orange",
                                "click": "openReference",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Referenz-Datensatz öffnen",
                                "lngTag": "21006030",
                                "events": {
                                    "hide": "!stateLink",
                                }
                            }],
                    }, "card": {
                        "avatar": {
                            "icon": "qm-icon-document_attachment"
                        },
                        "text": {
                            "label": "title",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "category",
                                "dType": "string",
                            },
                            {
                                "label": "truncatedFileName",
                                "dType": "string"
                            },
                            {
                                "label": "parent",
                                "dType": "string"
                            },
                            {
                                "label": "dateFrom",
                                "withTime": "true",
                                "dType": "Date"
                            }
                        ],
                        "buttons": [{
                                "icon": "qm-icon-download grey",
                                "click": "download",
                                "dType": "Button",
                                "tooltip": "Download",
                                "lngTag": "21006014",
                                "events": {
                                    "hide": "dontAllowDownload",
                                }
                            }, {
                                "icon": "qm-icon-document_attachment green",
                                "click": "open",
                                "dType": "Button",
                                "tooltip": "Vorschau",
                                "lngTag": "20000091",
                                "events": {
                                    "hide": "dontAllowPreview",
                                }
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteItem",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            },
                            {
                                "icon": "qm-icon-arrow_into orange",
                                "click": "openReference",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Referenz-Datensatz öffnen",
                                "lngTag": "21006030",
                                "events": {
                                    "hide": "!stateLink",
                                }
                            }]
                    },
                    "data": null
                };
            }
        }
        Stammdaten.UserInterface = UserInterface;
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
(() => {
    angular.module('QMC.Employee', []).config(routes);
    routes.$inject = ['$locationProvider', '$stateProvider', 'qmcBase'];
    function routes($locationProvider, $stateProvider, qmcBase) {
        $locationProvider.html5Mode({
            enabled: false,
            requireBase: false
        });
        const params = {
            dataId: {
                dynamic: true
            }
        };
        $stateProvider
            // employee
            .state('employeeList', {
            url: '/employee',
            templateUrl: qmcBase + '/stammdaten/employee',
            controller: 'EmployeeListController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Employee list');
                    }]
            }
        })
            .state('employee', {
            url: '/employee/:id',
            templateUrl: qmcBase + '/stammdaten/employee/detail',
            controller: 'EmployeeDetailController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: employee detail');
                    }]
            }
        })
            // Detail
            .state('employee.cover', {
            url: '/cover/:id',
            templateUrl: qmcBase + '/stammdaten/detail/cover',
            controller: 'DetailCoverController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten client detail cover');
                    }]
            }
        })
            .state('employee.communication', {
            url: '/communication/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/communication',
            controller: 'DetailCommunicationController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten employee detail communication');
                    }]
            },
            params
        })
            .state('employee.document', {
            url: '/documents/:id',
            templateUrl: qmcBase + '/stammdaten/detail/document',
            controller: 'DetailDocumentsController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten employee detail document');
                    }]
            },
            params
        })
            .state('employee.vaccination', {
            url: '/vaccination/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/vaccination',
            controller: 'DetailVaccinationController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten employee detail vaccination');
                    }]
            },
            params
        })
            .state('employee.medicalEvidence', {
            url: '/medicalEvidence/:id',
            templateUrl: qmcBase + '/stammdaten/detail/medicalEvidence',
            controller: 'DetailMedicalEvidenceController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten employee MedicalEvidence doctors visit');
                    }]
            }
        })
            .state('employee.medicalResponsible', {
            url: '/medicalResponsible/:id',
            templateUrl: qmcBase + '/stammdaten/detail/medicalResponsible',
            controller: 'DetailMedicalResponsibleController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten employee Medical Responsible / Medication is done by');
                    }]
            }
        })
            .state('employee.contactperson', {
            url: '/contactperson/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/contactperson',
            controller: 'DetailContactPersonController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten employee detail contact person');
                    }]
            },
            params
        })
            .state('employee.training', {
            url: '/training/:id',
            templateUrl: qmcBase + '/stammdaten/detail/training',
            controller: 'DetailTrainingController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten employee trainings list');
                    }]
            }
        })
            .state('employee.extendedMainData', {
            url: '/extendedMainData/:id',
            templateUrl: qmcBase + '/stammdaten/detail/extendedMainData',
            controller: 'DetailExtendedMainDataController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten employee detail extended Main Data');
                    }]
            }
        })
            .state('employee.address', {
            url: '/address/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/address',
            controller: 'DetailAddressController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten employee detail address');
                    }]
            },
            params
        })
            .state('employee.checklist', {
            url: '/checklist/:id?:dataId',
            templateUrl: qmcBase + '/stammdaten/detail/checklist',
            controller: 'DetailChecklistController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten employee detail address');
                    }]
            },
            params
        })
            .state('employee.udf', {
            url: '/udf/:type/:definitionId/:definitionObjectType/:id',
            templateUrl: qmcBase + '/stammdaten/detail/udf',
            controller: 'DetailUdfController',
            controllerAs: 'vm',
            resolve: {
                data: [() => {
                        console.log('Current State: Stammdaten employee udf');
                    }]
            }
        });
    }
})();
var QMC;
(function (QMC) {
    var Employee;
    (function (Employee) {
        let EmployeeListController = class EmployeeListController {
            constructor($location, $qui, employeeService, $scope, userService, permissionService) {
                this.$location = $location;
                this.$qui = $qui;
                this.employeeService = employeeService;
                this.$scope = $scope;
                this.userService = userService;
                this.permissionService = permissionService;
                this.storageName = 'employee-list-settings';
                this.allowTableExport = false;
                this.page = 0;
                this.filter = {
                    searchText: '',
                    searchId: '1655659a-5e10-4a1f-b6c6-e69cb74b64c7'
                };
                this.sortBy = '';
                this.sortDescending = false;
                this.onSort = (sortBy, sortDescending) => {
                    this.sortBy = sortBy;
                    this.sortDescending = sortDescending;
                    this.page = 0;
                    this.getData();
                };
                this.schema = {
                    "config": {
                        "tableRowLink": "#/employee/{{id}}/cover/{{id}}",
                    },
                    "table": {
                        "Bild": {
                            "label": "id",
                            "dType": "Avatar",
                            "name": "name",
                            "href": "#/employee/{{id}}/cover/{{id}}",
                            "forename": "forename"
                        },
                        "Name": {
                            "label": "name",
                            "dType": "string",
                            "lngTag": "20000072"
                        },
                        "Vorname": {
                            "label": "forename",
                            "dType": "string",
                            "lngTag": "20000057"
                        },
                        "Kürzel": {
                            "label": "abbreviation",
                            "dType": "string",
                            "lngTag": "20000221"
                        },
                        "Nummer": {
                            "label": "employeeNr",
                            "dType": "string",
                            "lngTag": "20000316"
                        },
                        "Stammhaus": {
                            "label": "institute",
                            "dType": "string",
                            "lngTag": "20000031"
                        },
                        "Geburtsdatum": {
                            "label": "birthday",
                            "dType": "Date",
                            "lngTag": "21002004"
                        },
                    },
                    "card": {
                        "avatar": {
                            "name": "name",
                            "forename": "forename",
                            "label": "id",
                            "href": "#/employee/{{id}}/cover/{{id}}",
                        },
                        "text": {
                            "label": ["name", "forename"],
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "abbreviation",
                                "dType": "string"
                            },
                            {
                                "label": "employeeNr",
                                "dType": "string"
                            },
                            {
                                "label": "actualInstitution",
                                "dType": "string"
                            },
                            {
                                "label": "birthday",
                                "dType": "Date",
                            }
                        ],
                        "buttons": []
                    },
                    "data": []
                };
                this.getFilterFromStorage();
                $qui.init($qui.getSectionColor(this.$location.path()), () => {
                    $qui.anonAvatar();
                    $('.qm-card').unbind('click');
                });
                // get base permissions
                this.permissionService.getPermissionsByObjectTypes([120000]).then((data) => {
                    this.allowTableExport = data[0].print;
                    // if we arent allowed to mess with employees stop here
                    if (!data[0].moduleAccess)
                        return;
                    this.employeeService.getPredefinedSearches().then((data) => {
                        this.searchValues = data;
                        this.searchValuesMap = this.$qui.selectAutoMap(data, 'id', 'caption');
                    });
                    this.$qui.getTableAutoload(this.userService).then((ltd) => {
                        this.shouldLoadTableData = ltd;
                        if (this.shouldLoadTableData) {
                            this.getData();
                        }
                    });
                });
                this.events();
            }
            /**
             * register view events
             *
             * @private
             *
             * @memberOf StammdatenClientListController
             */
            events() {
                this.$scope.$watch('vm.filter.searchId', (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        if (this.shouldLoadTableData) {
                            this.page = 0;
                            this.getData();
                        }
                        this.setFilterToStorage();
                    }
                });
                this.$scope.$watch('vm.filter.searchText', (newValue, oldValue) => {
                    if (newValue !== oldValue) {
                        if (this.shouldLoadTableData) {
                            const lastValue = this.filter.searchText;
                            setTimeout(() => {
                                if (this.filter.searchText === lastValue && ((newValue === null || newValue === void 0 ? void 0 : newValue.length) < (oldValue === null || oldValue === void 0 ? void 0 : oldValue.length) || this.filter.searchText.length >= 3)) {
                                    this.page = 0;
                                    this.getData();
                                }
                            }, 1500);
                        }
                        this.setFilterToStorage();
                    }
                });
                this.$scope.$watch('vm.page', (newValue, oldValue) => {
                    if (newValue !== oldValue)
                        this.getData();
                });
            }
            /**
             * get a filtered list of clients
             *
             * @private
             *
             * @memberOf StammdatenClientListController
             */
            getData() {
                this.loading = true;
                this.employeeService.getEmployeeListByPredfinedSearch(this.filter.searchId, this.page, 30, this.filter.searchText, ['name', 'forename', 'abbreviation', 'employeeNr', 'institute', 'birthday'], this.sortBy, this.sortDescending).then((data) => {
                    this.schema.data = data.items;
                    this.pagination = data.paginationInfo;
                    this.$qui.functionWaiter("createTable", this);
                }).catch((e) => {
                    this.schema.data = [];
                    console.error(e);
                }).finally(() => {
                    this.loading = false;
                });
            }
            setFilterToStorage() {
                QMC.Common.personalLocalStorage.setItem(this.storageName, JSON.stringify(this.filter));
            }
            getFilterFromStorage() {
                const store = QMC.Common.personalLocalStorage.getItem(this.storageName);
                if (!store)
                    return;
                this.filter = JSON.parse(store);
            }
        };
        EmployeeListController = __decorate([
            QMC.Controller('QMC.Employee', 'EmployeeListController'),
            QMC.Inject('$location', '$qui', 'EmployeeService', '$scope', 'UserService', 'QmcPermissionService')
        ], EmployeeListController);
    })(Employee = QMC.Employee || (QMC.Employee = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Employee;
    (function (Employee) {
        let EmployeeDetailController = class EmployeeDetailController {
            constructor($qui, $stateParams, $scope, $location, lng, employeeService, permissionService, udfService) {
                this.$qui = $qui;
                this.$scope = $scope;
                this.$location = $location;
                this.lng = lng;
                this.employeeService = employeeService;
                this.permissionService = permissionService;
                this.udfService = udfService;
                this.menuItems = [];
                this.loading = true;
                this.loadingWv = true;
                this.showInfoBox = true;
                this.section = 'cover';
                this.formState = 'edit';
                this.udf = [];
                this.formSchema = {
                    form: [{
                            label: "Name",
                            type: "String",
                            lngTag: 20000072,
                            model: "name",
                            required: true,
                            validate: {
                                message: "Bitte den Namen angeben",
                                messageTag: 21002015
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Vorname",
                            required: true,
                            type: "String",
                            lngTag: 20000057,
                            model: "forename",
                            validate: {
                                message: "Bitte den Vornamen angeben",
                                messageTag: 21003037
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Kürzel",
                            type: "String",
                            lngTag: 20000221,
                            model: "abbreviation",
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Mitarbeiter Nr.",
                            type: "String",
                            lngTag: 21002053,
                            model: "employeeNr",
                            style: {
                                icon: "fa fa-hashtag",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Geburtsdatum",
                            required: true,
                            type: "Date",
                            lngTag: 21002004,
                            model: "birthday",
                            validate: {
                                message: "Bitte das Geburtsdatum angeben",
                                messageTag: 21002018
                            },
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Anrede",
                            type: "Select",
                            lngTag: 20004005,
                            model: "salutationId",
                            dataSource: "getSalutationList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Titel",
                            type: "Select",
                            lngTag: 21002024,
                            model: "titleId",
                            dataSource: "getTitleList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Titel, nach",
                            type: "Select",
                            lngTag: 21002054,
                            model: "secondTitleId",
                            dataSource: "getSecondTitleList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Geschlecht",
                            type: "Select",
                            lngTag: 21002025,
                            model: "genderId",
                            dataSource: "getGenderList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                        }, {
                            label: "Status",
                            type: "Select",
                            lngTag: 20000164,
                            model: "personStatusId",
                            dataSource: "getStatusList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                        }],
                    actions: {
                        put: "updateEmployee",
                        post: ""
                    }
                };
                $qui.init($qui.getSectionColor("/employee"), () => {
                    $qui.bindEvents();
                    this.events();
                    $('.qm-card').unbind('click');
                });
                this.id = $stateParams.id;
                this.section = $location.$$path.split('/')[3];
                this.initForm();
                this.getEmployee();
                this.getEmployeeImage();
                this.getEmployeeWv();
                this.permissionService.getPermissionsByObjectTypes([120000, 120002, 120004, 120007, 120012, 120020, 120023, 120033, 120034, 120044, 120046]).then((data) => {
                    this.permissionService.getPermissionsForDataset(this.id, null).then((dData) => {
                        this.permissions = data;
                        this.permissions[0] = dData[0];
                        this.permissions[0].objectType = 120000;
                        this.createMenuByPermissions();
                    });
                });
                udfService.getUserDefinedFields(120000).then((data) => {
                    this.udf = data;
                    this.addUdfMenu();
                });
            }
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * register view events
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
             */
            events() {
                this.$scope.$watch('vm.mobileSelect', () => {
                    if (this.mobileSelect !== (null || undefined)) {
                        this.changeSection(this.mobileSelect);
                    }
                });
                this.$scope.$on('$locationChangeStart', (_event, next) => {
                    const activeItem = this.menuItems.filter(x => next.includes(`stammdaten/detail/${this.id}/${x.section}/${this.id}`))[0];
                    if (activeItem)
                        this.section = activeItem.section;
                });
            }
            initForm() {
                this.form = {
                    id: null,
                    objectId: null,
                    name: '',
                    forename: '',
                    displayTitle: '',
                    abbreviation: '',
                    birthday: null,
                    gender: null,
                    institute: '',
                    title: '',
                    amountChildren: 0,
                    birthName: '',
                    birthplace: '',
                    bloodType: '',
                    bloodTypeId: null,
                    comment: '',
                    dateOfDeath: null,
                    employeeNr: '',
                    eyeColor: '',
                    eyeColorId: null,
                    familyStatus: '',
                    familyStatusId: null,
                    firstLanguage: '',
                    firstLanguageId: null,
                    firstNationality: '',
                    firstNationalityId: null,
                    genderId: null,
                    hairColor: '',
                    hairColorId: null,
                    instituteId: null,
                    isBaptized: false,
                    originCountry: '',
                    originCountryId: null,
                    permissions: { view: false, new: false, modify: false, delete: false },
                    personStatus: '',
                    personStatusId: null,
                    postalSalutation: '',
                    postalSalutationId: null,
                    religion: '',
                    religionId: null,
                    salutation: '',
                    salutationId: null,
                    secondLanguage: '',
                    secondLanguageId: null,
                    secondNationality: '',
                    secondNationalityId: null,
                    titleId: null,
                };
            }
            /**
             * create the stammdaten menue by given permissions
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
             */
            createMenuByPermissions() {
                this.menuItems = [];
                //medicalEvidence
                if ($.grep(this.permissions, item => { return item.objectType === 120044; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20031000, "Med. Nachweis"), section: "medicalEvidence", icon: "qm-icon-stethoscope" });
                }
                if ($.grep(this.permissions, item => { return item.objectType === 120034; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(0, "Med. Verantwortlich / Medikamentausgabe"), section: "medicalResponsible", icon: "qm-icon-stethoscope" });
                }
                // Communication
                if ($.grep(this.permissions, item => { return item.objectType === 120004; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20001047, "Kommunikation"), section: "communication", icon: "qm-icon-book_telephone" });
                }
                // Contact Person
                if ($.grep(this.permissions, item => { return item.objectType === 120012; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20004000, "Kontaktpersonen"), section: "contactperson", icon: "qm-icon-users" });
                }
                // Document
                if ($.grep(this.permissions, item => { return item.objectType === 120007; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(21006000, "Dokumente"), section: "documents", icon: "qm-icon-document_attachment" });
                }
                //Training
                if ($.grep(this.permissions, item => { return item.objectType === 120023; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20033000, "Fähigkeit / Fortbildung"), section: "training", icon: "qm-icon-graduation_hat2" });
                }
                // Vaccination
                if ($.grep(this.permissions, item => { return item.objectType === 120046; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20009000, "Impfungen"), section: "vaccination", icon: "qm-icon-injection" });
                }
                //Adress
                if ($.grep(this.permissions, item => { return item.objectType === 120002; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20001511, "Adressen"), section: "address", icon: "qm-icon-location_pin" });
                }
                // Checklist
                if ($.grep(this.permissions, item => { return item.objectType === 120020; })[0].moduleAccess) {
                    this.menuItems.push({ caption: this.lng.translate(20011505, "Checklisten"), section: "checklist", icon: "qm-icon-check" });
                }
                this.addUdfMenu();
                this.menuItems = this.menuItems.sort((a, b) => { return a.caption > b.caption ? 1 : a.caption < b.caption ? -1 : 0; });
                this.menuItems.unshift({ caption: this.lng.translate(21002031, "Deckblatt"), section: "cover", icon: "qm-icon-form" });
                // Extended main data
                if ($.grep(this.permissions, item => { return item.objectType === 120033; })[0].moduleAccess) {
                    this.menuItems.splice(1, 0, { caption: this.lng.translate(21002048, "Erweiterte Stammdaten"), section: "extendedMainData", icon: "qm-icon-id_cards" });
                }
            }
            addUdfMenu() {
                this.udf.sort((a, b) => { return a.caption > b.caption ? 1 : a.caption < b.caption ? -1 : 0; }).forEach(udf => {
                    this.menuItems.push({
                        caption: udf.caption, section: `udf/${udf.type}/${udf.definitionId}/${udf.objectType}`, icon: "qm-icon-window_explorer"
                    });
                });
            }
            /**
             * change the section given by the view
             *
             * @private
             * @param {string} section
             *
             * @memberOf StammdatenClientDetailController
             */
            changeSection(section) {
                this.section = section;
                console.log("SECTION", section);
                this.$location.search('');
                this.$location.path(`employee/${this.id}/${section}/${this.id}`);
                $('#mobile-data').css('display', 'none'); // Hide mobile menu after selecting a section
                this.toggleInfoBox(false);
            }
            toggleInfoBox(state = !this.showInfoBox) {
                const header = window.getComputedStyle(document.getElementById('largerEmployeeDetailHeader'));
                if (header.display === 'none')
                    return; // if we got no option to show details again, never hide them
                const element = document.getElementById('infoContent');
                this.showInfoBox = state;
                if (this.showInfoBox)
                    element.style.display = 'unset';
                else
                    element.style.display = 'none';
            }
            editEmployee() {
                this.formState = "edit";
                this.$qui.functionWaiter("createForm", this);
                $('#edit-employee').modal('toggle');
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            getEmployee() {
                this.loading = true;
                this.employeeService.getEmployee(this.id).then((data) => {
                    this.employee = data;
                    const birthday = moment(data.birthday);
                    const prehistoric = moment('1900-01-01').endOf('day');
                    this.form.birthday = birthday <= prehistoric ? null : this.form.birthday;
                    this.form = angular.copy(data);
                    this.age = birthday <= prehistoric ? '?' : moment().diff(birthday, 'years');
                }).finally(() => {
                    this.loading = false;
                });
            }
            getEmployeeImage() {
                this.employeeService.getEmployeeImage(this.id, true).then((data) => {
                    if (data.imageData.length > 1) {
                        this.avatar = data.imageData;
                    }
                });
            }
            getEmployeeWv() {
                this.loadingWv = true;
                this.employeeService.getEmployeeWv().then((data) => {
                    this.wv = data;
                }).finally(() => {
                    this.loadingWv = false;
                });
            }
            updateEmployee(form) {
                this.loading = true;
                this.employeeService.putEmployee(form.objectId, form).then(() => {
                    this.getEmployee();
                }).catch(() => {
                    this.loading = false;
                });
            }
            getSalutationList() {
                return this.wv.salutationWvList.map(x => ({ text: x.name, value: x.objectId }));
            }
            getTitleList() {
                return this.wv.titleWvList.map(x => ({ text: x.name, value: x.objectId }));
            }
            getSecondTitleList() {
                return this.wv.secondTitleWvList.map(x => ({ text: x.name, value: x.objectId }));
            }
            getGenderList() {
                return this.wv.genderWvList.map(x => ({ text: x.name, value: x.objectId }));
            }
            getStatusList() {
                return this.wv.personStatusWvList.map(x => ({ text: x.name, value: x.objectId }));
            }
        };
        EmployeeDetailController = __decorate([
            QMC.Controller('QMC.Employee', 'EmployeeDetailController'),
            QMC.Inject('$qui', '$stateParams', '$scope', '$location', 'QmcLanguageService', 'EmployeeService', 'QmcPermissionService', 'QmcUdfService')
        ], EmployeeDetailController);
    })(Employee = QMC.Employee || (QMC.Employee = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Employee;
    (function (Employee) {
        let EmployeeService = class EmployeeService extends QMC.Common.BaseService {
            constructor($http, $q) {
                super($http, $q);
                this.$http = $http;
                this.$q = $q;
                this.modulePath = '/Person/Employee';
            }
            getEmployeeList() {
                return super.get(this.modulePath, {}, (data) => {
                    return data;
                });
            }
            getEmployeeListByPredfinedSearch(id, page, pagesize = 30, searchString = '', searchProperties = [], sortBy = '', sortDescending = false) {
                return super.getItem(this.modulePath + '/ByPredefinedSearch/' + id, { listSearch: searchString, page: page, pageSize: pagesize, searchProperties, sortBy, sortDecending: sortDescending }, (data) => {
                    return data;
                });
            }
            getPredefinedSearches() {
                return super.get('/PredefinedSearch', { objecttype: 120000 }, (data) => {
                    return data;
                });
            }
            getEmployee(id) {
                return super.getItem(this.modulePath + '/' + id, {}, (data) => {
                    return data;
                });
            }
            getEmployeeWv() {
                return super.getItem(this.modulePath + '/WvModel', {}, (data) => {
                    return data;
                });
            }
            putEmployee(parentObjectId, data) {
                return super.put(this.modulePath + '/' + parentObjectId, data).then((data) => {
                    console.log(data);
                    return data;
                });
            }
            getEmployeeImage(id, thumbnail, objectType = 120006) {
                if (id !== undefined) {
                    const thumbnailString = thumbnail ? 'true' : 'false';
                    return super.cachedGetItem('/Media/Image/MainImage', { parentObjectId: id, getThumbnail: thumbnailString, objectType: objectType }, (data) => {
                        return data;
                    });
                }
                return null;
            }
        };
        EmployeeService = __decorate([
            QMC.Service('QMC.Employee', 'EmployeeService'),
            QMC.Inject('$http', '$q')
        ], EmployeeService);
        Employee.EmployeeService = EmployeeService;
    })(Employee = QMC.Employee || (QMC.Employee = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailAddressController = class DetailAddressController {
            /**
             * QMC.Stammdaten.DetailAdressController
             * @constructor
             * @param stammdatenService
             * @param $qui
             * @param clientService
             * @param $stateParams
             * @param $scope
             * @param $state
             * @param lng
             */
            constructor(stammdatenService, $qui, clientService, $stateParams, $scope, $state, lng, permissionService, userService, $timeout, $location, udfService) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$stateParams = $stateParams;
                this.$scope = $scope;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.$timeout = $timeout;
                this.$location = $location;
                //formModalId = 'edit-form';
                this.formModalId = 'edit-form';
                this.allowTableExport = false;
                this.ui = new Stammdaten.DetailUI(this.formModalId);
                this.shouldLoadTableData = true;
                this.udfs = [];
                $scope.Model = $scope.Model || { Name: "xxx" };
                this.id = $stateParams.id;
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.parentObjectType = 120000;
                        this.objectType = 120002;
                        this.documentObjectType = 120007;
                        break;
                    default:
                        this.parentObjectType = 140000;
                        this.objectType = 140021;
                        this.documentObjectType = 140117;
                        break;
                }
                permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType]).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.moduleAccess = data[0].moduleAccess && data[0].view;
                    this.allowTableExport = data[0].print;
                    this.enableDocuments = data[1].moduleAccess;
                    $timeout(() => {
                        if (!this.new)
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                        else
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'unset');
                    });
                    this.getWv();
                    this.getData();
                });
                //$qui.init("stammdaten", () => {
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $(".qm-card").unbind("click");
                });
                this.lang = lng;
                this.promptOptions = {
                    title: "Adresse",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lang.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                const vm = this;
                $timeout(() => $(`#${this.formModalId}`).on('hidden.bs.modal', () => {
                    this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(() => vm.initForm());
                    $(`#edit-form`).find('.tab-content').children().removeClass('in').removeClass('active');
                    $(`#edit-form`).find('.tab-content').find('#baseDataTab').addClass('in active');
                }));
                udfService.getUserDefinedFields(this.objectType).then((data) => {
                    this.udfs = data.sort((a, b) => a.caption.localeCompare(b.caption));
                });
            }
            getData() {
                this.getAdress();
            }
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * Init view events
             *
             * @private
             *
             * @memberOf DetailAddressController
             */
            events() {
                var vm = this;
                $("#city .typeahead").typeahead({
                    minLength: 3,
                    source: function (query, process) {
                        vm.stammdatenService.getPostCodeByCityList(vm.form.objectIdCountry, query).then(function (data) {
                            process(data.map(function (obj) {
                                return obj.postCodeAndCity;
                            }));
                        });
                    },
                    updater: function (item) {
                        var data = item.split("...");
                        vm.form.postCode = data[0];
                        $("#postCode input").val(data[0]).trigger("change");
                        return data[1];
                    }
                });
                $("#postCode .typeahead").typeahead({
                    minLength: 3,
                    source: function (query, process) {
                        vm.stammdatenService.getCityByPostCodeList(vm.form.objectIdCountry, query).then(function (data) {
                            process(data.map(function (obj) {
                                return obj.postCodeAndCity;
                            }));
                        });
                    },
                    updater: function (item) {
                        var data = item.split("...");
                        vm.form.city = data[1];
                        $("#city input").val(data[1]).trigger("change");
                        return data[0];
                    }
                });
            }
            /**
             * init form
             *
             * @private
             *
             * @memberOf DetailAddressController
             */
            initForm() {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    objectType: this.objectType,
                    parentObjectType: this.parentObjectType,
                    parentObjectId: this.id,
                    street: null,
                    houseNumber: null,
                    addressAddition: null,
                    postCode: null,
                    city: null,
                    dateFrom: null,
                    dateTo: null,
                    objectIdCountry: QMC.Common.Constants.DEFAULT_COUNTRY_ID,
                    objectIdState: null,
                    objectIdAddressType: null,
                    isMainRecord: true,
                    isPostOfficeBox: false,
                    isHouseless: false,
                    comment: null,
                    isDatatransferForbidden: false,
                    isEmergency: false
                };
                this.userService.getUserSettings(["GLOBAL.DEFAULTLAND"], false).then((dataGlobal) => {
                    this.form.objectIdCountry = dataGlobal[0].value;
                });
                this.userService.getUserSettings(["GLOBAL.DEFAULTBUNDESLAND"], false).then((dataGlobal) => {
                    this.form.objectIdState = dataGlobal[0].value;
                });
                this.$qui.functionWaiter("ui.createForm", this);
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the address type list
             *
             * @private
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailAddressController
             */
            getAdressTypeList() {
                return this.wv.addressTypeWvList.map(obj => ({
                    value: obj.objectId,
                    text: obj.name
                }));
            }
            /**
             * get the country list
             *
             * @private
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailAddressController
             */
            getCountryList() {
                return this.stammdatenService.getAddressWv().then((data) => {
                    return this.ui.select(data.countriesWvList, { value: "objectId", text: "name" });
                });
            }
            /**
             * get the state list
             *
             * @private
             * @param {Guid} id
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailAddressController
             */
            getStatesList(id) {
                if (this.form.objectIdCountry === null)
                    return null;
                this.form.objectIdState = null;
                return this.stammdatenService.getStatesWv(this.form.objectIdCountry).then((data) => {
                    return this.ui.select(data, { value: "id", text: "caption" });
                });
            }
            /**
             * get the wv list
             *
             * @private
             *
             * @memberOf DetailAddressController
             */
            getWv() {
                this.loading = true;
                this.stammdatenService.getAddressWv().then((data) => {
                    this.wv = data;
                    this.initForm();
                    this.$qui.functionWaiter("ui.createForm", this);
                    setTimeout(() => {
                        this.events();
                    }, 200);
                    this.loading = false;
                });
            }
            /**
             * get all addresses
             *
             * @private
             *
             * @memberOf DetailAddressController
             */
            getAdress() {
                this.loading = true;
                this.stammdatenService.getAddressList(this.id).then((data) => {
                    data = data.map((obj) => {
                        if (obj.isDatatransferForbidden)
                            obj.style = { 'background-color': 'orangered', 'color': 'white', 'font-weight': 'bold' };
                        return obj;
                    });
                    this.ui.addressTable.data = data;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.loading = false;
                    if (this.$stateParams.dataId) {
                        const address = data.filter(x => x.objectId === this.$stateParams.dataId)[0];
                        console.log('open', this.$stateParams.dataId, this.formModalId, address);
                        if (address) {
                            $(`#${this.formModalId}`).modal('show');
                            this.editAdress(address);
                        }
                    }
                });
            }
            /**
             * add an address
             *
             * @private
             * @param {IAddress} form
             *
             * @memberOf DetailAddressController
             */
            addAddress(form) {
                form.parentObjectId = this.id;
                this.loading = true;
                this.stammdatenService.postAddress(form).then((e) => {
                    this.ui.notify(this.ui.successNote);
                    this.getAdress();
                    this.formState = "new";
                    $(`#${this.formModalId}`).modal('hide');
                });
            }
            /**
             * put an existing address
             *
             * @private
             * @param {IAddress} form
             *
             * @memberOf DetailAddressController
             */
            putAddress(form) {
                form.parentObjectId = this.id;
                this.loading = true;
                this.stammdatenService.putAddress(form.parentObjectId, form.objectId, form).then((data) => {
                    this.ui.notify(this.ui.successNote);
                    this.getAdress();
                    this.formState = "new";
                    $(`#${this.formModalId}`).modal('hide');
                });
                this.udfs.forEach(x => { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            }
            /**
             * delete an existing address
             *
             * @private
             * @param {IAddress} data
             *
             * @memberOf DetailAddressController
             */
            deleteAdress(item) {
                this.promptOptions.itemText = item.streetAndHouseNumber + ", " + item.postCode + " " + item.city;
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data) {
                        this.loading = true;
                        this.stammdatenService.deleteAddress(this.id, item.objectId).then((dataDelete) => {
                            this.ui.notify(this.ui.deleteNote);
                            this.getAdress();
                            this.formState = "new";
                            $(`#${this.formModalId}`).modal('hide');
                        });
                    }
                });
            }
            /**
             * edit an existing address
             *
             * @private
             * @param {IAddress} data
             *
             * @memberOf DetailAddressController
             */
            editAdress(data) {
                this.formState = "edit";
                this.form = angular.copy(data);
                if (data.dateFrom != null) {
                    this.form.dateFrom = moment(data.dateFrom).toDate();
                }
                if (this.form.dateTo !== null)
                    this.form.dateTo = moment(data.dateTo).toDate();
                this.$qui.waitForEl('#standardTabButton', () => {
                    $('#standardTabButton').click();
                });
                this.$state.go('.', { dataId: data.objectId });
            }
        };
        DetailAddressController = __decorate([
            QMC.Controller("QMC.Stammdaten", "DetailAddressController"),
            QMC.Inject("StammdatenService", "$qui", "KlientService", "$stateParams", "$scope", "$state", "QmcLanguageService", "QmcPermissionService", 'UserService', '$timeout', '$location', 'QmcUdfService')
        ], DetailAddressController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailAdmissionController = class DetailAdmissionController {
            constructor($scope, stammdatenService, $qui, $stateParams, $state, lng, permissionService, userService, $timeout, udfService) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$state = $state;
                this.lng = lng;
                this.userService = userService;
                this.objectType = 140011;
                this.documentObjectType = 140123;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.shouldLoadTableData = true;
                this.isLoading = {
                    data: false,
                    auxiliary: false,
                    detail: false
                };
                this.promptOptions = {
                    title: this.lng.translate(20006502, "Aufnahme löschen"),
                    yesNo: true,
                    icon: "qm-icon-arrow_into",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?"),
                    itemText: ''
                };
                this.udfs = [];
                this.validation = {
                    loading: false,
                    errors: [],
                    warnings: []
                };
                this.parentId = $stateParams.id;
                this.isLoading.auxiliary = true;
                Promise.all([permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType]), stammdatenService.getAdmissionWv()])
                    .then(datas => {
                    this.enableDocuments = datas[0][1].moduleAccess;
                    const permission = datas[0][0];
                    this.delete = permission.delete;
                    this.new = permission.new;
                    this.modify = permission.modify;
                    this.moduleAccess = permission.moduleAccess && permission.view;
                    this.allowTableExport = permission.print;
                    this.wvData = datas[1];
                    this.$qui.waitForEl('#newModalButton', () => {
                        document.getElementById('newModalButton').style.visibility = this.new ? 'unset' : 'hidden';
                    });
                    if (permission.moduleAccess)
                        this.getData();
                })
                    .finally(() => this.isLoading.auxiliary = false);
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                $(`#edit-form`).on('hidden.bs.modal', () => {
                    this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(() => this.initForm());
                });
                this.initForm();
                udfService.getUserDefinedFields(this.objectType).then((data) => {
                    this.udfs = data.sort((a, b) => a.caption.localeCompare(b.caption));
                });
                $scope.$watch('vm.form.objectId', () => this.validateAdmission({
                    instituteId: this.form.instituteId,
                    parentId: this.parentId,
                    admissionId: this.form.objectId,
                    date: this.form.date
                }));
                if ($stateParams.dataId)
                    this.editRow({ id: $stateParams.dataId, objectId: $stateParams.dataId, reasonIds: [], date: moment().startOf('day').toDate(), isPlaceOfAccomodation: false });
            }
            /////////////// DISPLAY LOGIC ///////////////
            initForm() {
                this.form = {
                    id: null,
                    objectId: null,
                    reasonIds: [],
                    isPlaceOfAccomodation: false,
                    date: moment().startOf('day').toDate()
                };
                // Initialize internal date/time fields for the form
                this.form.internalDate = moment(this.form.date).toDate();
                this.form.internalTime = moment(this.form.date).toDate();
                this.$qui.waitForEl(`#standardTabButton`, () => {
                    $(`#standardTabButton`).click();
                });
            }
            openForm() {
                $(`#edit-form`).modal('show');
            }
            editRow(row) {
                this.udfs.forEach(udf => udf.isValid = false);
                this.openForm();
                this.isLoading.detail = true;
                this.stammdatenService.getAdmission(this.parentId, row.objectId)
                    .then(data => {
                    this.form = data;
                    // Initialize internal date/time fields for editing
                    this.form.internalDate = moment(this.form.date).toDate();
                    this.form.internalTime = moment(this.form.date).toDate();
                })
                    .catch(() => this.initForm())
                    .finally(() => this.isLoading.detail = false);
            }
            deleteRow(row) {
                this.promptOptions.itemText = `${row.parentFacility} (${moment(row.date).format('DD.MM.YYYY')})`;
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data) {
                        this.isLoading.data = true;
                        this.stammdatenService.deleteAdmission(this.parentId, row.objectId).finally(() => this.getData());
                    }
                });
            }
            saveForm(form) {
                if (!this.isFormValid)
                    return;
                const saveAction = () => {
                    this.isLoading.data = true;
                    if (this.formState === 'new')
                        this.stammdatenService.postAdmission(this.parentId, form)
                            .then(() => $(`#edit-form`).modal('hide'))
                            .finally(() => this.getData());
                    else {
                        this.udfs.forEach(x => { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
                        this.stammdatenService.putAdmission(this.parentId, form.objectId, form)
                            .then(() => $(`#edit-form`).modal('hide'))
                            .finally(() => this.getData());
                    }
                };
                const currentValidation = {
                    parentId: this.parentId,
                    admissionId: form.objectId,
                    instituteId: form.instituteId,
                    date: form.date
                };
                if (JSON.stringify(currentValidation) === JSON.stringify(this.lastValidatedForm) && !this.validation.errors.length) {
                    saveAction();
                }
                else {
                    this.validateAdmission(currentValidation, saveAction);
                }
            }
            getData() {
                this.isLoading.data = true;
                this.stammdatenService.getAdmissionList(this.parentId)
                    .then(data => {
                    data.forEach(row => {
                        var _a, _b, _c;
                        row.initiatorType = (_a = this.wvData.initiatorTypeWvList.find(x => x.objectId === row.initiatorTypeId)) === null || _a === void 0 ? void 0 : _a.name;
                        row.severityOfAbnormability = (_b = this.wvData.severityOfAbnormabilityWvList.find(x => x.objectId === row.severityOfAbnormabilityId)) === null || _b === void 0 ? void 0 : _b.name;
                        row.migrationBackground = (_c = this.wvData.migrationBackgroundWvList.find(x => x.objectId === row.migrationBackgroundId)) === null || _c === void 0 ? void 0 : _c.name;
                    });
                    this.ui.admissionTable.data = data;
                })
                    .catch(() => this.ui.dismissalTable.data = [])
                    .finally(() => {
                    this.isLoading.data = false;
                    this.$qui.functionWaiter("ui.createTable", this);
                });
            }
            anyUdfInvalid() {
                return this.formState === 'edit' && this.udfs.some(udf => !udf.isValid);
            }
            validateAdmission(admissionValidation, onSuccessfullValidation) {
                this.validation.loading = true;
                this.stammdatenService.validateAdmission(admissionValidation)
                    .then(data => {
                    this.validation.errors = data.errors;
                    this.validation.warnings = data.warnings;
                    if (!this.validation.errors.length && !this.validation.warnings.length) {
                        onSuccessfullValidation === null || onSuccessfullValidation === void 0 ? void 0 : onSuccessfullValidation();
                    }
                })
                    .catch(() => {
                    this.validation.warnings = [];
                    this.validation.errors = [this.lng.translate(21003023, 'Der Datensatz konnte nicht erfolgreich validiert werden.')];
                })
                    .finally(() => {
                    this.validation.loading = false;
                    this.lastValidatedForm = admissionValidation;
                });
            }
        };
        DetailAdmissionController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailAdmissionController'),
            QMC.Inject('$scope', 'StammdatenService', '$qui', '$stateParams', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout', 'QmcUdfService')
        ], DetailAdmissionController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailChecklistController = class DetailChecklistController {
            /**
             * Creates an instance of DetailChecklistController.
             *
             * @memberOf DetailChecklistController
             */
            constructor(stammdatenService, $qui, $stateParams, $scope, permissionService, userService, lng, $state, $location, $timeout, udfService) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$scope = $scope;
                this.permissionService = permissionService;
                this.userService = userService;
                this.lng = lng;
                this.$state = $state;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.checkListItems = [];
                this.formState = 'new';
                this.cacheName = 'checklistCache';
                this.shouldLoadTableData = true;
                this.udfs = [];
                this.promptOptions = {
                    title: this.lng.translate(20011510, 'Checklisteneinträge'),
                    yesNo: true,
                    icon: 'qm-icon-check',
                    text: this.lng.translate(20000299, 'Wollen Sie wirklich alle Einträge löschen?'),
                    itemText: ''
                };
                this.promptOptionsHistory = {
                    title: this.lng.translate(20011511, 'Checklisteneintrag'),
                    yesNo: true,
                    icon: 'qm-icon-check',
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?"),
                    itemText: ''
                };
                this.historyFormState = 'new';
                this.id = this.$stateParams.id;
                switch ($location.$$path.split('/')[1]) {
                    case 'employee':
                        this.parentObjectType = 120000;
                        this.objectType = 120020;
                        this.documentObjectType = 120021;
                        this.historyObjectType = 120022;
                        break;
                    default:
                        this.parentObjectType = 140000;
                        this.objectType = 140057;
                        this.documentObjectType = 140059;
                        this.historyObjectType = 140060;
                        break;
                }
                this.maps = {
                    list: []
                };
                this.loading = {
                    items: false,
                    list: false,
                    save: false
                };
                this.initForm();
                this.permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType, this.historyObjectType]).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.allowTableExport = data[0].print;
                    this.moduleAccess = data[0].moduleAccess && data[0].view;
                    this.documentPermissions = data[1];
                    this.historyDelete = data[2].delete && data[2].moduleAccess;
                    this.historyModify = data[2].modify && data[2].moduleAccess;
                    this.historyNew = data[2].new && data[2].moduleAccess;
                    this.historyModuleAccess = data[2].moduleAccess && data[2].view;
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.$qui.waitForEl('#newModalButton', () => {
                    document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                });
                this.events();
                this.getChecklists();
                const vm = this;
                $timeout(() => $(`#edit-form`).on('hidden.bs.modal', () => {
                    this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(() => vm.initForm());
                    $(`#edit-form`).find('.tab-content').children().removeClass('in').removeClass('active');
                    $(`#edit-form`).find('.tab-content').find('#baseDataTab').addClass('in active');
                }));
                udfService.getUserDefinedFields(this.objectType).then((data) => {
                    this.udfs = data.sort((a, b) => a.caption.localeCompare(b.caption));
                });
            }
            /**
             * init the form with default values
             *
             * @private
             *
             * @memberOf DetailChecklistController
             */
            initForm() {
                this.form = {
                    id: null,
                    objectId: null,
                    date: new Date(),
                    dateShowAgain: null,
                    dateFrom: null,
                    dateTo: null,
                    comment: null,
                    caption: '',
                    order: 0,
                    checklistId: null,
                    checklistItemId: null,
                    history: [],
                    reminder: 0,
                    reminderActive: false
                };
                this.$qui.functionWaiter("ui.createForm", this);
            }
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * create events for the view
             *
             * @private
             *
             * @memberOf DetailChecklistController
             */
            events() {
                this.$scope.$watch('vm.checkListId', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    this.checkListItems = [];
                    if (!this.checkListId || this.checkListId.length === 0)
                        return;
                    this.getCheckListItems();
                });
            }
            getList() {
                return this.maps.list;
            }
            getData() {
                this.getCheckListItems();
            }
            formatItemForTable(item) {
                item.state = this.lng.translate(20011512, 'keiner');
                if (item.date) {
                    item.isChecked = true;
                    item.date = this.$qui.createDateFromString(item.date);
                    item.state = this.lng.translate(20011513, 'gültig');
                }
                ;
                if (item.dateFrom)
                    item.dateFrom = this.$qui.createDateFromString(item.dateFrom);
                if (item.dateTo)
                    item.dateTo = this.$qui.createDateFromString(item.dateTo);
                if (item.dateShowAgain)
                    item.dateShowAgain = this.$qui.createDateFromString(item.dateShowAgain);
                if (item.dateTo && item.dateTo < new Date()) {
                    item.isChecked = 'invalid';
                    item.state = this.lng.translate(20011514, 'abgelaufen');
                }
                else if (item.dateFrom && item.dateFrom > new Date()) {
                    item.isChecked = 'invalid';
                    item.state = this.lng.translate(20011515, 'zukünftig');
                }
                return item;
            }
            toggleCommentModal(data) {
                this.commentModalData = data;
                $('#commentModal').modal('show');
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the list of checklists
             *
             * @private
             *
             * @memberOf DetailChecklistController
             */
            getChecklists() {
                this.loading.list = true;
                this.stammdatenService.getChecklistList(this.parentObjectType).then((data) => {
                    this.maps.list = data.map(x => ({ text: x.caption, value: x.objectId, group: x.category }));
                    if (data.length === 1) {
                        this.checkListId = data[0].objectId;
                        this.getCheckListItems();
                    }
                    else if (QMC.Common.personalLocalStorage.getItem(this.cacheName) && this.maps.list.some(x => x.value === QMC.Common.personalLocalStorage.getItem(this.cacheName))) {
                        this.checkListId = QMC.Common.personalLocalStorage.getItem(this.cacheName);
                    }
                    this.loading.list = false;
                });
            }
            getCheckListItems() {
                if (!this.checkListId || this.checkListId === QMC.Common.Constants.GUID_EMPTY)
                    return;
                this.loading.items = true;
                QMC.Common.personalLocalStorage.setItem(this.cacheName, this.checkListId);
                this.ui.checklistTable.data = [];
                this.stammdatenService.getChecklistItemList(this.id, this.checkListId).then((data) => {
                    for (let item of data) {
                        item = this.formatItemForTable(item);
                    }
                    this.ui.checklistTable.data = data.sort((a, b) => { return a.order - b.order; });
                    this.loading.items = false;
                    this.$qui.functionWaiter("ui.createTable", this);
                    if (this.$stateParams.dataId) {
                        const item = data.filter(x => x.objectId === this.$stateParams.dataId)[0];
                        if (item) {
                            $(`#edit-form`).modal('show');
                            this.editCheck(item);
                        }
                    }
                });
            }
            newCheck(data) {
                this.formState = 'new';
                this.initForm();
                this.form.checklistItemId = data.checklistItemId;
                this.form.checklistId = data.checklistId;
                this.form.caption = data.caption;
                this.$qui.waitForEl('#standardTabButton', () => {
                    $('#standardTabButton').click();
                });
            }
            editCheck(data) {
                this.formState = 'edit';
                this.loading.save = true;
                this.stammdatenService.getChecklistItem(this.id, data.checklistId, data.checklistItemId).then((data) => {
                    if (data.date)
                        data.date = this.$qui.createDateFromString(data.date);
                    if (data.dateFrom)
                        data.dateFrom = this.$qui.createDateFromString(data.dateFrom);
                    if (data.dateTo)
                        data.dateTo = this.$qui.createDateFromString(data.dateTo);
                    if (data.dateShowAgain)
                        data.dateShowAgain = this.$qui.createDateFromString(data.dateShowAgain);
                    this.form = data;
                    for (let item of data.history) {
                        item = this.formatItemForTable(item);
                    }
                    this.ui.checklistHistoryTable.data = data.history.sort((a, b) => { return a.order - b.order; });
                    this.$qui.functionWaiter("createHistoryTable", this);
                }).finally(() => {
                    this.loading.save = false;
                });
                this.$qui.waitForEl('#standardTabButton', () => {
                    $('#standardTabButton').click();
                });
                this.$state.go('.', { dataId: data.objectId });
            }
            addChecklist(data) {
                this.loading.save = true;
                this.loading.items = true;
                this.stammdatenService.postCheckedItem(this.id, data).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.getCheckListItems();
                    $('#edit-form').modal('hide');
                }).finally(() => {
                    this.loading.save = false;
                });
            }
            putChecklist(data) {
                this.loading.save = true;
                this.loading.items = true;
                this.stammdatenService.putCheckedItem(this.id, data.objectId, data).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.getCheckListItems();
                    $('#edit-form').modal('hide');
                    $('#historyFormModal').modal('hide');
                }).finally(() => {
                    this.loading.save = false;
                });
                this.udfs.forEach(x => { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            }
            deleteCheck(data) {
                this.promptOptions.itemText = data.caption;
                QMC.Common.Utilities.confirm(this.promptOptions, (decission) => {
                    if (decission) {
                        this.loading.save = true;
                        this.stammdatenService.deleteCheckedItems(this.$stateParams.client, data.checklistItemId).then(() => {
                            this.ui.notify(this.ui.deleteNote);
                            this.getCheckListItems();
                            this.formState = "new";
                        }).finally(() => {
                            this.loading.save = false;
                        });
                    }
                    $('#edit-form').modal('hide');
                });
            }
            editHistory(data) {
                this.historyFormState = 'edit';
                this.historyForm = angular.copy(data);
                this.createHistoryForm();
                this.$qui.functionWaiter("createHistoryDirective", this);
                this.$qui.functionWaiter("createHistoryForm", this);
                this.$qui.waitForEl('#standardHistoryTabButton', () => {
                    $('#standardHistoryTabButton').click();
                });
            }
            deleteHistory(data) {
                this.promptOptionsHistory.itemText = `${data.state} ${this.lng.translate(20000218, 'vom')} ${moment(data.date).format('DD.MM.yyyy')}`;
                QMC.Common.Utilities.confirm(this.promptOptionsHistory, (decission) => {
                    if (decission) {
                        this.loading.save = true;
                        this.stammdatenService.deleteCheckedItem(this.$stateParams.client, data.checklistItemId, data.objectId).then(() => {
                            this.ui.notify(this.ui.deleteNote);
                            this.getCheckListItems();
                            this.historyFormState = "new";
                        }).finally(() => {
                            this.loading.save = false;
                        });
                        $('#edit-form').modal('hide');
                    }
                }, '#historyDeletePrompt');
            }
        };
        DetailChecklistController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailChecklistController'),
            QMC.Inject('StammdatenService', '$qui', '$stateParams', '$scope', 'QmcPermissionService', 'UserService', 'QmcLanguageService', '$state', '$location', '$timeout', 'QmcUdfService')
        ], DetailChecklistController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailClientInfoController = class DetailClientInfoController {
            /**
             * QMC.Stammdaten.DetailAbsenteeismController
             * @constructor
             * @param stammdatenService
             * @param clientService
             * @param $stateParams
             * @param $scope
             * @param $state
             * @param lng
             */
            constructor($qui, $stateParams, userService, lngService) {
                this.$qui = $qui;
                this.userService = userService;
                this.lngService = lngService;
                this.selectedClients = [];
                this.isMobile = QMC.Common.Constants.IS_MOBILE;
                this.newView = true;
                this.selectedClients.push($stateParams.id);
                this.$qui.waitForEl('#newModalButton', () => {
                    document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                });
                const ceBaseUrl = $('#session').data().ceUrl;
                this.allowExchange = (ceBaseUrl || ceBaseUrl.length > 0);
                this.newView = this.allowExchange;
                this.$qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
            }
            toggleView() {
                this.userService.postActionLogEntry({ type: this.newView ? 11 : 10, source: 1, area: 'ClientInformation', reference: 'toggle' });
                this.newView = !this.newView;
            }
            getTooltip() {
                return this.lngService.translate(this.newView ? 20000322 : 20000321, 'Ansicht wechseln');
            }
        };
        DetailClientInfoController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailClientInfoController'),
            QMC.Inject('$qui', '$stateParams', 'UserService', 'QmcLanguageService')
        ], DetailClientInfoController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailCommunicationController = class DetailCommunicationController {
            /**
             * Creates an instance of DetailCommunicationController.
             *
             * @memberOf DetailCommunicationController
             */
            constructor(stammdatenService, $qui, $stateParams, $scope, $state, lng, permissionService, userService, $timeout, $location, udfService) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.lng = lng;
                this.userService = userService;
                this.$location = $location;
                this.allowTableExport = false;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.shouldLoadTableData = true;
                this.enableDocuments = false;
                this.udfs = [];
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.id = $stateParams.id;
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.parentObjectType = 120000;
                        this.objectType = 120004;
                        this.documentObjectType = 120050;
                        break;
                    default:
                        this.parentObjectType = 140000;
                        this.objectType = 140023;
                        this.documentObjectType = 140118;
                        break;
                }
                permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType]).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.moduleAccess = data[0].moduleAccess && data[0].view;
                    this.allowTableExport = data[0].print;
                    this.enableDocuments = data[1].moduleAccess;
                    $timeout(() => {
                        if (!this.new)
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                        else
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'unset');
                    });
                    this.getWv();
                    this.userService.getUserSettings(["KOMMUNIKATION.ENABLE.EMAILSEND", "KOMMUNIKATION.ENABLE.TELCALL", "KOMMUNIKATION.ENABLE.URLOPEN"], false).then((data) => {
                        this.linkSetting = {
                            mail: data[0].value.toLowerCase() === 'true',
                            tele: data[1].value.toLowerCase() === 'true',
                            href: data[2].value.toLowerCase() === 'true'
                        };
                        this.getData();
                    });
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.promptOptions = {
                    title: "Kommunikation",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, 'Wollen Sie den Eintrag wirklich löschen?')
                };
                const vm = this;
                $(`#edit-form`).on('hidden.bs.modal', () => {
                    this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(() => vm.initForm());
                    $(`#edit-form`).find('.tab-content').children().removeClass('in').removeClass('active');
                    $(`#edit-form`).find('.tab-content').find('#baseDataTab').addClass('in active');
                });
                udfService.getUserDefinedFields(this.objectType).then((data) => {
                    this.udfs = data.sort((a, b) => a.caption.localeCompare(b.caption));
                });
            }
            /**
             * init the form with default values
             *
             * @private
             *
             * @memberOf DetailCommunicationController
             */
            initForm() {
                this.formState = 'new';
                this.form = {
                    id: null,
                    objectId: null,
                    dateFrom: null,
                    dateTo: null,
                    targetAddress: null,
                    isMainRecord: true,
                    isTypeMain: true,
                    communicationCategoryId: null,
                    communicationTypeId: "53fd55a0-9efe-41aa-9099-5c3b7b4e972f",
                    communicationTypeName: null,
                    comment: null,
                    countryCode: null,
                    areaCode: null,
                    isDatatransferForbidden: false,
                    displayAddress: null,
                    objectType: this.objectType,
                    parentObjectType: this.parentObjectType
                };
                this.$qui.functionWaiter("ui.createForm", this);
            }
            getData() {
                this.getCommunications();
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the communication type list
             *
             * @private
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailCommunicationController
             */
            getCommunicationTypeList() {
                return this.wvList.communicationTypeWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name,
                        isFix: obj.isFix
                    };
                });
            }
            /**
             * get the communication category list
             *
             * @private
             * @param {Guid} id
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailCommunicationController
             */
            getCommunicationCategoryList() {
                if (this.form.communicationCategoryName === "")
                    this.form.communicationCategoryId = null;
                for (let i = 0; i < this.wvList.communicationTypeWvList.length; i++) {
                    if (this.wvList.communicationTypeWvList[i].id === this.form.communicationTypeId) {
                        this.form.communicationTypeName = this.wvList.communicationTypeWvList[i].name.charAt(0).toLowerCase() + this.wvList.communicationTypeWvList[i].name.slice(1);
                        ;
                        break;
                    }
                }
                if (this.form.communicationTypeName !== (null || undefined || "") && this.wvList !== (null || undefined)) {
                    return this.wvList.communicationCategoryWvList[this.form.communicationTypeName].map(function (obj) {
                        return {
                            value: obj.id,
                            text: obj.name,
                            isFix: obj.isFix
                        };
                    });
                }
                else {
                    return null;
                }
            }
            /**
             * get the list of communications
             *
             * @private
             *
             * @memberOf DetailCommunicationController
             */
            getCommunications() {
                this.stammdatenService.getCommunicationList(this.id).then((data) => {
                    data = data.map(function (obj) {
                        if (obj.isDatatransferForbidden)
                            obj.style = { 'background-color': 'orangered', 'color': 'white', 'font-weight': 'bold' };
                        switch (obj.communicationTypeId) {
                            case '930511d9-aa40-4927-b8b0-bbfc2e040de6': // fax
                            case '6729f858-ca6d-4efe-8397-376133a2d974': // telephon
                                obj.type = this.linkSetting.tele ? 'tel' : undefined;
                                break;
                            case 'f25005b8-3a66-4b36-9395-60ce7896f7d6': // website
                                obj.type = this.linkSetting.href ? 'site' : undefined;
                                break;
                            case '53fd55a0-9efe-41aa-9099-5c3b7b4e972f': // email
                                obj.type = this.linkSetting.mail ? 'mail' : undefined;
                                break;
                        }
                        return obj;
                    }.bind(this));
                    this.ui.communicationTable.data = data;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.loading = false;
                    if (this.$stateParams.dataId) {
                        const item = data.filter(x => x.objectId === this.$stateParams.dataId)[0];
                        if (item) {
                            $(`#edit-form`).modal('show');
                            this.editCommunication(item);
                        }
                    }
                });
            }
            /**
             * get the wv list
             *
             * @private
             *
             * @memberOf DetailCommunicationController
             */
            getWv() {
                this.stammdatenService.getCommunicationWv().then((data) => {
                    this.wvList = data;
                    this.initForm();
                    this.$qui.functionWaiter("ui.createForm", this);
                });
            }
            /**
             * add a communication
             *
             * @private
             * @param {ICommunication} form
             *
             * @memberOf DetailCommunicationController
             */
            addCommunication(form) {
                this.loading = true;
                form.parentObjectId = this.id;
                this.stammdatenService.postCommunication(form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    this.getCommunications();
                    $('#edit-form').modal('hide');
                });
            }
            /**
             * put an existing communication
             *
             * @private
             * @param {ICommunication} form
             *
             * @memberOf DetailCommunicationController
             */
            putCommunication() {
                this.loading = true;
                this.stammdatenService.putCommunication(this.form.parentObjectId, this.form.objectId, this.form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.getCommunications();
                    this.formState = "new";
                    $('#edit-form').modal('hide');
                });
                this.udfs.forEach(x => { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            }
            /**
             * delete an existing communication
             *
             * @private
             * @param {ICommunication} data
             *
             * @memberOf DetailCommunicationController
             */
            deleteCommunication(item) {
                this.promptOptions.itemText = item.communicationCategoryName.length > 0 ? item.communicationCategoryName + ": " + item.targetAddress : item.targetAddress;
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.stammdatenService.deleteCommunication(this.id, item.objectId).then(() => {
                            this.ui.notify(this.ui.deleteNote);
                            this.formState = "new";
                            this.getCommunications();
                        });
                });
            }
            /**
             * edit an existing communication
             *
             * @private
             * @param {ICommunication} data
             *
             * @memberOf DetailCommunicationController
             */
            editCommunication(data) {
                if (data.communicationCategoryName === "")
                    data.communicationCategoryId = null;
                this.formState = "edit";
                this.form = data;
                this.$qui.waitForEl('#standardTabButton', () => {
                    $('#standardTabButton').click();
                });
                this.$state.go('.', { dataId: data.objectId });
            }
        };
        DetailCommunicationController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailCommunicationController'),
            QMC.Inject('StammdatenService', '$qui', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout', '$location', 'QmcUdfService')
        ], DetailCommunicationController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailContactPersonController = class DetailContactPersonController {
            /**
             * Creates an instance of DetailContactPersonController.
             *
             * @memberOf DetailContactPersonController
             */
            constructor(stammdatenService, $qui, $stateParams, $scope, $state, lng, permissionService, userService, $timeout, $location, udfService) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$scope = $scope;
                this.$state = $state;
                this.lng = lng;
                this.userService = userService;
                this.$location = $location;
                this.allowTableExport = false;
                this.ui = new Stammdaten.DetailUI();
                this.selectedCategoryId = QMC.Common.Constants.GUID_EMPTY;
                this.shouldLoadTableData = true;
                this.addressLoading = false;
                //communication
                this.communicationLoading = false;
                this.enableDocuments = false;
                this.udfs = [];
                this.isConnectRegistrationAvailable = false;
                this.id = $stateParams.id;
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.parentObjectType = 120000;
                        this.objectType = 120012;
                        this.documentObjectType = 0;
                        break;
                    default:
                        this.parentObjectType = 140000;
                        this.objectType = 140006;
                        this.documentObjectType = 140119;
                        break;
                }
                this.adrObjectType = this.objectType === 140006 ? 140017 : 120014;
                this.comObjectType = this.objectType === 140006 ? 140028 : 120013;
                permissionService.getPermissionsByObjectTypes([this.objectType, this.adrObjectType, this.comObjectType, this.documentObjectType]).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.moduleAccess = data[0].moduleAccess && data[0].view;
                    this.allowTableExport = data[0].print;
                    this.enableDocuments = data[3].moduleAccess;
                    $timeout(() => {
                        if (!this.new)
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                        else
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'unset');
                    });
                    for (const permission of data) {
                        if (permission.objectType === this.adrObjectType) {
                            this.deleteAdr = permission.delete;
                            this.newAdr = permission.new;
                            this.modifyAdr = permission.modify;
                            this.moduleAccessAdr = permission.moduleAccess && permission.view;
                        }
                        if (permission.objectType === this.comObjectType) {
                            this.deleteCom = permission.delete;
                            this.newCom = permission.new;
                            this.modifyCom = permission.modify;
                            this.moduleAccessCom = permission.moduleAccess && permission.view;
                        }
                    }
                    this.userService.getUserSettings(["KOMMUNIKATION.ENABLE.EMAILSEND", "KOMMUNIKATION.ENABLE.TELCALL", "KOMMUNIKATION.ENABLE.URLOPEN"], false).then((data) => {
                        this.linkSetting = {
                            mail: data[0].value.toLowerCase() === 'true',
                            tele: data[1].value.toLowerCase() === 'true',
                            href: data[2].value.toLowerCase() === 'true'
                        };
                        this.getWvList();
                        this.getCategories();
                    });
                });
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.lang = lng;
                this.promptOptions = {
                    title: this.lang.translate(20004502, "Kontaktpersonen löschen"),
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lang.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                const vm = this;
                $(`#edit-form`).on('hidden.bs.modal', () => {
                    this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(() => vm.initForm());
                    $(`#edit-form`).find('.tab-content').children().removeClass('in').removeClass('active');
                    $(`#edit-form`).find('.tab-content').find('#baseDataTab').addClass('in active');
                });
                udfService.getUserDefinedFields(this.objectType).then((data) => {
                    this.udfs = data.sort((a, b) => a.caption.localeCompare(b.caption));
                });
                Promise.all([
                    permissionService.isLicenseAvailable('MYNEVA_CONNECT'),
                    stammdatenService.isConnectRegistrationAvailable()
                ]).then(data => this.isConnectRegistrationAvailable = data.reduce((acc, val) => acc && val, true));
            }
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * init the form with default values
             *
             * @private
             *
             * @memberOf DetailContactPersonController
             */
            initForm() {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    objectType: this.objectType,
                    name: null,
                    forename: null,
                    birthday: new Date(1990, 1, 1),
                    birthplace: null,
                    dateFrom: new Date(),
                    dateTo: null,
                    salutationId: null,
                    titleId: null,
                    secondTitleId: null,
                    contactPersonTypeId: null,
                    contactPersonType: '',
                    comment: null,
                    isContactBan: false,
                    parentObjectType: this.parentObjectType,
                    isContactBanText: 'Nein'
                };
                this.loading = false;
                this.$qui.functionWaiter("ui.createForm", this);
            }
            getData() {
                this.getContacts();
            }
            createConnectUser(row) {
                this.stammdatenService.getConnectRegistrationUrl(this.id, row.objectId)
                    .then(url => window.open(url, '_blank'))
                    .catch(_ => this.$qui.notify({
                    message: this.lng.translate(20003527, "Das Anlegen eines myneva.connect Benutzers ist nicht möglich. Die Konfiguration ist unvollständig."),
                    title: this.lng.translate(20002015, "Fehler"),
                    icon: "fa-cloud",
                    status: "warning",
                    timer: 3500
                }));
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the wv list for communication and address
             *
             * @private
             *
             * @memberOf DetailContactPersonController
             */
            getWvList() {
                this.stammdatenService.getContactPersonWvList().then((data) => {
                    this.wvList = data;
                    this.initForm();
                    this.$qui.functionWaiter("createForm", this);
                    this.selectedContactPersonStatusId = this.wvList.contactPersonStatusWvList[0].objectId;
                    this.contactPersonStatusMap = this.$qui.selectAutoMap(this.wvList.contactPersonStatusWvList, 'id', 'name');
                    this.getData();
                });
                this.stammdatenService.getCommunicationWv().then((data) => {
                    this.communicationWv = data;
                });
                this.stammdatenService.getAddressWv().then((data) => {
                    this.addressWv = data;
                });
                this.$scope.$watch('vm.selectedCategoryId', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    this.getContacts();
                });
                this.$scope.$watch('vm.selectedContactPersonStatusId', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    this.getContacts();
                });
            }
            /**
             * get the contact person type list
             *
             * @private
             * @returns {*}
             *
             * @memberOf DetailContactPersonController
             */
            getContactPersonTypeList() {
                return this.wvList.contactPersonTypeWvList.map(function (obj) {
                    return {
                        value: obj.id,
                        text: obj.name,
                        isFix: obj.isFix,
                    };
                });
            }
            /**
             * get the gender wv list
             *
             * @private
             * @returns {ISelectListItem[]}
             *
             * @memberOf DetailContactPersonController
             */
            getGenderList() {
                return this.wvList.genderWvList.map(function (obj) {
                    return {
                        value: obj.id,
                        text: obj.name,
                        isFix: obj.isFix
                    };
                });
            }
            /**
             * get the salutaion wv list
             *
             * @private
             * @returns {*}
             *
             * @memberOf DetailContactPersonController
             */
            getSalutationList() {
                if (this.wvList === undefined) {
                    return this.stammdatenService.getContactPersonWvList().then((data) => {
                        this.wvList = data;
                        return this.wvList.salutationWvList.map(function (obj) {
                            return {
                                value: obj.id,
                                text: obj.name,
                                isFix: obj.isFix
                            };
                        });
                    });
                }
                else
                    return this.wvList.salutationWvList.map(function (obj) {
                        return {
                            value: obj.id,
                            text: obj.name,
                            isFix: obj.isFix
                        };
                    });
            }
            /**
             * get the title wv list
             *
             * @private
             * @returns {*}
             *
             * @memberOf DetailContactPersonController
             */
            getTitleList() {
                if (this.wvList === undefined) {
                    return this.stammdatenService.getContactPersonWvList().then((data) => {
                        this.wvList = data;
                        return this.wvList.titleWvList.map(function (obj) {
                            return {
                                value: obj.id,
                                text: obj.name,
                                isFix: obj.isFix
                            };
                        });
                    });
                }
                else
                    return this.wvList.titleWvList.map(obj => ({
                        value: obj.id,
                        text: obj.name,
                        isFix: obj.isFix
                    }));
            }
            getSecondTitleList() {
                if (!this.wvList)
                    return [];
                return this.wvList.secondTitleWvList.map(x => ({ text: x.name, value: x.objectId }));
            }
            getCategories() {
                this.stammdatenService.getContactPersonCategories().then(data => {
                    this.categoryList = data;
                    this.categoryListMap = this.$qui.selectAutoMap(data, 'id', 'caption');
                    this.categoryListMap.unshift({ text: this.lng.translate(20000212, '- Alle -'), value: QMC.Common.Constants.GUID_EMPTY });
                });
            }
            setCategoryFilter(categoryId) {
            }
            /**
             * get the list of contacts
             *
             * @private
             *
             * @memberOf DetailContactPersonController
             */
            getContacts() {
                this.loading = true;
                this.stammdatenService.getContactPersonList(this.id, this.selectedCategoryId, this.selectedContactPersonStatusId).then((data) => {
                    this.loading = false;
                    // ugly way to catch minDate from DB. this is done to decide if any birthday should be displayed at all
                    for (const contact of data) {
                        if (contact.isContactBan) {
                            contact.style = { 'background-color': 'orangered', 'color': 'white', 'font-weight': 'bold' };
                        }
                        if (contact.birthday !== null)
                            if (contact.birthday.toString().substr(0, 19) === "1900-01-01T12:00:00")
                                contact.birthday = null;
                        switch (contact.mainCommunicationTypeId) {
                            case '930511d9-aa40-4927-b8b0-bbfc2e040de6': // fax
                            case '6729f858-ca6d-4efe-8397-376133a2d974': // telephon
                                contact.type = this.linkSetting.tele ? 'tel' : undefined;
                                break;
                            case 'f25005b8-3a66-4b36-9395-60ce7896f7d6': // website
                                contact.type = this.linkSetting.href ? 'site' : undefined;
                                break;
                            case '53fd55a0-9efe-41aa-9099-5c3b7b4e972f': // email
                                contact.type = this.linkSetting.mail ? 'mail' : undefined;
                                break;
                        }
                    }
                    this.ui.contactPersonTable.data = data;
                    this.$qui.functionWaiter("createTable", this);
                    if (this.$stateParams.dataId) {
                        const item = data.filter(x => x.objectId === this.$stateParams.dataId)[0];
                        if (item) {
                            $(`#edit-form`).modal('show');
                            this.editContact(item);
                        }
                    }
                });
            }
            /**
             * add a new contact person
             *
             * @private
             * @param {IContactPerson} form
             *
             * @memberOf DetailContactPersonController
             */
            addContact(form) {
                this.loading = true;
                form.parentObjectId = this.id;
                this.stammdatenService.postContactPerson(form).then((e) => {
                    this.formState = "new";
                    this.ui.notify(this.ui.successNote);
                    this.getContacts();
                    $('#edit-form').modal('hide');
                });
            }
            /**
             * put a existing contact person
             *
             * @private
             * @param {IContactPerson} form
             *
             * @memberOf DetailContactPersonController
             */
            putContact(form) {
                this.loading = true;
                this.stammdatenService.putContactPerson(this.id, form.objectId, form).then((data) => {
                    this.formState = "new";
                    this.ui.notify(this.ui.successNote);
                    this.getContacts();
                    $('#edit-form').modal('hide');
                });
                this.udfs.forEach(x => { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            }
            /**
             * delete a existing contact person
             *
             * @private
             * @param {IContactPerson} data
             *
             * @memberOf DetailContactPersonController
             */
            deleteContact(item) {
                this.promptOptions.title = this.lang.translate(20004502, "Kontaktpersonen löschen");
                this.promptOptions.itemText = item.contactPersonType.length > 0
                    ? item.name + ", " + item.forename + " (" + item.contactPersonType + ")"
                    : item.name + ", " + item.forename;
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data) {
                        this.validation = {
                            loading: true,
                            warnings: [],
                            errors: [],
                            reference: item
                        };
                        $('#validationModal').modal('show');
                        this.stammdatenService.validateContactPersonDeletion(item.id, item.objectId).then(data => {
                            var _a;
                            console.log(data);
                            this.validation.errors = data.errors;
                            this.validation.warnings = data.warnings;
                            if (!((_a = data.errors) === null || _a === void 0 ? void 0 : _a.length) && !data.warnings.length) {
                                this.performDeletion();
                                $('#validationModal').modal('hide');
                            }
                        }).catch(() => {
                            this.validation.errors = [this.lng.translate(20000328, 'Die Validierung konnte nicht durchgeführt werden!')];
                        }).finally(() => {
                            this.validation.loading = false;
                        });
                    }
                });
            }
            performDeletion() {
                this.stammdatenService.deleteContactPerson(this.id, this.validation.reference.objectId).then((data) => {
                    this.ui.notify(this.ui.deleteNote);
                    this.getContacts();
                });
            }
            /**
             * show the details of an contact person
             *
             * @private
             * @param {IContactPerson} data
             *
             * @memberOf DetailContactPersonController
             */
            showDetailContact(data) {
                this.currentPerson = data.forename + " " + data.name;
                this.formState = "new";
                this.showDetail = true;
                this.setupAddress(data.objectId);
                this.setupCommunication(data.objectId);
            }
            /**
             * edit a existing contact person
             *
             * @private
             * @param {IContactPerson} data
             *
             * @memberOf DetailContactPersonController
             */
            editContact(data) {
                this.formState = "edit";
                this.form = angular.copy(data);
                this.form.dateFrom = moment(data.dateFrom).toDate();
                if (this.form.birthday !== null)
                    this.form.birthday = moment(data.birthday).toDate();
                if (data.dateTo !== null)
                    this.form.dateTo = moment(data.dateTo).toDate();
                this.$qui.waitForEl('#standardTabButton', () => {
                    $('#standardTabButton').click();
                });
                this.$state.go('.', { dataId: data.objectId });
            }
            /////////////// ADDRESS FUNCTIONS ///////////////
            /**
             * setup address for a contact person
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf DetailContactPersonController
             */
            setupAddress(id) {
                this.addressLoading = true;
                this.getAddresses(id);
                this.getAddressWv(id);
            }
            /**
             * init the address form with default values
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf DetailContactPersonController
             */
            initAddressForm(id) {
                this.addressForm = {
                    id: null,
                    objectId: null,
                    objectType: this.adrObjectType,
                    parentObjectId: id,
                    parentObjectType: this.objectType,
                    street: null,
                    houseNumber: null,
                    addressAddition: null,
                    postCode: null,
                    city: null,
                    dateFrom: new Date(),
                    dateTo: null,
                    objectIdCountry: QMC.Common.Constants.DEFAULT_COUNTRY_ID,
                    objectIdState: null,
                    objectIdAddressType: null,
                    isMainRecord: true,
                    isPostOfficeBox: false,
                    isHouseless: false,
                    comment: null,
                    isDatatransferForbidden: false,
                    isEmergency: false
                };
                //this is for a pull request change
                this.createAddressForm();
                setTimeout(() => {
                    this.addressEvents();
                }, 200);
            }
            /**
             * view events for the address form
             *
             * @private
             *
             * @memberOf DetailContactPersonController
             */
            addressEvents() {
                /**
                 * Address Autocomplete
                 */
                const vm = this;
                $('#city .typeahead').typeahead({
                    minLength: 3,
                    source: function (query, process) {
                        vm.stammdatenService.getPostCodeByCityList(vm.addressForm.objectIdCountry, query).then(function (data) {
                            process(data.map(function (obj) {
                                return obj.postCodeAndCity;
                            }));
                        });
                    },
                    updater: function (item) {
                        const data = item.split('...');
                        vm.addressForm.postCode = data[0];
                        $('#postCode input').val(data[0]).trigger('change');
                        return data[1];
                    }
                });
                $('#postCode .typeahead').typeahead({
                    minLength: 3,
                    source: function (query, process) {
                        vm.stammdatenService.getCityByPostCodeList(vm.addressForm.objectIdCountry, query).then(function (data) {
                            process(data.map(function (obj) {
                                return obj.postCodeAndCity;
                            }));
                        });
                    },
                    updater: function (item) {
                        const data = item.split('...');
                        vm.addressForm.city = data[1];
                        $('#city input').val(data[1]).trigger('change');
                        return data[0];
                    }
                });
            }
            /**
             * get the address wv list
             * @description get the wv list of address.
             * @private
             * @param {any} id
             *
             * @memberOf DetailContactPersonController
             */
            getAddressWv(id) {
                this.stammdatenService.getAddressWv().then((data) => {
                    this.addressWv = data;
                });
                // call init address form
                this.initAddressForm(id);
            }
            /**
             * Get the State list, by country id
             * @description get the state list
             * @private
             * @param {any} id
             *
             * @memberOf DetailContactPersonController
             */
            getStates() {
                this.stateList = null;
                this.stammdatenService.getStatesWv(this.addressForm.objectIdCountry).then((data) => {
                    this.stateList = data.map(function (obj) {
                        return {
                            id: obj.id,
                            text: obj.caption
                        };
                    });
                    if (this.stateList.length < 1) {
                        this.stateList = null;
                        this.addressForm.objectIdState = null;
                    }
                });
            }
            /**
             * get the address type list
             * @description get the addres type list
             * @private
            * @returns {ng.IPromise<ISelectListItem[]>}
             *
             * @memberOf DetailContactPersonController
             */
            getAdressTypeList() {
                return this.stammdatenService.getAddressWv().then((data) => {
                    return data.addressTypeWvList.map(function (obj) {
                        return {
                            value: obj.objectId,
                            text: obj.name
                        };
                    });
                });
            }
            /**
             * get the country wv list
             *
             * @private
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailContactPersonController
             */
            getCountryList() {
                return this.stammdatenService.getAddressWv().then((data) => {
                    return this.ui.select(data.countriesWvList, { value: "objectId", text: "name" });
                });
            }
            /**
             * get the state list by country id
             *
             * @private
             * @param {Guid} id
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailContactPersonController
             */
            getStatesList(id) {
                //Use the id from form as hotfix, since the provided id is always undefined
                //return this.stammdatenService.getStatesWv(id).then((data: IStatesWv[]) => {
                return this.stammdatenService.getStatesWv(this.addressForm.objectIdCountry).then((data) => {
                    return this.ui.select(data, { value: "id", text: "caption" });
                });
            }
            /**
             * create a empty address form
             *
             * @private
             * @param {ICommunication} data
             *
             * @memberOf DetailContactPersonController
             */
            newAddress(data) {
                this.initAddressForm(data.objectId);
            }
            /**
             * add a new address
             *
             * @private
             * @param {IAddress} form
             *
             * @memberOf DetailContactPersonController
             */
            addAddress(form) {
                this.stammdatenService.postAddress(form).then((e) => {
                    this.getAddresses(form.parentObjectId);
                    this.ui.notify(this.ui.successNote, 'Ihre Adresse wurde gespeichert');
                    this.formState = "new";
                });
            }
            /**
             * delete an existing address
             *
             * @private
             * @param {IAddress} form
             *
             * @memberOf DetailContactPersonController
             */
            deleteAdress(form) {
                this.promptOptions.title = this.lang.translate(20003503, "Addresse löschen");
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.stammdatenService.deleteAddress(form.parentObjectId, form.objectId).then((data) => {
                            this.getAddresses(form.parentObjectId);
                            this.ui.notify(this.ui.deleteNote);
                            this.formState = "new";
                        });
                });
            }
            /**
             * edit an existing address
             *
             * @private
             * @param {IAddress} address
             *
             * @memberOf DetailContactPersonController
             */
            editAdress(address) {
                this.addressForm = angular.copy(address);
                this.formState = "edit";
                this.addressForm.dateFrom = moment(address.dateFrom).toDate();
                if (this.addressForm.dateTo !== null)
                    this.addressForm.dateTo = moment(address.dateTo).toDate();
            }
            /**
             * put a existing address
             *
             * @private
             * @param {IAddress} form
             *
             * @memberOf DetailContactPersonController
             */
            putAddress(form) {
                this.stammdatenService.putAddress(form.parentObjectId, form.objectId, form).then((data) => {
                    this.getAddresses(form.parentObjectId);
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                });
            }
            /**
             * get the list of addresses for a contact person
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf DetailContactPersonController
             */
            getAddresses(id) {
                this.stammdatenService.getAddressList(id).then((data) => {
                    data = data.map((obj) => {
                        if (obj.isDatatransferForbidden)
                            obj.style = { 'background-color': 'orangered', 'color': 'white', 'font-weight': 'bold' };
                        return obj;
                    });
                    this.ui.contactPersonAddressTable.data = data;
                    this.createAddressTable();
                    this.getData(); //Daten (Kontakte) müssen auch geholt werden, auch wenn Adressen (noch) nicht in der Table angezeigt werden
                    this.addressLoading = false;
                });
            }
            /////////////// COMMUNICATION FUNCTIONS ///////////////
            /**
             * get the list of communications for a contact person
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf DetailContactPersonController
             */
            getCommunications(id) {
                this.stammdatenService.getCommunicationList(id).then((data) => {
                    data = data.map((obj) => {
                        if (obj.isDatatransferForbidden)
                            obj.style = { 'background-color': 'orangered', 'color': 'white', 'font-weight': 'bold' };
                        switch (obj.communicationTypeId) {
                            case '930511d9-aa40-4927-b8b0-bbfc2e040de6': // fax
                            case '6729f858-ca6d-4efe-8397-376133a2d974': // telephon
                                obj.type = this.linkSetting.tele ? 'tel' : undefined;
                                break;
                            case 'f25005b8-3a66-4b36-9395-60ce7896f7d6': // website
                                obj.type = this.linkSetting.href ? 'site' : undefined;
                                break;
                            case '53fd55a0-9efe-41aa-9099-5c3b7b4e972f': // email
                                obj.type = this.linkSetting.mail ? 'mail' : undefined;
                                break;
                        }
                        return obj;
                    });
                    this.ui.contactpersonCommunicationTable.data = data;
                    this.createCommunicationTable();
                    this.getData(); //Daten (Kontakte) müssen neu geladen werden
                    this.communicationLoading = false;
                });
            }
            /**
             * get the communication type list
             *
             * @private
             * @returns {ng.IPromise<ISelectItem[]>}
             *
             * @memberOf DetailContactPersonController
             */
            getCommunicationTypeList() {
                return this.stammdatenService.getCommunicationWv().then((data) => {
                    this.communicationWv = data;
                    return this.communicationWv.communicationTypeWvList.map(function (obj) {
                        return {
                            value: obj.objectId,
                            text: obj.name,
                            isFix: obj.isFix
                        };
                    });
                });
            }
            /**
             * get the communication category wv list
             *
             * @private
             * @param {Guid} id
             * @returns {QMC.Common.ISelectItem[]}
             *
             * @memberOf DetailContactPersonController
             */
            getCommunicationCategoryList(id) {
                var _a, _b;
                if (this.communicationWv === undefined)
                    return null;
                for (const wv of this.communicationWv.communicationTypeWvList) {
                    if (wv.id === this.communicationForm.communicationTypeId) {
                        console.log("id", wv.id);
                        this.communicationForm.communicationTypeName = wv.name.charAt(0).toLowerCase() + wv.name.slice(1);
                        break;
                    }
                }
                if (((_a = this.communicationForm.communicationTypeName) === null || _a === void 0 ? void 0 : _a.length) && this.communicationWv) {
                    return (_b = this.communicationWv.communicationCategoryWvList[this.communicationForm.communicationTypeName]) === null || _b === void 0 ? void 0 : _b.map(function (obj) {
                        return {
                            value: obj.id,
                            text: obj.name,
                            isFix: obj.isFix
                        };
                    });
                }
            }
            /**
             * set up a new communication form
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf DetailContactPersonController
             */
            setupCommunication(id) {
                this.getCommunications(id);
                this.getCommunicationWv(id);
            }
            /**
             * get the communication wv list
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf DetailContactPersonController
             */
            getCommunicationWv(id) {
                this.stammdatenService.getCommunicationWv().then((data) => {
                    //window.scrollTo(0, document.body.scrollHeight);
                    var element = $("#scrollTarget");
                    $("html, body").animate({ scrollTop: $("#scrollTarget").last().offset().top }, 1000);
                    this.communicationWv = data;
                    this.initCommunicationForm(id);
                });
            }
            /**
             * init the communication form with default values
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf DetailContactPersonController
             */
            initCommunicationForm(id) {
                this.communicationForm = {
                    id: null,
                    objectId: null,
                    objectType: this.comObjectType,
                    parentObjectId: id,
                    parentObjectType: this.objectType,
                    dateFrom: null,
                    dateTo: null,
                    targetAddress: null,
                    isMainRecord: true,
                    isTypeMain: true,
                    communicationCategoryId: null,
                    communicationTypeId: "53fd55a0-9efe-41aa-9099-5c3b7b4e972f",
                    communicationTypeName: null,
                    comment: null,
                    countryCode: null,
                    areaCode: null,
                    displayAddress: '',
                    isDatatransferForbidden: false
                };
                this.createCommunicationForm();
            }
            /**
             * init a new communication form
             *
             * @private
             * @param {ICommunicationWv} data
             *
             * @memberOf DetailContactPersonController
             */
            newCommunication(data) {
                this.initCommunicationForm(data.objectId);
            }
            /**
             * add a new communication
             *
             * @private
             * @param {ICommunication} form
             *
             * @memberOf DetailContactPersonController
             */
            addCommunication(form) {
                this.stammdatenService.postCommunication(this.communicationForm).then((data) => {
                    this.getCommunications(form.parentObjectId);
                    this.ui.notify(this.ui.successNote, this.lng.translate(20000291, 'Der Eintrag wurde gespeichert.'));
                    this.formState = "new";
                });
            }
            /**
             * delete a existing communication
             *
             * @private
             * @param {ICommunication} data
             *
             * @memberOf DetailContactPersonController
             */
            deleteCommunication(datas) {
                this.promptOptions.title = this.lang.translate(20005503, "Kommunikation löschen");
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.stammdatenService.deleteCommunication(datas.parentObjectId, datas.objectId).then((data) => {
                            this.getCommunications(datas.parentObjectId);
                            this.ui.notify(this.ui.deleteNote);
                            this.formState = "new";
                        });
                });
            }
            /**
             * edit a existing communication
             *
             * @private
             * @param {ICommunication} data
             *
             * @memberOf DetailContactPersonController
             */
            editCommunication(data) {
                this.formState = "edit";
                this.communicationForm = angular.copy(data);
            }
            /**
             * put a existing communication
             *
             * @private
             * @param {ICommunication} form
             *
             * @memberOf DetailContactPersonController
             */
            putCommunication(form) {
                this.stammdatenService.putCommunication(form.parentObjectId, form.objectId, form).then((data) => {
                    this.getCommunications(form.parentObjectId);
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                });
            }
        };
        DetailContactPersonController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailContactPersonController'),
            QMC.Inject('StammdatenService', '$qui', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout', '$location', 'QmcUdfService')
        ], DetailContactPersonController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailCoverController = class DetailCoverController {
            /**
             * Creates an instance of DetailNoteController.
             * @param {StammdatenService} stammdatenService
             * @param {any} $qui
             * @param {any} $state
             * @param {any} $stateParams
             * @param {any} $scope
             *
             * @memberOf DetailCoverController
             */
            constructor($qui, $stateParams, $scope, lng, reportingService, userService, $location, $q) {
                this.$qui = $qui;
                this.$scope = $scope;
                this.lng = lng;
                this.reportingService = reportingService;
                this.userService = userService;
                this.$location = $location;
                this.$q = $q;
                this.loading = {
                    report: false
                };
                this.coverCacheName = QMC.Common.LocalStorageConstants.CLIENT_COVER + $('#session').data().userId;
                this.invalidCover = false;
                this.postReportJobCancel = null;
                this.clientCoverReportTemplates = [];
                this.clientCoverReportTemplatesMap = [];
                this.clientCoverTemplate = QMC.Common.Constants.GUID_EMPTY;
                this.id = $stateParams.id;
                this.$scope.$on('$destroy', () => {
                    if (this.postReportJobCancel) {
                        this.postReportJobCancel.resolve();
                    }
                });
                this.$qui.waitForEl('#newModalButton', () => {
                    document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                });
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.objectType = 120000;
                        this.coverCacheName = 'EmployeeCover' + $('#session').data().userId;
                        break;
                    default:
                        this.objectType = 140000;
                        this.coverCacheName = QMC.Common.LocalStorageConstants.CLIENT_COVER + $('#session').data().userId;
                        break;
                }
                this.userService.getCoverReportTemplates(this.objectType).then((list) => {
                    for (const item of list) {
                        const reportItem = {
                            id: item.id,
                            objectId: item.objectId,
                            name: item.name,
                            reportType: item.reportType,
                            reportTypeName: this.getReportTypeCaption(item.reportType)
                        };
                        this.clientCoverReportTemplates.push(reportItem);
                    }
                    this.clientCoverReportTemplatesMap = this.clientCoverReportTemplates.map((x) => { return { text: x.name, value: x.objectId, group: this.getReportTypeCaption(x.reportType) }; });
                    if (this.clientCoverReportTemplatesMap.length === 1)
                        this.clientCoverTemplate = this.clientCoverReportTemplatesMap[0].value;
                    const cache = QMC.Common.personalLocalStorage.getItem(this.coverCacheName);
                    if (cache && cache !== null && cache !== undefined) {
                        const parsedCache = JSON.parse(cache);
                        if (parsedCache.reference === this.id && moment(parsedCache.timestamp).isAfter(moment().subtract(5, 'minutes'))) {
                            this.setReportFromResult(parsedCache, parsedCache.reportType);
                        }
                        this.clientCoverTemplate = parsedCache.reportTemplateId;
                        if (!this.clientCoverReportTemplatesMap.some(x => x.value === this.clientCoverTemplate))
                            this.getReportIdAndExecute();
                        else
                            this.generateReport(this.clientCoverTemplate);
                    }
                    else {
                        this.getReportIdAndExecute();
                    }
                    this.$scope.$watch('vm.clientCoverTemplate', (newVal, oldVal) => {
                        if (newVal !== oldVal && newVal && newVal !== QMC.Common.Constants.GUID_EMPTY) {
                            this.generateReport(this.clientCoverTemplate);
                        }
                    });
                });
                $qui.init(undefined, () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.pdfCallbackButton = {
                    icon: 'qm-icon-arrow_circle',
                    label: this.lng.translate(20000241, 'Aktualisieren')
                };
            }
            getReportTypeCaption(reportType) {
                switch (reportType) {
                    case 7000:
                        return this.lng.translate(20015036, 'Vorlage');
                    case 3000:
                        return this.lng.translate(20015038, 'Tabellenkalkulation');
                    default:
                        return '';
                }
            }
            getReportIdAndExecute() {
                this.userService.getUserSettings([`FRADECKBLATT.${this.objectType}.REPORTID`], false).then((data) => {
                    this.clientCoverTemplate = (data[0].value && data[0].value.length > 0 && data[0].value !== QMC.Common.Constants.GUID_EMPTY) ? data[0].value : this.clientCoverTemplate;
                    const report = this.GetReportDataFromList(this.clientCoverTemplate, this.clientCoverReportTemplates);
                    if (!report) {
                        if (this.clientCoverReportTemplatesMap.length)
                            this.clientCoverTemplate = this.clientCoverReportTemplatesMap[0].value;
                        else
                            this.invalidCover = this.clientCoverTemplate !== QMC.Common.Constants.GUID_EMPTY ? 'create' : false;
                        return;
                    }
                    this.invalidCover = false;
                    this.generateReport(this.clientCoverTemplate, report.reportType);
                });
            }
            GetReportDataFromList(id, list) {
                for (const item of list) {
                    if (item.id === id || item.objectId === id)
                        return item;
                }
                return null;
            }
            reload() {
                this.generateReport(this.clientCoverTemplate);
                this.base64Data = undefined;
            }
            disableReload() {
                return !this.clientCoverTemplate || this.clientCoverTemplate === QMC.Common.Constants.GUID_EMPTY;
            }
            generateReport(reportTemplateId, reportType = -1) {
                if (!this.clientCoverReportTemplates || this.clientCoverReportTemplates.length === 0 || !reportTemplateId || reportTemplateId === QMC.Common.Constants.GUID_EMPTY)
                    return;
                if (this.postReportJobCancel) {
                    this.postReportJobCancel.resolve();
                }
                this.invalidCover = false;
                this.loading.report = true;
                const reportForId = this.clientCoverReportTemplates.filter(reportItem => reportItem.objectId === reportTemplateId);
                const postItem = {
                    reportObjectId: reportTemplateId,
                    serverJobObjectId: this.$qui.generateGuid(),
                    reportType: reportType === -1 ? reportForId[0].reportType : reportType,
                    parameters: [],
                    isCancelled: false,
                    detailParentId: this.id
                };
                this.postReportJobCancel = this.$q.defer();
                this.reportingService.postReportJob(postItem, this.postReportJobCancel.promise).then((id) => {
                    this.getFinishedReportFile(id, postItem.reportType, reportTemplateId);
                }).catch((reason) => {
                    if (this.isReportJobRequestCancelled(reason))
                        return;
                    this.invalidCover = 'create';
                    this.loading.report = false;
                    this.base64Data = undefined;
                }).finally(() => {
                    this.postReportJobCancel = null;
                });
            }
            isReportJobRequestCancelled(reason) {
                return reason != null && reason.status === -1;
            }
            getFinishedReportFile(id, reportType, templateId) {
                this.fileName = this.lng.translate(21002031, 'Deckblatt');
                this.reportId = id;
                this.reportingService.getFinishedReportBase64(id, reportType, this.fileName).then((data) => {
                    this.setReportFromResult(data, reportType);
                    data.reference = this.id;
                    data.reportType = reportType;
                    data.reportTemplateId = templateId;
                    data.timestamp = moment();
                    try {
                        QMC.Common.personalLocalStorage.setItem(this.coverCacheName, JSON.stringify(data));
                    }
                    catch (e) {
                        console.warn('could not cache report', e);
                        QMC.Common.personalLocalStorage.removeItem(this.coverCacheName);
                    }
                }).catch(() => {
                    this.invalidCover = 'download';
                    this.base64Data = undefined;
                }).finally(() => {
                    this.loading.report = false;
                    this.$qui.scopeApply();
                });
            }
            setReportFromResult(data, reportType) {
                this.loading.report = false;
                this.reportType = reportType;
                this.base64Data = data.base64;
                if (reportType === 7000) {
                    this.fileType = 'pdf';
                }
                if (reportType === 3000) {
                    this.fileType = 'excel';
                }
                this.$qui.waitForEl('#infoContent', () => {
                    this.$qui.waitForEl('#infoToggler', () => {
                        if (document.getElementById('infoContent').style.display !== 'none')
                            document.getElementById('infoToggler').click();
                    });
                });
            }
        };
        DetailCoverController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailCoverController'),
            QMC.Inject('$qui', '$stateParams', '$scope', "QmcLanguageService", 'ReportingService', 'UserService', '$location', '$q')
        ], DetailCoverController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailNoteController = class DetailNoteController {
            /**
             * Creates an instance of DetailNoteController.
             * @param {StammdatenService} stammdatenService
             * @param {any} $qui
             * @param {Klient.KlientService} clientService
             * @param {any} $state
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberOf DetailNoteController
             */
            constructor(stammdatenService, $qui, clientService, $state, $stateParams, permissionService) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$state = $state;
                // Permissions
                this.ui = new QMC.Stammdaten.DetailUI();
                this.loading = true;
                this.parentObjectId = $stateParams.id;
                this.$qui.waitForEl('#newModalButton', () => {
                    document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                });
                this.stammdatenService.getNote(this.parentObjectId).then((data) => {
                    permissionService.getPermissionsForDataset(this.parentObjectId, null).then((data) => {
                        this.delete = data[0].delete;
                        this.new = data[0].new;
                        this.modify = data[0].modify;
                        this.moduleAccess = data[0].moduleAccess;
                    });
                    this.text = data.text;
                    this.loading = false;
                });
            }
            /**
             * update the client node
             *
             * @private
             *
             * @memberOf DetailNoteController
             */
            updateNote() {
                const data = {
                    parentObjectId: this.parentObjectId,
                    text: this.text,
                    permission: null
                };
                this.stammdatenService.putNote(this.parentObjectId, data).then((data) => {
                    this.ui.notify(this.ui.successNote);
                });
            }
        };
        DetailNoteController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailNoteController'),
            QMC.Inject('StammdatenService', '$qui', 'KlientService', '$state', '$stateParams', 'QmcPermissionService')
        ], DetailNoteController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailVaccinationController = class DetailVaccinationController {
            /**
             * Creates an instance of DetailVaccinationController.
             *
             * @memberOf DetailVaccinationController
             */
            constructor(stammdatenService, $qui, $stateParams, $scope, $state, lng, permissionService, userService, $timeout, $location, udfService) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$scope = $scope;
                this.$state = $state;
                this.lng = lng;
                this.userService = userService;
                this.$location = $location;
                this.allowTableExport = false;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.formState = "new";
                this.shouldLoadTableData = true;
                this.enableDocuments = false;
                this.udfs = [];
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.id = $stateParams.id;
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.parentobjectType = 120000;
                        this.objectType = 120046;
                        this.documentObjectType = 0; // not impl., no objectType
                        break;
                    default:
                        this.parentobjectType = 140000;
                        this.objectType = 140005;
                        this.documentObjectType = 140114;
                        break;
                }
                this.permissionLoading = true;
                this.doctorsAndMedicalOrganisations = [];
                permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType]).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.moduleAccess = data[0].moduleAccess && data[0].view;
                    this.allowTableExport = data[0].print;
                    this.enableDocuments = data[1].moduleAccess;
                    $timeout(() => {
                        if (!this.new)
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                        else
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'unset');
                    });
                    this.initForm();
                    this.getData();
                    this.permissionLoading = false;
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.lang = lng;
                this.promptOptions = {
                    title: "Impfung",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lang.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                const vm = this;
                $(`#edit-form`).on('hidden.bs.modal', () => {
                    this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(() => vm.initForm());
                    $(`#edit-form`).find('.tab-content').children().removeClass('in').removeClass('active');
                    $(`#edit-form`).find('.tab-content').find('#baseDataTab').addClass('in active');
                });
                udfService.getUserDefinedFields(this.objectType).then((data) => {
                    this.udfs = data.sort((a, b) => a.caption.localeCompare(b.caption));
                });
            }
            getData() {
                this.getVaccinations();
            }
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * init a new form with default values
             *
             * @private
             *
             * @memberOf DetailVaccinationController
             */
            initForm() {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    parentObjectId: this.id,
                    date: new Date(),
                    dateFollowupAppointment: null,
                    caption: null,
                    comment: null,
                    batchNumber: null,
                    diseaseId: null,
                    doctorId: null,
                    parentObjectType: this.parentobjectType,
                    objectType: this.objectType
                };
                this.$qui.functionWaiter("ui.createForm", this);
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get a list of vaccinations
             *
             * @private
             *
             * @memberOf DetailVaccinationController
             */
            getVaccinations() {
                this.loading = true;
                this.stammdatenService.getVaccinationList(this.id).then((data) => {
                    this.ui.vaccinationTable.data = data;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.loading = false;
                    if (this.$stateParams.dataId) {
                        const item = data.filter(x => x.objectId === this.$stateParams.dataId)[0];
                        if (item) {
                            this.$qui.waitForEl('#edit-form', () => {
                                $(`#edit-form`).modal('show');
                            });
                            this.editVaccination(item);
                        }
                    }
                });
            }
            getDoctorsAndMedicalOrg() {
                return this.stammdatenService.getDoctorList().then((dataDoctors) => {
                    dataDoctors.forEach((doctor) => {
                        this.doctorsAndMedicalOrganisations.push(doctor);
                    });
                    return this.stammdatenService.getMedicalOrganisationList().then((dataMedicalOrg) => {
                        let result = this.doctorsAndMedicalOrganisations.map((x) => { return { text: x.displayTitle, value: x.id, group: this.lng.translate(20010508, 'Arzt') }; });
                        result = result.concat(dataMedicalOrg.map((x) => { return { text: x.displayTitle, value: x.id, group: this.lng.translate(20023005, 'Medizinische Organisation') }; }));
                        return result;
                    });
                });
            }
            getDiseases() {
                return this.stammdatenService.getVaccinationWv().then((data) => {
                    this.dieseasesWv = data.diseaseVaccinationWvList;
                    return this.ui.select(data.diseaseVaccinationWvList, { value: 'id', text: 'name' });
                });
            }
            /**
             * add a new vaccination
             *
             * @private
             *
             * @memberOf DetailVaccinationController
             */
            addVaccination(form) {
                form.parentObjectId = this.id;
                this.stammdatenService.postVaccination(form).then((e) => {
                    this.formState = "new";
                    this.ui.notify(this.ui.successNote);
                    this.getVaccinations();
                    $('#edit-form').modal('hide');
                });
            }
            /**
             * delete a existing vaccination
             *
             * @private
             * @param {IVaccination} data
             *
             * @memberOf DetailVaccinationController
             */
            deleteVaccination(item) {
                this.loading = true;
                this.promptOptions.itemText = moment(item.date).format("DD.MM.YYYY") + " " + item.diseaseName;
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.stammdatenService.deleteVaccination(this.id, item.objectId).then((data) => {
                            this.ui.notify(this.ui.deleteNote);
                            this.formState = "new";
                            this.getVaccinations();
                            $('#edit-form').modal('hide');
                        });
                });
            }
            /**
             * edit a existing vaccination
             *
             * @private
             * @param {IVaccination} data
             *
             * @memberOf DetailVaccinationController
             */
            editVaccination(data) {
                this.form = angular.copy(data);
                this.formState = "edit";
                this.form.date = moment(data.date).toDate();
                if (this.form.dateFollowupAppointment !== null) {
                    this.form.dateFollowupAppointment = moment(data.dateFollowupAppointment).toDate();
                }
                this.$qui.waitForEl('#standardTabButton', () => {
                    $('#standardTabButton').click();
                });
                this.$state.go('.', { dataId: data.objectId });
            }
            putVaccination(form) {
                this.loading = true;
                this.stammdatenService.putVaccination(this.form.parentObjectId, this.form.objectId, form).then((data) => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    $('#edit-form').modal('hide');
                }).finally(() => this.getVaccinations());
                this.udfs.forEach(x => { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            }
        };
        DetailVaccinationController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailVaccinationController'),
            QMC.Inject('StammdatenService', '$qui', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout', '$location', 'QmcUdfService')
        ], DetailVaccinationController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailHobbyController = class DetailHobbyController {
            /**
             * Creates an instance of DetailHobbyController.
             *
             * @memberOf DetailHobbyController
             */
            constructor(stammdatenService, $qui, clientService, $stateParams, $scope, lng, permissionService, userService, $timeout, udfService) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$scope = $scope;
                this.lng = lng;
                this.userService = userService;
                this.allowTableExport = false;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.formState = "new";
                this.objectType = 140054;
                this.shouldLoadTableData = true;
                this.udfs = [];
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.id = $stateParams.id;
                this.permissionLoading = true;
                permissionService.getPermissionsByObjectType(this.objectType).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.moduleAccess = data[0].moduleAccess && data[0].view;
                    this.allowTableExport = data[0].print;
                    this.$qui.waitForEl('#newModalButton', () => {
                        if (!this.new)
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                        else
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'unset');
                    });
                    this.societyList = null;
                    this.contactPersonList = null;
                    this.getWvList();
                    this.getData();
                    this.permissionLoading = false;
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.promptOptions = {
                    title: "Hobby",
                    yesNo: true,
                    icon: "qm-icon-soccer_ball",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                this.$scope.$watch('vm.form.typeId', (newVal, oldVal) => {
                    if (newVal === oldVal)
                        return;
                    this.form.isHobbyDisabled = !newVal || newVal === QMC.Common.Constants.GUID_EMPTY;
                });
                $(`#edit-form`).on('hidden.bs.modal', () => {
                    $timeout(() => $scope.vm.initForm());
                    $(`#edit-form`).find('.tab-content').children().removeClass('in').removeClass('active');
                    $(`#edit-form`).find('.tab-content').find('#baseDataTab').addClass('in active');
                });
                udfService.getUserDefinedFields(this.objectType).then((data) => {
                    this.udfs = data.sort((a, b) => a.caption.localeCompare(b.caption));
                });
            }
            getData() {
                this.getHobbies();
            }
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * init a new form with default values
             *
             * @private
             *
             * @memberOf DetailHobbyController
             */
            initForm() {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    validFrom: new Date(),
                    validTo: null,
                    typeId: QMC.Common.Constants.GUID_EMPTY,
                    subTypeId: QMC.Common.Constants.GUID_EMPTY,
                    societyId: QMC.Common.Constants.GUID_EMPTY,
                    caption: '',
                    comment: '',
                    contactPersonId: QMC.Common.Constants.GUID_EMPTY,
                    parentObjectId: this.id,
                    membershipNo: ''
                };
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get a list of hobbies
             *
             * @private
             *
             * @memberOf DetailHobbyController
             */
            getHobbies() {
                this.loading = true;
                this.stammdatenService.getHobbyList(this.id).then((data) => {
                    this.ui.hobbyTable.data = data;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.loading = false;
                });
            }
            getAdditionalInfos() {
                this.stammdatenService.getSocietyListItem().then((dataSociety) => {
                    this.societyList = dataSociety;
                    return this.clientService.getContactPersonListOfPerson(this.form.societyId, "", true, false, true).then((dataContactPerson) => {
                        const values = dataContactPerson.map(x => ({ value: x.objectId, text: x.displayTitle }));
                        values.sort((a, b) => (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0));
                        this.contactPersonList = values;
                        this.$qui.functionWaiter("ui.createForm", this);
                    });
                });
            }
            getSocietyListItems() {
                if (this.societyList != (null || undefined)) {
                    return this.ui.select(this.societyList, { value: 'id', text: 'displayTitle' });
                }
                else {
                    return null;
                }
            }
            getContactPersonItems() {
                if (this.form.societyId != (null || undefined || "") && this.contactPersonList != (null || undefined)) {
                    return this.clientService.getContactPersonListOfPerson(this.form.societyId, "", true, false, true).then((data) => {
                        const values = data.map(x => ({ value: x.objectId, text: x.displayTitle }));
                        values.sort((a, b) => (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0));
                        this.contactPersonList = values;
                        if (this.contactPersonList.length === 0) {
                            this.form.contactPersonId = null;
                        }
                        return this.ui.select(values, { value: 'value', text: 'text' });
                    });
                }
                else {
                    return null;
                }
            }
            /**
             * get the wv list
             *
             * @private
             *
             * @memberOf DetailHobbyController
             */
            getWvList() {
                this.loading = true;
                this.stammdatenService.getHobbyWv().then((wvData) => {
                    this.wvList = wvData;
                    this.getAdditionalInfos();
                    this.getHobbyRequiredFields();
                    this.initForm();
                    this.loading = false;
                });
            }
            getHobbyRequiredFields() {
                this.stammdatenService.getHobbyRequiredFields().then((data) => {
                    this.hobbyRequiredFields = data;
                });
            }
            getTypeWv() {
                return this.wvList.typeWvList.map(function (obj) {
                    return {
                        value: obj.id,
                        text: obj.name
                    };
                });
            }
            getSubTypeWv() {
                let data = [];
                if (!this.form.typeId || this.form.typeId === QMC.Common.Constants.GUID_EMPTY)
                    return [];
                let hobbyTypeName = this.getHobyTypeName(this.form.typeId);
                data = this.wvList.subTypeWvList[hobbyTypeName];
                return data.map(function (obj) {
                    return {
                        value: obj.id,
                        text: obj.name
                    };
                });
            }
            getHobyTypeName(hobbyTypeId) {
                const hobbyTypeConst = this.wvList.typeWvList.filter(hobbyType => hobbyType.objectId === hobbyTypeId);
                return hobbyTypeConst ? (hobbyTypeConst[0].name.substring(0, 1).toLowerCase() + hobbyTypeConst[0].name.substring(1)).trim() : '';
            }
            /**
             * add a new hobby
             *
             * @private
             *
             * @memberOf DetailHobbyController
             */
            addHobby(form) {
                form.parentObjectId = this.id;
                this.stammdatenService.postHobby(form).then((e) => {
                    this.formState = "new";
                    this.ui.notify(this.ui.successNote);
                    this.getHobbies();
                    $('#edit-form').modal('hide');
                });
            }
            /**
             * delete an existing hobby
             *
             * @private
             * @param {IHobby} data
             *
             * @memberOf DetailHobbyController
             */
            deleteHobby(item) {
                this.promptOptions.itemText = item.validFrom != null ? moment(item.validFrom).format("DD.MM.YYYY") + " " + item.caption : item.caption;
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.stammdatenService.deleteHobby(this.id, item.objectId).then((data) => {
                            this.ui.notify(this.ui.deleteNote);
                            this.formState = "new";
                            this.getHobbies();
                        });
                });
            }
            /**
             * edit a existing hobby
             *
             * @private
             * @param {IHobby} data
             *
             * @memberOf DetailHobbyController
             */
            editHobby(data) {
                this.form = angular.copy(data);
                this.formState = "edit";
                this.form.validFrom = moment(data.validFrom).toDate();
                if (data.validTo != null) {
                    this.form.validTo = moment(data.validTo).toDate();
                }
                this.$qui.waitForEl('#standardTabButton', () => {
                    $('#standardTabButton').click();
                });
            }
            putHobby(form) {
                this.loading = true;
                this.stammdatenService.putHobby(this.id, this.form.objectId, form).then((data) => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    $('#edit-form').modal('hide');
                }).finally(() => this.getHobbies());
                this.udfs.forEach(x => { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            }
        };
        DetailHobbyController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailHobbyController'),
            QMC.Inject('StammdatenService', '$qui', 'KlientService', '$stateParams', '$scope', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout', 'QmcUdfService')
        ], DetailHobbyController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailDocumentsController = class DetailDocumentsController {
            constructor($qui, $stateParams, $location) {
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$location = $location;
                this.id = this.$stateParams.id;
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.parentObjectType = 120000;
                        this.objectType = 120007;
                        break;
                    default:
                        this.parentObjectType = 140000;
                        this.objectType = 140032;
                        break;
                }
                this.$qui.waitForEl('#newModalButton', () => {
                    document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                });
                $qui.init(this.$qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.$qui.functionWaiter("createDirective", this);
            }
        };
        DetailDocumentsController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailDocumentsController'),
            QMC.Inject('$qui', '$stateParams', '$location')
        ], DetailDocumentsController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailDiseaseController = class DetailDiseaseController {
            /**
             * Creates an instance of DetailDiseaseController.
             *
             * @memberOf DetailDiseaseController
             */
            constructor(stammdatenService, $qui, $stateParams, $scope, $state, lng, permissionService, userService, $timeout, udfService) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.lng = lng;
                this.userService = userService;
                this.allowTableExport = false;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.diseases = [];
                this.formState = "new";
                this.shouldLoadTableData = true;
                this.objectType = 140002;
                this.documentObjectType = 140110;
                this.enableDocuments = false;
                this.udfs = [];
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.id = $stateParams.id;
                permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType]).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.moduleAccess = data[0].moduleAccess && data[0].view;
                    this.allowTableExport = data[0].print;
                    this.enableDocuments = data[1].moduleAccess;
                    $timeout(() => {
                        if (!this.new)
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                        else
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'unset');
                    });
                    this.diseaseWvList = [];
                    this.getDiseaseWvList();
                    this.getData();
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.promptOptions = {
                    title: "Krankheit",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                const vm = this;
                $(`#edit-form`).on('hidden.bs.modal', () => {
                    this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(() => vm.initForm());
                    $(`#edit-form`).find('.tab-content').children().removeClass('in').removeClass('active');
                    $(`#edit-form`).find('.tab-content').find('#baseDataTab').addClass('in active');
                });
                udfService.getUserDefinedFields(this.objectType).then((data) => {
                    this.udfs = data.sort((a, b) => a.caption.localeCompare(b.caption));
                });
            }
            getData() {
                this.getDiseases();
            }
            events() {
                $('#liveDiseases .typeahead').typeahead({
                    source: (query, process) => {
                        this.stammdatenService.getDiseasesBySearchText(this.form.diseaseCodeSchemaId, query).then((data) => {
                            this.diseases = data.items;
                            process(data.items.map(obj => {
                                return obj.name;
                            }));
                        });
                        this.form.diseaseId = null;
                        if (this.invalidateForm)
                            this.invalidateForm('diseaseName');
                    },
                    items: -1,
                    menu: '<ul class="typeahead dropdown-menu pre-scrollable"></ul>',
                    fitToElement: true,
                    updater: (item) => {
                        /* Find the id to the selected text */
                        for (const disease of this.diseases) {
                            if (disease.name === item) {
                                this.form.diseaseId = disease.id;
                                break;
                            }
                            else {
                                this.form.diseaseId = null;
                                if (this.invalidateForm)
                                    this.invalidateForm('diseaseName');
                            }
                        }
                        return item;
                    },
                    //no default sorting from the component, use the sorting used in API for loading the data, BEZEICHNUNG
                    sorter: (items) => {
                        return items;
                    },
                    matcher: (_item) => {
                        return true;
                    }
                });
            }
            /**
             * init a new form with default values
             *
             * @private
             *
             * @memberOf DetailDiseaseController
             */
            initForm() {
                this.formState = 'new';
                this.form = {
                    id: null,
                    objectId: null,
                    comment: null,
                    dateFrom: new Date(),
                    dateTo: null,
                    diseaseCodeSchemaId: QMC.Common.Constants.DEFAULT_DISEASE_CODE_SCHEMA,
                    diseaseId: null,
                    diseaseTypeId: null,
                    parentObjectId: this.id,
                    parentObjectType: QMC.Common.Constants.OBJECTTYPE_CLIENT
                };
                this.$qui.functionWaiter("ui.createForm", this);
                setTimeout(() => {
                    this.events();
                }, 500);
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the disease wv list
             *
             * @private
             * @returns }
             *
             * @memberOf DetailDiseaseController
             */
            getDiseaseWvList() {
                return this.stammdatenService.getDiseaseWvList().then((data) => {
                    this.diseaseWvList.push(data);
                    this.initForm();
                });
            }
            getDiseaseCodeSchemaWvList() {
                return this.ui.select(this.diseaseWvList[0].diseaseCodeSchemaWvList, { value: 'id', text: 'name' });
            }
            getDiseaseTypeWvList() {
                return this.ui.select(this.diseaseWvList[0].diseaseTypeWvList, { value: 'id', text: 'name' });
            }
            /**
             * get a list of diseases
             *
             * @private
             *
             * @memberOf DetailDiseaseController
             */
            getDiseases() {
                this.loading = true;
                this.stammdatenService.getDiseaseList(this.id).then((data) => {
                    this.ui.diseaseTable.data = data;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.loading = false;
                    if (this.$stateParams.dataId) {
                        const item = data.filter(x => x.objectId === this.$stateParams.dataId)[0];
                        if (item) {
                            $(`#edit-form`).modal('show');
                            this.editDisease(item);
                        }
                    }
                });
            }
            /**
             * add a new disease
             *
             * @private
             * @param {IDisease} form
             *
             * @memberOf DetailDiseaseController
             */
            addDisease(form) {
                if (!this.form.diseaseId) {
                    console.warn('No disease code supplied (post)', this.form);
                    return;
                }
                this.loading = true;
                this.stammdatenService.postDisease(form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    this.getDiseases();
                    $('#edit-form').modal('hide');
                });
            }
            /**
             * put a existing disease
             *
             * @private
             * @param {IDisease} form
             *
             * @memberOf DetailDiseaseController
             */
            putDisease(form) {
                if (!this.form.diseaseId) {
                    console.warn('No disease code supplied (put)', this.form);
                    return;
                }
                this.loading = true;
                this.stammdatenService.putDisease(form.parentObjectId, form.objectId, form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    this.getDiseases();
                    $('#edit-form').modal('hide');
                });
                this.udfs.forEach(x => { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            }
            /**
             * edit a existing disease
             *
             * @private
             * @param {IDisease} data
             *
             * @memberOf DetailDiseaseController
             */
            editDisease(data) {
                this.formState = "edit";
                this.form = data;
                this.form.dateFrom = moment(data.dateFrom).toDate();
                if (this.form.dateTo !== null)
                    this.form.dateTo = moment(data.dateTo).toDate();
                this.$qui.waitForEl('#standardTabButton', () => {
                    $('#standardTabButton').click();
                });
                this.$state.go('.', { dataId: data.objectId });
            }
            /**
             * delete a existing disease
             *
             * @private
             * @param {IDisease} data
             *
             * @memberOf DetailDiseaseController
             */
            deleteDisease(item) {
                this.promptOptions.itemText = item.diseaseName;
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.stammdatenService.deleteDisease(this.id, item.objectId).then(() => {
                            this.ui.notify(this.ui.deleteNote);
                            this.formState = "new";
                            this.getDiseases();
                        });
                });
            }
        };
        DetailDiseaseController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailDiseaseController'),
            QMC.Inject('StammdatenService', '$qui', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout', 'QmcUdfService')
        ], DetailDiseaseController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailDismissalController = class DetailDismissalController {
            constructor(stammdatenService, $qui, $stateParams, $state, lng, permissionService, userService, $timeout, udfService) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$state = $state;
                this.lng = lng;
                this.userService = userService;
                this.objectType = 140012;
                this.documentObjectType = 140124;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.shouldLoadTableData = true;
                this.isLoading = {
                    data: false,
                    auxiliary: false,
                    detail: false
                };
                this.promptOptions = {
                    title: this.lng.translate(20006510, "Entlassung löschen"),
                    yesNo: true,
                    icon: "qm-icon-arrow_into",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?"),
                    itemText: ''
                };
                this.udfs = [];
                this.parentId = $stateParams.id;
                this.isLoading.auxiliary = true;
                Promise.all([permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType]), stammdatenService.getDismissalWv(), stammdatenService.getAdmissionList(this.parentId)])
                    .then(datas => {
                    this.enableDocuments = datas[0][1].moduleAccess;
                    const permission = datas[0][0];
                    this.delete = permission.delete;
                    this.new = permission.new;
                    this.modify = permission.modify;
                    this.moduleAccess = permission.moduleAccess && permission.view;
                    this.allowTableExport = permission.print;
                    this.wvData = datas[1];
                    this.admissions = datas[2];
                    this.$qui.waitForEl('#newModalButton', () => {
                        document.getElementById('newModalButton').style.visibility = this.new ? 'unset' : 'hidden';
                    });
                    if (this.moduleAccess)
                        this.getData();
                })
                    .finally(() => this.isLoading.auxiliary = false);
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                $(`#edit-form`).on('hidden.bs.modal', () => {
                    this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(() => this.initForm());
                });
                this.initForm();
                udfService.getUserDefinedFields(this.objectType).then((data) => {
                    this.udfs = data.sort((a, b) => a.caption.localeCompare(b.caption));
                });
                if ($stateParams.dataId)
                    this.editRow({ id: $stateParams.dataId, objectId: $stateParams.dataId, date: new Date() });
            }
            /////////////// DISPLAY LOGIC ///////////////
            initForm() {
                this.form = {
                    id: null,
                    objectId: null,
                    date: moment().endOf('day').toDate(),
                    internalTime: moment().endOf('day').toDate()
                };
                this.$qui.waitForEl(`#standardTabButton`, () => {
                    $(`#standardTabButton`).click();
                });
            }
            openForm() {
                $(`#edit-form`).modal('show');
            }
            editRow(row) {
                this.udfs.forEach(udf => udf.isValid = false);
                this.openForm();
                this.isLoading.detail = true;
                this.stammdatenService.getDismissal(this.parentId, row.objectId)
                    .then(data => this.form = data)
                    .catch(() => this.initForm())
                    .finally(() => this.isLoading.detail = false);
            }
            deleteRow(row) {
                var _a, _b, _c;
                this.promptOptions.itemText = `${(_a = row.remainingAfterDismissal) !== null && _a !== void 0 ? _a : ''} ${(_c = (_b = this.admissions.find(x => x.objectId === row.admissionId)) === null || _b === void 0 ? void 0 : _b.parentFacility) !== null && _c !== void 0 ? _c : ''} (${moment(row.date).format('DD.MM.YYYY')})`.trim();
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data) {
                        this.isLoading.data = true;
                        this.stammdatenService.deleteDismissal(this.parentId, row.objectId).finally(() => this.getData());
                    }
                });
            }
            saveForm(form) {
                if (!this.isFormValid)
                    return;
                this.isLoading.data = true;
                if (this.formState === 'new')
                    this.stammdatenService.postDismissal(this.parentId, form)
                        .then(() => $(`#edit-form`).modal('hide'))
                        .finally(() => this.getData());
                else {
                    this.udfs.forEach(x => { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
                    this.stammdatenService.putDismissal(this.parentId, form.objectId, form)
                        .then(() => $(`#edit-form`).modal('hide'))
                        .finally(() => this.getData());
                }
            }
            getData() {
                this.isLoading.data = true;
                this.stammdatenService.getDismissalList(this.parentId)
                    .then(data => {
                    data.forEach(x => {
                        var _a, _b, _c, _d, _e, _f;
                        x.admission = `${(_b = (_a = this.admissions.find(y => y.objectId === x.admissionId)) === null || _a === void 0 ? void 0 : _a.parentFacility) !== null && _b !== void 0 ? _b : ''} (${moment(x.date).format('DD.MM.YYYY')})`.trim();
                        x.initiative = (_c = this.wvData.initiativeWvList.find(y => y.objectId === x.initiativeId)) === null || _c === void 0 ? void 0 : _c.name;
                        x.remainingAfterDismissal = (_d = this.wvData.remainingAfterDismissalWvList.find(y => y.objectId === x.remainingAfterDismissalId)) === null || _d === void 0 ? void 0 : _d.name;
                        x.initiatedBy = (_e = this.wvData.initiatedByWvList.find(y => y.objectId === x.initiatedById)) === null || _e === void 0 ? void 0 : _e.name;
                        x.reason = (_f = this.wvData.reasonWvList.find(y => y.objectId === x.reasonId)) === null || _f === void 0 ? void 0 : _f.name;
                    });
                    this.ui.dismissalTable.data = data;
                })
                    .catch(() => this.ui.dismissalTable.data = [])
                    .finally(() => {
                    this.isLoading.data = false;
                    this.$qui.functionWaiter("ui.createTable", this);
                });
            }
            anyUdfInvalid() {
                return this.formState === 'edit' && this.udfs.some(udf => !udf.isValid);
            }
        };
        DetailDismissalController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailDismissalController'),
            QMC.Inject('StammdatenService', '$qui', '$stateParams', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout', 'QmcUdfService')
        ], DetailDismissalController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailDoctorsVisitController = class DetailDoctorsVisitController {
            /**
             * Creates an instance of DetailDoctorsVisitController.
             *
             * @memberOf DetailDoctorsVisitController
             */
            constructor(stammdatenService, $qui, $stateParams, $scope, $state, lng, permissionService, userService, $timeout, udfService) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$state = $state;
                this.lng = lng;
                this.userService = userService;
                this.allowTableExport = false;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.medOrgas = [];
                this.doctors = [];
                this.shouldLoadTableData = true;
                this.objectType = 140003;
                this.documentObjectType = 140111;
                this.enableDocuments = false;
                this.udfs = [];
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.id = $stateParams.id;
                this.permissionLoading = true;
                permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType]).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.moduleAccess = data[0].moduleAccess && data[0].view;
                    this.allowTableExport = data[0].print;
                    this.enableDocuments = data[1].moduleAccess;
                    $timeout(() => {
                        if (!this.new)
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                        else
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'unset');
                    });
                    this.stammdatenService.getDoctorList().then((data) => {
                        this.doctors = this.ui.select(data, { value: 'id', text: 'displayTitle' });
                        this.stammdatenService.getMedicalOrganisationList().then((data) => {
                            this.medOrgas = this.ui.select(data, { value: 'id', text: 'name' });
                            this.initForm();
                            this.getData();
                            this.permissionLoading = false;
                        });
                    });
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.lang = lng;
                this.promptOptions = {
                    title: "Arztbesuch",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lang.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                const vm = this;
                $(`#edit-form`).on('hidden.bs.modal', () => {
                    this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(() => vm.initForm());
                    $(`#edit-form`).find('.tab-content').children().removeClass('in').removeClass('active');
                    $(`#edit-form`).find('.tab-content').find('#baseDataTab').addClass('in active');
                });
                udfService.getUserDefinedFields(this.objectType).then((data) => {
                    this.udfs = data.sort((a, b) => a.caption.localeCompare(b.caption));
                });
            }
            getData() {
                this.getDocVisits();
            }
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * init the form with default values
             *
             * @private
             *
             * @memberOf DetailDoctorsVisitController
             */
            initForm() {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    date: new Date(),
                    time: new Date(),
                    treaterId: null,
                    treaterObjectType: 0,
                    diagnose: null,
                    discipline: null,
                    parentObjectId: null
                };
                this.$qui.functionWaiter("ui.createForm", this);
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the list of doc visits
             *
             * @private
             *
             * @memberOf DetailDoctorsVisitController
             */
            getDocVisits() {
                this.loading = true;
                this.stammdatenService.getDoctorsVisitList(this.id).then((data) => {
                    this.ui.docVisitTable.data = data;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.loading = false;
                    if (this.$stateParams.dataId) {
                        const item = data.filter(x => x.objectId === this.$stateParams.dataId)[0];
                        if (item) {
                            $(`#edit-form`).modal('show');
                            this.editDocVisit(item);
                        }
                    }
                });
            }
            /**
             * get the list of doctors
             *
             * @private
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailDoctorsVisitController
             */
            getDoctors() {
                let result = this.doctors.map((x) => { return { text: x.text, value: x.value, group: this.lng.translate(20010508, 'Arzt') }; });
                result = result.concat(this.medOrgas.map((x) => { return { text: x.text, value: x.value, group: this.lng.translate(20023005, 'Medizinische Organisation') }; }));
                return result;
            }
            /**
             * add a new doc visit
             *
             * @private
             * @param {IDoctorsVisit} form
             *
             * @memberOf DetailDoctorsVisitController
             */
            addDocVisit(form) {
                form.parentObjectId = this.id;
                form.date = this.ui.addTimeToDate(form.date, form.time);
                form.time = form.date;
                form.treaterObjectType = this.getTreaterObjectType(form.treaterId);
                this.loading = true;
                this.stammdatenService.postDoctorsVisit(form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    this.getDocVisits();
                    $('#edit-form').modal('hide');
                });
            }
            /**
             * put a existing doc visit
             *
             * @private
             * @param {IDoctorsVisit} form
             *
             * @memberOf DetailDoctorsVisitController
             */
            putDocVisit(form) {
                form.date = this.ui.addTimeToDate(form.date, form.time);
                form.time = form.date;
                form.treaterObjectType = this.getTreaterObjectType(form.treaterId);
                this.loading = true;
                this.stammdatenService.putDoctorsVisit(form.parentObjectId, form.objectId, form).then(() => {
                    this.$qui.notify(this.$qui.successNote);
                    this.formState = "new";
                    $('#edit-form').modal('hide');
                    this.getDocVisits();
                });
                this.udfs.forEach(x => { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            }
            getTreaterObjectType(treaterId) {
                if (this.doctors.some(x => x.value === treaterId))
                    return 110000;
                if (this.medOrgas.some(x => x.value === treaterId))
                    return 310000;
                return 0;
            }
            /**
             * delete a existing doc visit
             *
             * @private
             * @param {IDoctorsVisit} item
             *
             * @memberOf DetailDoctorsVisitController
             */
            deleteDocVisit(item) {
                this.loading = true;
                this.promptOptions.itemText = item.treaterName + " (" + moment(item.date).format("DD.MM.YYYY HH:mm") + ")";
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.stammdatenService.deleteDoctorsVisit(this.id, item.objectId).then(() => {
                            this.ui.notify(this.ui.deleteNote);
                            this.formState = "new";
                            $('#edit-form').modal('hide');
                            this.getDocVisits();
                        });
                });
            }
            /**
             * edit a existing doc visit
             *
             * @private
             * @param {IDoctorsVisit} data
             *
             * @memberOf DetailDoctorsVisitController
             */
            editDocVisit(data) {
                console.log('edit', data);
                this.formState = "edit";
                this.stammdatenService.getDoctorsVisit(this.id, data.objectId).then((docVisit) => {
                    this.form = docVisit;
                    this.form.date = moment(docVisit.date).toDate();
                    this.form.time = moment(docVisit.time).toDate();
                    this.$qui.waitForEl('#standardTabButton', () => {
                        $('#standardTabButton').click();
                    });
                });
                this.$state.go('.', { dataId: data.objectId });
            }
        };
        DetailDoctorsVisitController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailDoctorsVisitController'),
            QMC.Inject('StammdatenService', '$qui', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout', 'QmcUdfService')
        ], DetailDoctorsVisitController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailAbsenteeismController = class DetailAbsenteeismController {
            /**
             * QMC.Stammdaten.DetailAbsenteeismController
             * @constructor
             * @param stammdatenService
             * @param clientService
             * @param $stateParams
             * @param $scope
             * @param $state
             * @param lng
             */
            constructor(stammdatenService, $qui, clientService, $stateParams, $scope, $state, lng, permissionService, userService, $timeout) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$scope = $scope;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.$timeout = $timeout;
                this.allowTableExport = false;
                this.ui = new Stammdaten.DetailUI();
                this.formState = "new";
                this.shouldLoadTableData = true;
                this.overlapCheck = false;
                this.overlapCheckType = 'warnings';
                this.overlapCheckOnlyForSameType = false;
                this.validation = {
                    errors: [],
                    warnings: [],
                };
                this.validationSuccessfulMessage = '';
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.id = $stateParams.id;
                permissionService.getPermissionsByObjectType(140033).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.moduleAccess = data[0].moduleAccess && data[0].view;
                    this.allowTableExport = data[0].print;
                    $timeout(() => {
                        if (!this.new)
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                        else
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'unset');
                    });
                    this.getAbsenteeismBans();
                    this.initForm();
                    this.userService.getUserSettings(['ABWESENHEIT.CHECK.OVERLAP', 'ABWESENHEIT.CHECK.OVERLAP.TYPEONLY'], false).then((data) => {
                        if (data[0].value) {
                            this.overlapCheck = data[0].value !== 'fe55229f-b052-4d3a-b2d1-e127b0d08879';
                            this.overlapCheckType = data[0].value === '042e92e2-09b4-48b6-b3ee-7b0dc077d42b' ? 'errors' : 'warnings';
                        }
                        this.overlapCheckOnlyForSameType = data[1].value.toLowerCase() === 'true';
                    });
                    this.getData();
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.$scope.$watch('vm.form.absenteeismReasonId', (newVal, oldVal) => {
                    if (newVal === oldVal && !this.loading)
                        return;
                    setTimeout(() => {
                        this.validate();
                    }, 1000);
                }, true);
                this.$scope.$watch('vm.form.dateFrom', (newVal, oldVal) => {
                    if (newVal === oldVal && !this.loading)
                        return;
                    setTimeout(() => {
                        this.validate();
                    }, 1000);
                }, true);
                this.$scope.$watch('vm.form.dateTo', (newVal, oldVal) => {
                    if (newVal === oldVal && !this.loading)
                        return;
                    setTimeout(() => {
                        this.validate();
                    }, 1000);
                }, true);
                this.promptOptions = {
                    title: "Abwesenheit",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
            }
            getData() {
                this.getAbsenteeisms();
            }
            /////////////// DISPLAY LOGIC ///////////////
            /**
             * init the form with default values
             *
             * @private
             *
             * @memberOf DetailAbsenteeismController
             */
            initForm() {
                this.validation.errors = [];
                this.validation.warnings = [];
                this.validationSuccessfulMessage = this.lng.translate(21008009, 'Zeitraumsvalidierung erfolgreich');
                this.form = {
                    id: null,
                    objectId: null,
                    dateTo: null,
                    dateFrom: moment().startOf('day').toDate(),
                    absenteeismReasonId: null,
                    parentObjectId: null,
                    parentObjectType: QMC.Common.Constants.OBJECTTYPE_CLIENT,
                    comment: null,
                    contactPersonId: null
                };
                this.$qui.functionWaiter("ui.createForm", this);
            }
            getWvList() {
                return this.stammdatenService.getAbsenteeismWv().then((data) => {
                    this.wvList = data;
                    return this.ui.select(data.absenteeismReasonWvList, { value: 'objectId', text: 'name' });
                });
            }
            getContactPersonList() {
                return this.stammdatenService.getParticipantsSelectionAssignment('ABWESENHEIT_AUFENTHALT_BEI', true).then((data) => {
                    return this.ui.select(data, { value: 'objectId', text: 'displayTitle', group: 'objectTypeCaption' });
                });
            }
            /**
             * Get all absenteeisms in array from WebAPI
             *
             * @private
             *
             * @memberOf DetailAbsenteeismController
             */
            getAbsenteeisms() {
                this.loading = true;
                this.stammdatenService.getAbsenteeismList(this.id).then((data) => {
                    this.absenteeisms = data;
                    this.ui.absenteeismTable.data = data.map((x) => ({
                        id: x.id,
                        objectId: x.objectId,
                        absenteeismReasonId: x.absenteeismReasonId,
                        absenteeismReason: x.absenteeismReason,
                        comment: x.comment,
                        dateFrom: x.dateFrom,
                        dateTo: x.dateTo,
                        contactPersonName: x.contactPersonName,
                        contactPersonId: x.contactPersonId,
                        style: this.isAbsenteeismBanned(x) ? { 'background-color': 'orangered', 'color': 'white', 'font-weight': 'bold' } : {}
                    }));
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.loading = false;
                });
            }
            /**
             * Get all absenteeism bans in array from WebAPI
             *
             * @private
             *
             * @memberOf DetailAbsenteeismController
             */
            getAbsenteeismBans() {
                this.stammdatenService.getAbsenteeismBanList(this.id).then((data) => {
                    this.absenteeismBansList = data;
                });
            }
            /**
             * Add a new absenteeism
             *
             * @private
             * @param {IAbsenteeism} form
             *
             * @memberOf DetailAbsenteeismController
             */
            addAbsenteeism(form) {
                form.parentObjectId = this.id;
                if (this.checkIsBanned(this.form)) {
                    $('#absenteeismBan').modal('show');
                    return;
                }
                this.stammdatenService.postAbsenteeism(form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    this.getAbsenteeisms();
                });
            }
            /**
             * Edit an existing absenteeism
             *
             * @private
             * @param {IAbsenteeism} data
             *
             * @memberOf DetailAbsenteeismController
             */
            editAbsenteeism(data) {
                this.form = angular.copy(data);
                this.formState = "edit";
                this.form.dateFrom = moment(data.dateFrom).toDate();
                this.form.dateTo = data.dateTo ? moment(data.dateTo).toDate() : null;
            }
            /**
             * Update an existing absenteeism by id
             *
             * @private
             *
             * @memberOf DetailAbsenteeismController
             */
            putAbsenteeism() {
                if (this.checkIsBanned(this.form)) {
                    $('#absenteeismBan').modal('show');
                    return;
                }
                this.stammdatenService.putAbsenteeism(this.id, this.form.objectId, this.form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    this.getAbsenteeisms();
                });
            }
            /**
             * Delete an existing absenteeism by id
             *
             * @private
             * @param {any} data
             *
             * @memberOf DetailAbsenteeismController
             */
            deleteAbsenteeism(item) {
                if (!this.isAbsenteeismBanned(item, true)) {
                    this.promptOptions.itemText = item.absenteeismReason;
                    QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                        if (data)
                            this.stammdatenService.deleteAbsenteeism(this.id, item.objectId).then(() => {
                                this.ui.notify(this.ui.deleteNote);
                                this.formState = "new";
                                this.getAbsenteeisms();
                            });
                    });
                }
            }
            isAbsenteeismBanned(item, showWarning = false) {
                let isBanned = false;
                if (item && this.absenteeismBansList && item.id) {
                    isBanned = this.checkIsBanned(item);
                }
                if (isBanned && showWarning) {
                    this.$qui.notify({
                        message: this.lng.translate(21008006, "Abwesenheitsperre vorhanden"),
                        title: "Fehler",
                        icon: "qm-icon-error",
                        status: "warning",
                        timer: 3500
                    });
                }
                return isBanned;
            }
            checkIsBanned(item) {
                if (!this.absenteeismBansList || !item)
                    return;
                for (const listItem of this.absenteeismBansList) {
                    if (moment(listItem.banDate).endOf('day').toDate() >= this.$qui.createDateFromString(item.dateFrom)) {
                        return true;
                    }
                }
                return false;
            }
            shouldDisableForm(form) {
                if (this.formState !== 'edit')
                    return false;
                const item = this.ui.absenteeismTable.data.filter(x => x.objectId === form.objectId)[0];
                if (item)
                    return this.checkIsBanned(item);
                return false;
            }
            validate() {
                var _a;
                this.validation.errors = [];
                this.validation.warnings = [];
                if (this.overlapCheck) {
                    const absenteeismRequestValidation = {
                        dateFrom: this.form.dateFrom,
                        objectId: this.form.objectId,
                        parentObjectId: (_a = this.form.parentObjectId) !== null && _a !== void 0 ? _a : this.id,
                        dateTo: this.form.dateTo,
                        reasonId: this.form.absenteeismReasonId
                    };
                    this.stammdatenService.checkAbsenteeismValidation(absenteeismRequestValidation).then((data) => {
                        this.validation.errors = data.errors;
                        this.validation.warnings = data.warnings;
                        if (this.checkIsBanned(this.form)) {
                            this.validation.errors.push(this.lng.translate(21008007, 'Der Zeitraum ist für Abwesenheiten gesperrt.'));
                        }
                    });
                }
            }
        };
        DetailAbsenteeismController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailAbsenteeismController'),
            QMC.Inject('StammdatenService', '$qui', 'KlientService', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout')
        ], DetailAbsenteeismController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailEducationController = class DetailEducationController {
            /**
             * Creates an instance of DetailEducationController.
             * @param {StammdatenService} stammdatenService
             * @param {any} $qui
             * @param {Klient.KlientService} clientService
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {any} $state
             * @param {Common.QmcLanguageService} lng
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberOf DetailEducationController
             */
            constructor(stammdatenService, $qui, clientService, $stateParams, $scope, $state, lng, permissionService, userService, $timeout) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$stateParams = $stateParams;
                this.$scope = $scope;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.$timeout = $timeout;
                this.allowTableExport = false;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.formState = "new";
                this.educationKind = [];
                this.shouldLoadTableData = true;
                this.objectType = 140068;
                this.documentObjectType = 140102;
                this.enableDocuments = false;
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.id = $stateParams.id;
                permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType]).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.moduleAccess = data[0].moduleAccess && data[0].view;
                    this.allowTableExport = data[0].print;
                    this.enableDocuments = data[1].moduleAccess;
                    $timeout(() => {
                        if (!this.new)
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                        else
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'unset');
                    });
                    const schoolEducationKind = {
                        id: "0",
                        objectId: "0",
                        caption: this.lang.translate(20012000, "Schulausbildung")
                    };
                    const professEducationKind = {
                        id: "1",
                        objectId: "1",
                        caption: this.lang.translate(20012001, "Berufliche Ausbildung")
                    };
                    const professCareerEducationKind = {
                        id: "2",
                        objectId: "2",
                        caption: this.lang.translate(20012002, "Beruflicher Werdegang")
                    };
                    this.educationKind.push(schoolEducationKind);
                    this.educationKind.push(professEducationKind);
                    this.educationKind.push(professCareerEducationKind);
                    this.educationSchemaWvList = [];
                    this.schoolsList = null;
                    this.gradeLevelList = null;
                    this.companiesList = null;
                    this.getData();
                    this.getEducationWvList();
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.lang = lng;
                this.promptOptions = {
                    title: "Lebenslauf / Ausbildung",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lang.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                const vm = this;
                $(`#edit-form`).on('hidden.bs.modal', () => {
                    this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(() => vm.initForm());
                });
            }
            getData() {
                this.getEducations();
            }
            /**
             * init a new form with default values
             *
             * @private
             *
             * @memberOf DetailEducationController
             */
            initForm() {
                this.formState = "new";
                this.form = {
                    id: null,
                    educationKind: null,
                    objectId: null,
                    comment: null,
                    validFrom: new Date(),
                    validTo: null,
                    caption: null,
                    classId: null,
                    contactPersonId: null,
                    educationType: null,
                    schoolCompanyId: QMC.Common.Constants.GUID_EMPTY,
                    statusId: null,
                    parentObjectId: this.id,
                    parentObjectType: QMC.Common.Constants.OBJECTTYPE_CLIENT
                };
                this.$qui.functionWaiter("ui.createForm", this);
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the education wv list
             *
             * @private
             * @returns }
             *
             * @memberOf DetailEducationController
             */
            getEducationWvList() {
                this.loading = true;
                return this.stammdatenService.getEducationWvList().then((dataEducation) => {
                    this.educationSchemaWvList.push(dataEducation);
                    this.initForm();
                    let counter = 0;
                    const createForm = () => {
                        counter++;
                        if (counter > 2)
                            this.$qui.functionWaiter("ui.createForm", this);
                    };
                    this.stammdatenService.getSchoolsList().then((data) => {
                        this.schoolsList = data;
                        createForm();
                    });
                    this.stammdatenService.getCompaniesList().then((data) => {
                        this.companiesList = data;
                        createForm();
                    });
                    this.clientService.getContactPersonListOfPerson(this.form.schoolCompanyId, "", true, false, true).then((dataContactPerson) => {
                        const values = dataContactPerson.map(x => ({ value: x.objectId, text: x.displayTitle }));
                        values.sort((a, b) => (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0));
                        this.contactPersonsList = values;
                        this.stammdatenService.getGradeLevelList(this.form.schoolCompanyId).then((dataGradeLvel) => {
                            this.gradeLevelList = dataGradeLvel;
                            createForm();
                        });
                    });
                    this.loading = false;
                });
            }
            getCompaniesItemList() {
                var _a;
                return this.ui.select((_a = this.companiesList) !== null && _a !== void 0 ? _a : [], { value: 'id', text: 'displayTitle' });
            }
            getSchoolsItemList() {
                var _a;
                return this.ui.select((_a = this.schoolsList) !== null && _a !== void 0 ? _a : [], { value: 'id', text: 'displayTitle' });
            }
            getContactPersonsItemList() {
                if (this.form.schoolCompanyId) {
                    return this.clientService.getContactPersonListOfPerson(this.form.schoolCompanyId, "", true, false, true).then((dataContactPerson) => {
                        var _a;
                        const values = dataContactPerson.map(x => ({ value: x.objectId, text: x.displayTitle }));
                        values.sort((a, b) => (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0));
                        this.contactPersonsList = values;
                        //prevent illegal values in contactPersonId
                        if (!this.contactPersonsList.some(x => x.value === this.form.contactPersonId))
                            this.form.contactPersonId = undefined;
                        return this.ui.select((_a = this.contactPersonsList) !== null && _a !== void 0 ? _a : [], { value: 'value', text: 'text' });
                    });
                }
                else {
                    return [];
                }
            }
            getGradeLevelList() {
                if (this.form.schoolCompanyId != (null || undefined || "") && this.gradeLevelList != (null || undefined)) {
                    return this.stammdatenService.getGradeLevelList(this.form.schoolCompanyId).then((dataGradeLvel) => {
                        this.gradeLevelList = dataGradeLvel;
                        return this.ui.select(this.gradeLevelList, { value: 'id', text: 'className' });
                    });
                }
                else {
                    return [];
                }
            }
            getEducationKindWv() {
                var _a;
                return this.ui.select((_a = this.educationKind) !== null && _a !== void 0 ? _a : [], { value: 'id', text: 'caption' });
            }
            getSchoolTypeWv() {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.schoolTypeWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            }
            getSchoolGraduationWv() {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.schoolGraduationWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            }
            getSchoolStatusWv() {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.schoolStatusWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            }
            getProfessionalTypeWv() {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.professionalTypeWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            }
            getProfessionalGraduationWv() {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.professionalGraduationWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            }
            getProfessionalStatusWv() {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.professionalStatusWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            }
            getProfessionalCareerTypeWv() {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.professionalCareerTypeWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            }
            getProfessionalCareerStatusWv() {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.professionalCareerStatusWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            }
            getProfessionalTrainingTypeWv() {
                var _a, _b;
                return this.ui.select((_b = (_a = this.educationSchemaWvList[0]) === null || _a === void 0 ? void 0 : _a.professionalTrainingTypeWvList) !== null && _b !== void 0 ? _b : [], { value: 'id', text: 'name' });
            }
            /**
             * get a list of education
             *
             * @private
             *
             * @memberOf DetailEducationController
             */
            getEducations() {
                this.loading = true;
                this.stammdatenService.getEducationList(this.id).then((data) => {
                    this.ui.educationTable.data = data;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.loading = false;
                    if (this.$stateParams.dataId) {
                        const item = data.filter(x => x.objectId === this.$stateParams.dataId)[0];
                        if (item) {
                            $(`#edit-form`).modal('show');
                            this.editEducation(item);
                        }
                    }
                });
            }
            /**
             * add a new education
             *
             * @private
             * @param {IEducation} form
             *
             * @memberOf DetailEducationController
             */
            addEducation(form) {
                this.loading = true;
                this.stammdatenService.postEducation(form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    this.getEducations();
                    $('#edit-form').modal('hide');
                });
            }
            /**
             * put a existing education
             *
             * @private
             * @param {IEducation} form
             *
             * @memberOf DetailEducationController
             */
            putEducation(form) {
                this.loading = true;
                this.stammdatenService.putEducation(this.id, form.objectId, form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    this.getEducations();
                    $('#edit-form').modal('hide');
                });
            }
            /**
             * edit a existing education
             *
             * @private
             * @param {IEducation} data
             *
             * @memberOf DetailEducationController
             */
            editEducation(data) {
                this.formState = "edit";
                this.form = angular.copy(data);
                this.form.validFrom = moment(data.validFrom).toDate();
                if (this.form.validTo !== null)
                    this.form.validTo = moment(data.validTo).toDate();
                this.$qui.functionWaiter("ui.createForm", this);
                this.$qui.waitForEl('#standardTabButton', () => {
                    $('#standardTabButton').click();
                });
                this.$state.go('.', { dataId: data.objectId });
            }
            /**
             * delete a existing education
             *
             * @private
             * @param {IEducation} data
             *
             * @memberOf DetailEducationController
             */
            deleteEducation(item) {
                this.promptOptions.itemText = item.caption;
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.stammdatenService.deleteEducation(this.id, item.objectId, item.educationKind).then(() => {
                            this.ui.notify(this.ui.deleteNote);
                            this.formState = "new";
                            this.getEducations();
                        });
                });
            }
        };
        DetailEducationController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailEducationController'),
            QMC.Inject('StammdatenService', '$qui', 'KlientService', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout')
        ], DetailEducationController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailTrainingController = class DetailTrainingController {
            /**
             * Creates an instance of DetailTrainingController.
             * @param {StammdatenService} stammdatenService
             * @param {any} $qui
             * @param {Klient.KlientService} clientService
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {any} $state
             * @param {Common.QmcLanguageService} lng
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberOf DetailTrainingController
             */
            constructor(stammdatenService, $qui, clientService, $stateParams, $scope, $state, lng, permissionService, userService, $timeout) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$scope = $scope;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.$timeout = $timeout;
                this.allowTableExport = false;
                this.ui = new QMC.Stammdaten.DetailUI();
                this.formState = "new";
                this.shouldLoadTableData = true;
                $scope.Model = $scope.Model || { Name: 'xxx' };
                this.id = $stateParams.id;
                permissionService.getPermissionsByObjectType(120023).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.moduleAccess = data[0].moduleAccess && data[0].view;
                    this.allowTableExport = data[0].print;
                    $timeout(() => {
                        if (!this.new)
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                        else
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'unset');
                    });
                    this.trainingSchemaWvList = [];
                    this.getData();
                });
                //$qui.init('stammdaten', () => {
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.lang = lng;
                this.promptOptions = {
                    title: "Fähigkeit / Fortbildung",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lang.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
            }
            getData() {
                this.getTrainingWvList();
                this.getTrainingList();
            }
            /**
             * init a new form with default values
             *
             * @private
             *
             * @memberOf DetailTrainingController
             */
            initForm() {
                this.form = {
                    id: null,
                    objectId: null,
                    parentObjectId: this.id,
                    parentObjectType: QMC.Common.Constants.OBJECTTYPE_EMPLOYEE,
                    validFrom: null,
                    validTo: null,
                    assignmentType: null,
                    childObjectType: null,
                    acquiredById: null,
                    description: null,
                    trainingId: null,
                    trainingTypeId: null
                };
                this.$qui.functionWaiter("ui.createForm", this);
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            /**
             * get the training wv list
             *
             * @private
             * @returns }
             *
             * @memberOf DetailTrainingController
             */
            getTrainingWvList() {
                this.loading = true;
                return this.stammdatenService.getTrainingWvList().then((dataTrainingWv) => {
                    this.trainingSchemaWvList.push(dataTrainingWv);
                    this.initForm();
                    this.loading = false;
                });
            }
            getAquiredByWv() {
                return this.ui.select(this.trainingSchemaWvList[0].acquiredByWvList, { value: 'id', text: 'name' });
            }
            getTrainingTypeWv() {
                return this.ui.select(this.trainingSchemaWvList[0].trainingTypeWvList, { value: 'id', text: 'name' });
            }
            getTrainingWv() {
                return this.ui.select(this.trainingSchemaWvList[0].trainingWvList, { value: 'id', text: 'name' });
            }
            /**
             * get a list of training
             *
             * @private
             *
             * @memberOf DetailTrainingController
             */
            getTrainingList() {
                this.loading = true;
                this.stammdatenService.getTrainingList(this.id, QMC.Common.Constants.OBJECTTYPE_EMPLOYEE).then((data) => {
                    this.ui.trainingTable.data = data;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.loading = false;
                });
            }
            /**
             * add a new training
             *
             * @private
             * @param {ITraining} form
             *
             * @memberOf DetailTrainingController
             */
            addTraining(form) {
                this.stammdatenService.postTraining(form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    this.getTrainingList();
                });
            }
            /**
             * put an existing training
             *
             * @private
             * @param {ITraining} form
             *
             * @memberOf DetailTrainingController
             */
            putTraining(form) {
                this.stammdatenService.putTraining(this.id, form.objectId, form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    this.getTrainingList();
                });
            }
            /**
             * edit an existing training
             *
             * @private
             * @param {ITraining} data
             *
             * @memberOf DetailTrainingController
             */
            editTraining(data) {
                this.formState = "edit";
                this.form = angular.copy(data);
                this.form.validFrom = moment(data.validFrom).toDate();
                if (this.form.validTo !== null)
                    this.form.validTo = moment(data.validTo).toDate();
            }
            /**
             * delete a existing training
             *
             * @private
             * @param {ITraining} data
             *
             * @memberOf DetailTrainingController
             */
            deleteTraining(item) {
                this.promptOptions.itemText = item.description;
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.stammdatenService.deleteTraining(this.id, item.objectId).then(() => {
                            this.ui.notify(this.ui.deleteNote);
                            this.formState = "new";
                            this.getTrainingList();
                        });
                });
            }
        };
        DetailTrainingController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailTrainingController'),
            QMC.Inject('StammdatenService', '$qui', 'KlientService', '$stateParams', '$scope', '$state', 'QmcLanguageService', 'QmcPermissionService', 'UserService', '$timeout')
        ], DetailTrainingController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailAccountingBookController = class DetailAccountingBookController {
            constructor($qui, $stateParams) {
                this.$qui = $qui;
                this.reference = {
                    id: $stateParams.id,
                    objectType: QMC.Common.Constants.OBJECTTYPE_CLIENT
                };
                this.$qui.functionWaiter("createDirective", this);
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
            }
        };
        DetailAccountingBookController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailAccountingBookController'),
            QMC.Inject('$qui', '$stateParams')
        ], DetailAccountingBookController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailLegalController = class DetailLegalController {
            /**
             * QMC.Stammdaten.DetailLegalController
             * @constructor
             * @param stammdatenService
             * @param $qui
             * @param clientService
             * @param $stateParams
             * @param $scope
             * @param $state
             * @param lng
             */
            constructor(stammdatenService, $qui, clientService, $stateParams, $scope, $state, lng, permissionService, userService, $timeout, udfService) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$stateParams = $stateParams;
                this.$scope = $scope;
                this.$state = $state;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.$timeout = $timeout;
                this.allowTableExport = false;
                this.ui = new Stammdaten.DetailUI();
                this.lawOwnerPersons = [];
                this.shouldLoadTableData = true;
                this.objectType = 140027;
                this.documentObjectType = 140116;
                this.enableDocuments = false;
                this.udfs = [];
                $scope.Model = $scope.Model || { Name: "xxx" };
                this.id = $stateParams.id;
                this.permissionLoad = true;
                permissionService.getPermissionsByObjectTypes([this.objectType, this.documentObjectType]).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.moduleAccess = data[0].moduleAccess && data[0].view;
                    this.allowTableExport = data[0].print;
                    this.enableDocuments = data[0].moduleAccess;
                    $timeout(() => {
                        if (!this.new)
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                        else
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'unset');
                    });
                    this.getData();
                    this.permissionLoad = false;
                    // get possible lawOwners, by generic method (only legal Carer)
                    this.clientService.getPersonsByKeyAssignment('RECHTLICHES_RECHTEINHABER', false).then((data) => {
                        this.lawOwnerPersons = data;
                        this.getWvList();
                    });
                });
                this.lang = lng;
                this.promptOptions = {
                    title: "Rechtliches löschen",
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lang.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $(".qm-card").unbind("click");
                });
                this.initForm();
                const vm = this;
                $(`#edit-form`).on('hidden.bs.modal', () => {
                    this.$state.go('.', { dataId: undefined }, { reload: false });
                    $timeout(() => vm.initForm());
                    $(`#edit-form`).find('.tab-content').children().removeClass('in').removeClass('active');
                    $(`#edit-form`).find('.tab-content').find('#baseDataTab').addClass('in active');
                });
                udfService.getUserDefinedFields(this.objectType).then((data) => {
                    this.udfs = data.sort((a, b) => a.caption.localeCompare(b.caption));
                });
            }
            getData() {
                this.getLegalList();
            }
            /**
             * init form
             *
             * @private
             *
             * @memberOf DetailLegalController
             */
            initForm() {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    parentObjectId: this.id,
                    dateFrom: new Date(),
                    dateTo: null,
                    lawTypeId: null,
                    lawTypeName: '',
                    firstLawOwnerId: null,
                    firstLawOwnerName: '',
                    secondLawOwnerId: null,
                    secondLawOwnerName: '',
                    lawBookId: null,
                    lawBookName: '',
                    lawBookShortName: '',
                    legalScaleId: null,
                    legalScaleName: '',
                    legalBasisId: null,
                    legalBasisName: '',
                    comment: '',
                    hasNoLawAdditions: false,
                    hasNoParagraphs: false,
                    personTypeFirst: null,
                    personTypeSecond: null,
                };
            }
            /**
             * get the wv list
             *
             * @private
             *
             * @memberOf DetailAddressController
             */
            getWvList() {
                this.loading = true;
                this.stammdatenService.getLegalWvList().then((wvData) => {
                    this.wvList = wvData;
                    this.loading = false;
                    this.$qui.functionWaiter("ui.createForm", this);
                });
            }
            /**
             * get all legal data of a client
             *
             * @private
             *
             * @memberOf DetailLegalController
             */
            getLegalList() {
                this.loading = true;
                this.stammdatenService.getLegalList(this.$stateParams.client).then((data) => {
                    this.ui.legalTable.data = data;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.loading = false;
                    if (this.$stateParams.dataId) {
                        const item = data.filter(x => x.objectId === this.$stateParams.dataId)[0];
                        if (item) {
                            $(`#edit-form`).modal('show');
                            this.editLegal(item);
                        }
                    }
                });
            }
            /**
             * add a new legal
             *
             * @private
             * @param {ILegalCreate} form
             *
             * @memberOf DetailAddressController
             */
            addLegal(form) {
                if (this.form.lawBookId === null) {
                    this.form.legalBasisId = null;
                }
                this.loading = true;
                form.parentObjectId = this.id;
                this.stammdatenService.postLegal(form).then((e) => {
                    this.ui.notify(this.ui.successNote);
                    this.getLegalList();
                    this.formState = "new";
                    $('#edit-form').modal('hide');
                });
            }
            /**
             * Edit an existing legal
             *
             * @private
             * @param {ILegalUpdate} data
             *
             * @memberOf DetailLegalController
             */
            editLegal(data) {
                this.formState = "edit";
                this.$qui.waitForEl('#standardTabButton', () => {
                    $('#standardTabButton').click();
                });
                this.$state.go('.', { dataId: data.objectId });
                setTimeout(() => {
                    this.stammdatenService.getLegal(this.id, data.id).then((data) => {
                        this.form = data;
                        this.$qui.scopeApply(this.$scope);
                    });
                });
            }
            /**
             * Updates an existing legal by id
             *
             * @private
             *
             * @memberOf DetailLegalController
             */
            putLegal() {
                if (this.form.lawBookId === null) {
                    this.form.legalBasisId = null;
                }
                this.loading = true;
                this.stammdatenService.putLegal(this.form.parentObjectId, this.form.objectId, this.form).then((data) => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    this.getLegalList();
                    $('#edit-form').modal('hide');
                });
                this.udfs.forEach(x => { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            }
            /**
             * Delete an existing legal by id
             *
             * @private
             * @param {any} data
             *
             * @memberOf DetailLegalController
             */
            deleteLegal(item) {
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data) {
                        this.stammdatenService.deleteLegal(this.id, item.objectId).then((e) => {
                            this.ui.notify(this.ui.deleteNote);
                            this.formState = "new";
                            this.getLegalList();
                        });
                    }
                });
            }
            /**
             * get the law type list
             *
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailLegalController
             */
            getLawTypeList() {
                return this.wvList.lawWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name
                    };
                });
            }
            /**
             * get the law addition list
             *
             * @private
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailLegalController
             */
            getLawAdditionList() {
                let data = [];
                if (this.form.hasNoLawAdditions) {
                    this.form.legalScaleId = null;
                }
                if (this.form.lawTypeId == null)
                    return [];
                let lawTypeName = this.getLawTypeName(this.form.lawTypeId);
                data = this.wvList.lawAdditionWvList[lawTypeName];
                this.form.hasNoLawAdditions = (data.length <= 0);
                return data.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name
                    };
                });
            }
            getLawTypeName(lawTypeId) {
                const lawType = this.wvList.lawWvList.filter(lawType => lawType.objectId === lawTypeId);
                let lawTypeName = lawType[0].name;
                return lawTypeName.substring(0, 1).toLowerCase() + lawTypeName.substring(1);
            }
            getLawOwnerList() {
                let list = this.lawOwnerPersons.map(x => ({ value: x.objectId, text: this.$qui.createPersonDisplay(x.name, x.forename, x.shortCaption, x.personNumber), subText: x.institute, group: x.objectTypeCaption }));
                list.unshift({ text: '', value: '', group: '', subText: '' });
                return list;
            }
            getLawBooks() {
                return this.wvList.lawBookCategoryWvList.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name
                    };
                });
            }
            /**
             * get the paragraph (law Basis) list
             *
             * @private
             * @returns {ng.IPromise<any>}
             *
             * @memberOf DetailLegalController
             */
            getParagraphList() {
                if (this.form.lawBookId === null || this.form.lawBookId === QMC.Common.Constants.GUID_EMPTY) {
                    this.form.hasNoParagraphs = true;
                    return [];
                }
                const lawBookName = this.getLawBookName(this.form.lawBookId);
                const data = this.wvList.legalBasisWvList[lawBookName];
                if (!data) {
                    return [];
                }
                this.form.hasNoParagraphs = (data.length <= 0);
                if (this.form.hasNoParagraphs || this.form.lawBookId === null || this.form.lawBookId === QMC.Common.Constants.GUID_EMPTY) {
                    return [];
                }
                const lawBookId = data.find(lawBookId => lawBookId.objectId === this.form.legalBasisId);
                this.form.legalBasisId = lawBookId != null ? lawBookId.objectId : data[0].objectId;
                return data.map(function (obj) {
                    return {
                        value: obj.objectId,
                        text: obj.name
                    };
                });
            }
            getLawBookName(lawBookId) {
                if (!lawBookId || lawBookId === QMC.Common.Constants.GUID_EMPTY)
                    return "";
                const lawBook = this.wvList.lawBookCategoryWvList.filter(lawBook => lawBook.objectId === lawBookId);
                const lawBookName = lawBook[0].name;
                return lawBookName.substring(0, 1).toLowerCase() + lawBookName.substring(1);
            }
        };
        DetailLegalController = __decorate([
            QMC.Controller("QMC.Stammdaten", "DetailLegalController"),
            QMC.Inject("StammdatenService", "$qui", "KlientService", "$stateParams", "$scope", "$state", "QmcLanguageService", "QmcPermissionService", 'UserService', '$timeout', 'QmcUdfService')
        ], DetailLegalController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailExtendedMainDataController = class DetailExtendedMainDataController {
            /**
             * Creates an instance of DetailExtendedMainDataController.
             * @param {StammdatenService} stammdatenService
             * @param {any} $qui
             * @param {Klient.KlientService} clientService
             * @param {any} $state
             * @param {any} $stateParams
             * @param {any} $scope
             * @param {Common.QmcPermissionService} permissionService
             *
             * @memberOf ExtendedMainDataController
             */
            constructor(stammdatenService, $qui, clientService, $state, $stateParams, $scope, permissionService, $timeout, employeeService, $location) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.clientService = clientService;
                this.$state = $state;
                this.permissionService = permissionService;
                this.$timeout = $timeout;
                this.employeeService = employeeService;
                this.$location = $location;
                // Permissions
                this.ui = new QMC.Stammdaten.DetailUI();
                this.validation = {
                    errors: [],
                    warnings: []
                };
                this.loading = true;
                this.id = $stateParams.id;
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.parentObjectType = 120000;
                        this.objectType = 120033; //Mitarbeiter: Erweiterte Stammdaten
                        break;
                    default:
                        this.parentObjectType = 140000;
                        this.objectType = 140086; //Kliente: Erweiterte Stammdaten
                        break;
                }
                permissionService.getPermissionsForDataset(this.id, this.objectType).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.moduleAccess = data[0].moduleAccess;
                });
                this.$qui.waitForEl('#newModalButton', () => {
                    document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                });
                this.initForm();
                this.getWv().then(() => {
                    this.languageWvList = this.wv.languageWvList.map(x => ({ text: x.name, value: x.objectId }));
                    this.familyStatusWvList = this.wv.familyStatusWvList.map(x => ({ text: x.name, value: x.objectId }));
                    this.nationalityWvList = this.wv.nationalityWvList.map(x => ({ text: x.name, value: x.objectId }));
                    this.hairColorWvList = this.wv.hairColorWvList.map(x => ({ text: x.name, value: x.objectId }));
                    if (this.parentObjectType === 140000) {
                        this.languageLevelWvList = this.wv.languageLevelWvlist.map(x => ({ text: x.name, value: x.objectId }));
                        this.bloodCategoryWvList = this.wv.bloodCategoryWvList.map(x => ({ text: x.name, value: x.objectId }));
                        this.eyesColorWvList = this.wv.eyesColorWvList.map(x => ({ text: x.name, value: x.objectId }));
                        this.migrationBackgroundWvList = this.wv.migrationBackgroundWvList.map(x => ({ text: x.name, value: x.objectId }));
                        this.birthCountryWvList = this.wv.birthCountryWvList.map(x => ({ text: x.name, value: x.objectId }));
                    }
                    else {
                        this.bloodCategoryWvList = this.wv.bloodTypeWvList.map(x => ({ text: x.name, value: x.objectId }));
                        this.eyesColorWvList = this.wv.eyeColorWvList.map(x => ({ text: x.name, value: x.objectId }));
                        this.birthCountryWvList = this.wv.countryWvList.map(x => ({ text: x.name, value: x.objectId }));
                    }
                    this.getData(this.id);
                });
                this.saveEventChange = false;
            }
            /**
             * init form
             *
             * @private
             *
             * @memberOf StammdatenClientDetailController
             */
            initForm() {
                if (this.parentObjectType === 140000) {
                    this.form = {
                        id: null,
                        objectId: null,
                        languageId: null,
                        languageLevelId: null,
                        secondLanguageId: null,
                        secondLanguageLevelId: null,
                        thirdLanguageId: null,
                        thirdLanguageLevelId: null,
                        bloodCategoryId: null,
                        hairColorId: null,
                        eyesColorId: null,
                        familyStatusId: null,
                        migrationBackgroundId: null,
                        nationalityId: null,
                        secondNationalityId: null,
                        socialInsuranceNumber: '',
                        dateOfDeath: null,
                        birthcountryId: null
                    };
                }
                else {
                    this.form = {
                        id: null,
                        objectId: null,
                        name: '',
                        forename: '',
                        displayTitle: '',
                        abbreviation: '',
                        birthday: null,
                        gender: null,
                        institute: '',
                        title: '',
                        amountChildren: 0,
                        birthName: '',
                        birthplace: '',
                        bloodType: '',
                        bloodTypeId: null,
                        comment: '',
                        dateOfDeath: null,
                        employeeNr: '',
                        eyeColor: '',
                        eyeColorId: null,
                        familyStatus: '',
                        familyStatusId: null,
                        firstLanguage: '',
                        firstLanguageId: null,
                        firstNationality: '',
                        firstNationalityId: null,
                        genderId: null,
                        hairColor: '',
                        hairColorId: null,
                        instituteId: null,
                        isBaptized: false,
                        originCountry: '',
                        originCountryId: null,
                        permissions: { view: false, new: false, modify: false, delete: false },
                        personStatus: '',
                        personStatusId: null,
                        postalSalutation: '',
                        postalSalutationId: null,
                        religion: '',
                        religionId: null,
                        salutation: '',
                        salutationId: null,
                        secondLanguage: '',
                        secondLanguageId: null,
                        secondNationality: '',
                        secondNationalityId: null,
                        socialInsuranceNumber: '',
                        titleId: null,
                    };
                }
            }
            /**
             * get the client wv list
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
            */
            getWv() {
                if (this.parentObjectType === 140000) {
                    return this.clientService.getClientWv().then((data) => {
                        this.wv = data;
                    });
                }
                else {
                    return this.employeeService.getEmployeeWv().then((data) => {
                        this.wv = data;
                    });
                }
            }
            getData(id) {
                if (this.parentObjectType === 140000) {
                    return this.clientService.getClientExtendedMainData(id).then((data) => {
                        this.form = angular.copy(data);
                    }).finally(() => {
                        this.loading = false;
                    });
                }
                else {
                    return this.employeeService.getEmployee(id).then((data) => {
                        this.form = angular.copy(data);
                    }).finally(() => {
                        this.loading = false;
                    });
                }
            }
            /**
             * update the extended main data of a client
             *
             * @private
             * @param {Guid} id
             *
             * @memberOf StammdatenClientDetailController
            */
            updateData(data) {
                this.validation.errors.length = 0;
                this.validation.warnings.length = 0;
                const validationRequest = {
                    socialInsuranceNumber: this.form.socialInsuranceNumber,
                    id: this.id,
                    objectType: this.parentObjectType
                };
                this.stammdatenService.getPersonValidation(validationRequest).then((dataValidationResult) => {
                    this.validation.errors = dataValidationResult.errors;
                    this.validation.warnings = dataValidationResult.warnings;
                    if (this.validation.errors.length === 0 && this.validation.warnings.length === 0) {
                        this.saveData();
                    }
                    else {
                        $('#validationModal').modal('toggle');
                    }
                });
            }
            saveData() {
                this.saving = true;
                if (this.parentObjectType === 140000) {
                    this.clientService.putClientExtendedMainData(this.id, this.form).then((dataClient) => {
                        this.$qui.notify(this.$qui.successNote);
                    }).finally(() => {
                        this.saving = false;
                    });
                    ;
                }
                else {
                    this.employeeService.putEmployee(this.id, this.form).then((dataEmployee) => {
                        this.$qui.notify(this.$qui.successNote);
                    }).finally(() => {
                        this.saving = false;
                    });
                }
            }
        };
        DetailExtendedMainDataController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailExtendedMainDataController'),
            QMC.Inject('StammdatenService', '$qui', 'KlientService', '$state', '$stateParams', '$scope', 'QmcPermissionService', '$timeout', 'EmployeeService', '$location')
        ], DetailExtendedMainDataController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailMedicalEvidenceController = class DetailMedicalEvidenceController {
            constructor(stammdatenService, $qui, $stateParams, lng, permissionService, userService, $location, $timeout, $scope, udfService) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.lng = lng;
                this.userService = userService;
                this.$location = $location;
                this.allowTableExport = false;
                this.ui = new Stammdaten.DetailUI();
                this.shouldLoadTableData = true;
                this.udfs = [];
                this.id = $stateParams.id;
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.parentObjectType = 120000;
                        this.objectType = 120044;
                        break;
                    default:
                        this.parentObjectType = 140000;
                        this.objectType = 140044;
                        break;
                }
                permissionService.getPermissionsByObjectType(this.objectType).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.moduleAccess = data[0].moduleAccess && data[0].view;
                    this.allowTableExport = data[0].print;
                    this.$qui.waitForEl('#newModalButton', () => {
                        if (!this.new)
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                        else
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'unset');
                    });
                    this.getWv();
                    this.getData();
                });
                $qui.init(undefined, () => {
                    $qui.bindEvents();
                    $(".qm-card").unbind("click");
                });
                this.promptOptions = {
                    title: this.lng.translate(20031000, "Med. Nachweis"),
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
                $(`#edit-form`).on('hidden.bs.modal', () => {
                    $timeout(() => $scope.vm.initForm());
                    $(`#edit-form`).find('.tab-content').children().removeClass('in').removeClass('active');
                    $(`#edit-form`).find('.tab-content').find('#baseDataTab').addClass('in active');
                });
                udfService.getUserDefinedFields(this.objectType).then((data) => {
                    this.udfs = data.sort((a, b) => a.caption.localeCompare(b.caption));
                });
            }
            getData() {
                this.getList();
            }
            /////////////// DISPLAY LOGIC ///////////////
            initForm() {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    date: new Date(),
                    validToDate: null,
                    additionalText: '',
                    executor: '',
                    executorId: null,
                    evidenceType: '',
                    evidenceTypeId: null,
                    evidenceKind: '',
                    evidenceKindId: null,
                    initiative: '',
                    initiativeId: null,
                    result: '',
                    resultId: null,
                    comment: '',
                    parentObjectId: this.id
                };
            }
            getEvidenceKind() {
                return this.wv.evidenceKindWvList.map(x => ({ text: x.name, value: x.objectId }));
            }
            getEvidenceType() {
                return this.wv.evidenceTypeWvList.map(x => ({ text: x.name, value: x.objectId }));
            }
            getInitiative() {
                const list = this.wv.initiativeWvList.map(x => ({ text: x.name, value: x.objectId }));
                list.unshift({ text: '', value: '' });
                return list;
            }
            getExecutioner() {
                const list = this.executioners.map(x => ({ text: x.displayTitle, value: x.objectId, group: x.objectTypeCaption }));
                list.unshift({ text: '', value: '', group: '' });
                return list;
            }
            getResult() {
                return this.wv.resultWvList.map(x => ({ text: x.name, value: x.objectId }));
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            getWv() {
                this.stammdatenService.getMedicalEvidenceWvList().then((data) => {
                    this.wv = data;
                    this.stammdatenService.getMedicalEvidenceExecutioners().then((data) => {
                        this.executioners = data;
                        this.initForm();
                        this.$qui.functionWaiter("ui.createForm", this);
                    });
                });
            }
            getList() {
                this.loading = true;
                this.stammdatenService.getMedicalEvidenceList(this.id).then((data) => {
                    this.ui.medicalEvidenceTable.data = data;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.loading = false;
                });
            }
            addMedicalEvidence(form) {
                this.stammdatenService.postMedicalEvidence(form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    this.getList();
                    $('#edit-form').modal('hide');
                });
            }
            editMedicalEvidence(data) {
                this.formState = "edit";
                this.form = data;
                if (data.date)
                    this.form.date = this.$qui.createDateFromString(this.form.date);
                if (data.validToDate)
                    this.form.validToDate = this.$qui.createDateFromString(this.form.validToDate);
                this.$qui.waitForEl('#standardTabButton', () => {
                    $('#standardTabButton').click();
                });
            }
            putMedicalEvidence(form) {
                this.stammdatenService.putMedicalEvidence(this.id, form.objectId, form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    this.getList();
                    $('#edit-form').modal('hide');
                });
                this.udfs.forEach(x => { var _a; return (_a = x.save) === null || _a === void 0 ? void 0 : _a.call(x, false); });
            }
            deleteMedicalEvidence(item) {
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.stammdatenService.deleteMedicalEvidence(this.id, item.objectId).then(() => {
                            this.ui.notify(this.ui.deleteNote);
                            this.formState = "new";
                            this.getList();
                        });
                });
            }
        };
        DetailMedicalEvidenceController = __decorate([
            QMC.Controller("QMC.Stammdaten", "DetailMedicalEvidenceController"),
            QMC.Inject("StammdatenService", "$qui", "$stateParams", "QmcLanguageService", "QmcPermissionService", 'UserService', '$location', '$timeout', '$scope', 'QmcUdfService')
        ], DetailMedicalEvidenceController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailMedicalResponsibleController = class DetailMedicalResponsibleController {
            /**
             * QMC.Stammdaten.DetailMedicalResponsibleController
             * @constructor
             * @param stammdatenService
             * @param $qui
             * @param clientService
             * @param $stateParams
             * @param $scope
             * @param $state
             * @param lng
             */
            constructor(stammdatenService, $qui, $stateParams, lng, permissionService, userService) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.allowTableExport = false;
                this.ui = new Stammdaten.DetailUI();
                this.shouldLoadTableData = true;
                this.institutes = [];
                this.id = this.$stateParams.id;
                this.medicationIssuedThroughData = null;
                this.medicalResponsibleData = null;
                this.permissionService.getPermissionsByObjectTypes([120028, 120034]).then((data) => {
                    this.deleteMedicalResponsiblePerm = data[0].delete;
                    this.newMedicalResponsiblePerm = data[0].new;
                    this.modifyMedicalResponsiblePerm = data[0].modify;
                    this.moduleMedicalResponsiblePerm = data[0].moduleAccess && data[0].view;
                    this.deleteMedicationIssuedThrough = data[1].delete;
                    this.newMedicationIssuedThrough = data[1].new;
                    this.modifyMedicationIssuedThrough = data[1].modify;
                    this.moduleAccessMedicationIssuedThrough = data[1].moduleAccess && data[0].view;
                    this.allowTableExport = data[0].print;
                    this.$qui.waitForEl('#newModalButton', () => {
                        document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                    });
                    this.getWv();
                    this.getData();
                });
                $qui.init(undefined, () => {
                    $qui.bindEvents();
                    $(".qm-card").unbind("click");
                });
                this.promptOptions = {
                    title: this.lng.translate(20034005, "Med. Verantwortlich / Medikamentausgabe"),
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
            }
            getData() {
                this.getList();
            }
            /////////////// DISPLAY LOGIC ///////////////
            initForm() {
                this.formState = "new";
                this.form = {
                    id: null,
                    organisationId: null,
                    objectId: null,
                    assignmentType: this.assignmentType,
                    displayTitle: null,
                    organisation: null,
                    organisationIds: [],
                    parentObjectId: null,
                    parentObjectType: 130000,
                    childObjectId: this.id,
                    childObjectType: QMC.Common.Constants.OBJECTTYPE_EMPLOYEE
                };
            }
            getInstitute() {
                return this.institutes.map(x => ({ text: x.caption, value: x.objectId }));
                ;
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            getWv() {
                this.stammdatenService.getInstituteList().then((data) => {
                    this.institutes = data;
                    this.initForm();
                    this.$qui.functionWaiter("ui.createForm", this);
                });
            }
            getList() {
                this.getMedicalResponsibleList();
                this.getMedicationIssuedThroughList();
            }
            getMedicalResponsibleList() {
                this.loading = true;
                this.stammdatenService.getMedicationResponsibleMedicatioThroughList(this.id, 160).then((data) => {
                    this.medicalResponsibleData = data;
                    this.ui.medicalResponsibleTable.data = data;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.loading = false;
                });
            }
            getMedicationIssuedThroughList() {
                this.loading = true;
                this.stammdatenService.getMedicationResponsibleMedicatioThroughList(this.id, 150).then((data) => {
                    this.medicationIssuedThroughData = data;
                    this.ui.medicationIssuedThroughTable.data = data;
                    this.createMedicationIssuedThroughTable();
                    this.loading = false;
                });
            }
            addOrRemoveOrganisationFrom(form) {
                //first remove from the dataset the removed items
                if (this.form.organisationIds.length > 0) {
                    for (let i = 0; i < (form.assignmentType === 160 ? this.medicalResponsibleData.length : this.medicationIssuedThroughData.length); i++) {
                        const itemToCheck = form.assignmentType === 160 ? this.medicalResponsibleData[i] : this.medicationIssuedThroughData[i];
                        const itemFound = this.form.organisationIds.filter(item => item === itemToCheck.parentObjectId);
                        if (itemFound.length === 0) {
                            this.stammdatenService.deleteMedResponsibleIssuedThroughItem(this.id, itemToCheck.assignmentType, itemToCheck.objectId);
                        }
                    }
                    this.stammdatenService.postMedResponsibleIssuedThroughItem(form).then(() => {
                        this.ui.notify(this.ui.successNote);
                        this.formState = "new";
                        setTimeout(() => { this.getList(); }, 250);
                    });
                }
            }
            editMedicalResponsible(data) {
                this.formState = "edit";
                this.form = data;
            }
            putMedicalResponsible(form) {
                this.stammdatenService.putMedResponsibleIssuedThroughItem(this.id, form.objectId, form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    this.getList();
                });
            }
            deleteMedicalResponsible(item) {
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.stammdatenService.deleteMedResponsibleIssuedThroughItem(this.id, item.assignmentType, item.objectId).then(() => {
                            this.ui.notify(this.ui.deleteNote);
                            this.formState = "new";
                            this.getList();
                        });
                });
            }
            newEntry(assignmentType) {
                this.assignmentType = assignmentType;
                this.initForm();
                for (let i = 0; i < (assignmentType === 160 ? this.medicalResponsibleData.length : this.medicationIssuedThroughData.length); i++) {
                    this.form.organisationIds.push(assignmentType === 160 ? this.medicalResponsibleData[i].parentObjectId : this.medicationIssuedThroughData[i].parentObjectId);
                }
                $('#edit-form').modal('show');
            }
        };
        DetailMedicalResponsibleController = __decorate([
            QMC.Controller("QMC.Stammdaten", "DetailMedicalResponsibleController"),
            QMC.Inject("StammdatenService", "$qui", "$stateParams", "QmcLanguageService", "QmcPermissionService", 'UserService')
        ], DetailMedicalResponsibleController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailTempInstituteChangeController = class DetailTempInstituteChangeController {
            /**
             * QMC.Stammdaten.DetailAdressController
             * @constructor
             * @param stammdatenService
             * @param $qui
             * @param clientService
             * @param $stateParams
             * @param $scope
             * @param $state
             * @param lng
             */
            constructor(stammdatenService, $qui, $stateParams, lng, permissionService, userService) {
                this.stammdatenService = stammdatenService;
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.lng = lng;
                this.permissionService = permissionService;
                this.userService = userService;
                this.allowTableExport = false;
                this.ui = new Stammdaten.DetailUI();
                this.shouldLoadTableData = true;
                this.institutes = [];
                this.id = this.$stateParams.id;
                this.permissionService.getPermissionsByObjectType(820003).then((data) => {
                    this.delete = data[0].delete;
                    this.new = data[0].new;
                    this.modify = data[0].modify;
                    this.moduleAccess = data[0].moduleAccess && data[0].view;
                    this.allowTableExport = data[0].print;
                    this.$qui.waitForEl('#newModalButton', () => {
                        if (!this.new)
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                        else
                            document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'unset');
                    });
                    this.getWv();
                    this.getData();
                });
                $qui.init(undefined, () => {
                    $qui.bindEvents();
                    $(".qm-card").unbind("click");
                });
                this.promptOptions = {
                    title: this.lng.translate(20032000, "Temp. Organisationszuordnung"),
                    yesNo: true,
                    icon: "qm-icon-history2",
                    text: this.lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                };
            }
            getData() {
                this.getList();
            }
            /////////////// DISPLAY LOGIC ///////////////
            initForm() {
                this.formState = "new";
                this.form = {
                    id: null,
                    objectId: null,
                    dateFrom: null,
                    dateTo: null,
                    institute: '',
                    instituteId: null,
                    reason: '',
                    reasonId: null,
                    comment: '',
                    parentObjectId: this.id
                };
            }
            getReason() {
                return this.wv.reasonWvList.map(x => ({ text: x.name, value: x.objectId }));
            }
            getInstitute() {
                return this.institutes.map(x => ({ text: x.caption, value: x.objectId }));
                ;
            }
            /////////////// SERVICE FUNCTIONS ///////////////
            getWv() {
                this.stammdatenService.getTempInstituteChangeWvList().then((data) => {
                    this.wv = data;
                    this.stammdatenService.getInstituteList().then((data) => {
                        this.institutes = data;
                        this.initForm();
                        this.$qui.functionWaiter("ui.createForm", this);
                    });
                });
            }
            getList() {
                this.loading = true;
                this.stammdatenService.getTempInstituteChangeList(this.id).then((data) => {
                    this.ui.tempInstituteChangeTable.data = data;
                    this.$qui.functionWaiter("ui.createTable", this);
                    this.loading = false;
                });
            }
            addTempInstituteChange(form) {
                this.stammdatenService.postTempInstituteChange(form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    this.getList();
                });
            }
            editTempInstituteChange(data) {
                this.formState = "edit";
                this.form = data;
                if (data.dateFrom)
                    this.form.dateFrom = this.$qui.createDateFromString(this.form.dateFrom);
                if (data.dateTo)
                    this.form.dateTo = this.$qui.createDateFromString(this.form.dateTo);
            }
            putTempInstituteChange(form) {
                this.stammdatenService.putTempInstituteChange(this.id, form.objectId, form).then(() => {
                    this.ui.notify(this.ui.successNote);
                    this.formState = "new";
                    this.getList();
                });
            }
            deleteTempInstituteChange(item) {
                QMC.Common.Utilities.confirm(this.promptOptions, (data) => {
                    if (data)
                        this.stammdatenService.deleteTempInstituteChange(this.id, item.objectId).then(() => {
                            this.ui.notify(this.ui.deleteNote);
                            this.formState = "new";
                            this.getList();
                        });
                });
            }
        };
        DetailTempInstituteChangeController = __decorate([
            QMC.Controller("QMC.Stammdaten", "DetailTempInstituteChangeController"),
            QMC.Inject("StammdatenService", "$qui", "$stateParams", "QmcLanguageService", "QmcPermissionService", 'UserService')
        ], DetailTempInstituteChangeController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        let DetailUdfController = class DetailUdfController {
            constructor($qui, $stateParams, $location) {
                this.$qui = $qui;
                this.$stateParams = $stateParams;
                this.$location = $location;
                this.show = true;
                this.objectType = 140000;
                switch (this.$location.$$path.split('/')[1]) {
                    case 'employee':
                        this.objectType = 120000;
                        break;
                    default:
                        this.objectType = 140000;
                        break;
                }
                this.id = this.$stateParams.id;
                this.type = this.$stateParams.type;
                this.definitionObjectType = this.$stateParams.definitionObjectType;
                this.definitionId = this.$stateParams.definitionId;
                $qui.init($qui.getSectionColor("/stammdaten"), () => {
                    $qui.bindEvents();
                    $('.qm-card').unbind('click');
                });
                this.$qui.waitForEl('#newModalButton', () => {
                    document.getElementsByName('newModalButton').forEach(x => x.style.visibility = 'hidden');
                });
            }
        };
        DetailUdfController = __decorate([
            QMC.Controller('QMC.Stammdaten', 'DetailUdfController'),
            QMC.Inject('$qui', '$stateParams', '$location')
        ], DetailUdfController);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        /**
         * Stammdaten Detail UserInterface class
         *
        * @export
        * @class UserInterface
        * @extends {Common.UserInterface}
        */
        class DetailUI extends QMC.Common.UserInterface {
            constructor(modalId) {
                super();
                this.modalId = 'edit-form';
                /**
                * Client detail info form
                * @memberOf UserInterface
                */
                this.infoForm = {
                    form: [{
                            label: "Name",
                            type: "String",
                            lngTag: 20000072,
                            model: "name",
                            required: true,
                            validate: {
                                message: "Bitte den Namen angeben",
                                messageTag: 21002015
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Vorname",
                            required: true,
                            type: "String",
                            lngTag: 20000057,
                            model: "forename",
                            validate: {
                                message: "Bitte den Vornamen angeben",
                                messageTag: 21003037
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Kürzel",
                            type: "String",
                            lngTag: 20000221,
                            model: "shortCaption",
                            validate: {
                                message: "Bitte ein Kürzel angeben",
                                messageTag: 21003008
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            label: "Nummer",
                            type: "String",
                            lngTag: 20000316,
                            model: "clientNumber",
                            validate: {
                                message: "Bitte eine Nummer angeben",
                                messageTag: 21003008
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            placeholder: "Geburtsname",
                            label: "Geburtsname",
                            type: "String",
                            lngTag: 21002021,
                            model: "birthname",
                            validate: {
                                message: "Bitte den Geburtsnamen angeben",
                                messageTag: 21002022
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            placeholder: "Geburtsort",
                            label: "Geburtsort",
                            type: "String",
                            lngTag: 21002019,
                            model: "birthplace",
                            validate: {
                                message: "Bitte den Geburtsort angeben",
                                messageTag: 21002020
                            },
                            style: {
                                icon: "fa fa-globe",
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            placeholder: "Geburtsdatum",
                            label: "Geburtsdatum",
                            required: true,
                            type: "Date",
                            lngTag: 21002004,
                            model: "birthday",
                            validate: {
                                message: "Bitte das Geburtsdatum angeben",
                                messageTag: 21002018
                            },
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            placeholder: "Anrede angeben ...",
                            label: "Anrede",
                            type: "Select",
                            lngTag: 20004005,
                            model: "salutationId",
                            dataSource: "getSalutationList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            placeholder: "Titel angeben ...",
                            label: "Titel",
                            type: "Select",
                            lngTag: 21002024,
                            model: "titleId",
                            dataSource: "getTitleList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            placeholder: "Titel, nach angeben ...",
                            label: "Titel, nach",
                            type: "Select",
                            lngTag: 21002054,
                            model: "secondTitleId",
                            dataSource: "getSecondTitleList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            placeholder: "Geschlecht angeben ...",
                            label: "Geschlecht",
                            type: "Select",
                            lngTag: 21002025,
                            model: "genderId",
                            dataSource: "getGenderList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                        }],
                    actions: {
                        put: "updateClient",
                        post: ""
                    }
                };
                /**
                * Client detail address table
                * @memberOf UserInterface
                */
                this.addressTable = {
                    "table": {
                        "Typ": {
                            "label": "addressTypeName",
                            "dType": "string",
                            "lngTag": "20000025",
                            "style": "style"
                        },
                        "Straße": {
                            "label": "street",
                            "dType": "string",
                            "lngTag": "20003001",
                            "style": "style"
                        },
                        "Hausnummer": {
                            "label": "houseNumber",
                            "dType": "string",
                            "lngTag": "20003002",
                            "style": "style"
                        },
                        "PLZ": {
                            "label": "postCode",
                            "dType": "string",
                            "lngTag": "20003005",
                            "style": "style"
                        },
                        "Ort": {
                            "label": "city",
                            "dType": "string",
                            "lngTag": "20003004",
                            "style": "style"
                        },
                        "Land": {
                            "label": "countryName",
                            "dType": "string",
                            "lngTag": "20003521",
                            "style": "style"
                        },
                        "Bundesland": {
                            "label": "stateName",
                            "dType": "string",
                            "lngTag": "20000284",
                            "style": "style"
                        },
                        "Datum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000047",
                            "style": "style"
                        },
                        "Datum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "lngTag": "20000054",
                            "style": "style"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAdress",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify",
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAdress",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-location_pin"
                        },
                        "text": {
                            "label": ["street", "houseNumber"],
                            "dType": "string",
                            "lngTag": ""
                        },
                        "subtext": [{
                                "label": "city",
                                "dType": "string"
                            }, {
                                "label": "stateName",
                                "dType": "string",
                            }, {
                                "label": "type",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAdress",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAdress",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
                * Client detail address form
                * @memberOf UserInterface
                */
                this.addressForm = {
                    form: [{
                            label: "Land",
                            type: "Select2",
                            placeholder: "Land",
                            lngTag: 20003521,
                            model: "objectIdCountry",
                            dataSource: "getCountryList",
                            events: {
                                updateDataSource: "objectIdState",
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            wvId: '4969d506-cd05-427f-9cda-afd003cfc8e0',
                            wvListData: 'wvList.countriesWvList'
                        }, {
                            placeholder: "Bundesland",
                            label: "Bundesland",
                            type: "Select2",
                            lngTag: 20000284,
                            model: "objectIdState",
                            dataSource: "getStatesList",
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Adressart wählen ...",
                            label: "Adressart",
                            type: "Select2",
                            lngTag: 20003516,
                            model: "objectIdAddressType",
                            dataSource: "getAdressTypeList",
                            required: true,
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                            events: {
                                hideExpression: "(qmForm.isHouseless)"
                            },
                            wvId: 'da631a1c-5ace-4f33-8f4a-1aed8a3ade5e',
                            wvListData: 'wvList.addressTypeWvList'
                        }, {
                            placeholder: "Adressart wählen ...",
                            label: "Adressart",
                            type: "Select2",
                            lngTag: 20003516,
                            model: "objectIdAddressType",
                            dataSource: "getAdressTypeList",
                            required: false,
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                            events: {
                                hideExpression: "!(qmForm.isHouseless)"
                            },
                            wvId: 'da631a1c-5ace-4f33-8f4a-1aed8a3ade5e',
                            wvListData: 'wvList.addressTypeWvList'
                        }, {
                            type: "hr",
                        }, {
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            lngTag: {
                                dateFrom: 20000047,
                                dateTo: 20000054
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true,
                                dateFromNotRequired: true
                            }
                        }, {
                            label: "Wohnungslos",
                            type: "CheckboxInline",
                            lngTag: 20003008,
                            model: "isHouseless",
                            id: "isHouseless",
                            style: {
                                class: "col-xs-6"
                            }
                        }, {
                            label: "Postfach",
                            type: "CheckboxInline",
                            lngTag: 20003009,
                            model: "isPostOfficeBox",
                            id: "isPostOfficeBox",
                            style: {
                                class: "col-xs-6"
                            }
                        }, {
                            placeholder: "Postfach",
                            placeholderTag: '20003009',
                            label: "Postfach",
                            type: "String",
                            lngTag: 20003009,
                            required: true,
                            model: "street",
                            validate: {
                                message: "Bitte das Postfach angeben",
                                messageTag: 20003524
                            },
                            events: {
                                hideExpression: "(!(qmForm.isPostOfficeBox)||(qmForm.isHouseless))"
                            },
                            style: {
                                icon: "fa fa-road",
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: "Postfach",
                            placeholderTag: '20003009',
                            label: "Postfach",
                            type: "String",
                            lngTag: 20003009,
                            model: "street",
                            validate: {
                                message: "Bitte das Postfach angeben",
                                messageTag: 20003524
                            },
                            events: {
                                hideExpression: "(!(qmForm.isPostOfficeBox)||!(qmForm.isHouseless))"
                            },
                            style: {
                                icon: "fa fa-road",
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: "Straße",
                            placeholderTag: '20003001',
                            label: "Straße",
                            type: "String",
                            lngTag: 20003001,
                            required: true,
                            model: "street",
                            validate: {
                                message: "Bitte den Straßennamen angeben",
                                messageTag: 20003510
                            },
                            events: {
                                hideExpression: "(qmForm.isHouseless || qmForm.isPostOfficeBox)"
                            },
                            style: {
                                icon: "fa fa-road",
                                class: "col-md-8 col-xs-12"
                            }
                        }, {
                            placeholder: "Straße",
                            placeholderTag: '20003001',
                            label: "Straße",
                            type: "String",
                            lngTag: 20003001,
                            model: "street",
                            validate: {
                                message: "Bitte den Straßennamen angeben",
                                messageTag: 20003510
                            },
                            events: {
                                hideExpression: "(!qmForm.isHouseless || qmForm.isPostOfficeBox)"
                            },
                            style: {
                                icon: "fa fa-road",
                                class: "col-md-8 col-xs-12"
                            }
                        }, {
                            placeholder: "Hausnummer",
                            label: "Hausnummer",
                            type: "String",
                            lngTag: 20003006,
                            placeholderTag: '20003006',
                            maxLength: 10,
                            model: "houseNumber",
                            required: true,
                            validate: {
                                message: "Bitte die Hausnummer angeben ( 10 Zeichen Maximal )"
                            },
                            events: {
                                hideExpression: "(qmForm.isHouseless || qmForm.isPostOfficeBox)"
                            },
                            style: {
                                class: "col-xs-12 col-md-4",
                                icon: "fa fa-home",
                            }
                        }, {
                            placeholder: "Hausnummer",
                            label: "Hausnummer",
                            type: "String",
                            lngTag: 20003006,
                            placeholderTag: '20003006',
                            maxLength: 10,
                            model: "houseNumber",
                            validate: {
                                message: "Bitte die Hausnummer angeben ( 10 Zeichen Maximal )"
                            },
                            events: {
                                hideExpression: "(!qmForm.isHouseless || qmForm.isPostOfficeBox)"
                            },
                            style: {
                                class: "col-xs-12 col-md-4",
                                icon: "fa fa-home",
                            }
                        }, {
                            placeholder: "PLZ",
                            label: "PLZ",
                            type: "Autocomplete",
                            lngTag: 20003005,
                            placeholderTag: '20003005',
                            required: true,
                            maxLength: 10,
                            id: "postCode",
                            model: "postCode",
                            events: {
                                hide: "isHouseless"
                            },
                            validate: {
                                message: "Bitte den PLZ angeben."
                            },
                            style: {
                                class: "col-xs-12 col-md-4",
                                icon: "fa fa-hashtag"
                            }
                        }, {
                            placeholder: "PLZ",
                            label: "PLZ",
                            type: "Autocomplete",
                            lngTag: 20003005,
                            placeholderTag: '20003005',
                            required: false,
                            maxLength: 10,
                            id: "postCode",
                            model: "postCode",
                            events: {
                                hideExpression: "!(qmForm.isHouseless)"
                            },
                            validate: {
                                message: "Bitte den PLZ angeben."
                            },
                            style: {
                                class: "col-xs-12 col-md-4",
                                icon: "fa fa-hashtag"
                            }
                        }, {
                            label: "Ort",
                            placeholder: "Ort eintragen...",
                            type: "Autocomplete",
                            lngTag: 20003004,
                            placeholderTag: '20003004',
                            model: "city",
                            required: true,
                            id: "city",
                            events: {
                                hide: "isHouseless"
                            },
                            validate: {
                                message: "Bitte den Ort angeben."
                            },
                            style: {
                                class: "col-md-8 col-xs-12",
                                icon: "fa fa-globe"
                            }
                        }, {
                            label: "Ort",
                            placeholder: "Ort eintragen...",
                            type: "Autocomplete",
                            lngTag: 20003004,
                            placeholderTag: '20003004',
                            model: "city",
                            required: false,
                            id: "city",
                            events: {
                                hideExpression: "!(qmForm.isHouseless)"
                            },
                            validate: {
                                message: "Bitte den Ort angeben."
                            },
                            style: {
                                class: "col-md-8 col-xs-12",
                                icon: "fa fa-globe"
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            lngTag: 20000049,
                            placeholderTag: '20000049',
                            model: "comment",
                            maxLength: 255,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12",
                            }
                        }, {
                            label: "Als Standard",
                            type: "CheckboxInline",
                            lngTag: 20000070,
                            model: "isMainRecord",
                            id: "isMainRecord",
                            style: {
                                class: "col-xs-6 col-sm-4"
                            }
                        }, {
                            label: "Keine Datenweitergabe",
                            type: "CheckboxInline",
                            lngTag: 20023021,
                            model: "isDatatransferForbidden",
                            id: "isDatatransferForbidden",
                            style: {
                                class: "col-xs-6 col-sm-4"
                            }
                        }, {
                            label: "Notfalldaten",
                            type: "CheckboxInline",
                            lngTag: 20003525,
                            model: "isEmergency",
                            id: "isEmergency",
                            style: {
                                class: "col-xs-6 col-sm-4"
                            }
                        }],
                    actions: {
                        put: "putAddress",
                        post: "addAddress"
                    }
                };
                /**
                * Client detail communication table
                * @memberOf UserInterface
                */
                this.checklistTable = {
                    "config": {
                        "defaultSort": "order",
                        "sortReverse": "false",
                    },
                    "table": {
                        "StatusIcon": {
                            "label": "isChecked",
                            "dType": "Bool",
                            "noHeader": true
                        },
                        "Status": {
                            "label": "state",
                            "dType": "string",
                            "lngTag": "20000164"
                        },
                        "Bezeichnung": {
                            "label": "caption",
                            "dType": "string",
                            "lngTag": "20000053"
                        },
                        "Erhalten am": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20011508",
                        },
                        "Gültig von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000277"
                        },
                        "Gültig bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "lngTag": "20000278"
                        },
                        "Wiedervorlage am": {
                            "label": "dateShowAgain",
                            "dType": "Date",
                            "lngTag": "20011509"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-checkbox green",
                                "click": "newCheck",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Abhaken",
                                "lngTag": "20011517",
                                "permission": "new",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`
                            }, {
                                "icon": "qm-icon-eye blue",
                                "click": "editCheck",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000141",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "events": {
                                    "hide": "!isChecked"
                                }
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteCheck",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "events": {
                                    "hide": "!isChecked"
                                }
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-check"
                        },
                        "text": {
                            "label": "caption",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "state",
                                "dType": "string",
                                "type": "type"
                            }, {
                                "label": "date",
                                "dType": "Date",
                                "type": "type"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-plus green",
                                "click": "newCheck",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Neu",
                                "lngTag": "20000298",
                                "permission": "new",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`
                            }, {
                                "icon": "qm-icon-eye blue",
                                "click": "editCheck",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000141",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "events": {
                                    "hide": "!isChecked"
                                }
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteCheck",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "events": {
                                    "hide": "!isChecked"
                                }
                            }]
                    },
                    "data": null,
                };
                this.checklistHistoryTable = {
                    "config": {
                        "defaultSort": "date",
                        "sortReverse": "true",
                    },
                    "table": {
                        "StatusIcon": {
                            "label": "isChecked",
                            "dType": "Bool",
                            "noHeader": true
                        },
                        "Status": {
                            "label": "state",
                            "dType": "string",
                            "lngTag": "20000164"
                        },
                        "Erhalten am": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20011508",
                        },
                        "Gültig von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000277"
                        },
                        "Gültig bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "lngTag": "20000278"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-eye blue",
                                "click": "editHistory",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000141",
                                "openModal": "true",
                                "targetModal": "#historyFormModal",
                                "permission": "historyModuleAccess"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteHistory",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "historyDelete"
                            }, {
                                "icon": "qm-icon-note_text darkslategray",
                                "click": "toggleCommentModal",
                                "label": "Comment",
                                "dType": "Button",
                                "events": {
                                    "hide": "!comment",
                                },
                                "tooltip": "Bemerkung",
                                "lngTag": "20000049",
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-check"
                        },
                        "text": {
                            "label": "state",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "date",
                                "dType": "Date",
                                "type": "type"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-eye blue",
                                "click": "editHistory",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000141",
                                "openModal": "true",
                                "targetModal": "#historyFormModal",
                                "permission": "historyModuleAccess"
                            }, {
                                "icon": "qm-icon-note_text darkslategray",
                                "click": "toggleCommentModal",
                                "label": "Comment",
                                "dType": "Button",
                                "events": {
                                    "hide": "!comment",
                                },
                                "tooltip": "Bemerkung",
                                "lngTag": "20000049",
                            }]
                    },
                    "data": null,
                };
                this.checklistForm = {
                    form: [
                        {
                            label: "Erhalten am",
                            type: "Date",
                            lngTag: 20011508,
                            model: "date",
                            required: true,
                            validate: {
                                message: "Bitte das Datum angeben",
                                messageTag: 0,
                            },
                            style: {
                                icon: "fa fa-calendar",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            label: "Wiedervorlage am",
                            type: "Date",
                            lngTag: 20011509,
                            model: "dateShowAgain",
                            style: {
                                icon: "fa fa-calendar-o",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            lngTag: {
                                dateFrom: 20000277,
                                dateTo: 20000278
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true,
                                dateFromNotRequired: true
                            }
                        }, {
                            // commented since this is only applicable if workflow license is granted which is actually newver the case
                            //    label: "Erinnerung",
                            //    type: "Checkbox",
                            //    lngTag: 20011507,
                            //    model: "reminderActive",
                            //    style: {
                            //        class: "col-xs-12 col-md-4"
                            //    }
                            //},
                            //{
                            //    lngTag: "20011506",
                            //    label: "Tage vorher",
                            //    type: "Number",
                            //    model: "reminder",
                            //    style: {
                            //        class: "col-md-6 col-xs-12",
                            //        icon: "qm-icon-calendar_5"
                            //    },
                            //    events: {
                            //        hideExpression: "!qmForm.reminderActive"
                            //    }
                            //}, {
                            label: "Bemerkung",
                            type: "Summernote",
                            lngTag: "20000049",
                            model: "comment",
                            style: {
                                class: "col-xs-12",
                            }
                        }
                    ],
                    actions: {
                        post: "addChecklist",
                        put: "putChecklist"
                    }
                };
                /**
                * Client detail communication table
                * @memberOf UserInterface
                */
                this.communicationTable = {
                    "table": {
                        "Typ": {
                            "label": "communicationTypeName",
                            "dType": "string",
                            "lngTag": "20005504",
                            "style": "style"
                        },
                        "Kommunikationsart": {
                            "label": "communicationCategoryName",
                            "dType": "string",
                            "lngTag": "20005511",
                            "style": "style"
                        },
                        "Adresse": {
                            "label": "displayAddress",
                            "dType": "string",
                            "lngTag": "20001045",
                            "style": "style",
                            "type": "type"
                        },
                        "Datum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000047"
                        },
                        "Datum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "lngTag": "20000054"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editCommunication",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteCommunication",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-book_telephone"
                        },
                        "text": {
                            "label": "communicationCategoryName",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "displayAddress",
                                "dType": "string",
                                "type": "type"
                            }, {
                                "label": "communicationTypeName",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editCommunication",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteCommunication",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
                 * Client detail communication form
                 * @memberOf UserInterface
                 */
                this.communicationForm = {
                    form: [
                        {
                            label: "Datum von",
                            type: "Date",
                            lngTag: 20000047,
                            model: "dateFrom",
                            style: {
                                icon: "fa qm-icon-calendar_7",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Datum bis",
                            type: "Date",
                            lngTag: 20000054,
                            model: "dateTo",
                            style: {
                                icon: "fa qm-icon-calendar_7",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: "Kommunikationstyp",
                            placeholderTag: "20005504",
                            label: "Kommunikationstyp",
                            type: "Select",
                            lngTag: 20005504,
                            id: "typeId",
                            model: "communicationTypeId",
                            required: true,
                            dataSource: "getCommunicationTypeList",
                            //events: {
                            //    updateDataSource: "communicationCategoryId"
                            //},
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            placeholder: "Kommunikationsart wählen...",
                            placeholderTag: "20005511",
                            label: "Kommunikationsart",
                            type: "Select2",
                            lngTag: 20005511,
                            model: "communicationCategoryId",
                            dataSource: "getCommunicationCategoryList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                            validate: {
                                message: "Bitte eine Art auswählen!"
                            },
                            wvId: '05dd15e1-4db2-4b55-b92c-e150ed00e300',
                            wvSubParent: 'communicationTypeId'
                        }, {
                            placeholder: "E-Mail-Adresse",
                            placeholderTag: "20000069",
                            label: "E-Mail-Adresse",
                            type: "String",
                            lngTag: 20000069,
                            required: true,
                            model: "targetAddress",
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "fa fa-at"
                            },
                            events: {
                                hideExpression: "!(qmForm.communicationTypeId == '53fd55a0-9efe-41aa-9099-5c3b7b4e972f')"
                            },
                            validate: {
                                message: "Bitte eine E-Mail Adresse angeben.",
                            },
                        }, {
                            placeholder: "Landesvorwahl",
                            placeholderTag: "20005505",
                            label: "Landesvorwahl",
                            type: "String",
                            lngTag: 20005505,
                            model: "countryCode",
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "fa fa-fax"
                            },
                            events: {
                                hideExpression: "!(qmForm.communicationTypeId == '930511d9-aa40-4927-b8b0-bbfc2e040de6' || qmForm.communicationTypeId == '6729f858-ca6d-4efe-8397-376133a2d974')"
                            },
                            validate: {
                                message: "Bitte die Landesvorwahl angeben.",
                            },
                        }, {
                            placeholder: "Ortsvorwahl",
                            placeholderTag: "20005506",
                            label: "Ortsvorwahl",
                            type: "String",
                            lngTag: 20005506,
                            model: "areaCode",
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "fa fa-fax"
                            },
                            events: {
                                hideExpression: "!(qmForm.communicationTypeId == '930511d9-aa40-4927-b8b0-bbfc2e040de6' || qmForm.communicationTypeId == '6729f858-ca6d-4efe-8397-376133a2d974')"
                            },
                            validate: {
                                message: "Bitte die Ortsvorwahl angeben.",
                            },
                        }, {
                            placeholder: "Rufnummer",
                            placeholderTag: "20005507",
                            label: "Rufnummer",
                            type: "String",
                            lngTag: 20005507,
                            required: true,
                            model: "targetAddress",
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "fa fa-fax"
                            },
                            events: {
                                hideExpression: "!(qmForm.communicationTypeId == '930511d9-aa40-4927-b8b0-bbfc2e040de6' || qmForm.communicationTypeId == '6729f858-ca6d-4efe-8397-376133a2d974')"
                            },
                            validate: {
                                message: "Bitte die Rufnummer angeben.",
                            },
                        }, {
                            placeholder: "Messenger",
                            placeholderTag: "20005512",
                            label: "Messenger",
                            type: "String",
                            lngTag: 20005512,
                            required: true,
                            model: "targetAddress",
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "fa fa-comments-o"
                            },
                            events: {
                                hideExpression: "!(qmForm.communicationTypeId == '968deb9e-9e7a-417b-b096-a20dac7e61b8')"
                            },
                            validate: {
                                message: "Bitte die Messenger ID angeben.",
                            },
                        }, {
                            placeholder: "Website",
                            placeholderTag: "20000014",
                            label: "Website",
                            type: "String",
                            lngTag: 20000014,
                            model: "targetAddress",
                            required: true,
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "fa fa-share-square-o"
                            },
                            events: {
                                hideExpression: "!(qmForm.communicationTypeId == 'f25005b8-3a66-4b36-9395-60ce7896f7d6')"
                            },
                            validate: {
                                message: "Bitte die Website angeben.",
                            },
                        }, {
                            placeholder: "Sonstige",
                            placeholderTag: "20000238",
                            label: "Sonstige",
                            type: "String",
                            lngTag: 20000238,
                            required: true,
                            model: "targetAddress",
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "qm-icon-note_text"
                            },
                            events: {
                                hideExpression: "!(qmForm.communicationTypeId == '9088ac4c-8ff8-4d6b-939a-19e9ad252cc9')"
                            },
                            validate: {
                                message: "Bitte angeben.",
                            },
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            placeholderTag: "20000049",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: 255,
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                class: "col-xs-12 col-md-12",
                                icon: "qm-icon-note_text"
                            }
                        }, {
                            label: "Standard",
                            type: "Checkbox",
                            lngTag: 20000070,
                            model: "isMainRecord",
                            id: "com_isMainRecord",
                            style: {
                                class: "col-xs-12 col-md-4"
                            }
                        }, {
                            label: "Standard pro Typ",
                            type: "Checkbox",
                            lngTag: 20005521,
                            model: "isTypeMain",
                            id: "com_isTypeMain",
                            style: {
                                class: "col-xs-12 col-md-4"
                            }
                        }, {
                            label: "Keine Datenweitergabe",
                            type: "Checkbox",
                            lngTag: 20023021,
                            model: "isDatatransferForbidden",
                            id: "isDatatransferForbidden",
                            style: {
                                class: "col-xs-12 col-md-4"
                            }
                        }
                    ],
                    actions: {
                        post: "addCommunication",
                        put: "putCommunication"
                    }
                };
                /**
                 * Client detail contact person table
                 * @memberOf UserInterface
                 */
                this.contactPersonTable = {
                    "config": {
                        "defaultSort": "category"
                    },
                    "table": {
                        "Kategorie": {
                            "label": "category",
                            "dType": "string",
                            "lngTag": "20000137",
                            "style": "style"
                        },
                        "Vorname": {
                            "label": "forename",
                            "dType": "string",
                            "lngTag": "20000057",
                            "style": "style"
                        },
                        "Nachname": {
                            "label": "name",
                            "dType": "string",
                            "lngTag": "20000058",
                            "style": "style"
                        },
                        "Kontaktpersonart": {
                            "label": "contactPersonType",
                            "dType": "string",
                            "lngTag": "20004003",
                            "style": "style"
                        },
                        "Kommunikation": {
                            "label": "mainCommunication",
                            "dType": "string",
                            "lngTag": "20001047",
                            "style": "style",
                            "type": "type"
                        },
                        "Bemerkung": {
                            "lngTag": "20000049",
                            "label": "comment",
                            "dType": "string",
                            "style": "style"
                        },
                        "Aktionen": [{
                                "icon": "qm-button blue qm-icon-eye green",
                                "click": "showDetailContact",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000141",
                                "permission": "modify",
                                "events": {
                                //"hide": "showActions"
                                }
                            }, {
                                "icon": "qm-icon-pencil blue",
                                "click": "editContact",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteContact",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }, {
                                "icon": "qm-icon-location_pin grey",
                                "click": "newAddress",
                                "openModal": "true",
                                "targetModal": "#edit-adress",
                                "dType": "Button",
                                "tooltip": "Adresse hinzufügen",
                                "lngTag": "20000142",
                                "permission": "newAdr",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }, {
                                "icon": "qm-icon-book_telephone",
                                "click": "newCommunication",
                                "openModal": "true",
                                "targetModal": "#edit-communication",
                                "dType": "Button",
                                "tooltip": "Kommunikation hinzufügen",
                                "lngTag": "20000143",
                                "permission": "newCom",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }, {
                                "icon": "qm-icon-cloud",
                                "click": "createConnectUser",
                                "dType": "Button",
                                "tooltip": "myneva.connect Benutzer anlegen",
                                "lngTag": "20003526",
                                "permission": "isConnectRegistrationAvailable",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-users"
                        },
                        "text": {
                            "label": ["name", "forename"],
                            "dType": "string",
                            "style": "style"
                        },
                        "subtext": [{
                                "label": "contactPersonType",
                                "dType": "string",
                                "style": "style"
                            }, {
                                "label": "mainCommunication",
                                "dType": "string",
                                "style": "style"
                            }, {
                                "label": "stateName",
                                "dType": "string",
                                "style": "style"
                            }, {
                                "label": "type",
                                "dType": "string",
                                "style": "style"
                            }],
                        "buttons": [{
                                "icon": "qm-button blue qm-icon-eye green",
                                "click": "showDetailContact",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Ansehen",
                                "lngTag": "20000141",
                                "permission": "modify",
                                "events": {
                                //"hide": "hideActions"
                                }
                            }, {
                                "icon": "qm-icon-pencil blue",
                                "click": "editContact",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteContact",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }, {
                                "icon": "qm-icon-location_pin grey",
                                "click": "newAddress",
                                "openModal": "true",
                                "targetModal": "#edit-adress",
                                "dType": "Button",
                                "tooltip": "Adresse hinzufügen",
                                "lngTag": "20000142",
                                "permission": "newAdr",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }, {
                                "icon": "qm-icon-book_telephone",
                                "click": "newCommunication",
                                "openModal": "true",
                                "targetModal": "#edit-communication",
                                "dType": "Button",
                                "tooltip": "Kommunikation hinzufügen",
                                "lngTag": "20000143",
                                "permission": "newCom",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }, {
                                "icon": "qm-icon-cloud",
                                "click": "createConnectUser",
                                "dType": "Button",
                                "tooltip": "myneva.connect Benutzer anlegen",
                                "lngTag": "20003526",
                                "permission": "isConnectRegistrationAvailable",
                                "events": {
                                    "hide": "!showActions"
                                }
                            }]
                    },
                    "data": null,
                };
                /**
        * Client detail contact person form
        * @memberOf UserInterface
        */
                this.contactPersonForm = {
                    form: [{
                            placeholder: "Kontaktpersonart auswählen",
                            placeholderTag: "20004003",
                            label: "Kontaktpersonart",
                            type: "Select2",
                            model: "contactPersonTypeId",
                            lngTag: 20004003,
                            required: true,
                            dataSource: "getContactPersonTypeList",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            validate: {
                                message: "Bitte die Art auswählen!"
                            },
                            wvId: '3829213d-7823-4c31-b478-ac818b62c3a4',
                            wvListData: 'wvList.contactPersonTypeWvList'
                        }, {
                            placeholder: "Anrede auswählen",
                            placeholderTag: "20004005",
                            label: "Anrede",
                            type: "Select2",
                            model: "salutationId",
                            lngTag: 20004005,
                            dataSource: "getSalutationList",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            validate: {
                                message: "Bitte die Anrede auswählen!"
                            },
                            wvId: 'a1aaf203-f1ee-4147-abb1-1e2426303f6c',
                            wvListData: 'wvList.salutationWvList'
                        }, {
                            placeholder: "Titel auswählen",
                            placeholderTag: "21002024",
                            label: "Titel",
                            type: "Select2",
                            model: "titleId",
                            lngTag: 21002024,
                            dataSource: "getTitleList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: '9fb4b9b9-33ad-4e7c-ac26-df3eacca2eba',
                            wvListData: 'wvList.titleWvList'
                        }, {
                            label: "Titel, nach",
                            type: "Select2",
                            model: "secondTitleId",
                            lngTag: 21002054,
                            dataSource: "getSecondTitleList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'd0b392c7-3f9f-48d0-9c1b-6d6bf19f7352',
                            wvListData: 'wvList.secondTitleWvList'
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Vorname",
                            placeholderTag: "20000057",
                            label: "Vorname",
                            type: "String",
                            lngTag: 20000057,
                            model: "forename",
                            validate: {
                                message: "Bitte den Vornamen angeben",
                                messageTag: 20003510,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: "Nachname",
                            placeholderTag: "20000058",
                            label: "Nachname",
                            type: "String",
                            lngTag: 20000058,
                            required: true,
                            model: "name",
                            validate: {
                                message: "Bitte den Nachnamen angeben",
                                messageTag: 20003510,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: "Geburtsdatum",
                            placeholderTag: "21002004",
                            label: "Geburtsdatum",
                            type: "Date",
                            lngTag: 21002004,
                            model: "birthday",
                            validate: {
                                message: "Bitte das Geburtsdatum angeben",
                                messageTag: 21003020,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            lngTag: {
                                dateFrom: "20000277",
                                dateTo: "20000278"
                            },
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            placeholderTag: "20000049",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12 col-md-12"
                            }
                        }, {
                            label: "Kontaktsperre",
                            type: "Checkbox",
                            model: "isContactBan",
                            lngTag: 20004512,
                            id: "isContactBan",
                            style: {
                                class: "medium"
                            }
                        }],
                    actions: {
                        post: "addContact",
                        put: "putContact"
                    }
                };
                /**
        * Client detail contact person address table
        * @memberOf UserInterface
        */
                this.contactPersonAddressTable = {
                    "table": {
                        "Straße": {
                            "label": "street",
                            "dType": "string",
                            "lngTag": "20003001",
                            "style": "style",
                        },
                        "Hausnummer": {
                            "label": "houseNumber",
                            "dType": "string",
                            "lngTag": "20003002",
                            "style": "style",
                        },
                        "PLZ": {
                            "label": "postCode",
                            "dType": "string",
                            "lngTag": "20003005",
                            "style": "style",
                        },
                        "Ort": {
                            "label": "city",
                            "dType": "string",
                            "lngTag": "20003005",
                            "style": "style",
                        },
                        "Land": {
                            "label": "countryName",
                            "dType": "string",
                            "lngTag": "20003521",
                            "style": "style",
                        },
                        "Bundesland": {
                            "label": "stateName",
                            "dType": "string",
                            "lngTag": "20000284",
                            "style": "style",
                        },
                        "Typ": {
                            "label": "addressTypeName",
                            "dType": "string",
                            "lngTag": "20000025",
                            "style": "style",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAdress",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": "#edit-adress",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAdress",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "permissionByDataSet": true
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-location_pin"
                        },
                        "text": {
                            "label": ["street", "houseNumber"],
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "city",
                                "dType": "string"
                            }, {
                                "label": "stateName",
                                "dType": "string",
                            }, {
                                "label": "type",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAdress",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "openModal": "true",
                                "targetModal": "#edit-adress",
                                "lngTag": "20000044",
                                "permission": "modify",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAdress",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "permissionByDataSet": true
                            }]
                    },
                    "data": null,
                };
                /**
        * Client detail contact person communication table
        * @memberOf UserInterface
        */
                this.contactpersonCommunicationTable = {
                    "table": {
                        "Kommunikationsart": {
                            "label": "communicationCategoryName",
                            "dType": "string",
                            "lngTag": "20005511",
                            "style": "style",
                        },
                        "Landesvorwahl": {
                            "label": "countryCode",
                            "dType": "string",
                            "lngTag": "20005505",
                            "style": "style",
                        },
                        "Ortsvorwahl": {
                            "label": "areaCode",
                            "dType": "string",
                            "lngTag": "20005506",
                            "style": "style",
                        },
                        "Adresse": {
                            "label": "targetAddress",
                            "dType": "string",
                            "lngTag": "20001045",
                            "style": "style",
                            "type": "type"
                        },
                        "Typ": {
                            "label": "communicationTypeName",
                            "dType": "string",
                            "lngTag": "20005504",
                            "style": "style",
                        },
                        "Standard": {
                            "label": "isMainRecord",
                            "dType": "Bool",
                            "lngTag": "20000070",
                            "style": "style",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editCommunication",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": "#edit-communication",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteCommunication",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete",
                                "permissionByDataSet": true
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-book_telephone"
                        },
                        "text": {
                            "label": "communicationCategoryName",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "targetAddress",
                                "dType": "string"
                            }, {
                                "label": "communicationTypeName",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editCommunication",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": "#edit-communication",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modifyCom",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteCommunication",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "deleteCom",
                                "permissionByDataSet": true
                            }]
                    },
                    "data": null,
                };
                /**
        * Client detail doctor visit table
        * @memberOf UserInterface
        */
                this.docVisitTable = {
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000045"
                        },
                        "Diagnose": {
                            "label": "diagnose",
                            "dType": "string",
                            "lngTag": "20010503"
                        },
                        "Arzt/Med. Organisation": {
                            "label": "treaterName",
                            "dType": "string",
                            "lngTag": "20010502"
                        },
                        //"Vorname": {
                        //    "label": "forename",
                        //    "dType": "string",
                        //    "lngTag": "20000057"
                        //},
                        "Fachrichtung": {
                            "label": "discipline",
                            "dType": "string",
                            "lngTag": "20023004"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editDocVisit",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteDocVisit",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-doctor"
                        },
                        "text": {
                            "label": "treaterName",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "discipline",
                                "dType": "string"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editDocVisit",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteDocVisit",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
        * Client detail doctor visit form
        * @memberOf UserInterface
        */
                this.docVisitForm = {
                    form: [{
                            placeholder: "Datum",
                            label: "Datum",
                            type: "Date",
                            model: "date",
                            lngTag: 20000045,
                            required: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Uhrzeit",
                            label: "Uhrzeit",
                            type: "Time",
                            lngTag: 20000046,
                            model: "time",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            placeholder: "Arzt/Med. Organisation",
                            label: "Arzt/Med. Organisation",
                            type: "Select2",
                            model: "treaterId",
                            lngTag: 20010502,
                            required: true,
                            dataSource: "getDoctors",
                            style: {
                                class: "col-md-12 col-xs-12",
                            },
                        }, {
                            label: "Diagnose",
                            placeholder: "Diagnose ...",
                            placeholderTag: "20010503",
                            type: "Summernote",
                            lngTag: "20010503",
                            model: "diagnose",
                            style: {
                                class: "col-xs-12",
                            }
                        }],
                    actions: {
                        put: "putDocVisit",
                        post: "addDocVisit"
                    }
                };
                /**
        * Client detail document table
        * @memberOf UserInterface
        */
                this.clientAttachedFilesTable = {
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045"
                        },
                        "Dateiname": {
                            "label": "fileName",
                            "dType": "string",
                            "lngTag": "21006017"
                        },
                        "Dateigröße": {
                            "label": "fileSize",
                            "dType": "string",
                            "lngTag": "21006018"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-download grey",
                                "click": "downloadFile",
                                "openModal": "false",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Herunterladen",
                                "lngTag": "21006014",
                                "permission": "allowDownload"
                            }, {
                                "icon": "qm-icon-document_attachment green",
                                "click": "previewDocument",
                                "openModal": "false",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Vorschau",
                                "lngTag": "20000091",
                                "permission": "allowPreview"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteFileFromFolder",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "deleteFile"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-document_attachment"
                        },
                        "text": {
                            "label": "fileName",
                            "dType": "string"
                        },
                        "subtext": [
                            {
                                "label": "date",
                                "dType": "Date"
                            }
                        ],
                        "buttons": [
                            {
                                "icon": "qm-icon-download grey",
                                "click": "downloadFile",
                                "openModal": "false",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Herunterladen",
                                "lngTag": "21006014",
                                "permission": "allowDownload"
                            }, {
                                "icon": "qm-icon-document_attachment green",
                                "click": "previewDocument",
                                "openModal": "false",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Vorschau",
                                "lngTag": "20000091",
                                "permission": "view"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteFileFromFolder",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }
                        ]
                    },
                    "data": null,
                };
                /**
        * Client detail vaccination table
        * @memberOf UserInterface
        */
                this.vaccinationTable = {
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045",
                        },
                        "Folgetermin": {
                            "label": "dateFollowupAppointment",
                            "dType": "Date",
                            "lngTag": "20009504",
                        },
                        "Arzt": {
                            "label": "doctorName",
                            "dType": "string",
                            "lngTag": "20010508",
                        },
                        "Impfung": {
                            "label": "diseaseName",
                            "dType": "string",
                            "lngTag": "20009514",
                        },
                        "Impfstoff": {
                            "label": "caption",
                            "dType": "string",
                            "lngTag": "20009506",
                        },
                        "Chargen-Nr": {
                            "label": "batchNumber",
                            "dType": "string",
                            "lngTag": "20009507",
                        },
                        "Bemerkung": {
                            "label": "commentPlain",
                            "dType": "string",
                            "lngTag": "20000049",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editVaccination",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteVaccination",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-injection"
                        },
                        "text": {
                            "label": "caption",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "diseaseName",
                                "dType": "string"
                            }, {
                                "label": "doctorName",
                                "dType": "string",
                            }, {
                                "label": "type",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editVaccination",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteVaccination",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
        * Client detail vaccination form
        * @memberOf UserInterface
        */
                this.vaccinationForm = {
                    form: [{
                            lngTag: {
                                dateFrom: "20000045",
                                dateTo: "20009504"
                            },
                            label: {
                                dateFrom: "Datum",
                                dateTo: "Folgetermin"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "date",
                                dateTo: "dateFollowupAppointment"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Arzt auswählen",
                            label: "Arzt",
                            type: "Select2",
                            model: "doctorId",
                            lngTag: 20010502,
                            dataSource: "getDoctorsAndMedicalOrg",
                            required: true,
                            validate: {
                                message: "Bitte den Arzt angeben.",
                                messageTag: 21003014
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Impfung auswählen",
                            placeholderTag: "20009515",
                            label: "Impfung",
                            type: "Select2",
                            model: "diseaseId",
                            dataSource: "getDiseases",
                            lngTag: 20009514,
                            required: true,
                            id: "disease",
                            validate: {
                                message: "Bitte eine Krankheit angeben",
                                messageTag: 21003006
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            wvId: '5485878a-6f2f-43fa-9d83-450732ff39b7',
                            wvListData: 'wvList.dieseasesWv'
                        }, {
                            placeholder: "Impfstoff Handelsname",
                            placeholderTag: "20009512",
                            label: "Impfstoff",
                            type: "String",
                            lngTag: 20009512,
                            model: "caption",
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-stethoscope"
                            },
                        }, {
                            placeholder: "Chargen-Nr",
                            placeholderTag: "20009507",
                            label: "Chargen-Nr",
                            type: "String",
                            model: "batchNumber",
                            lngTag: 20009507,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-hashtag"
                            },
                        }, {
                            placeholder: "Bemerkung eintragen",
                            placeholderTag: "20000049",
                            label: "Bemerkung",
                            type: "Summernote",
                            maxLength: -1,
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12",
                            }
                        },],
                    actions: {
                        put: "putVaccination",
                        post: "addVaccination"
                    }
                };
                /**
        * Client detail hobby table
        * @memberOf UserInterface
        */
                this.hobbyTable = {
                    "table": {
                        "Gültig von": {
                            "label": "validFrom",
                            "dType": "Date",
                            "lngTag": "20008013",
                        },
                        "Gültig bis": {
                            "label": "validTo",
                            "dType": "Date",
                            "lngTag": "20008014",
                        },
                        "Bezeichnung": {
                            "label": "caption",
                            "dType": "string",
                            "lngTag": "20008006",
                        },
                        "Verein": {
                            "label": "societyName",
                            "dType": "string",
                            "lngTag": "20008008",
                        },
                        "Ansprechpartner/in": {
                            "label": "contactPerson",
                            "dType": "string",
                            "lngTag": "20008015",
                        },
                        "Hobbyart": {
                            "label": "type",
                            "dType": "string",
                            "lngTag": "20008002",
                        },
                        "Hobby": {
                            "label": "subType",
                            "dType": "string",
                            "lngTag": "20008004",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editHobby",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20008016",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteHobby",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20008017",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-soccer_ball"
                        },
                        "text": {
                            "label": "caption",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "type",
                                "dType": "string"
                            }, {
                                "label": "subType",
                                "dType": "string",
                            }, {
                                "label": "societyName",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editHobby",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteHobby",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
        * Client detail hobby form
        * @memberOf UserInterface
        */
                this.hobbyForm = {
                    form: [{
                            lngTag: {
                                dateFrom: "20008000",
                                dateTo: "20008001"
                            },
                            label: {
                                dateFrom: "Mitgliedschaft von",
                                dateTo: "bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "validFrom",
                                dateTo: "validTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Hobbyart auswählen",
                            label: "Hobbyart",
                            type: "Select2",
                            model: "typeId",
                            lngTag: 20008002,
                            dataSource: "getTypeWv",
                            required: true,
                            //events: {
                            //    updateDataSource: "subTypeId"
                            //},
                            validate: {
                                message: "Bitte den Hobbyart auswählen.",
                                messageTag: 20008003
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'ebba5d70-a416-4d46-82cd-a12ddd906ff8',
                            wvListData: 'wvList.typeWvList'
                        }, {
                            placeholder: "Hobby auswählen",
                            label: "Hobby",
                            type: "Select2",
                            model: "subTypeId",
                            dataSource: "getSubTypeWv",
                            lngTag: 20008004,
                            required: true,
                            validate: {
                                message: "Bitte einen Hobby auswählen",
                                messageTag: 20008005
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'af561b60-6040-41bb-96f7-a4a59cdce563',
                            wvSubParent: 'typeId',
                            events: {
                                hideExpression: "qmForm.isHobbyDisabled"
                            }
                        }, {
                            placeholder: "Hobby auswählen",
                            label: "Hobby",
                            type: "Select2",
                            model: "subTypeId",
                            dataSource: "getSubTypeWv",
                            lngTag: 20008004,
                            required: true,
                            disabled: true,
                            validate: {
                                message: "Bitte einen Hobby auswählen",
                                messageTag: 20008005
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            events: {
                                hideExpression: "!qmForm.isHobbyDisabled"
                            }
                        }, {
                            placeholder: "Bezeichnung",
                            placeholderTag: "20008006",
                            label: "Bezeichnung",
                            type: "String",
                            lngTag: 20008006,
                            model: "caption",
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "qm-icon-ballpen"
                            },
                        }, {
                            placeholder: "Verein auswählen",
                            placeholderTag: "20008007",
                            label: "Verein",
                            type: "Select2",
                            model: "societyId",
                            dataSource: "getSocietyListItems",
                            id: "society",
                            lngTag: 20008008,
                            events: {
                                updateDataSource: "contactPersonId"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            placeholder: "Ansprechpartner/in auswählen",
                            placeholderTag: "20008018",
                            label: "Ansprechpartner/in",
                            type: "Select2",
                            model: "contactPersonId",
                            dataSource: "getContactPersonItems",
                            id: "contactPerson",
                            lngTag: 20008015,
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            placeholder: "Mitgliedsnummer",
                            placeholderTag: "20008010",
                            label: "Mitgliedsnummer",
                            type: "String",
                            model: "membershipNo",
                            lngTag: 20008010,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-hashtag"
                            },
                        }, {
                            placeholder: "Bemerkung eintragen",
                            placeholderTag: "20008011",
                            label: "Bemerkung",
                            type: "Summernote",
                            maxLength: -1,
                            lngTag: 20008012,
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12",
                            }
                        },],
                    actions: {
                        put: "putHobby",
                        post: "addHobby"
                    }
                };
                /**
        * Client detail education table
        * @memberOf UserInterface
        */
                this.educationTable = {
                    "table": {
                        "Gültig von": {
                            "label": "validFrom",
                            "dType": "Date",
                            "lngTag": "20012004",
                        },
                        "Gültig bis": {
                            "label": "validTo",
                            "dType": "Date",
                            "lngTag": "20012005",
                        },
                        "Ausbildungstyp": {
                            "label": "educationKindDescr",
                            "dType": "string",
                            "lngTag": "20012014",
                        },
                        "Schule/Firma": {
                            "label": "schoolCompanyName",
                            "dType": "string",
                            "lngTag": "20012006",
                        },
                        "Hauptansprechpartner": {
                            "label": "contactPerson",
                            "dType": "string",
                            "lngTag": "20012007",
                        },
                        "Abschluss": {
                            "label": "graduation",
                            "dType": "string",
                            "lngTag": "20012008",
                        },
                        "Art der Ausbildung": {
                            "label": "educationType",
                            "dType": "string",
                            "lngTag": "20012010",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editEducation",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteEducation",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-graduation_hat2"
                        },
                        "text": {
                            "label": "educationKindDescr",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "caption",
                                "dType": "string"
                            }, {
                                "label": "contactPerson",
                                "dType": "string",
                            }, {
                                "label": "educationType",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editEducation",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteEducation",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                this.educationForm = {
                    form: [{
                            placeholder: "Ausbildungstyp auswählen",
                            placeholderTag: "20012026",
                            label: "Ausbildungstyp",
                            type: "Select2",
                            model: "educationKind",
                            lngTag: 20012003,
                            dataSource: "getEducationKindWv",
                            required: true,
                            validate: {
                                message: "Bitte den Ausbildungstyp auswählen.",
                                messageTag: 20012016
                            },
                            events: {
                                hideExpression: "(qmForm.educationKind != null && qmState == 'edit')"
                            },
                            style: {
                                class: "col-md-12 col-xs-12",
                            }
                        }, {
                            lngTag: {
                                dateFrom: "20012004",
                                dateTo: "20012005"
                            },
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "validFrom",
                                dateTo: "validTo"
                            },
                            events: {
                                hideExpression: "(qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Art der Ausbildung auswählen",
                            placeholderTag: "20012030",
                            label: "Art der Ausbildung",
                            type: "Select2",
                            model: "educationTypeId",
                            dataSource: "getProfessionalTypeWv",
                            lngTag: 20012010,
                            id: "educationaType",
                            required: true,
                            validate: {
                                message: "Bitte das art der Ausbildung auswählen",
                                messageTag: 20012031
                            },
                            events: {
                                hideExpression: "(qmForm.educationKind != 1) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            wvId: '5c177c51-a3a8-4516-99ef-54ba88e946d2',
                            wvListData: 'educationSchemaWvList.professionalTypeWvList'
                        },
                        {
                            placeholder: "Art der Ausbildung auswählen",
                            placeholderTag: "20012030",
                            label: "Art der Ausbildung",
                            type: "Select2",
                            model: "educationTypeId",
                            dataSource: "getSchoolTypeWv",
                            lngTag: 20012010,
                            id: "educationaType",
                            required: true,
                            validate: {
                                message: "Bitte das art der Ausbildung auswählen",
                                messageTag: 20012031
                            },
                            events: {
                                hideExpression: "(qmForm.educationKind != 0) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            wvId: '7bc3ef03-862e-442c-a925-7edf8a2e1cd3',
                            wvListData: 'educationSchemaWvList.schoolTypeWvList'
                        }, {
                            placeholder: "Eintragsart auswählen",
                            placeholderTag: "20012029",
                            label: "Eintragsart",
                            type: "Select2",
                            model: "educationTypeId",
                            dataSource: "getProfessionalCareerTypeWv",
                            lngTag: 20012022,
                            id: "professionalCareer",
                            events: {
                                hideExpression: "(qmForm.educationKind != 2) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            wvId: 'e709e81f-b8ec-47c8-a72c-8f5d982dbc41',
                            wvListData: 'educationSchemaWvList.professionalCareerTypeWvList'
                        }, {
                            placeholder: "Schule auswählen",
                            placeholderTag: "20012018",
                            label: "Schule",
                            type: "Select2",
                            model: "schoolCompanyId",
                            dataSource: "getSchoolsItemList",
                            lngTag: 20012019,
                            id: "school",
                            events: {
                                hideExpression: "(qmForm.educationKind != 0 ) || (qmForm.educationKind == null)",
                                updateDataSource: "classId"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        },
                        {
                            placeholder: "Firma auswählen",
                            placeholderTag: "20012017",
                            label: "Firma",
                            type: "Select2",
                            model: "schoolCompanyId",
                            dataSource: "getCompaniesItemList",
                            lngTag: 20012011,
                            id: "company",
                            events: {
                                hideExpression: "(qmForm.educationKind == 0) || (qmForm.educationKind == null)",
                                updateDataSource: "contactPersonId"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        }, {
                            placeholder: "Manueller Text",
                            placeholderTag: "20012012",
                            label: "Manueller Text",
                            type: "String",
                            lngTag: 20012012,
                            model: "caption",
                            events: {
                                hideExpression: "(qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        }, {
                            placeholder: "Status auswählen",
                            placeholderTag: "20012028",
                            label: "Status",
                            type: "Select2",
                            model: "statusId",
                            dataSource: "getSchoolStatusWv",
                            lngTag: 20012013,
                            id: "statusSchool",
                            events: {
                                hideExpression: "(qmForm.educationKind != 0) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'fd81f106-4773-493d-a04f-223e4ebfd195',
                            wvListData: 'educationSchemaWvList.schoolStatusWvList'
                        }, {
                            placeholder: "Status auswählen",
                            placeholderTag: "20012028",
                            label: "Status",
                            type: "Select2",
                            model: "statusId",
                            dataSource: "getProfessionalStatusWv",
                            lngTag: 20012013,
                            id: "statusProfessional",
                            events: {
                                hideExpression: "(qmForm.educationKind != 1) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'fd81f106-4773-493d-a04f-223e4ebfd195',
                            wvListData: 'educationSchemaWvList.professionalStatusWvList'
                        }, {
                            placeholder: "Status auswählen",
                            placeholderTag: "20012028",
                            label: "Status",
                            type: "Select2",
                            model: "statusId",
                            dataSource: "getProfessionalCareerStatusWv",
                            lngTag: 20012013,
                            id: "statusProfessionalCareer",
                            events: {
                                hideExpression: "(qmForm.educationKind != 2) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'ddcde80d-3634-4ccc-9434-03bd09f36014',
                            wvListData: 'educationSchemaWvList.professionalCareerStatusWvList'
                        }, {
                            placeholder: "Klasse auswählen",
                            placeholderTag: "20012027",
                            label: "Klasse",
                            type: "Select2",
                            model: "classId",
                            dataSource: "getGradeLevelList",
                            lngTag: 20012021,
                            id: "class",
                            events: {
                                hideExpression: "(qmForm.educationKind != 0) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        },
                        {
                            placeholder: "Ausbildungstyp auswählen",
                            placeholderTag: "20012026",
                            label: "Ausbildungstyp",
                            type: "Select2",
                            model: "professionalTrainingTypeId",
                            dataSource: "getProfessionalTrainingTypeWv",
                            lngTag: 20012014,
                            id: "professionTrainingType",
                            events: {
                                hideExpression: "(qmForm.educationKind != 1) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: '92528000-789f-4eb5-8f1c-4bcd24a3aeea',
                            wvListData: 'educationSchemaWvList.professionalTrainingTypeWvList'
                        }, {
                            placeholder: "Ansprechpartner auswählen",
                            placeholderTag: "20012025",
                            label: "Ansprechpartner",
                            type: "Select2",
                            model: "contactPersonId",
                            dataSource: "getContactPersonsItemList",
                            lngTag: 20012015,
                            id: "contactPerson",
                            events: {
                                hideExpression: "(qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        }, {
                            placeholder: "Abschluss auswählen",
                            placeholderTag: "20012023",
                            label: "Abschluss",
                            type: "Select2",
                            model: "graduationId",
                            dataSource: "getSchoolGraduationWv",
                            lngTag: 20012008,
                            id: "schoolGraduation",
                            events: {
                                hideExpression: "(qmForm.educationKind != 0) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: '6fe5a13e-45f2-4c77-b784-b3130c796d72',
                            wvListData: 'educationSchemaWvList.schoolGraduationWvList'
                        }, {
                            placeholder: "Abschluss auswählen",
                            placeholderTag: "20012023",
                            label: "Abschluss",
                            type: "Select2",
                            model: "graduationId",
                            dataSource: "getProfessionalGraduationWv",
                            lngTag: 20012008,
                            id: "professionalGraduation",
                            events: {
                                hideExpression: "(qmForm.educationKind != 1) || (qmForm.educationKind == null)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: '770a34b0-2839-4732-84f7-06715703810d',
                            wvListData: 'educationSchemaWvList.professionalGraduationWvList'
                        }, {
                            placeholder: "Bemerkung eintragen",
                            placeholderTag: "20012024",
                            label: "Bemerkung",
                            type: "Summernote",
                            maxLength: -1,
                            lngTag: 20000049,
                            model: "comment",
                            events: {
                                hideExpression: "(qmForm.educationKind == null)"
                            },
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12",
                            }
                        },],
                    actions: {
                        put: "putEducation",
                        post: "addEducation"
                    }
                };
                /**
        * Client detail training table
        * @memberOf UserInterface
        */
                this.trainingTable = {
                    "table": {
                        "Gueltig von": {
                            "label": "validFrom",
                            "dType": "Date",
                            "lngTag": "20033001"
                        },
                        "Gueltig bis": {
                            "label": "validTo",
                            "dType": "Date",
                            "lngTag": "20033002"
                        },
                        "Typ": {
                            "label": "trainingTypeDescr",
                            "dType": "string",
                            "lngTag": "20033003"
                        },
                        "Faehigkeit": {
                            "label": "trainingDescr",
                            "dType": "string",
                            "lngTag": "20033000"
                        },
                        "Erworben durch": {
                            "label": "acquiredByDescr",
                            "dType": "string",
                            "lngTag": "20033005"
                        },
                        "Bemerkung": {
                            "label": "description",
                            "dType": "string",
                            "lngTag": "20033006"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editTraining",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteTraining",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-injection"
                        },
                        "text": {
                            "label": "trainingTypeDescr",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "trainingDescr",
                                "dType": "string"
                            }, {
                                "label": "validFrom",
                                "dType": "Date",
                            },],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editTraining",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteTraining",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
        * Client detail training form
        * @memberOf UserInterface
        */
                this.trainingForm = {
                    form: [{
                            lngTag: {
                                dateFrom: "20033001",
                                dateTo: "20033002",
                            },
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis",
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "validFrom",
                                dateTo: "validTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Typ",
                            label: "Typ",
                            type: "Select2",
                            model: "trainingTypeId",
                            dataSource: "getTrainingTypeWv",
                            lngTag: 20033003,
                            required: true,
                            validate: {
                                message: "Wählen Sie den Typ aus",
                                messageTag: 20033007
                            },
                            style: {
                                class: "col-md-12 col-xs-12",
                            },
                            wvId: '9837b948-2099-4544-947c-eadbfd5908e2',
                            wvListData: 'trainingSchemaWvList.trainingTypeWvList'
                        }, {
                            placeholder: "Fähigkeit / Fortbildung",
                            label: "Fähigkeit / Fortbildung",
                            type: "Select2",
                            model: "trainingId",
                            dataSource: "getTrainingWv",
                            lngTag: 20033000,
                            required: true,
                            validate: {
                                message: "Wählen Sie die Fähigkeit aus",
                                messageTag: 20033008
                            },
                            style: {
                                class: "col-md-12 col-xs-12"
                            },
                            wvId: '6dfcbb34-3d58-401e-bf1f-29a5da6bde88',
                            wvListData: 'trainingSchemaWvList.trainingWvList'
                        },
                        {
                            placeholder: "Erworben durch",
                            label: "Erworben durch",
                            type: "Select2",
                            model: "acquiredById",
                            dataSource: "getAquiredByWv",
                            lngTag: 20033005,
                            style: {
                                class: "col-md-12 col-xs-12"
                            },
                            wvId: '95dcc367-adf8-4f3d-98fd-bf167221172e',
                            wvListData: 'trainingSchemaWvList.acquiredByWvList'
                        },
                        {
                            placeholder: "Bemerkung eintragen ...",
                            placeholderTag: "20000049",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "description",
                            lngTag: 20033006,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12 col-md-12",
                            }
                        },],
                    actions: {
                        put: "putTraining",
                        post: "addTraining",
                    }
                };
                /**
        * Client detail disease table
        * @memberOf UserInterface
        */
                this.diseaseTable = {
                    "table": {
                        "Datum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000047"
                        },
                        "Datum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "lngTag": "20000054"
                        },
                        "Codeschema": {
                            "label": "diseaseCodeSchema",
                            "dType": "string",
                            "lngTag": "20007002"
                        },
                        "Krankheit": {
                            "label": "diseaseName",
                            "dType": "string",
                            "lngTag": "20001049"
                        },
                        "Bemerkung": {
                            "label": "comment",
                            "dType": "string",
                            "lngTag": "20000049"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editDisease",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteDisease",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-injection"
                        },
                        "text": {
                            "label": "diseaseName",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "diseaseCodeSchema",
                                "dType": "string"
                            }, {
                                "label": "dateFrom",
                                "dType": "Date",
                            },],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editDisease",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteDisease",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
        * Client detail disease form
        * @memberOf UserInterface
        */
                this.diseaseForm = {
                    form: [{
                            lngTag: {
                                dateFrom: "20000047",
                                dateTo: "20000054",
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Codeschema",
                            label: "Codeschema",
                            type: "Select2",
                            model: "diseaseCodeSchemaId",
                            dataSource: "getDiseaseCodeSchemaWvList",
                            lngTag: 20007002,
                            required: true,
                            validate: {
                                message: "Bitte das Codeschema angeben.",
                                messageTag: 21003005
                            },
                            style: {
                                class: "col-md-12 col-xs-12",
                            }
                        }, {
                            placeholder: "Krankheit",
                            label: "Krankheit",
                            type: "Autocomplete",
                            model: "diseaseName",
                            lngTag: 20001049,
                            required: true,
                            id: "liveDiseases",
                            validate: {
                                message: "Bitte die Krankheit angeben."
                            },
                            style: {
                                class: "col-md-12 col-xs-12",
                                icon: "fa fa-globe"
                            }
                        },
                        {
                            placeholder: "Krankheitsart",
                            label: "Krankheitsart",
                            type: "Select2",
                            model: "diseaseTypeId",
                            dataSource: "getDiseaseTypeWvList",
                            lngTag: 20007513,
                            style: {
                                class: "col-md-12 col-xs-12",
                            }
                        },
                        {
                            placeholder: "Bemerkung eintragen ...",
                            placeholderTag: "20000049",
                            label: "Bemerkung",
                            type: "Summernote",
                            maxLength: -1,
                            model: "formattedComment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12 col-md-12",
                            }
                        },],
                    actions: {
                        put: "putDisease",
                        post: "addDiseased",
                    }
                };
                /**
        * Client detail absenteeism table
        * @memberOf UserInterface
        */
                this.absenteeismTable = {
                    "table": {
                        "Datum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000047",
                            "style": "style"
                        },
                        "Datum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000054",
                            "style": "style"
                        },
                        "Abwesenheitsgrund": {
                            "label": "absenteeismReason",
                            "dType": "string",
                            "lngTag": "21008001",
                            "style": "style"
                        },
                        "Kontaktperson": {
                            "label": "contactPersonName",
                            "dType": "string",
                            "lngTag": "20001048",
                            "style": "style"
                        },
                        "Bemerkung": {
                            "label": "comment",
                            "dType": "string",
                            "lngTag": "20000049",
                            "style": "style"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAbsenteeism",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAbsenteeism",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-calendar_7"
                        },
                        "text": {
                            "label": "absenteeismReason",
                            "dType": "string"
                        },
                        "text": {
                            "label": "contactPersonName",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "dateFrom",
                                "dType": "Date"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAbsenteeism",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAbsenteeism",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null
                };
                /**
        * Client detail absenteeism form
        * @memberOf UserInterface
        */
                this.absenteeismForm = {
                    form: [{
                            placeholder: "Abwesenheitsgrund",
                            label: "Abwesenheitsgrund",
                            type: "Select2",
                            lngTag: 21008001,
                            model: "absenteeismReasonId",
                            dataSource: "getWvList",
                            required: true,
                            validate: {
                                message: "Bitte einen Grund auswählen.",
                                messageTag: 21008002
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            wvId: '18ad8c93-5212-4736-b9bb-a00ae7a0d95f',
                            wvListData: 'wvList.absenteeismReasonWvList'
                        }, {
                            placeholder: "Aufenthalt bei",
                            label: "Aufenthalt bei",
                            type: "Select2",
                            lngTag: 21008010,
                            model: "contactPersonId",
                            dataSource: "getContactPersonList",
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            type: "hr"
                        }, {
                            lngTag: {
                                dateFrom: "20000047",
                                dateTo: "20000054"
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayTime: true,
                                disableTime: false,
                                displayDateTo: true,
                                disableDate: false,
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12",
                            }
                        }],
                    actions: {
                        put: "putAbsenteeism",
                        post: "addAbsenteeism"
                    }
                };
                /**
             * Client detail accountingBook table
             * @memberOf UserInterface
             */
                this.accountingBookTable = {
                    "table": {
                        "Kassenbuchart": {
                            "label": "accountingBookType",
                            "dType": "string",
                            "lngTag": "20019002",
                        },
                        "Bezeichnung": {
                            "label": "caption",
                            "dType": "string",
                            "lngTag": "20000053",
                        },
                        "Kontonummer": {
                            "label": "accountNumber",
                            "dType": "string",
                            "lngTag": "20019004",
                        },
                        "Währung": {
                            "label": "currency",
                            "dType": "string",
                            "lngTag": "20019003",
                        },
                        "MwSt.": {
                            "label": "standardVat",
                            "dType": "string",
                            "lngTag": "20000279"
                        },
                        "Negativen Saldo zulassen": {
                            "label": "onlyPositive",
                            "dType": "Bool",
                            "lngTag": "20019025"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-magnifying_glass green",
                                "click": "getAccountingBook",
                                "label": "data",
                                "dType": "Button",
                                "lngTag": "21006000",
                                "tooltip": "Einträge anzeigen",
                                "events": {
                                    "hide": "!view"
                                }
                            }, {
                                "icon": "qm-icon-pencil blue",
                                "click": "editAccountingBook",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "events": {
                                    "hide": "!modify"
                                }
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAccountingBook",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "special",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-plus green",
                                "openModal": "true",
                                "targetModal": "#edit-entryForm",
                                "click": "initEntryForm",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Eintrag hinzufügen",
                                "lngTag": "20000044",
                                "permission": "entryNew"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-cashier"
                        },
                        "text": {
                            "label": "caption",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "accountingBookType",
                                "dType": "string"
                            }, {
                                "label": "currency",
                                "dType": "string"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-magnifying_glass green",
                                "click": "getAccountingBook",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Einträge anzeigen",
                                "lngTag": "21006000",
                                "permission": "view",
                                "events": {
                                    "hide": "!view"
                                }
                            }, {
                                "icon": "qm-icon-pencil blue",
                                "click": "editAccountingBook",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify",
                                "events": {
                                    "hide": "!modify"
                                }
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAccountingBook",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "special",
                                "permissionByDataSet": true
                            }, {
                                "icon": "qm-icon-plus_selected green",
                                "openModal": "true",
                                "targetModal": "#edit-entryForm",
                                "click": "initEntryForm",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Eintrag hinzufügen",
                                "lngTag": "20000044",
                                "permission": "entryNew"
                            }]
                    },
                    "data": null,
                };
                /**
        * client detail accounting book form
        * @memberOf UserInterface
        */
                this.accountingBookForm = {
                    form: [{
                            label: "Kassenbuchname",
                            type: "String",
                            model: "caption",
                            lngTag: 20019019,
                            required: true,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-md-6 col-xs-12",
                            },
                            validate: {
                                message: "Bitte die Bezeichnung angeben."
                            }
                        }, {
                            label: "Kassenbuchart",
                            type: "Select2",
                            lngTag: "20019002",
                            model: "accountingBookTypeId",
                            dataSource: "getTypeList",
                            id: "accountingBookTypeId",
                            required: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            validate: {
                                message: "Bitte die Kassenbuchart angeben."
                            },
                            wvId: '3a2e140f-9e22-414f-bd7c-518085cd0012',
                            wvListData: 'wvList.accountingBookTypeWvList'
                        }, {
                            label: "Konto-Nr.",
                            lngTag: "20019027",
                            type: "String",
                            model: "accountNumber",
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "fa fa-hashtag"
                            }
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Land",
                            label: "Land",
                            type: "Select2",
                            lngTag: 20003521,
                            model: "countryId",
                            dataSource: "getCountryList",
                            required: true,
                            events: {
                                updateDataSource: "currencyId",
                            },
                            style: {
                                class: "col-xs-12",
                            }
                        }, {
                            placeholder: "Währung",
                            label: "Währung",
                            type: "Select",
                            lngTag: 20019003,
                            model: "currencyId",
                            dataSource: "getCurrencyList",
                            required: true,
                            id: "currencyId",
                            validate: {
                                message: "Bitte eine Währung auswählen",
                                messageTag: 20019005
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            placeholder: "Standard Mehrwertsteuer",
                            label: "Standard Mehrwertsteuer",
                            type: "Select",
                            lngTag: 20019006,
                            model: "standardVatId",
                            dataSource: "getVatList",
                            id: "standardVatId",
                            events: {
                                hideExpression: "(d.dataSource.value.length < 1)"
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            label: "Negativen Saldo zulassen",
                            type: "Checkbox",
                            model: "onlyPositive",
                            id: "onlyPositive",
                            lngTag: "20019025",
                            style: {
                                class: "col-xs-6"
                            }
                        }, {
                            label: "abgeschlossen bis",
                            type: "Date",
                            model: "endingDate",
                            lngTag: "20019026",
                            //required: true,
                            //events: {
                            //    hide: "onlyPositive"
                            //},
                            style: {
                                class: "col-xs-6"
                            }
                        }, {
                            label: "Als Standard",
                            lngTag: "20000070",
                            type: "Checkbox",
                            model: "isStandard",
                            id: "isStandard",
                            disabled: true,
                            style: {
                                class: "col-xs-6"
                            },
                            events: {
                                hideExpression: "!qmForm.wasStandard"
                            }
                        }, {
                            label: "Als Standard",
                            lngTag: "20000070",
                            type: "Checkbox",
                            model: "isStandard",
                            id: "isStandard2",
                            disabled: false,
                            style: {
                                class: "col-xs-6"
                            },
                            events: {
                                hideExpression: "qmForm.wasStandard"
                            }
                        },],
                    actions: {
                        put: "putAccountingBook",
                        post: "addAccountingBook"
                    }
                };
                /**
        * client detail accounting book entry table
        * @memberOf UserInterface
        */
                this.accountingBookEntryTableIn = {
                    "config": {
                        "showTitle": "true",
                        "defaultSort": "date",
                        "sortReverse": "true",
                    },
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045"
                        },
                        "Belegtyp": {
                            "label": "voucherType",
                            "dType": "string",
                            "lngTag": "20019014"
                        },
                        // "Belegtext": {
                        //     "label": "voucherText",
                        //     "dType": "string",
                        //     "lngTag": "20019003"
                        // },
                        "Betrag": {
                            "label": "amountSigned",
                            "dType": "Number",
                            "calculate": "true",
                            "lngTag": "20000122"
                        },
                        "Währung": {
                            "label": "currency",
                            "dType": "string",
                            "lngTag": "20019003"
                        },
                        // "MwSt.": {
                        //     "label": "vatText",
                        //     "dType": "string"
                        // },
                        "Beleg Nr.": {
                            "label": "voucherNr",
                            "dType": "string",
                            "lngTag": "20019015"
                        },
                        "Gegenb.": {
                            "label": "isCounterBooking",
                            "dType": "Bool",
                            "lngTag": "0"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAccountingBookEntry",
                                "openModal": "true",
                                "targetModal": "#edit-entryForm",
                                "label": "data",
                                "dType": "Button",
                                "lngTag": "20000144",
                                "tooltip": "Anzeigen und Bearbeiten",
                                "permission": "entryModify",
                                "hide": "!allowEdit"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAccountingBookEntry",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "entryDelete",
                                "hide": "!allowDelete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "fa fa-plus-circle fa-green"
                        },
                        "text": {
                            "label": "voucherType",
                            "dType": "string"
                        },
                        "subtext": [{
                                "dType": "string"
                            }, {
                                "label": "amountSigned",
                                "dType": "Number"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAccountingBookEntry",
                                "openModal": "true",
                                "targetModal": "#edit-entryForm",
                                "label": "data",
                                "dType": "Button",
                                "lngTag": "20000144",
                                "tooltip": "Bearbeiten",
                                "permission": "entryModify",
                                "hide": "!allowEdit"
                            }]
                    },
                    "data": null,
                };
                this.accountingBookEntryTableOut = {
                    "config": {
                        "showTitle": "true",
                        "defaultSort": "date",
                        "sortReverse": "true"
                    },
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045"
                        },
                        "Belegtyp": {
                            "label": "voucherType",
                            "dType": "string",
                            "lngTag": "20019014"
                        },
                        // "Belegtext": {
                        //     "label": "voucherText",
                        //     "dType": "string",
                        //     "lngTag": "20019003"
                        // },
                        "Betrag": {
                            "label": "amountSigned",
                            "dType": "Number",
                            "calculate": "true",
                            "lngTag": "20000122"
                        },
                        "Währung": {
                            "label": "currency",
                            "dType": "string",
                            "lngTag": "20019003"
                        },
                        // "MwSt.": {
                        //     "label": "vatText",
                        //     "dType": "string"
                        // },
                        "Beleg Nr.": {
                            "label": "voucherNr",
                            "dType": "string",
                            "lngTag": "20019015"
                        },
                        "Gegenb.": {
                            "label": "isCounterBooking",
                            "dType": "Bool",
                            "lngTag": "0"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAccountingBookEntry",
                                "openModal": "true",
                                "targetModal": "#edit-entryForm",
                                "label": "data",
                                "dType": "Button",
                                "lngTag": "20000144",
                                "tooltip": "Anzeigen und Bearbeiten",
                                "permission": "entryModify",
                                "hide": "!allowEdit"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteAccountingBookEntry",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "entryDelete",
                                "hide": "!allowDelete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "fa fa-minus-circle fa-red"
                        },
                        "text": {
                            "label": "voucherType",
                            "dType": "string"
                        },
                        "subtext": [{
                                "dType": "string"
                            }, {
                                "label": "amountSigned",
                                "dType": "Number"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editAccountingBookEntry",
                                "openModal": "true",
                                "targetModal": "#edit-entryForm",
                                "label": "data",
                                "dType": "Button",
                                "lngTag": "20000144",
                                "tooltip": "Bearbeiten",
                                "permission": "entryModify",
                                "hide": "!allowEdit"
                            }]
                    },
                    "data": null,
                };
                /**
        * client detail accounting book entry form
        * @memberOf UserInterface
        */
                this.accountingBookEntryForm = {
                    form: [{
                            lngTag: "20000025",
                            label: "Typ",
                            type: "Select",
                            model: "isDeposit",
                            required: true,
                            dataSource: "getDepositList",
                            style: {
                                class: "col-xs-12- col-md-6"
                            }
                        }, {
                            lngTag: "20019014",
                            label: "Belegtyp",
                            type: "Select2",
                            model: "voucherTypeId",
                            required: true,
                            dataSource: "getVoucherTypeList",
                            style: {
                                class: "col-xs-12 col-md-6",
                                icon: "fa fa-hashtag"
                            },
                            events: {
                                hideExpression: "qmForm.isDeposit == true"
                            },
                            wvId: 'c102cb74-6152-45bb-adf1-9e6a53c5b71b',
                            wvListData: 'wvList.paymentVoucherTypeWvList'
                        }, {
                            lngTag: "20019028",
                            label: "Einnahmetyp",
                            type: "Select2",
                            model: "voucherTypeId",
                            required: true,
                            dataSource: "getDepositTypeList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                            events: {
                                hideExpression: "qmForm.isDeposit == false"
                            },
                            wvId: '7b1c5c67-0606-4613-bac0-97dea9ee78e8',
                            wvListData: 'wvList.depositVoucherTypeWvList'
                        }, {
                            label: "Generiere Belegnummer",
                            type: "Checkbox",
                            model: "createVoucherNr",
                            id: "createVoucherNr",
                            lngTag: "20019021",
                            style: {
                                class: "col-xs-12 col-md-6 col-lg-3",
                            },
                            events: {
                                hideExpression: "(qmForm.generateVoucherNrPossible == false || qmForm.isVoucherNumberFix == true)"
                            }
                        }, {
                            lngTag: "20019015",
                            label: "Beleg Nr.",
                            type: "String",
                            model: "voucherNr",
                            disabled: true,
                            style: {
                                class: "col-xs-12 col-md-6 col-lg-3",
                                icon: "fa fa-hashtag",
                            },
                            events: {
                                hideExpression: "qmForm.createVoucherNr != true"
                            }
                        }, {
                            lngTag: "20019015",
                            label: "Beleg Nr.",
                            type: "String",
                            model: "voucherNr",
                            style: {
                                class: "col-xs-12 col-md-6 col-lg-3",
                                icon: "fa fa-hashtag",
                            },
                            events: {
                                hideExpression: "qmForm.createVoucherNr == true"
                            }
                        }, {
                            lngTag: "20000045",
                            label: "Datum",
                            type: "Date",
                            model: "date",
                            required: true,
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }, {
                            type: "hr"
                        }, {
                            lngTag: "20019029",
                            label: "Belegtext",
                            type: "String",
                            model: "voucherText",
                            required: true,
                            style: {
                                class: "col-xs-12 col-md-12",
                                icon: "qm-icon-note_text"
                            }
                        },
                        {
                            lngTag: "20019024",
                            label: "Personenbezug",
                            type: "Select2",
                            model: "referenceId",
                            dataSource: "getReferences",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            lngTag: "20000122",
                            label: "Betrag",
                            type: "Number",
                            model: "amount",
                            minValue: -1000000,
                            //id: "amount",
                            required: true,
                            validate: {
                                message: "Bitte den Betrag ausfüllen",
                                messageTag: 20019005
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-eur"
                            },
                        }, {
                            placeholder: "Währung",
                            label: "Währung",
                            type: "String",
                            lngTag: 20019003,
                            model: "currency",
                            disabled: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-info"
                            },
                        }, {
                            lngTag: "20000049",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: 255,
                            model: "comment",
                            style: {
                                class: "col-xs-12",
                                icon: "qm-icon-note_text",
                            },
                        },],
                    actions: {
                        put: "putAccountingBookEntry",
                        post: "addAccountingBookEntry"
                    }
                };
                this.accountingBookCounterBookingTable = {
                    "table": {
                        "Typ": {
                            "label": "referenceType",
                            "dType": "string",
                            "lngTag": "20000025",
                        },
                        "Bezug": {
                            "label": "reference",
                            "dType": "string",
                            "lngTag": "20000283",
                        },
                        "Kassenbuch": {
                            "label": "name",
                            "dType": "string",
                            "lngTag": "20001044",
                        },
                        "Kassenbuchart": {
                            "label": "type",
                            "dType": "string",
                            "lngTag": "20019002",
                        },
                        "Hauptkassenbuch": {
                            "label": "isStandard",
                            "dType": "Bool",
                            "lngTag": "20000279"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-cashier blue",
                                "click": "selectCounterAccountingBook",
                                "dType": "Button",
                                "lngTag": "20019033",
                                "tooltip": "Gegenbuchung für dieses Kassenbuch erstellen",
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-cashier"
                        },
                        "text": {
                            "label": "name",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "referenceType",
                                "dType": "string"
                            }, {
                                "label": "reference",
                                "dType": "string"
                            }, {
                                "label": "type",
                                "dType": "string"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-cashier blue",
                                "click": "selectCounterAccountingBook",
                                "dType": "Button",
                                "lngTag": "0",
                                "tooltip": "Gegenbuchung für dieses Kassenbuch erstellen",
                            }]
                    },
                    "data": null,
                };
                this.smartAufgabeForm = {
                    form: [
                        {
                            label: "Aufgabe",
                            placeholder: "",
                            type: "String",
                            lngTag: "20014007",
                            required: true,
                            model: "taskName",
                            validate: {
                                message: "Bitte die Aufgabe angeben.",
                                messageTag: 20014008
                            },
                            style: {
                                icon: "qm-icon-check",
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Kategorie",
                            placeholder: "Kategorie auswählen",
                            type: "Select",
                            lngTag: "20000137",
                            model: "categoryId",
                            dataSource: "getCategoryList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Priorität",
                            placeholder: "Priorität auswählen",
                            type: "Select",
                            lngTag: "20014013",
                            model: "priorityId",
                            dataSource: "getPriorityList",
                            id: "priorityList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            placeholder: "Erledigungstyp auswählen ...",
                            label: "Erledigungstyp",
                            type: "Select",
                            lngTag: "20014014",
                            model: "executionTypeId",
                            dataSource: "getExecutionTypeList",
                            id: "executionTypeList",
                            required: true,
                            validate: {
                                message: "Bitte Erledigungstyp angeben.",
                                messageTag: 20014021
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Erledigungsfrist",
                            placeholder: "zu erledigen bis",
                            type: "Date",
                            model: "dateToFinishTill",
                            startDate: new Date(),
                            lngTag: "20014005",
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Termin(e) verwenden",
                            type: "Checkbox",
                            model: "isAppointment",
                            id: "isAppointment",
                            lngTag: "20014030",
                            style: {
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Teilnehmer (Mitarbeiter)",
                            type: "Select2",
                            lngTag: "20014010",
                            model: "participants",
                            dataSource: "getParticipantsList",
                            multiple: true,
                            id: "participantsTypeList",
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Beschreibung",
                            placeholder: "Beschreibung eingeben ...",
                            type: "Summernote",
                            maxLength: -1,
                            lngTag: "20014019",
                            model: "taskDescription",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12"
                            }
                        }
                    ],
                    actions: {
                        put: "putAufgabe",
                        post: "addAufgabe",
                    }
                };
                this.smartContactpersonForm = {
                    form: [
                        {
                            placeholder: "Klient auswählen",
                            label: "Klient",
                            type: "Select",
                            model: "participants",
                            lngTag: 20017049,
                            required: true,
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            style: {
                                class: "col- xs - 12",
                            },
                            validate: {
                                message: "Bitte einen Klienten angeben.",
                                messageTag: 21003000
                            }
                        },
                        {
                            placeholder: "Kontaktpersonart auswählen",
                            label: "Kontaktpersonart",
                            type: "Select",
                            model: "contactPersonTypeId",
                            lngTag: 20004003,
                            required: true,
                            dataSource: "getContactPersonTypeList",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            validate: {
                                message: "Bitte die Art auswählen!"
                            }
                        }, {
                            placeholder: "Anrede auswählen",
                            label: "Anrede",
                            type: "Select",
                            model: "salutationId",
                            lngTag: 20004005,
                            dataSource: "getSalutationList",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                            validate: {
                                message: "Bitte die Anrede auswählen!"
                            }
                        }, {
                            placeholder: "Titel auswählen",
                            label: "Titel",
                            type: "Select",
                            model: "titleId",
                            lngTag: 21002024,
                            dataSource: "getTitleList",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Vorname",
                            label: "Vorname",
                            type: "String",
                            lngTag: 20000057,
                            model: "forename",
                            validate: {
                                message: "Bitte den Vornamen angeben",
                                messageTag: 20003510,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: "Nachname",
                            label: "Nachname",
                            type: "String",
                            lngTag: 20000058,
                            required: true,
                            model: "name",
                            validate: {
                                message: "Bitte den Nachnamen angeben",
                                messageTag: 20003510,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: "Geburtsdatum",
                            label: "Geburtsdatum",
                            type: "Date",
                            lngTag: 21002004,
                            model: "birthday",
                            validate: {
                                message: "Bitte das Geburtsdatum angeben",
                                messageTag: 21003020,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-md-6 col-xs-12"
                            }
                        }, {
                            placeholder: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12 col-md-12"
                            }
                        }, {
                            label: "Kontaktsperre",
                            type: "Checkbox",
                            model: "isContactBan",
                            lngTag: 20004512,
                            id: "isContactBan",
                            style: {
                                class: "medium"
                            }
                        }
                    ],
                    actions: {
                        post: "addContactperson",
                        put: "putContactperson"
                    }
                };
                this.smartAppointmentForm = {
                    form: [{
                            label: "Betreff",
                            placeholder: "Betreff",
                            type: "String",
                            model: "title",
                            required: true,
                            validate: {
                                message: "Bitte den Betreff angeben.",
                                messageTag: 20018024
                            },
                            style: {
                                class: "col-xs-12",
                                icon: "fa fa-font"
                            }
                        },
                        {
                            label: "Teilnehmer (Klienten)",
                            type: "Select2",
                            model: "participants",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Teilnehmer (Mitarbeiter)",
                            type: "Select2",
                            model: "selectedEmployeeIds",
                            id: "selectedEmployeeIds",
                            dataSource: "getEmployeeList",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            type: "hr"
                        }, {
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            type: "DateRange",
                            lngTag: "20000130",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayTime: true,
                                displayDateTo: true,
                                disableTime: "isAllDay"
                            }
                        },
                        {
                            placeholder: "Ort",
                            label: "Ort",
                            type: "String",
                            model: "location",
                            style: {
                                class: "col-xs-12",
                                icon: "qm-icon-fa fa-map-marker"
                            }
                        },
                        {
                            label: "Bemerkung",
                            placeholder: "Bemerkung eingeben ...",
                            type: "Textarea",
                            maxLength: -1,
                            lngTag: "20000049",
                            model: "description",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Privat",
                            type: "Checkbox",
                            lngTag: 20018014,
                            model: "isPrivate",
                            id: "isPrivate",
                            style: {
                                class: "col-md-4 col-xs-6"
                            }
                        },
                        {
                            label: "Erledigt",
                            type: "Checkbox",
                            lngTag: 20000120,
                            model: "isFinished",
                            id: "isFinished",
                            style: {
                                class: "col-md-4 col-xs-6"
                            }
                        },
                        {
                            label: "Ganztägig",
                            type: "Checkbox",
                            lngTag: 20018016,
                            model: "isAllDay",
                            id: "isAllDay",
                            style: {
                                class: "col-md-4 col-xs-6"
                            }
                        },],
                    actions: {
                        put: "putAppointment",
                        post: "addAppointment"
                    }
                };
                this.smartAbsenteeismForm = {
                    form: [{
                            label: "Teilnehmer (Klienten)",
                            type: "Select2",
                            model: "participants",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: "Abwesenheitsgrund",
                            label: "Abwesenheitsgrund",
                            type: "Select",
                            lngTag: 21008001,
                            model: "absenteeismReasonId",
                            dataSource: "getWvList",
                            required: true,
                            validate: {
                                message: "Bitte einen Grund auswählen.",
                                messageTag: 21008002
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            type: "hr"
                        }, {
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayTime: true,
                                disableTime: false,
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12",
                            }
                        },],
                    actions: {
                        put: "putAbsenteeism",
                        post: "addAbsenteeism"
                    }
                };
                this.smartDiseaseForm = {
                    form: [{
                            label: "Teilnehmer (Klienten)",
                            type: "Select2",
                            model: "participants",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            label: {
                                dateFrom: "Datum von",
                                dateTo: "Datum bis",
                            },
                            type: "DateRange",
                            lngTag: 20000130,
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            placeholder: "Codeschema",
                            label: "Codeschema",
                            type: "Select2",
                            model: "diseaseCodeSchemaId",
                            dataSource: "getDiseaseWvList",
                            lngTag: 20007002,
                            required: true,
                            validate: {
                                message: "Bitte das Codeschema angeben.",
                                messageTag: 21003005
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Krankheit",
                            label: "Krankheit",
                            type: "Autocomplete",
                            model: "diseaseName",
                            lngTag: 20001049,
                            required: true,
                            id: "liveDiseases",
                            validate: {
                                message: "Bitte die Krankheit angeben."
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-globe"
                            }
                        }, {
                            placeholder: "Bemerkung eintragen ...",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            model: "comment",
                            lngTag: 20000049,
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12 col-md-12",
                            }
                        },],
                    actions: {
                        put: "putDisease",
                        post: "addDisease",
                    }
                };
                this.smartDocVisitForm = {
                    form: [{
                            label: "Teilnehmer (Klienten)",
                            type: "Select2",
                            model: "participants",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        }, {
                            placeholder: "Datum",
                            label: "Datum",
                            type: "Date",
                            model: "date",
                            lngTag: 20000045,
                            required: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Uhrzeit",
                            label: "Uhrzeit",
                            type: "Time",
                            lngTag: 20000046,
                            model: "time",
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Arzt",
                            label: "Arzt",
                            type: "Select2",
                            model: "doctorId",
                            lngTag: 20010502,
                            dataSource: "getDoctors",
                            style: {
                                class: "col-md-12 col-xs-12",
                            },
                        }, {
                            placeholder: "Diagnose",
                            label: "Diagnose",
                            type: "Textarea",
                            maxLength: -1,
                            lngTag: 20010503,
                            model: "diagnose",
                            style: {
                                class: "col-md-12 col-xs-12",
                                icon: "fa fa-user-md"
                            },
                        },],
                    actions: {
                        put: "putDocVisit",
                        post: "addDocVisit"
                    }
                };
                this.smartVaccinationForm = {
                    form: [{
                            label: "Teilnehmer (Klienten)",
                            type: "Select2",
                            model: "participants",
                            id: "selectedClientIds",
                            dataSource: "getClientList",
                            multiple: true,
                            style: {
                                class: "col-xs-12"
                            }
                        }, {
                            lngTag: {
                                dateFrom: "20000045",
                                dateTo: "20009504"
                            },
                            label: {
                                dateFrom: "Datum",
                                dateTo: "Folgetermin"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "date",
                                dateTo: "dateFollowupAppointment"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        }, {
                            type: "hr"
                        }, {
                            placeholder: "Arzt auswählen",
                            label: "Arzt",
                            type: "Select2",
                            model: "doctorId",
                            lngTag: 20010502,
                            dataSource: "getDoctors",
                            required: true,
                            validate: {
                                message: "Bitte den Arzt angeben.",
                                messageTag: 21003014
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            }
                        }, {
                            placeholder: "Krankheit auswählen",
                            label: "Krankheit",
                            type: "Select2",
                            model: "diseaseId",
                            dataSource: "getDiseases",
                            lngTag: 20001049,
                            required: true,
                            id: "disease",
                            validate: {
                                message: "Bitte eine Krankheit angeben",
                                messageTag: 21003006
                            },
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        }, {
                            placeholder: "Impfstoff Handelsname",
                            label: "Impfstoff",
                            type: "String",
                            lngTag: 20009512,
                            model: "caption",
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-stethoscope"
                            },
                        }, {
                            placeholder: "Chargen-Nr",
                            label: "Chargen-Nr",
                            type: "String",
                            model: "batchNumber",
                            lngTag: 20009507,
                            style: {
                                class: "col-md-6 col-xs-12",
                                icon: "fa fa-hashtag"
                            },
                        }, {
                            placeholder: "Bemerkung eintragen",
                            label: "Bemerkung",
                            type: "Textarea",
                            maxLength: -1,
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "colm-md-6 col-xs-12",
                            }
                        },],
                    actions: {
                        put: "putVaccination",
                        post: "addVaccination"
                    }
                };
                /**
                * Client detail legal table
                * @memberOf UserInterface
                */
                this.legalTable = {
                    "table": {
                        "Gültig von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000277"
                        },
                        "Gültig bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "lngTag": "20000278"
                        },
                        "Rechtsbezeichnung": {
                            "label": "lawType",
                            "dType": "string",
                            "lngTag": "20022004"
                        },
                        "Rechteinhaber": {
                            "label": "firstLawOwner",
                            "dType": "string",
                            "lngTag": "20022005"
                        },
                        "Gesetzbuch": {
                            "label": "lawBook",
                            "dType": "string",
                            "lngTag": "20022006"
                        },
                        "Zusatz zum Recht": {
                            "label": "legalScale",
                            "dType": "string",
                            "lngTag": "20022010"
                        },
                        "Rechtsgrundlage": {
                            "label": "legalBasis",
                            "dType": "string",
                            "lngTag": "20022008"
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editLegal",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteLegal",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-calendar_7"
                        },
                        "text": {
                            "label": "lawType",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "lawBook",
                                "dType": "string"
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editLegal",
                                "label": "data",
                                "dType": "Button",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteLegal",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null
                };
                /**
                * Client detail legal form
                * @memberOf UserInterface
                */
                this.legalForm = {
                    form: [{
                            lngTag: {
                                dateFrom: "20000277",
                                dateTo: "20000278"
                            },
                            label: {
                                dateFrom: "Gültig von",
                                dateTo: "Gültig bis"
                            },
                            type: "DateRange",
                            model: {
                                dateFrom: "dateFrom",
                                dateTo: "dateTo"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            config: {
                                displayDateTo: true
                            }
                        },
                        {
                            label: "Recht",
                            type: "Select2",
                            model: "lawTypeId",
                            lngTag: 20022009,
                            dataSource: "getLawTypeList",
                            required: true,
                            //events: {
                            //    updateDataSource: "legalScaleId"
                            //},
                            style: {
                                class: "col-xs-12"
                            },
                            id: "lawTypeId",
                            wvId: '550b1b03-57b9-4329-b7cb-9e9dffb378d1',
                            wvListData: 'wvList.lawWvList'
                        },
                        {
                            label: "Zusatz zum Recht",
                            type: "Select2",
                            model: "legalScaleId",
                            lngTag: 20022010,
                            dataSource: "getLawAdditionList",
                            events: {
                                hideExpression: "qmForm.hasNoLawAdditions || qmForm.lawTypeId == null"
                            },
                            style: {
                                class: "col-xs-12"
                            },
                            id: "legalScaleId",
                            wvId: '3e0d8030-1421-41b1-aed9-053d2d01a344',
                            wvSubParent: 'lawTypeId'
                        },
                        {
                            label: "1. Rechteinhaber",
                            type: "Select2",
                            model: "firstLawOwnerId",
                            lngTag: 20022013,
                            dataSource: "getLawOwnerList",
                            style: {
                                class: "col-xs-6"
                            },
                            id: "firstLawOwnerId"
                        },
                        {
                            label: "2. Rechteinhaber",
                            type: "Select2",
                            model: "secondLawOwnerId",
                            lngTag: 20022014,
                            dataSource: "getLawOwnerList",
                            style: {
                                class: "col-xs-6"
                            },
                            id: "secondLawOwnerId"
                        },
                        {
                            label: "Gesetzbuch",
                            type: "Select2",
                            model: "lawBookId",
                            lngTag: 20022006,
                            dataSource: "getLawBooks",
                            events: {
                                updateDataSource: "legalBasisId"
                            },
                            style: {
                                class: "col-xs-6"
                            },
                            id: "lawBookId"
                        },
                        {
                            label: "Paragraph",
                            type: "Select2",
                            model: "legalBasisId",
                            dataSource: "getParagraphList",
                            lngTag: 20022015,
                            events: {
                                hideExpression: "qmForm.hasNoParagraphs || qmForm.lawBookId == null"
                            },
                            style: {
                                class: "col-xs-6"
                            },
                            id: "legalBasisId"
                        },
                        {
                            placeholder: "Bemerkung",
                            placeholderTag: "20000049",
                            label: "Notizen",
                            type: "Summernote",
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12"
                            }
                        },
                    ],
                    actions: {
                        put: "putLegal",
                        post: "addLegal"
                    }
                };
                /**
                * detail medicalEvidence table
                * @memberOf UserInterface
                */
                this.medicalEvidenceTable = {
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045",
                        },
                        "Ablaufdatum": {
                            "label": "validToDate",
                            "dType": "Date",
                            "lngTag": "20031007",
                        },
                        "Nachweisart": {
                            "label": "evidenceKind",
                            "dType": "string",
                            "lngTag": "20031006",
                        },
                        "Nachweistyp": {
                            "label": "evidenceType",
                            "dType": "string",
                            "lngTag": "20031005",
                        },
                        "Initiative": {
                            "label": "initiative",
                            "dType": "string",
                            "lngTag": "20031004",
                        },
                        "Ergebnis": {
                            "label": "result",
                            "dType": "string",
                            "lngTag": "20031001",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editMedicalEvidence",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteMedicalEvidence",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-injection"
                        },
                        "text": {
                            "label": "evidenceKind",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "evidenceType",
                                "dType": "string"
                            }, {
                                "label": "date",
                                "dType": "Date",
                            }, {
                                "label": "validToDate",
                                "dType": "Date",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editMedicalEvidence",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteMedicalEvidence",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
                * detail medicalEvidence form
                * @memberOf UserInterface
                */
                this.medicalEvidenceForm = {
                    form: [{
                            label: "Datum",
                            type: "Date",
                            lngTag: 20000045,
                            model: "date",
                            required: true,
                            validate: {
                                message: "Bitte das Datum angeben",
                                messageTag: 21003001
                            },
                            style: {
                                icon: "fa fa-calendar",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Ablaufdatum",
                            type: "Date",
                            lngTag: 20031007,
                            model: "validToDate",
                            style: {
                                icon: "fa fa-calendar-o",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Nachweisart",
                            type: "Select2",
                            model: "evidenceKindId",
                            lngTag: 20031006,
                            dataSource: "getEvidenceKind",
                            required: true,
                            validate: {
                                message: "Bitte eine Nachweisart auswählen",
                                messageTag: 21003042
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'a1f7e0af-f2ab-4b54-beea-82d0aa4c28f7',
                            wvListData: 'wv.evidenceKindWvList'
                        },
                        {
                            label: "Nachweistyp",
                            type: "Select2",
                            model: "evidenceTypeId",
                            lngTag: 20031005,
                            dataSource: "getEvidenceType",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: '15ba6762-32da-40ae-94c5-ce176776d4a4',
                            wvListData: 'wv.evidenceTypeWvList'
                        },
                        {
                            label: "Initiative",
                            type: "Select2",
                            model: "initiativeId",
                            lngTag: 20031004,
                            dataSource: "getInitiative",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: '79906dfe-0730-44a8-9e46-00cd79d4451f',
                            wvListData: 'wv.initiativeWvList'
                        },
                        {
                            label: "Zusatztext",
                            type: "String",
                            model: "additionalText",
                            lngTag: 20031003,
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12"
                            },
                        },
                        {
                            label: "Durchgeführt von",
                            type: "Select2",
                            model: "executorId",
                            lngTag: 20031002,
                            dataSource: "getExecutioner",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                        },
                        {
                            label: "Ergebnis",
                            type: "Select2",
                            model: "resultId",
                            lngTag: 20031001,
                            dataSource: "getResult",
                            required: true,
                            validate: {
                                message: "Bitte ein Ergebnis auswählen.",
                                messageTag: 21003043
                            },
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'fa480b40-f518-4abd-a14a-836f543cb68a',
                            wvListData: 'wv.resultWvList'
                        },
                        {
                            placeholder: "Bemerkung",
                            placeholderTag: 20000049,
                            label: "Bemerkung",
                            type: "Summernote",
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12"
                            }
                        }],
                    actions: {
                        put: "putMedicalEvidence",
                        post: "addMedicalEvidence",
                    }
                };
                /**
                * detail tempInstituteChange table
                * @memberOf UserInterface
                */
                this.tempInstituteChangeTable = {
                    "table": {
                        "Datum von": {
                            "label": "dateFrom",
                            "dType": "Date",
                            "lngTag": "20000047",
                        },
                        "Datum bis": {
                            "label": "dateTo",
                            "dType": "Date",
                            "lngTag": "20000054",
                        },
                        "Organisation": {
                            "label": "institute",
                            "dType": "string",
                            "lngTag": "20000279",
                        },
                        "Grund": {
                            "label": "reason",
                            "dType": "string",
                            "lngTag": "20032001",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editTempInstituteChange",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteTempInstituteChange",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-injection"
                        },
                        "text": {
                            "label": "institute",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "dateFrom",
                                "dType": "Date"
                            }, {
                                "label": "dateTo",
                                "dType": "Date",
                            }, {
                                "label": "reason",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editTempInstituteChange",
                                "label": "data",
                                "openModal": "true",
                                "targetModal": `#${this.modalId}`,
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteTempInstituteChange",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                /**
                * detail medicationIssuedThrough table
                * @memberOf UserInterface
                */
                this.medicationIssuedThroughTable = {
                    "table": {
                        "Organisation": {
                            "label": "displayTitle",
                            "dType": "string",
                            "lngTag": "20034003",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteMedicalResponsible",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "deleteMedicationIssuedThrough"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-injection"
                        },
                        "text": {
                            "label": "displayTitle",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "organisation",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteMedicalResponsible",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "deleteMedicationIssuedThrough"
                            }]
                    },
                    "data": null,
                };
                /**
                * detail medicalResponsible table
                * @memberOf UserInterface
                */
                this.medicalResponsibleTable = {
                    "table": {
                        "Organisation": {
                            "label": "displayTitle",
                            "dType": "string",
                            "lngTag": "20034003",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteMedicalResponsible",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "deleteMedicalResponsiblePerm"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-injection"
                        },
                        "text": {
                            "label": "organisation",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "displayTitle",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteMedicalResponsible",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "deleteMedicalResponsiblePerm"
                            }]
                    },
                    "data": null,
                };
                /**
                * detail medicalResponsible form
                * @memberOf UserInterface
                */
                this.medicalResponsibleForm = {
                    form: [{
                            placeholder: "Organisation auswählen",
                            placeholderTag: 20034008,
                            label: "Organisation",
                            type: "Select2",
                            model: "organisationIds",
                            multiple: true,
                            validate: {
                                message: "Bitte die Organisation angeben",
                                messageTag: 20034006
                            },
                            lngTag: 20034003,
                            dataSource: "getInstitute",
                            style: {
                                class: "col-xs-12"
                            },
                        }],
                    actions: {
                        put: "putMedicalResponsible",
                        post: "addOrRemoveOrganisationFrom",
                    }
                };
                /**
                * detail tempInstituteChange form
                * @memberOf UserInterface
                */
                this.tempInstituteChangeForm = {
                    form: [{
                            label: "Datum von",
                            type: "Date",
                            lngTag: 20000047,
                            model: "dateFrom",
                            required: true,
                            validate: {
                                message: "Bitte das Datum von angeben",
                                messageTag: 21003001
                            },
                            style: {
                                icon: "fa fa-calendar",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Datum bis",
                            type: "Date",
                            lngTag: 20000054,
                            model: "dateTo",
                            required: true,
                            validate: {
                                message: "Bitte das Datum bis angeben",
                                messageTag: 21003001
                            },
                            style: {
                                icon: "fa fa-calendar",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Organisation",
                            type: "Select2",
                            model: "instituteId",
                            required: true,
                            validate: {
                                message: "Bitte die Organisation angeben",
                                messageTag: 21003041
                            },
                            lngTag: 20000279,
                            dataSource: "getInstitute",
                            style: {
                                class: "col-xs-12"
                            },
                        },
                        {
                            label: "Grund",
                            type: "Select2",
                            model: "reasonId",
                            required: true,
                            validate: {
                                message: "Bitte den Grund angeben",
                                messageTag: 21003040
                            },
                            lngTag: 20032001,
                            dataSource: "getReason",
                            style: {
                                class: "col-md-6 col-xs-12"
                            },
                            wvId: 'a493c156-d518-40dd-b1b2-c3185f2617a5',
                            wvListData: 'wv.reasonWvList'
                        },
                        {
                            placeholder: "Bemerkung",
                            placeholderTag: 20000049,
                            label: "Bemerkung",
                            type: "Textarea",
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12"
                            }
                        }],
                    actions: {
                        put: "putTempInstituteChange",
                        post: "addTempInstituteChange",
                    }
                };
                this.admissionTable = {
                    "table": {
                        "Abgeschlossen": {
                            "label": "isFinished",
                            "dType": "Bool",
                            "lngTag": "20006012",
                        },
                        "Aufnahmedatum": {
                            "label": "date",
                            "dType": "Date",
                            "lngTag": "20000045",
                            "withTime": "true"
                        },
                        "Organisation": {
                            "label": "parentFacility",
                            "dType": "string",
                            "lngTag": "20006508",
                        },
                        "Unterbringung": {
                            "label": "isPlaceOfAccomodation",
                            "dType": "Bool",
                            "lngTag": "20006004",
                        },
                        "Veranlasser": {
                            "label": "initiatorType",
                            "dType": "string",
                            "lngTag": "20006008",
                        },
                        "Migrationshintergrund": {
                            "label": "migrationBackground",
                            "dType": "string",
                            "lngTag": "20006010",
                        },
                        "Schweregrad": {
                            "label": "severityOfAbnormability",
                            "dType": "string",
                            "lngTag": "20006507",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editRow",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteRow",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-arrow_into"
                        },
                        "text": {
                            "label": "parentFacility",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "date",
                                "dType": "Date",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editRow",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteRow",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                this.dismissalTable = {
                    "table": {
                        "Datum": {
                            "label": "date",
                            "dType": "Date",
                            "withTime": "true",
                            "lngTag": "20000045",
                        },
                        "Initiative": {
                            "label": "initiative",
                            "dType": "string",
                            "lngTag": "20006009",
                        },
                        "Verbleib": {
                            "label": "remainingAfterDismissal",
                            "dType": "string",
                            "lngTag": "20006519",
                        },
                        "Veranlasser": {
                            "label": "initiatedBy",
                            "dType": "string",
                            "lngTag": "20006008",
                        },
                        "Grund": {
                            "label": "reason",
                            "dType": "string",
                            "lngTag": "20006518",
                        },
                        "Aufnahme": {
                            "label": "admission",
                            "dType": "string",
                            "lngTag": "20006011",
                        },
                        "Aktionen": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editRow",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteRow",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "card": {
                        "avatar": {
                            "icon": "qm-icon-arrow_into"
                        },
                        "text": {
                            "label": "parentFacility",
                            "dType": "string"
                        },
                        "subtext": [{
                                "label": "admission",
                                "dType": "string",
                            }, {
                                "label": "remainingAfterDismissal",
                                "dType": "string",
                            }],
                        "buttons": [{
                                "icon": "qm-icon-pencil blue",
                                "click": "editRow",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Bearbeiten",
                                "lngTag": "20000044",
                                "permission": "modify"
                            }, {
                                "icon": "qm-icon-garbage_can red",
                                "click": "deleteRow",
                                "label": "data",
                                "dType": "Button",
                                "tooltip": "Löschen",
                                "lngTag": "20000002",
                                "permission": "delete"
                            }]
                    },
                    "data": null,
                };
                this.modalId = modalId !== null && modalId !== void 0 ? modalId : this.modalId;
            }
        }
        Stammdaten.DetailUI = DetailUI;
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        angular.module('QMC.Stammdaten').directive('qmAccountingBook', ['$qui', 'QmcLanguageService', 'QmcPermissionService', 'StammdatenService', 'UserService', ($qui, lng, permissionService, stammdatenService, userService) => {
                return {
                    restrict: 'E',
                    templateUrl: './stammdaten/Directives/AccountingBook',
                    transclude: true,
                    scope: {
                        qmParent: '=',
                        qmCreate: '=',
                        autoload: '=?'
                    },
                    link: (scope) => {
                        scope.vm = scope;
                        //Set defaults
                        scope.allowTableExport = false;
                        scope.ui = new Stammdaten.DetailUI();
                        scope.calcIn = 0;
                        scope.calcOut = 0;
                        scope.isMobile = false;
                        scope.formState = 'new';
                        scope.entryFormState = 'new';
                        scope.timeAmount = 0;
                        scope.loading = true;
                        scope.loadingDetail = false;
                        scope.generateVoucherNrPossible = false;
                        scope.generateVoucherNrPreselection = false;
                        scope.reweNumberData = "";
                        scope.filterWatcher = {
                            dateFrom: null,
                            dateTo: null
                        };
                        scope.validation = {
                            errors: [],
                            warnings: [],
                            isLoading: false
                        };
                        scope.promptOptions = {
                            title: lng.translate(20001044, "Kassenbuch"),
                            yesNo: true,
                            icon: "qm-icon-history2",
                            text: lng.translate(20000290, "Wollen Sie den Eintrag wirklich löschen?")
                        };
                        scope.promptOptionsCounter = {
                            title: lng.translate(20019030, "Gegenbuchung"),
                            yesNo: true,
                            icon: "qm-icon-cashier",
                            text: lng.translate(20019031, "Möchten Sie eine Gegenbuchung eintragen?")
                        };
                        scope.promptOptionsCounterDismiss = {
                            title: lng.translate(20019030, "Gegenbuchung"),
                            yesNo: true,
                            icon: "qm-icon-cashier",
                            text: lng.translate(20019032, "Sie haben kein Ziel für eine Gegenbuchung ausgewählt. Möchten Sie wirklich ohne fortfahren?")
                        };
                        scope.isMobile = QMC.Common.Constants.IS_MOBILE;
                        scope.qmCreate = () => {
                            scope.created = true;
                            scope.showDetail = false;
                            permissionService.getPermissionsByObjectTypes([330003, 330000]).then((data) => {
                                //permissionService.getPermissionsByObjectTypes([330003, 140008]).then((data: Common.IPermission[]) => {
                                scope.entryView = data[0].view;
                                scope.entryDelete = data[0].delete;
                                scope.entryNew = data[0].new;
                                scope.entryModify = data[0].modify;
                                scope.view = data[1].view;
                                scope.delete = data[1].delete;
                                scope.new = data[1].new;
                                scope.modify = data[1].modify;
                                scope.moduleAccess = data[1].moduleAccess;
                                scope.allowTableExport = data[1].print;
                                $qui.waitForEl('#newModalButton', () => {
                                    if (!scope.new)
                                        document.getElementById('newModalButton').style.visibility = 'hidden';
                                    else
                                        document.getElementById('newModalButton').style.visibility = 'unset';
                                });
                                scope.getWv();
                                if (scope.autoload) {
                                    scope.shouldLoadTableData = true;
                                    scope.getData();
                                }
                                else {
                                    $qui.getTableAutoload(userService).then((ltd) => {
                                        scope.shouldLoadTableData = ltd;
                                        if (scope.shouldLoadTableData) {
                                            scope.getData();
                                        }
                                    });
                                }
                                userService.getUserSettings(["KASSENBUCH.BELEGNUMMER_BUCHUNGSKREIS", "KLIENT.BELEGNUMMER_BUCHUNGSKREIS", "KASSENBUCH.BELEGNUMMERGENERIEREN.KLIENT", "KASSENBUCH.ShowFiBuDataInSearchDialog", "KASSENBUCH.GEGENBUCHUNG.CREATE"], false).then((data) => {
                                    scope.generateVoucherNrPossible = (data[0].value.toLowerCase() !== "" && data[0].value.toLowerCase() !== QMC.Common.Constants.GUID_EMPTY);
                                    scope.generateVoucherNrPossible = scope.generateVoucherNrPossible || (data[1].value.toLowerCase() !== "" && data[1].value.toLowerCase() !== QMC.Common.Constants.GUID_EMPTY);
                                    scope.generateVoucherNrPreselection = data[2].value.toLowerCase() === "true";
                                    if (data[3].value.toLowerCase() === "true")
                                        scope.getReweNumberData();
                                    if (scope.entryForm) {
                                        scope.entryForm.generateVoucherNrPossible = scope.generateVoucherNrPossible;
                                        scope.entryForm.createVoucherNr = scope.generateVoucherNrPreselection;
                                    }
                                    scope.counterBookingMode = data[4].value;
                                    if (!(!scope.counterBookingMode || scope.counterBookingMode === '' || scope.counterBookingMode === QMC.Common.Constants.GUID_EMPTY || scope.counterBookingMode === '13358c99-565d-4c56-b9d4-e213977ecfd2')) { //if counterbooking could be shown, load data
                                        stammdatenService.getAccountingBooks().then((data) => {
                                            scope.ui.accountingBookCounterBookingTable.data = data;
                                        });
                                    }
                                });
                                scope.$watch('vm.entryForm.amount', (newValue, oldValue) => {
                                    if (newValue === oldValue)
                                        return;
                                    scope.validateKassenbuchEntry(false, scope.entryForm);
                                }, true);
                                scope.$watch('vm.entryForm.voucherNr', (newValue, oldValue) => {
                                    if (newValue === oldValue)
                                        return;
                                    scope.validateKassenbuchEntry(false, scope.entryForm);
                                }, true);
                                scope.$watch('vm.entryForm.isDeposit', (newValue, oldValue) => {
                                    if (newValue === oldValue)
                                        return;
                                    scope.validateKassenbuchEntry(false, scope.entryForm);
                                }, true);
                                scope.$watch('vm.entryForm.date', (newValue, oldValue) => {
                                    if (newValue === oldValue)
                                        return;
                                    scope.validateKassenbuchEntry(false, scope.entryForm);
                                }, true);
                                const sortItemListByDate = () => {
                                    scope.detailItems.sort((a, b) => a.date.value > b.date.value ? 1 : a.date.value < b.date.value ? -1 : 0);
                                };
                                scope.$watch('detailInItems', (newValue, oldValue) => {
                                    var _a, _b;
                                    if (newValue === oldValue)
                                        return;
                                    scope.detailItems = ((_a = scope.detailInItems) !== null && _a !== void 0 ? _a : []).concat((_b = scope.detailOutItems) !== null && _b !== void 0 ? _b : []);
                                    sortItemListByDate();
                                }, true);
                                scope.$watch('detailOutItems', (newValue, oldValue) => {
                                    var _a, _b;
                                    if (newValue === oldValue)
                                        return;
                                    scope.detailItems = ((_a = scope.detailInItems) !== null && _a !== void 0 ? _a : []).concat((_b = scope.detailOutItems) !== null && _b !== void 0 ? _b : []);
                                    sortItemListByDate();
                                }, true);
                            });
                            scope.dateFrom = moment().startOf('month').subtract('months', 3).toDate();
                            scope.dateTo = moment().toDate();
                            scope.events();
                        };
                        scope.events = () => {
                            scope.filterWatcher.dateTo = scope.$watch('vm.dateTo', (newValue, oldValue) => {
                                if (newValue === oldValue || scope.form === (null || undefined))
                                    return;
                                scope.getAccountingBook(scope.form);
                            });
                            scope.filterWatcher.dateFrom = scope.$watch('vm.dateFrom', (newValue, oldValue) => {
                                if (newValue === oldValue || !scope.form)
                                    return;
                                scope.getAccountingBook(scope.form);
                            });
                        };
                        /****************** FORM ******************/
                        scope.initForm = () => {
                            var _a;
                            scope.form = {
                                id: null,
                                objectId: null,
                                caption: null,
                                isStandard: false,
                                standardVatId: scope.userConfig.defaultVat,
                                currencyId: scope.userConfig.defaultCurrency,
                                endingDate: null,
                                onlyPositive: true,
                                accountNumber: null,
                                parentObjectId: scope.qmParent.id,
                                parentObjectType: (_a = scope.qmParent.objectType) !== null && _a !== void 0 ? _a : QMC.Common.Constants.OBJECTTYPE_CLIENT,
                                accountingBookTypeId: null,
                                countryId: scope.userConfig.defaultCountry
                            };
                            scope.entryForm = {
                                objectId: null,
                                id: null,
                                comment: null,
                                voucherTypeId: null,
                                vatId: null,
                                isDeposit: false,
                                amount: 0,
                                date: new Date(),
                                accountingBookId: null,
                                currency: null,
                                currencyShort: null,
                                voucherText: "",
                                voucherNr: "",
                                voucherType: null,
                                vat: null,
                                vatText: null,
                                clientId: scope.qmParent.id,
                                generateVoucherNrPossible: scope.generateVoucherNrPossible,
                                createVoucherNr: scope.generateVoucherNrPreselection,
                                isVoucherNumberFix: false,
                                isCounterBooking: false,
                                counterBookingId: null
                            };
                        };
                        scope.initEntryForm = (form) => {
                            scope.initForm();
                            scope.entryForm.vatId = form.standardVatId;
                            scope.entryForm.accountingBookId = form.id;
                            scope.entryForm.currency = form.currency;
                            scope.entryForm.isVoucherNumberFix = false;
                        };
                        scope.editAccountingBook = (form) => {
                            scope.formState = 'edit';
                            scope.form = form;
                            if (form.endingDate) {
                                scope.form.endingDate = $qui.createDateFromString(form.endingDate);
                            }
                        };
                        scope.editAccountingBookEntry = (form) => {
                            scope.entryFormState = 'edit';
                            scope.entryForm = form;
                            if (form.isVoucherNumberFix)
                                scope.entryForm.createVoucherNr = true;
                            setTimeout(function () {
                                // Parse to two decimal digits comma value (see mantis 0021255)
                                //if (isNaN($(this).val()))
                                //    $(this).val(0);
                                const withPoint = form.amount.toString().replace(',', '.');
                                const twoDecimalDigits = parseFloat(withPoint).toFixed(2);
                                const withComma = twoDecimalDigits.replace('.', ',');
                                $('#amount').val(withComma);
                            }, 300);
                            if (form.date !== (null || undefined))
                                scope.entryForm.date = $qui.createDateFromString(form.date);
                        };
                        /****************** DATA ******************/
                        scope.getData = () => {
                            scope.getAccountingBooks();
                        };
                        scope.getReferences = () => {
                            return stammdatenService.getAccountingBookReferences().then((data) => {
                                const values = data.map(x => ({ value: x.objectId, text: x.displayTitle, group: x.objectTypeCaption }));
                                values.sort((a, b) => (a.text.toLocaleLowerCase() > b.text.toLocaleLowerCase()) ? 1 : ((b.text.toLocaleLowerCase() > a.text.toLocaleLowerCase()) ? -1 : 0));
                                values.sort((a, b) => (a.group.toLocaleLowerCase() > b.group.toLocaleLowerCase()) ? 1 : ((b.group.toLocaleLowerCase() > a.group.toLocaleLowerCase()) ? -1 : 0));
                                return values;
                            });
                        };
                        scope.getTypeList = () => {
                            return scope.wvList.accountingBookTypeWvList.map(function (obj) {
                                return {
                                    value: obj.id,
                                    text: obj.name,
                                    isFix: obj.isFix
                                };
                            });
                        };
                        scope.getCountryList = () => {
                            return scope.ui.select(scope.wvList.countryWvList, {
                                value: 'objectId',
                                text: 'name'
                            });
                        };
                        scope.getDepositList = () => {
                            return [{
                                    value: true,
                                    text: "Einnahme"
                                }, {
                                    value: false,
                                    text: "Ausgabe"
                                }];
                        };
                        scope.getCurrencyList = () => {
                            return scope.wvListForCountry.currencyWvList.map(function (obj) {
                                return {
                                    value: obj.id,
                                    text: obj.caption,
                                    isFix: obj.isFix,
                                };
                            });
                        };
                        scope.getVatList = () => {
                            return scope.wvListForCountry.vatWvList.map(function (obj) {
                                return {
                                    value: obj.id,
                                    text: obj.caption,
                                    isFix: obj.isFix,
                                };
                            });
                        };
                        scope.getDepositTypeList = () => {
                            return scope.wvList.depositVoucherTypeWvList.map(function (obj) {
                                return {
                                    value: obj.id,
                                    text: obj.name,
                                    isFix: obj.isFix
                                };
                            });
                        };
                        scope.getVoucherTypeList = () => {
                            return scope.wvList.paymentVoucherTypeWvList.map(function (obj) {
                                return {
                                    value: obj.id,
                                    text: obj.name,
                                    isFix: obj.isFix,
                                };
                            });
                        };
                        /****************** COUNTERBOOKING EXTRA ******************/
                        scope.addAccountingBookEntry = (form) => {
                            if (!scope.counterBookingMode || scope.counterBookingMode === '' || scope.counterBookingMode === QMC.Common.Constants.GUID_EMPTY || scope.counterBookingMode === '13358c99-565d-4c56-b9d4-e213977ecfd2') { //never
                                scope.addAccountingBookEntryAction(form);
                            }
                            else { //always //ask
                                QMC.Common.Utilities.confirm(scope.promptOptionsCounter, (open) => {
                                    if (open) {
                                        scope.counterBookingFilter = '';
                                        scope.entryForm = angular.copy(form);
                                        scope.entryFormState = 'new';
                                        $qui.functionWaiter("createCounterBookingTable", scope);
                                        $('#counterBookingModal').modal('show');
                                    }
                                    else {
                                        scope.addAccountingBookEntryAction(form);
                                    }
                                }, '#promptCounter', true);
                            }
                        };
                        scope.putAccountingBookEntry = (form) => {
                            if (!scope.counterBookingMode || scope.counterBookingMode === '' || scope.counterBookingMode === QMC.Common.Constants.GUID_EMPTY || scope.counterBookingMode === '13358c99-565d-4c56-b9d4-e213977ecfd2') { //never
                                scope.putAccountingBookEntryAction(form);
                            }
                            else { //always //ask
                                QMC.Common.Utilities.confirm(scope.promptOptionsCounter, (open) => {
                                    if (open) {
                                        scope.entryForm = angular.copy(form);
                                        scope.entryFormState = 'edit';
                                        $qui.functionWaiter("createCounterBookingTable", scope);
                                        $('#counterBookingModal').modal('show');
                                    }
                                    else {
                                        scope.putAccountingBookEntryAction(form);
                                    }
                                }, '#promptCounter', true);
                            }
                        };
                        scope.selectCounterAccountingBook = (item = undefined) => {
                            if (item) {
                                scope.entryForm.counterBookingId = item.id;
                                scope.validateKassenbuchEntryCounterBooking(scope.entryForm);
                                return;
                            }
                            scope.performSaveAction();
                        };
                        scope.closeCounterBookingModal = () => {
                            QMC.Common.Utilities.confirm(scope.promptOptionsCounterDismiss, (dismiss) => {
                                if (dismiss) {
                                    scope.entryForm.counterBookingId = undefined;
                                    scope.selectCounterAccountingBook();
                                }
                                else {
                                    $('#counterBookingModal').modal('show');
                                }
                            }, '#promptCounterDismiss', true);
                        };
                        scope.validateKassenbuchEntryCounterBooking = (form) => {
                            scope.validation.errors = null;
                            scope.validation.warnings = null;
                            const validationObject = {
                                idCashJournal: form.counterBookingId,
                                idObjectEntry: undefined,
                                entryDate: form.date,
                                isRevenue: !scope.entryForm.isDeposit,
                                amount: form.amount ? form.amount : 0,
                                voucherNumber: form.voucherNr,
                                infoText: form.comment,
                                isDeletionRequest: false,
                            };
                            stammdatenService.checkForWarningsAndErrors(validationObject).then((dataValidation) => {
                                if (dataValidation.errors.length > 0 || dataValidation.warnings.length > 0) {
                                    scope.validation.errors = dataValidation.errors;
                                    scope.validation.warnings = dataValidation.warnings;
                                    $('#validationCounterBookingModal').modal('show');
                                }
                                else {
                                    scope.performSaveAction();
                                }
                            });
                        };
                        scope.performSaveAction = () => {
                            $('#counterBookingModal').modal('hide');
                            if (scope.entryFormState === 'new') {
                                scope.addAccountingBookEntryAction(scope.entryForm);
                            }
                            else {
                                scope.putAccountingBookEntryAction(scope.entryForm);
                            }
                        };
                        /****************** SERVICE ******************/
                        scope.addAccountingBook = (form) => {
                            stammdatenService.postAccountingBook(form).then(() => {
                                scope.ui.notify(scope.ui.successNote);
                                scope.formState = 'new';
                                scope.getAccountingBooks();
                            });
                        };
                        scope.putAccountingBook = (form) => {
                            stammdatenService.putAccountingBook(scope.qmParent.id, form.id, form).then(() => {
                                scope.ui.notify(scope.ui.successNote);
                                scope.formState = 'new';
                                scope.getAccountingBooks();
                            });
                        };
                        scope.deleteAccountingBook = (item) => {
                            scope.promptOptions.itemText = item.caption;
                            QMC.Common.Utilities.confirm(scope.promptOptions, (data) => {
                                if (data)
                                    stammdatenService.deleteAccountingBook(scope.qmParent.id, item.id).then(() => {
                                        scope.ui.notify(scope.ui.deleteNote);
                                        scope.formState = 'new';
                                        scope.getAccountingBooks();
                                    });
                            });
                        };
                        scope.addAccountingBookEntryAction = (form) => {
                            form.clientId = scope.qmParent.id;
                            scope.loadingDetail = true;
                            stammdatenService.postAccountingBookEntry(form).then(() => {
                                scope.ui.notify(scope.ui.successNote);
                                scope.getAccountingBook({ id: form.accountingBookId });
                            }).catch(() => {
                                scope.loadingDetail = false;
                            }).finally(() => {
                                scope.entryFormState = 'new';
                            });
                        };
                        scope.putAccountingBookEntryAction = (form) => {
                            form.clientId = scope.qmParent.id;
                            scope.loadingDetail = true;
                            stammdatenService.putAccountingBookEntry(form.id, form).then(() => {
                                scope.ui.notify(scope.ui.successNote);
                                scope.getAccountingBook({ id: form.accountingBookId });
                            }).catch(() => {
                                scope.loadingDetail = false;
                            }).finally(() => {
                                scope.entryFormState = 'new';
                            });
                        };
                        scope.deleteAccountingBookEntry = (form) => {
                            //I put the delete function in the validateKassenbuchEntry in order to better handle the validation result
                            scope.validateKassenbuchEntry(true, form);
                        };
                        scope.getWv = () => {
                            stammdatenService.getAccountingBookWv().then((data) => {
                                scope.wvList = data;
                                stammdatenService.getAccountingBookUserConfig().then((data) => {
                                    scope.userConfig = data;
                                    scope.initForm();
                                    scope.getWvForCountry();
                                    $qui.functionWaiter("createEntryForm", scope);
                                    setTimeout(function () {
                                        $('#amount').on('change', function () {
                                            // Parse to two decimal digits comma value (see mantis 0021255)
                                            const input = $(this).val().toString().replace(',', '.');
                                            if (isNaN(input))
                                                $(this).val(0);
                                            const withPoint = $(this).val().toString().replace(',', '.');
                                            const twoDecimalDigits = parseFloat(withPoint).toFixed(2);
                                            const withComma = twoDecimalDigits.replace('.', ',');
                                            $('#amount').val(withComma);
                                        });
                                    }, 300);
                                });
                            });
                        };
                        scope.getWvForCountry = () => {
                            stammdatenService.getAccountingBookWvForCountry(scope.form.countryId).then((data) => {
                                scope.loading = false;
                                scope.wvListForCountry = data;
                                $qui.functionWaiter("ui.createForm", scope);
                            });
                        };
                        scope.getAccountingBooks = () => {
                            scope.loading = true;
                            stammdatenService.getAccountingBookList(scope.qmParent.id).then((data) => {
                                data = data.map(function (obj) {
                                    obj.new = obj.permissions.new && this.entryNew;
                                    obj.modify = obj.permissions.modify;
                                    obj.delete = obj.permissions.delete;
                                    obj.view = obj.permissions.view;
                                    obj.permissions.special = obj.permissions.delete && !obj.isStandard;
                                    obj.wasStandard = obj.isStandard;
                                    return obj;
                                }.bind(scope));
                                scope.accountingBooks = data;
                                scope.ui.accountingBookTable.data = data;
                                $qui.functionWaiter("createAcountingbookTable", scope);
                                scope.loading = false;
                            });
                        };
                        scope.getAccountingBook = (form) => {
                            if (!form.id || form.id === QMC.Common.Constants.GUID_EMPTY)
                                return;
                            if (scope.filterWatcher.dateFrom) {
                                scope.filterWatcher.dateFrom();
                                scope.filterWatcher.dateTo();
                            }
                            scope.showDetail = true;
                            scope.loadingDetail = true;
                            scope.form = form;
                            for (const acc in scope.accountingBooks)
                                if (form.id === scope.accountingBooks[acc].id)
                                    scope.caption = scope.accountingBooks[acc].caption;
                            stammdatenService.getAccountingBook(scope.qmParent.id, form.id, scope.dateFrom, scope.dateTo).then((data) => {
                                scope.totalAmount = data.sum;
                                data.items = data.items.map((obj) => {
                                    obj.allowEdit = (scope.entryModify && obj.permissions.modify) && !obj.isCounterBooking;
                                    // DA-5330: apperantly server always disallows deletion for ds, so for now set it to the same permission as editing
                                    obj.allowDelete = obj.allowEdit;
                                    //obj.allowDelete = (scope.entryDelete && obj.permissions.delete);
                                    obj.amountSigned = obj.amount;
                                    if (!obj.isDeposit)
                                        obj.amountSigned = -Math.abs(obj.amount);
                                    return obj;
                                });
                                const input = [];
                                const out = [];
                                scope.timeAmount = 0;
                                for (const element of data.items) {
                                    if (element.isDeposit) {
                                        input.push(element);
                                        scope.timeAmount = scope.timeAmount + element.amount;
                                    }
                                    else {
                                        out.push(element);
                                        scope.timeAmount = scope.timeAmount - element.amount;
                                    }
                                }
                                scope.ui.accountingBookEntryTableIn.data = input;
                                scope.ui.accountingBookEntryTableOut.data = out;
                                $qui.functionWaiter("createEntryTableOut", scope);
                                $qui.functionWaiter("createEntryTableIn", scope);
                                scope.loadingDetail = false;
                                scope.events();
                            });
                        };
                        scope.getReweNumberData = () => {
                            scope.reweNumberData = '';
                            stammdatenService.getReweNumber(140000, scope.qmParent.id).then((data) => {
                                if (data[scope.qmParent.id] && data[scope.qmParent.id].length > 0) {
                                    for (const number of data[scope.qmParent.id]) {
                                        if (scope.reweNumberData.length > 0)
                                            scope.reweNumberData += '; ';
                                        scope.reweNumberData += number.caption + ': ' + number.value;
                                    }
                                }
                            });
                        };
                        scope.validateKassenbuchEntry = (isDeleteRequest, form) => {
                            if (!(moment(form.date).isValid()) || isNaN(form.amount))
                                return;
                            scope.validation.errors = null;
                            scope.validation.warnings = null;
                            const validationObject = {
                                idCashJournal: form.accountingBookId,
                                idObjectEntry: form.objectId,
                                entryDate: form.date,
                                isRevenue: scope.entryForm.isDeposit,
                                amount: form.amount ? form.amount : 0,
                                voucherNumber: form.voucherNr,
                                infoText: form.comment,
                                isDeletionRequest: isDeleteRequest,
                            };
                            stammdatenService.checkForWarningsAndErrors(validationObject).then((dataValidation) => {
                                if (dataValidation.errors.length > 0 || dataValidation.warnings.length > 0) {
                                    scope.validation.errors = dataValidation.errors;
                                    scope.validation.warnings = dataValidation.warnings;
                                }
                                if (isDeleteRequest && dataValidation.errors.length === 0 && dataValidation.warnings.length === 0) {
                                    QMC.Common.Utilities.confirm(scope.promptOptions, (deleteOK) => {
                                        if (deleteOK) {
                                            scope.deleteForm = {
                                                accountingBookId: form.accountingBookId,
                                                objectId: form.objectId
                                            };
                                            scope.deleteEntry();
                                        }
                                    });
                                }
                                else {
                                    if (isDeleteRequest) {
                                        scope.deleteForm = {
                                            accountingBookId: form.accountingBookId,
                                            objectId: form.objectId
                                        };
                                        $('#validationModal').modal('show');
                                    }
                                }
                            });
                        };
                        scope.deleteEntry = () => {
                            stammdatenService.deleteAccountingBookEntry(scope.deleteForm.accountingBookId, scope.deleteForm.objectId).then(() => {
                                $('#validationModal').modal('hide');
                                scope.ui.notify(scope.ui.deleteNote);
                                scope.entryFormState = 'new';
                                scope.getAccountingBook({ id: scope.deleteForm.accountingBookId });
                            });
                        };
                    }
                };
            }
        ]);
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        class AdmissionFormDirective {
            constructor(scope, $qui, stammdatenService) {
                this.scope = scope;
                this.$qui = $qui;
                this.stammdatenService = stammdatenService;
                this.isValid = false;
                this.disableInstituteChange = false;
                this.id = 'qmAdmissionForm_' + Math.random().toString(36).substring(2, 11);
                this.wvSelects = { reason: [], initiatorType: [], migrationBackground: [], severityOfAbnormability: [], admissionType: [], serviceSetting: [], origins: [], initiatives: [] };
                this.$postLink = () => {
                    // Initialize data if not already set
                    if (!this.data) {
                        this.data = {
                            id: null,
                            objectId: null,
                            reasonIds: [],
                            isPlaceOfAccomodation: false,
                            date: moment().startOf('day').toDate()
                        };
                    }
                    this.scope.$watch('vm.disableInstituteChange', () => {
                        this.formSchema = this.getSchema();
                    });
                    this.scope.$watch('vm.data.objectId', (newVal, oldVal) => {
                        var _a;
                        this.data = (_a = this.data) !== null && _a !== void 0 ? _a : {
                            id: null,
                            objectId: null,
                            reasonIds: [],
                            isPlaceOfAccomodation: false,
                            date: moment().startOf('day').toDate()
                        };
                        this.state = this.data.objectId ? 'edit' : 'new';
                        if (newVal === oldVal)
                            return;
                        this.$qui.functionWaiter("createForm", this);
                    });
                    this.$qui.functionWaiter("createForm", this);
                    //Setup dateTime synching
                    this.scope.$watch('vm.data.date', (newVal, oldVal) => {
                        if (!this.data || moment(newVal).isSame(oldVal))
                            return;
                        this.data.internalDate = moment(this.data.date).toDate();
                        this.data.internalTime = moment(this.data.date).toDate();
                    }, true);
                    const syncDateTime = (newVal, oldVal) => {
                        if (!this.data || moment(newVal).isSame(oldVal))
                            return;
                        const dateMoment = moment(this.data.internalDate);
                        const timeMoment = moment(this.data.internalTime);
                        this.data.date = dateMoment.clone().set({
                            hour: timeMoment.hour(),
                            minute: timeMoment.minute(),
                            second: timeMoment.second(),
                        }).toDate();
                    };
                    this.scope.$watch('vm.data.internalDate', syncDateTime, true);
                    this.scope.$watch('vm.data.internalTime', syncDateTime, true);
                    // Initialize internal date/time fields after data is set
                    if (this.data && this.data.date) {
                        this.data.internalDate = moment(this.data.date).toDate();
                        this.data.internalTime = moment(this.data.date).toDate();
                    }
                    if (!this.wvData)
                        this.loadWvs();
                    this.scope.$watch('vm.wvData', (newVal, oldVal) => {
                        var _a;
                        if (newVal === oldVal || !newVal)
                            return;
                        this.wvSelects = {
                            reason: this.wvData.reasonWvList.map(x => ({ value: x.objectId, text: x.name })),
                            initiatorType: this.wvData.initiatorTypeWvList.map(x => ({ value: x.objectId, text: x.name })),
                            migrationBackground: this.wvData.migrationBackgroundWvList.map(x => ({ value: x.objectId, text: x.name })),
                            severityOfAbnormability: this.wvData.severityOfAbnormabilityWvList.map(x => ({ value: x.objectId, text: x.name })),
                            admissionType: this.wvData.admissionTypeWvList.map(x => ({ value: x.objectId, text: x.name })),
                            serviceSetting: ((_a = this.wvData.serviceSettingWvList) !== null && _a !== void 0 ? _a : []).map(x => ({ value: x.objectId, text: x.name })),
                            origins: this.wvData.originWvList.map(x => ({ value: x.objectId, text: x.name })),
                            initiatives: this.wvData.initiativeWvList.map(x => ({ value: x.objectId, text: x.name })),
                        };
                        //add empty entries
                        Object.keys(this.wvSelects).forEach(key => {
                            const wv = this.wvSelects[key];
                            if (!wv.some(x => !x.value || x.value === QMC.Common.Constants.GUID_EMPTY))
                                wv.push({ value: QMC.Common.Constants.GUID_EMPTY, text: '' });
                        });
                        this.$qui.functionWaiter("createForm", this);
                    });
                    Promise.all([this.stammdatenService.getAdmissionFieldInfo(), this.stammdatenService.getAdmissionRequiredFields(), this.stammdatenService.getInstituteList()])
                        .then(datas => {
                        for (let key in datas[0]) {
                            const formElement = this.formSchema.form.find(x => x.model === key);
                            if (!formElement)
                                continue;
                            formElement.required = datas[0][key].required;
                            formElement.hidden = datas[0][key].invisible;
                        }
                        const serviceSettingElement = this.formSchema.form.find(x => x.model === 'serviceSettingId');
                        if (serviceSettingElement && datas[1].serviceSettingId !== undefined)
                            serviceSettingElement.required = datas[1].serviceSettingId;
                        this.institutes = datas[2].map(x => ({ value: x.objectId, text: x.caption }));
                    })
                        .finally(() => this.$qui.functionWaiter("createForm", this));
                };
                this.$onDestroy = () => {
                };
                this.formSchema = this.getSchema();
            }
            loadWvs() {
                this.stammdatenService.getAdmissionWv()
                    .then(data => this.wvData = data);
            }
            getInstitutes() {
                return this.institutes;
            }
            getAdmissionTypes() {
                return this.wvSelects.admissionType;
            }
            getServiceSettings() {
                return this.wvSelects.serviceSetting;
            }
            getReasons() {
                return this.wvSelects.reason;
            }
            getSeverities() {
                return this.wvSelects.severityOfAbnormability;
            }
            getMigrationBackgrounds() {
                return this.wvSelects.migrationBackground;
            }
            getInitiatorTypes() {
                return this.wvSelects.initiatorType;
            }
            getOrigins() {
                return this.wvSelects.origins;
            }
            getInitiatives() {
                return this.wvSelects.initiatives;
            }
            getSchema() {
                return {
                    form: [{
                            label: "Aufnahmedatum",
                            type: "Date",
                            lngTag: 20006002,
                            model: "internalDate",
                            required: true,
                            style: {
                                icon: "fa fa-calendar",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Uhrzeit",
                            type: "Time",
                            lngTag: 20000046,
                            model: "internalTime",
                            required: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        },
                        {
                            label: "Aufnahme-Organisation",
                            type: "Select2",
                            lngTag: 20006003,
                            model: "instituteId",
                            required: true,
                            dataSource: "getInstitutes",
                            style: {
                                icon: "fa fa-home",
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Hauptaufnahme",
                            type: "CheckboxInline",
                            lngTag: 20006004,
                            model: "isPlaceOfAccomodation",
                            style: {
                                class: "col-xs-12 col-sm-6"
                            }
                        },
                        !this.disableInstituteChange && {
                            label: "Stammhauswechsel",
                            type: "CheckboxInline",
                            lngTag: 20006504,
                            model: "IsInstituteChange",
                            style: {
                                class: "col-xs-12 col-sm-6"
                            }
                        },
                        {
                            label: "Aufnahmetyp",
                            type: "Select2",
                            lngTag: 20006505,
                            model: "admissionTypeId",
                            dataSource: "getAdmissionTypes",
                            wvId: 'e8798921-9656-4dc7-87f4-1e81e9a83829',
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Leistungssetting",
                            type: "Select2",
                            lngTag: 20006520,
                            model: "serviceSettingId",
                            dataSource: "getServiceSettings",
                            wvId: '3423d547-31e0-4e09-a191-60a9e94e0320',
                            required: true,
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Aufnahmegrund",
                            type: "Select2",
                            lngTag: 20006506,
                            model: "reasonIds",
                            multiple: true,
                            dataSource: "getReasons",
                            wvId: 'ee379655-d04b-47d0-93f5-88d654785357',
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Herkunft",
                            type: "Select2",
                            lngTag: 20006005,
                            model: "originId",
                            dataSource: "getOrigins",
                            wvId: '953826e4-7cf2-4f95-8a57-37eb18f77436',
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Schweregrad der Gesamtauffälligkeit",
                            type: "Select2",
                            lngTag: 20006006,
                            model: "severityOfAbnormabilityId",
                            dataSource: "getSeverities",
                            wvId: '4474a94b-04d5-4f80-b925-18d1487ccad2',
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Migrationshintergrund",
                            type: "Select2",
                            lngTag: 20006010,
                            model: "migrationBackgroundId",
                            dataSource: "getMigrationBackgrounds",
                            wvId: '533c8b83-efe3-4472-ac75-80d673898f1c',
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Veranlasser",
                            type: "Select2",
                            lngTag: 20006008,
                            model: "initiatorTypeId",
                            dataSource: "getInitiatorTypes",
                            wvId: '9f6641b2-1299-44cd-849d-f94862bf4fd4',
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Initiative",
                            type: "Select2",
                            lngTag: 20006009,
                            model: "initiativeId",
                            dataSource: "getInitiatives",
                            wvId: 'e5244243-6ef6-4713-91e2-1bf0177b7390',
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            placeholder: "Bemerkung",
                            placeholderTag: 20000049,
                            label: "Bemerkung",
                            type: "Summernote",
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12"
                            }
                        }]
                };
            }
        }
        angular.module('QMC.Stammdaten').component('qmAdmissionForm', {
            templateUrl: './stammdaten/Directives/AdmissionForm',
            controller: ['$scope', '$qui', 'StammdatenService', AdmissionFormDirective],
            controllerAs: 'vm',
            bindings: {
                data: '=?',
                state: '=?',
                isValid: '=?',
                wvData: '=?',
                disabled: '=?',
                disableInstituteChange: '=?'
            }
        });
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        class DismissalFormDirective {
            constructor(scope, $qui, stammdatenService) {
                this.scope = scope;
                this.$qui = $qui;
                this.stammdatenService = stammdatenService;
                this.isValid = false;
                this.id = 'qmDismissalForm_' + Math.random().toString(36).substring(2, 11);
                this.admissions = [];
                this.institutes = [];
                this.wvSelects = { reason: [], initiatedBy: [], initiative: [], planedEmployment: [], remainingAfterDismissal: [] };
                this.$postLink = () => {
                    this.scope.$watch('vm.data.objectId', (newVal, oldVal) => {
                        this.state = this.data.objectId ? 'edit' : 'new';
                        if (newVal === oldVal)
                            return;
                        this.$qui.functionWaiter("createForm", this);
                    });
                    this.$qui.functionWaiter("createForm", this);
                    if (!this.wvData)
                        this.stammdatenService.getDismissalWv().then(data => {
                            this.wvData = data;
                            this.$qui.functionWaiter("createForm", this);
                        });
                    //Setup dateTime synching
                    this.scope.$watch('vm.data.date', (newVal, oldVal) => {
                        if (!this.data || moment(newVal).isSame(oldVal))
                            return;
                        this.data.internalDate = moment(this.data.date).toDate();
                        this.data.internalTime = moment(this.data.date).toDate();
                    }, true);
                    const syncDateTime = (newVal, oldVal) => {
                        if (!this.data || moment(newVal).isSame(oldVal))
                            return;
                        const dateMoment = moment(this.data.internalDate);
                        const timeMoment = moment(this.data.internalTime);
                        this.data.date = dateMoment.clone().set({
                            hour: timeMoment.hour(),
                            minute: timeMoment.minute(),
                            second: timeMoment.second(),
                        }).toDate();
                    };
                    this.scope.$watch('vm.data.internalDate', syncDateTime, true);
                    this.scope.$watch('vm.data.internalTime', syncDateTime, true);
                    this.scope.$watch('vm.data.remainingAfterDismissalId', (newVal, oldVal) => {
                        if (oldVal === newVal)
                            return;
                        const isInstituteChange = this.data.remainingAfterDismissalId === '9d827d8b-6d7e-49ff-acc3-f02c71546c21';
                        const targetSchemaElement = this.formSchema.form.find(x => x.model === 'targetInstituteId');
                        const statusChangeSchemaElement = this.formSchema.form.find(x => x.model === 'deactivateClient');
                        if (targetSchemaElement) {
                            targetSchemaElement.disabled = !isInstituteChange;
                            targetSchemaElement.required = isInstituteChange;
                        }
                        if (statusChangeSchemaElement)
                            statusChangeSchemaElement.disabled = isInstituteChange;
                        this.$qui.functionWaiter("createForm", this);
                    });
                    this.scope.$watch('vm.wvData', (newVal, oldVal) => {
                        if (newVal === oldVal || !newVal)
                            return;
                        this.wvSelects = {
                            reason: this.wvData.reasonWvList.map(x => ({ value: x.objectId, text: x.name })),
                            initiatedBy: this.wvData.initiatedByWvList.map(x => ({ value: x.objectId, text: x.name })),
                            initiative: this.wvData.initiativeWvList.map(x => ({ value: x.objectId, text: x.name })),
                            planedEmployment: this.wvData.planedEmploymentWvList.map(x => ({ value: x.objectId, text: x.name })),
                            remainingAfterDismissal: this.wvData.remainingAfterDismissalWvList.map(x => ({ value: x.objectId, text: x.name })),
                        };
                        //add empty entries
                        Object.keys(this.wvSelects).forEach(key => {
                            const wv = this.wvSelects[key];
                            if (!wv.some(x => !x.value || x.value === QMC.Common.Constants.GUID_EMPTY))
                                wv.push({ value: QMC.Common.Constants.GUID_EMPTY, text: '' });
                        });
                        this.$qui.functionWaiter("createForm", this);
                    });
                    this.scope.$watch('vm.parentId', () => {
                        this.stammdatenService.getAdmissionList(this.parentId)
                            .then(data => this.admissions = data)
                            .finally(() => this.$qui.functionWaiter("createForm", this));
                    });
                    Promise.all([this.stammdatenService.getDismissalRequiredFields(), this.stammdatenService.getInstituteList()])
                        .then(datas => {
                        for (let key in datas[0]) {
                            const formElement = this.formSchema.form.find(x => x.model === key);
                            if (!formElement)
                                continue;
                            formElement.required = datas[0][key];
                        }
                        this.institutes = datas[1].map(x => ({ value: x.objectId, text: x.caption }));
                    })
                        .finally(() => this.$qui.functionWaiter("createForm", this));
                };
                this.$onDestroy = () => {
                };
                this.formSchema = {
                    form: [{
                            label: "Zugehörige Aufnahme",
                            type: "Select2",
                            lngTag: 20006517,
                            model: "admissionId",
                            required: true,
                            dataSource: "getAdmissions",
                            style: {
                                icon: "fa fa-home",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            type: 'hr'
                        },
                        {
                            label: "Entlassungsdatum",
                            type: "Date",
                            lngTag: 20006516,
                            model: "internalDate",
                            required: true,
                            style: {
                                icon: "fa fa-calendar",
                                class: "col-md-6 col-xs-12"
                            }
                        },
                        {
                            label: "Uhrzeit",
                            type: "Time",
                            lngTag: 20000046,
                            model: "internalTime",
                            required: true,
                            style: {
                                class: "col-md-6 col-xs-12",
                            },
                        },
                        {
                            label: "Verbleib nach Entlassung",
                            type: "Select2",
                            lngTag: 20006515,
                            model: "remainingAfterDismissalId",
                            dataSource: "getRemainingAfterDismissal",
                            wvId: 'c34e744a-ed76-40d0-bb8d-4817723f34b2',
                            style: {
                                class: "col-xs-12 col-sm-6"
                            }
                        },
                        {
                            label: "Neue Einrichtung",
                            type: "Select2",
                            lngTag: 20006514,
                            model: "targetInstituteId",
                            disabled: true,
                            dataSource: "getInstitutes",
                            style: {
                                class: "col-xs-12 col-sm-6"
                            }
                        },
                        {
                            label: "Entlassungsgrund",
                            type: "Select2",
                            lngTag: 20006513,
                            model: "reasonId",
                            dataSource: "getReasons",
                            wvId: 'de2ee5bd-eef4-43f0-9c74-666d574719d5',
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Veranlasst durch",
                            type: "Select2",
                            lngTag: 20006008,
                            model: "initiatedById",
                            dataSource: "getInitiatedBys",
                            wvId: '398ec3c9-84a6-44cc-b133-d9e1112c2ece',
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Initiative",
                            type: "Select2",
                            lngTag: 20006009,
                            model: "initiativeId",
                            dataSource: "getInitiatives",
                            wvId: '285715fa-a511-4037-9345-6c2943562aae',
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Geplante berufliche Situation nach Entlassung",
                            type: "Select2",
                            lngTag: 20006512,
                            model: "planedEmploymentId",
                            dataSource: "getPlanedEmployments",
                            wvId: '48f8a4f2-7a22-4ba4-9a10-00d32adfa4a0',
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            label: "Personstatus ändern (inaktiv)",
                            type: "Checkbox",
                            lngTag: 20006511,
                            model: "deactivateClient",
                            events: {
                                hideExpression: "qmForm.objectId"
                            },
                            style: {
                                class: "col-xs-12"
                            }
                        },
                        {
                            placeholder: "Bemerkung",
                            placeholderTag: 20000049,
                            label: "Bemerkung",
                            type: "Summernote",
                            lngTag: 20000049,
                            model: "comment",
                            style: {
                                icon: "qm-icon-note_text",
                                class: "col-xs-12"
                            }
                        }]
                };
            }
            getAdmissions() {
                return this.admissions
                    .filter(x => !x.isFinished || x.objectId === this.data.admissionId)
                    .map(x => ({ value: x.objectId, text: `${x.parentFacility} (${moment(x.date).format('DD.MM.YYYY')})` }));
            }
            getInstitutes() {
                return this.institutes;
            }
            getRemainingAfterDismissal() {
                return this.wvSelects.remainingAfterDismissal;
            }
            getReasons() {
                return this.wvSelects.reason;
            }
            getPlanedEmployments() {
                return this.wvSelects.planedEmployment;
            }
            getInitiatives() {
                return this.wvSelects.initiative;
            }
            getInitiatedBys() {
                return this.wvSelects.initiatedBy;
            }
        }
        angular.module('QMC.Stammdaten').component('qmDismissalForm', {
            templateUrl: './stammdaten/Directives/DismissalForm',
            controller: ['$scope', '$qui', 'StammdatenService', DismissalFormDirective],
            controllerAs: 'vm',
            bindings: {
                parentId: '=',
                data: '=?',
                state: '=?',
                isValid: '=?',
                wvData: '=?'
            }
        });
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));
var QMC;
(function (QMC) {
    var Stammdaten;
    (function (Stammdaten) {
        class NewClientDirective {
            constructor(scope, $qui, clientService, stammdatenService, lng, permissionService) {
                this.scope = scope;
                this.$qui = $qui;
                this.clientService = clientService;
                this.stammdatenService = stammdatenService;
                this.lng = lng;
                this.storageName = 'newClientForm';
                this.id = 'qmNewClientForm_' + Math.random().toString(36).substring(2, 11);
                this.loading = false;
                this.openAfterSave = false;
                this.validation = {
                    errors: [],
                    warnings: [],
                    success: false
                };
                this.admission = {
                    active: true,
                    data: { date: moment().startOf('day').toDate(), isPlaceOfAccomodation: false, reasonIds: [], id: null, objectId: null, internalTime: moment().startOf('day') }
                };
                this.$postLink = () => {
                    this.open = () => { this.openModal(); };
                    this.scope.$watch('vm.form.data.actualInstitutionId', () => {
                        if (this.form.data.actualInstitutionId && (!this.admission.data.instituteId || this.admission.data.instituteId === QMC.Common.Constants.GUID_EMPTY))
                            this.admission.data.instituteId = this.form.data.actualInstitutionId;
                    });
                };
                this.openModal = () => {
                    $('#' + this.id).modal('show');
                    this.$qui.waitForEl(`#standardTabButton_${this.id}`, () => {
                        this.initForm();
                        $(`#standardTabButton_${this.id}`).click();
                    });
                };
                this.$onDestroy = () => {
                };
                this.defaultFormValues = {
                    name: '',
                    statusId: '45f0d412-5907-4ced-a236-f88989a2091c',
                    actualInstitutionId: QMC.Common.Constants.GUID_EMPTY,
                };
                this.formSchema = {
                    form: [
                        {
                            label: "Vorname",
                            type: "String",
                            lngTag: 20000057,
                            model: "forename",
                            validate: {
                                message: "Bitte den Vornamen angeben",
                                messageTag: 20003510,
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        },
                        {
                            label: "Name",
                            type: "String",
                            lngTag: 20000072,
                            model: "name",
                            required: true,
                            validate: {
                                message: "Bitte den Namen angeben",
                                messageTag: 21002015
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        },
                        {
                            label: "Kürzel",
                            type: "String",
                            lngTag: 20000221,
                            model: "shortCaption",
                            validate: {
                                message: "Bitte ein Kürzel angeben",
                                messageTag: 21003008
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        },
                        {
                            label: "Nummer",
                            type: "String",
                            lngTag: 20000316,
                            model: "clientNumber",
                            validate: {
                                message: "Bitte eine Nummer angeben",
                                messageTag: 21003008
                            },
                            style: {
                                icon: "fa fa-font",
                                class: "col-xs-12 col-md-6"
                            }
                        },
                        {
                            label: "Geburtsort",
                            type: "String",
                            lngTag: 21002019,
                            model: "birthplace",
                            validate: {
                                message: "Bitte den Geburtsort angeben",
                                messageTag: 21002020
                            },
                            style: {
                                icon: "fa fa-globe",
                                class: "col-xs-12 col-md-6"
                            }
                        },
                        {
                            label: "Geburtsdatum",
                            type: "Date",
                            lngTag: 21002004,
                            model: "birthday",
                            validate: {
                                message: "Bitte das Geburtsdatum angeben",
                                messageTag: 21002018
                            },
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        },
                        {
                            label: "Geschlecht",
                            type: "Select",
                            lngTag: 21002025,
                            model: "genderId",
                            dataSource: "getGenderList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        },
                        {
                            label: "Staatsangehörigkeit",
                            type: "Select",
                            lngTag: 21002041,
                            model: "nationalityId",
                            dataSource: "getNationalityList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        },
                        {
                            label: "Status",
                            type: "Select",
                            lngTag: 20000164,
                            model: "statusId",
                            dataSource: "getStatusList",
                            style: {
                                class: "col-xs-12 col-md-6"
                            },
                        },
                        {
                            type: "hr"
                        },
                        {
                            label: "Migrationshintergrund",
                            type: "Select",
                            lngTag: 21002045,
                            model: "migrationBackgroundId",
                            dataSource: "getMigrationBackgroundList",
                            ddnPosition: 'up',
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        },
                        {
                            label: "Stammhaus",
                            type: "Select",
                            lngTag: 20000031,
                            model: "actualInstitutionId",
                            dataSource: "getActualInstitutionList",
                            ddnPosition: 'up',
                            required: true,
                            style: {
                                class: "col-xs-12 col-md-6"
                            }
                        }
                    ]
                };
                this.form = {
                    ...this.form,
                    schema: this.formSchema,
                    data: { ...this.defaultFormValues },
                    state: 'new'
                };
                this.loading = true;
                Promise.all([
                    this.clientService.getClientWv(),
                    this.clientService.getInstituteList(),
                    permissionService.getPermissionsByObjectTypes([140011])
                ]).then(data => {
                    this.clientWv = data[0];
                    this.institutes = data[1];
                    this.admission.permission = data[2][0];
                }).finally(() => this.loading = false);
                this.clientService.getClientRequiredFields().then(data => {
                    Object.keys(data).forEach(key => {
                        const formField = this.formSchema.form.find(x => x.model === key);
                        if (formField) {
                            if (data[key])
                                formField.required = data[key];
                            else
                                delete formField.required;
                        }
                    });
                });
                this.loadLocalStorage();
            }
            getGenderList() {
                return this.$qui.select(this.clientWv.genderWvList, { value: 'objectId', text: 'name' });
            }
            getNationalityList() {
                return this.$qui.select(this.clientWv.nationalityWvList, { value: 'objectId', text: 'name' });
            }
            getMigrationBackgroundList() {
                return this.$qui.select(this.clientWv.migrationBackgroundWvList, { value: 'objectId', text: 'name' });
            }
            getStatusList() {
                return this.$qui.select(this.clientWv.personStatusWvList, { value: 'objectId', text: 'name' });
            }
            getActualInstitutionList() {
                return this.$qui.select(this.institutes, { value: 'objectId', text: 'caption' });
            }
            createClient(form) {
                if (this.validation.success)
                    this.saveClient(form);
                else
                    this.validate(form, this.saveClient.bind(this));
            }
            saveClient(form) {
                const finallyAction = () => {
                    this.$qui.scopeApply(this.scope);
                    this.loading = false;
                };
                this.loading = true;
                this.saveLocalStorage();
                this.clientService.createClient(form).then(data => {
                    var _a;
                    (_a = this.afterSave) === null || _a === void 0 ? void 0 : _a.call(this);
                    $('#' + this.id).modal('hide');
                    if (this.openAfterSave)
                        location.href = `#/stammdaten/detail/${data.createdObjectId}/cover/${data.createdObjectId}`;
                    if (this.admission.active && this.admission.permission.new && this.admission.isValid) {
                        this.stammdatenService.postAdmission(data.createdObjectId, this.admission.data).finally(finallyAction);
                    }
                }).finally(() => {
                    if (!(this.admission.active && this.admission.permission.new && this.admission.isValid))
                        finallyAction();
                });
            }
            validate(form, onSuccessFullValidation) {
                this.loading = true;
                this.stammdatenService.getPersonValidation({
                    objectType: QMC.Common.Constants.OBJECTTYPE_CLIENT,
                    firstName: form.forename,
                    lastName: form.name,
                    birthday: form.birthday
                })
                    .then(data => {
                    this.validation = { ...data, success: data.errors.length === 0 };
                    if (this.admission.active && !this.admission.isValid)
                        data.errors.push(this.lng.translate(0, 'Die Aufnahme benötigt weitere Eingaben'));
                    if ((data.errors.length + data.warnings.length) === 0) // no warnings and errors => directly save
                        onSuccessFullValidation === null || onSuccessFullValidation === void 0 ? void 0 : onSuccessFullValidation(form);
                    else
                        this.loading = false;
                })
                    .catch(e => {
                    this.validation = {
                        errors: [this.lng.translate(20028043, 'Der Datensatz konnte nicht validiert werden')],
                        warnings: [],
                        success: false
                    };
                    this.loading = false;
                });
            }
            initForm() {
                this.form.data = { ...this.defaultFormValues };
                this.admission.data = { date: moment().startOf('day'), isPlaceOfAccomodation: false, reasonIds: [], id: null, objectId: null, internalTime: moment().startOf('day') };
                this.validation = {
                    errors: [],
                    warnings: [],
                    success: false
                };
                this.createForm();
            }
            createForm() {
                if (this.form.createForm && this.clientWv && this.institutes)
                    this.form.createForm();
                else
                    setTimeout(() => { this.createForm(); }, 500);
            }
            loadLocalStorage() {
                const storage = QMC.Common.personalLocalStorage.getItem(this.storageName);
                const result = storage ? JSON.parse(storage) : undefined;
                if (result) {
                    this.openAfterSave = result.openAfterSave;
                }
                return result;
            }
            saveLocalStorage() {
                const data = {
                    openAfterSave: this.openAfterSave
                };
                QMC.Common.personalLocalStorage.setItem(this.storageName, JSON.stringify(data));
            }
        }
        angular.module('QMC.Stammdaten').component('qmNewClientForm', {
            templateUrl: './stammdaten/Directives/NewClientForm',
            controller: ['$scope', '$qui', 'KlientService', 'StammdatenService', 'QmcLanguageService', 'QmcPermissionService', NewClientDirective],
            controllerAs: 'vm',
            bindings: {
                open: '=?',
                afterSave: '=?'
            }
        });
    })(Stammdaten = QMC.Stammdaten || (QMC.Stammdaten = {}));
})(QMC || (QMC = {}));

//# sourceMappingURL=../../maps/Stammdaten/qmc.stammdaten.js.map
